/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type Adjustment_Status =
  | 'ALL'
  | 'MATCHED'
  | 'UNMATCHED';

/** Admin user role types */
export type Admin_User_Role =
  | 'ACCOUNTING'
  | 'ACCOUNTS_RECEIVABLE'
  | 'BOOKKEEPER'
  | 'BUYING_MANAGER'
  | 'CEO'
  | 'CFO'
  | 'CONTROLLER'
  | 'CPO'
  | 'CREDIT_MANAGER'
  | 'FINANCE_DIRECTOR'
  | 'OFFICE_MANAGER'
  | 'OTHER'
  | 'OWNER_FOUNDER'
  | 'PRESIDENT'
  | 'TREASURER';

/** These mostly mimic the auth service JWT types. */
export type Access =
  /** C2FO User but can only access their own data */
  | 'ACCESSING_USER'
  /** C2FO employee who used LDAP/AD to login */
  | 'ACTIVE_DIRECTORY'
  /** Any application configured in the user auth service */
  | 'APPLICATION_AUTH'
  /** C2FO User */
  | 'PASSWORD';

/** A representation of a SalesForce Account which is a collection of Supplier Divisions. */
export type Account = {
  __typename?: 'Account';
  divisions?: Maybe<Array<Maybe<Division>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newExperienceEnabled?: Maybe<Scalars['Boolean']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  srm?: Maybe<Srm>;
};

/** Account Config - configuration fields for a given account */
export type AccountConfig = {
  __typename?: 'AccountConfig';
  accountId: Scalars['String']['output'];
  configUuid: Scalars['ID']['output'];
  newExperienceEligible: Scalars['Boolean']['output'];
  newExperienceEnabled: Scalars['Boolean']['output'];
  newExperienceSubgroup?: Maybe<Scalars['String']['output']>;
};

export type AddSuppliersInput = {
  /** All selected configuration */
  allSelected?: InputMaybe<PlanAllSelectedOptions>;
  /** List of vendor variant IDs to add to the wave */
  vendorVariantIds: Array<Scalars['String']['input']>;
};

/** Address - normalized according to our spec here: https://honeycomb.jira.com/wiki/spaces/ENG/pages/856457228/2018-11-01%2BCLOSED%2B--%2BAddress%2BStorage%2Band%2BViewing */
export type Address = {
  __typename?: 'Address';
  /** Street Address Line(s) */
  addressLines?: Maybe<Scalars['String']['output']>;
  /** Administrative area. State, Province, Island, etc. - California, SP, Seoul */
  adminArea?: Maybe<Scalars['String']['output']>;
  /** City or Locality - Mountain View, São Paulo, Gangnam-Gu */
  city?: Maybe<Scalars['String']['output']>;
  /** This is thname of the locality. USA, Canda, etc. */
  country?: Maybe<Scalars['String']['output']>;
  /** This is the data key as seen in the listing. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** inner-city, district, suburb */
  dependentLocality?: Maybe<Scalars['String']['output']>;
  /** Persons name at the company. */
  name?: Maybe<Scalars['String']['output']>;
  /** The organization name inside the company. Google has Google Korea, Google France, etc. */
  organization?: Maybe<Scalars['String']['output']>;
  /** Zip or postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Were not sure, but its not used often. */
  sortingCode?: Maybe<Scalars['String']['output']>;
};

export type AdjustmentToleranceUnionBuyerAppDualAuthorization = BuyerAppAdjustmentSettings | BuyerAppDualAuthorization;

export type AggregatedMarketsStatsInput = {
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type AggregatedMarketsStatsOutput = {
  __typename?: 'AggregatedMarketsStatsOutput';
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  invoicesCustom?: Maybe<Scalars['Float']['output']>;
  weightedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  weightedYield?: Maybe<Scalars['Float']['output']>;
};

export type AggregationLevel =
  | 'ALL'
  | 'DIVISION'
  | 'MARKET'
  | 'ORG';

export type AggregationLevelWithMarketType =
  | 'ALL'
  | 'DIVISION'
  | 'MARKET'
  | 'MARKET_TYPE'
  | 'ORG';

/** An object that links a market with an agreement. */
export type Agreement = {
  __typename?: 'Agreement';
  cmsId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  marketId: Scalars['ID']['output'];
};

/** A record showing what agreeement has been agreed to by what user. */
export type AgreementAudit = {
  __typename?: 'AgreementAudit';
  agreement: Agreement;
  agreementId: Scalars['String']['output'];
  authServiceUuid: Scalars['String']['output'];
  dateAccepted: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  revision: Scalars['String']['output'];
};

export type AgreementAuditConnection = {
  __typename?: 'AgreementAuditConnection';
  /** Array of edges. */
  edges: Array<AgreementAuditEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AgreementAuditEdge = {
  __typename?: 'AgreementAuditEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AgreementAudit */
  node: AgreementAudit;
};

export type AgreementAuditFilter = {
  agreement?: InputMaybe<AgreementAuditFilterAgreementFilter>;
  agreementId?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<AgreementAuditFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AgreementAuditFilter>>;
};

export type AgreementAuditFilterAgreementFilter = {
  and?: InputMaybe<Array<AgreementAuditFilterAgreementFilter>>;
  cmsId?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AgreementAuditFilterAgreementFilter>>;
};

/** The input DTO to record that an agreement has been agreed to. */
export type AgreementAuditInput = {
  agreementId: Scalars['String']['input'];
  authServiceUuid: Scalars['String']['input'];
  revision: Scalars['String']['input'];
};

export type AgreementAuditSort = {
  direction: SortDirection;
  field: AgreementAuditSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type AgreementAuditSortFields =
  | 'agreementId'
  | 'authServiceUuid';

export type AgreementConnection = {
  __typename?: 'AgreementConnection';
  /** Array of edges. */
  edges: Array<AgreementEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Agreement */
  node: Agreement;
};

export type AgreementFilter = {
  and?: InputMaybe<Array<AgreementFilter>>;
  cmsId?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AgreementFilter>>;
};

export type AgreementSort = {
  direction: SortDirection;
  field: AgreementSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type AgreementSortFields =
  | 'cmsId'
  | 'marketId';

export type AgreementStatusEnum =
  | 'DRAFT'
  | 'LIVE'
  | 'STAGE';

export type AllSelectedFiltersInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Level 6 Supplier Industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 2 Supplier Industries */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 3 Supplier Industries */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary Supplier Categories */
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Supplier Categories */
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Supplier Categories */
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type AllSelectedOptionsInput = {
  /** Additional filters to apply when all suppliers are selected */
  additionalFilters: AllSelectedFiltersInput;
  /** Must be true to indicate all suppliers are selected */
  value?: Scalars['Boolean']['input'];
};

export type Application = {
  __typename?: 'Application';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type AssignDefaultBuyerAppDivisionsUsersRolesToUserInput = {
  /** Division UUID of the division the user is added to */
  divisionUuid: Scalars['String']['input'];
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['input'];
};

export type Benchmarking_Period =
  | 'PERIOD_TO_DATE'
  | 'THIRTY_SIX_MONTHS'
  | 'TWELVE_MONTHS'
  | 'TWENTY_FOUR_MONTHS';

export type Benchmarking_Strategies =
  | 'custom'
  | 'industryCountry75'
  | 'industryCountry85'
  | 'industryCountry90'
  | 'industryCountry95'
  | 'industryCountry99'
  | 'industryCountryMedian'
  | 'industryGlobal75'
  | 'industryGlobal85'
  | 'industryGlobal90'
  | 'industryGlobal95'
  | 'industryGlobal99'
  | 'industryGlobalMax'
  | 'industryGlobalMedian'
  | 'waHarmonization';

export type Benchmarking_Strategies_With_Harmonization =
  | 'harmonization'
  | 'industryCountry75'
  | 'industryCountry85'
  | 'industryCountry90'
  | 'industryCountry95'
  | 'industryCountry99'
  | 'industryCountryMax'
  | 'industryCountryMedian'
  | 'industryGlobal75'
  | 'industryGlobal85'
  | 'industryGlobal90'
  | 'industryGlobal95'
  | 'industryGlobal99'
  | 'industryGlobalMax'
  | 'industryGlobalMedian';

export type Buyer_Config =
  | 'SHOW_NEW_SUPPLIER_PROFILE';

/** Data center of a buyer */
export type Buyer_Data_Center =
  | 'AP_SOUTH_1'
  | 'CN_NORTH_1'
  | 'EUROPE_WEST3'
  | 'US_WEST_1'
  | 'US_WEST_2';

export type Buyer_Region =
  | 'AMER'
  | 'EMEA';

export type BenchmarkStrategyInput = {
  /** Core segment benchmark strategy */
  coreBenchmarkStrategy: Scalars['String']['input'];
  /** No Naics Terms Increment */
  noNaicsTermsIncrement: Scalars['Float']['input'];
  /** Strategic segment benchmark strategy */
  strategicBenchmarkStrategy: Scalars['String']['input'];
  /** Tail segment benchmark strategy */
  tailBenchmarkStrategy: Scalars['String']['input'];
};

export type BenchmarkStrategyOutput = {
  __typename?: 'BenchmarkStrategyOutput';
  /** Core segment benchmark strategy */
  coreBenchmarkStrategy: Scalars['String']['output'];
  /** No Naics Terms Increment */
  noNaicsTermsIncrement: Scalars['Float']['output'];
  /** Strategic segment benchmark strategy */
  strategicBenchmarkStrategy: Scalars['String']['output'];
  /** Tail segment benchmark strategy */
  tailBenchmarkStrategy: Scalars['String']['output'];
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Buyer = {
  __typename?: 'Buyer';
  active: Scalars['Boolean']['output'];
  buyerEmailDomain?: Maybe<Scalars['String']['output']>;
  buyerPortalUrl?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  makerRouteKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** This is just a helper to let me know where the data came from. We probably dont want it in production */
  source: Scalars['String']['output'];
};

export type BuyerAppAdjustmentSettings = {
  __typename?: 'BuyerAppAdjustmentSettings';
  adjustmentTolerance: Scalars['Float']['output'];
};

export type BuyerAppAdjustmentToleranceInputDto = {
  /** adjustment tolerance value */
  adjTolerance?: InputMaybe<Scalars['Float']['input']>;
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type BuyerAppAggregatedScfDisclosure = {
  __typename?: 'BuyerAppAggregatedScfDisclosure';
  /** associated currency wise disclosure */
  currencyWiseScfDisclosure: Array<BuyerAppCurrencyWiseScfDisclosure>;
  /** funding partner uuid */
  fundingPartnerUuid: Scalars['String']['output'];
};

export type BuyerAppAggregatedScfDisclosureInput = {
  /** Division Uuid */
  divisionUuid: Scalars['String']['input'];
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Funding Partner Uuids */
  fundingPartnerUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

/** Aggregated SCF disclosure data with data gap metadata for incomplete funder-currency combinations */
export type BuyerAppAggregatedScfDisclosureOutput = {
  __typename?: 'BuyerAppAggregatedScfDisclosureOutput';
  /** Data gaps detected for funder-currency combinations */
  dataGaps: Array<BuyerAppScfDataGap>;
  /** Aggregated disclosure data per funder */
  disclosures: Array<BuyerAppAggregatedScfDisclosure>;
};

export type BuyerAppApPerformanceReportInput = {
  /** display currency */
  displayCurrency: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** display currency */
  periods: Array<BuyerAppYoyReportPeriod>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppApPerformanceReportOutput = {
  __typename?: 'BuyerAppApPerformanceReportOutput';
  /** Awarded AP */
  awardedAp: Scalars['Float']['output'];
  awardedRate?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  /** Eligible AP */
  eligibleAp: Scalars['Float']['output'];
  income?: Maybe<Scalars['Float']['output']>;
  /** Loaded AP */
  loadedAp: Scalars['Float']['output'];
  /** Participated AP */
  participatedAp: Scalars['Float']['output'];
  participationRate?: Maybe<Scalars['Float']['output']>;
  /** period */
  period: Scalars['DateTime']['output'];
  /** Registered AP */
  registeredAp: Scalars['Float']['output'];
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppApSummaryOutput = {
  __typename?: 'BuyerAppApSummaryOutput';
  /** Awarded AP */
  awardedAp: Scalars['Float']['output'];
  /** Eligible AP */
  eligibleAp: Scalars['Float']['output'];
  /** Loaded AP */
  loadedAp: Scalars['Float']['output'];
  /** Participated AP */
  participatedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Registered AP */
  registeredAp: Scalars['Float']['output'];
};

export type BuyerAppAprSettingsInput = {
  /** Market APR */
  apr: Scalars['Float']['input'];
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Minimum APR from the market */
  minApr: Scalars['Float']['input'];
};

export type BuyerAppAwardedSupplierHistory = {
  __typename?: 'BuyerAppAwardedSupplierHistory';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceCounts?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  displayCurrency: Scalars['String']['output'];
  firstAwardDate?: Maybe<Scalars['String']['output']>;
  funder: Scalars['String']['output'];
  isParticipating: Scalars['Boolean']['output'];
  lastAwardDate?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Float']['output'];
  marketUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payDate: Scalars['DateTime']['output'];
  rank?: Maybe<Scalars['Float']['output']>;
  takerId: Scalars['Float']['output'];
  takerUuid: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
};

export type BuyerAppAwardedSuppliersHistoryFilters = {
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  fundedMarkets: Array<Scalars['String']['input']>;
  orgUuid: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  selfMarkets: Array<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type BuyerAppAwardedSuppliersHistoryInput = {
  filters: BuyerAppAwardedSuppliersHistoryFilters;
  paging: BuyerAppAwardedSuppliersHistoryPaging;
};

export type BuyerAppAwardedSuppliersHistoryOutput = {
  __typename?: 'BuyerAppAwardedSuppliersHistoryOutput';
  history: Array<BuyerAppAwardedSupplierHistory>;
  orgUuid: Scalars['String']['output'];
  totalRows: Scalars['Float']['output'];
};

export type BuyerAppAwardedSuppliersHistoryPaging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type BuyerAppBuyerConfigResponse = {
  __typename?: 'BuyerAppBuyerConfigResponse';
  /** Configuration object */
  configuration: Scalars['JSON']['output'];
};

export type BuyerAppBuyerReportEmailOutput = {
  __typename?: 'BuyerAppBuyerReportEmailOutput';
  message: Scalars['String']['output'];
};

export type BuyerAppBuyerReportsDbtUnloadInput = {
  /** array of buyer report types */
  dbtModels: Array<Dbt_Model>;
  period: Scalars['String']['input'];
};

export type BuyerAppBuyerReportsDbtUnloadOutput = {
  __typename?: 'BuyerAppBuyerReportsDBTUnloadOutput';
  /** status of dbt unload */
  status: Scalars['Boolean']['output'];
};

export type BuyerAppBuyerReportsEmailsInput = {
  /** Email IDs of users to send buyer report email. NOTE: If none is supplied, then email would be sent to all buyer app users */
  userEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BuyerAppBuyerReportsMarketsInput = {
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Markets Uuids */
  marketUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppBuyerReportsMarketsInputWithCurrency = {
  /** display currency */
  displayCurrency: Scalars['String']['input'];
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Markets Uuids */
  marketUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppBuyerSupplierCounts = {
  __typename?: 'BuyerAppBuyerSupplierCounts';
  created: Scalars['DateTime']['output'];
  /** Maker UUID */
  makerUuid: Scalars['String']['output'];
  /** Total number of registered suppliers */
  registeredSuppliers: Scalars['Float']['output'];
  /** Total number of suppliers */
  totalSuppliers: Scalars['Float']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppBuyerSupplierCountsFilter = {
  and?: InputMaybe<Array<BuyerAppBuyerSupplierCountsFilter>>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppBuyerSupplierCountsFilter>>;
};

export type BuyerAppBuyerSupplierCountsSort = {
  direction: SortDirection;
  field: BuyerAppBuyerSupplierCountsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppBuyerSupplierCountsSortFields =
  | 'makerUuid';

export type BuyerAppCashPoolSettingsInput = {
  /** Cash Available for the market. NOTE: Supply this only if cashPoolLimit is not supplied */
  cashPool?: InputMaybe<Scalars['Float']['input']>;
  /** Cash pool limit. NOTE: Supply this only if cashPool is not supplied */
  cashPoolLimit?: InputMaybe<Scalars['Float']['input']>;
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type BuyerAppClearHistory = {
  __typename?: 'BuyerAppClearHistory';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  marketUuids?: Maybe<Array<Scalars['String']['output']>>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppClearHistoryGraphInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Pay Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Pay Date */
  startDate: Scalars['String']['input'];
  timePeriod?: Time_Periods;
};

export type BuyerAppClearHistoryGraphOutput = {
  __typename?: 'BuyerAppClearHistoryGraphOutput';
  history: Array<BuyerAppClearHistory>;
};

export type BuyerAppClearHistoryStats = {
  __typename?: 'BuyerAppClearHistoryStats';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedYield?: Maybe<Scalars['Float']['output']>;
  clearedAprAvg?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmountAvgByPayDate?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  interestAmount?: Maybe<Scalars['Float']['output']>;
  participatingSuppliersCount?: Maybe<Scalars['Float']['output']>;
  region: Scalars['String']['output'];
  revShareAmount?: Maybe<Scalars['Float']['output']>;
  totalSuppliersCount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppClearHistoryStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Pay Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Pay Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppClearHistoryStatsOutput = {
  __typename?: 'BuyerAppClearHistoryStatsOutput';
  clearHistoryStats: BuyerAppClearHistoryStats;
};

export type BuyerAppClearingTopOffers = {
  __typename?: 'BuyerAppClearingTopOffers';
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyAcceptedEarn: Scalars['Float']['output'];
  baseCurrencyAcceptedInvoiceAmount: Scalars['Float']['output'];
  displayCurrency: Scalars['String']['output'];
  funder: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
};

export type BuyerAppClearingTopOffersInput = {
  filters: BuyerAppTopOffersFilters;
  paging: BuyerAppCursorPaging;
  sorting: BuyerAppClearingTopOffersSorting;
};

export type BuyerAppClearingTopOffersOutput = {
  __typename?: 'BuyerAppClearingTopOffersOutput';
  offers: Array<BuyerAppClearingTopOffers>;
  pageInfo: BuyerAppCursorPagingInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppClearingTopOffersSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Clearing_Top_Offers_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppCoreMarketMetricsDetailsOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsDetailsOutput';
  /** awarded Ap */
  awardedAp: Scalars['Float']['output'];
  /** count of awarded vendors */
  countOfAwardedVendors: Scalars['Float']['output'];
  /** DPE */
  dpe: Scalars['Float']['output'];
  /** eligible Ap */
  eligibleAp: Scalars['Float']['output'];
  /** income */
  income?: Maybe<Scalars['Float']['output']>;
  /** participated Ap */
  participatedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** registered Ap */
  registeredAp: Scalars['Float']['output'];
  /** total Ap */
  totalAp: Scalars['Float']['output'];
  /** yield */
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppCoreMarketMetricsDownloadOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsDownloadOutput';
  /** period */
  period: Scalars['DateTime']['output'];
  /** self market metrics */
  self?: Maybe<BuyerAppCoreMarketMetricsDetailsOutput>;
  /** third party market metrics */
  thirdParty?: Maybe<Array<BuyerAppCoreMarketMetricsWithFunderOutput>>;
};

export type BuyerAppCoreMarketMetricsOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsOutput';
  /** all market metrics */
  all: BuyerAppCoreMarketMetricsDetailsOutput;
  /** period */
  period: Scalars['DateTime']['output'];
  /** self market metrics */
  self?: Maybe<BuyerAppCoreMarketMetricsDetailsOutput>;
  /** third party market metrics */
  thirdParty?: Maybe<BuyerAppCoreMarketMetricsDetailsOutput>;
};

export type BuyerAppCoreMarketMetricsWithFunderOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsWithFunderOutput';
  /** awarded Ap */
  awardedAp: Scalars['Float']['output'];
  /** count of awarded vendors */
  countOfAwardedVendors: Scalars['Float']['output'];
  /** DPE */
  dpe: Scalars['Float']['output'];
  /** eligible Ap */
  eligibleAp: Scalars['Float']['output'];
  /** funder name */
  funder: Scalars['String']['output'];
  /** income */
  income?: Maybe<Scalars['Float']['output']>;
  /** participated Ap */
  participatedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** registered Ap */
  registeredAp: Scalars['Float']['output'];
  /** total Ap */
  totalAp: Scalars['Float']['output'];
  /** yield */
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppCreateReserveInputDto = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** Invoice priority field */
  invoicePriority: Scalars['String']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Reserve percentage value */
  reservePercentage: Scalars['Float']['input'];
  /** Field to indicate run before adjustments */
  runBeforeAdjustments: Scalars['Boolean']['input'];
};

export type BuyerAppCreditLimit = {
  __typename?: 'BuyerAppCreditLimit';
  /** Division uuid */
  buyerDivisionUuid: Scalars['String']['output'];
  /** Credit limit currency */
  currency: Scalars['String']['output'];
  /** Funder uuid */
  funderUuid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  /** Credit limit value */
  limit: Scalars['Float']['output'];
};

export type BuyerAppCreditLimitInput = {
  /** Display currency for credit limit amount */
  currency?: Scalars['String']['input'];
  /** Division Uuids */
  divisionUuids: Array<Scalars['String']['input']>;
  investmentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BuyerAppCreditLimitOutput = {
  __typename?: 'BuyerAppCreditLimitOutput';
  /** Credit Limit */
  creditLimit: Array<BuyerAppCreditLimit>;
  /** Credit utilised */
  utilisation: Array<BuyerAppCreditUtilisation>;
};

export type BuyerAppCreditUtilisation = {
  __typename?: 'BuyerAppCreditUtilisation';
  /** Date of cash investment */
  investmentDate: Scalars['String']['output'];
  /** Organization uuid */
  makerOrganizationUuid: Scalars['String']['output'];
  /** Division uuid */
  makerUuid: Scalars['String']['output'];
  /** Market uuid */
  marketUuid: Scalars['String']['output'];
  /** cash invested value */
  normalizedCashInvested: Scalars['Float']['output'];
};

export type BuyerAppCumulativeVendorsDetailsOutput = {
  __typename?: 'BuyerAppCumulativeVendorsDetailsOutput';
  /** newly loaded supplier count */
  newlyLoadedVendors: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** loaded supplier count */
  totalLoadedVendors: Scalars['Float']['output'];
};

export type BuyerAppCurrencyWiseScfDisclosure = {
  __typename?: 'BuyerAppCurrencyWiseScfDisclosure';
  beginningBalance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  earliestMaturityDate?: Maybe<Scalars['DateTime']['output']>;
  /** The end date of the available data */
  endDate: Scalars['DateTime']['output'];
  endingBalance: Scalars['Float']['output'];
  grossAmountExpedited: Scalars['Float']['output'];
  grossAmountReimbursed: Scalars['Float']['output'];
  latestMaturityDate?: Maybe<Scalars['DateTime']['output']>;
  /** The start date of the available data */
  startDate: Scalars['DateTime']['output'];
};

export type BuyerAppCursorPaging = {
  /** end Cursor for paging through collections */
  end?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Float']['input'];
  /** start Cursor for paging through collections */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppCursorPagingInfo = {
  __typename?: 'BuyerAppCursorPagingInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppDivisionRegion = {
  __typename?: 'BuyerAppDivisionRegion';
  id: Scalars['Float']['output'];
  makerUuid: Scalars['String']['output'];
  region: Buyer_Region;
};

export type BuyerAppDivisionRegionDeleteResponse = {
  __typename?: 'BuyerAppDivisionRegionDeleteResponse';
  id?: Maybe<Scalars['Float']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Buyer_Region>;
};

export type BuyerAppDivisionRegionFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionRegionFilter>>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionRegionFilter>>;
};

export type BuyerAppDivisionRegionInput = {
  makerUuid: Scalars['String']['input'];
  region: Buyer_Region;
};

export type BuyerAppDivisionRegionSort = {
  direction: SortDirection;
  field: BuyerAppDivisionRegionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppDivisionRegionSortFields =
  | 'makerUuid';

export type BuyerAppDivisionRegionUpdateFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionRegionUpdateFilter>>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionRegionUpdateFilter>>;
};

export type BuyerAppDivisionRegionUpdateInput = {
  region: Buyer_Region;
};

export type BuyerAppDivisionReportingCurrencies = {
  __typename?: 'BuyerAppDivisionReportingCurrencies';
  /** currency */
  currency: Scalars['String']['output'];
  /** Division Name */
  divisionName: Scalars['String']['output'];
  /** Division UUID */
  divisionUuid: Scalars['String']['output'];
  /** ID */
  id: Scalars['Float']['output'];
  /** Report Type */
  reportType: Report_Type;
};

export type BuyerAppDivisionReportingCurrenciesDeleteFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionReportingCurrenciesDeleteFilter>>;
  divisionUuid?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionReportingCurrenciesDeleteFilter>>;
  reportType?: InputMaybe<Report_TypeFilterComparison>;
};

export type BuyerAppDivisionReportingCurrenciesEdge = {
  __typename?: 'BuyerAppDivisionReportingCurrenciesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppDivisionReportingCurrencies */
  node: BuyerAppDivisionReportingCurrencies;
};

export type BuyerAppDivisionReportingCurrenciesInput = {
  /** Division UUIDs */
  divisionUuids: Array<Scalars['String']['input']>;
  /** Report Type */
  reportType: Report_Type;
};

export type BuyerAppDivisionReportingCurrenciesOutput = {
  __typename?: 'BuyerAppDivisionReportingCurrenciesOutput';
  /** Custom currencies configured for the division */
  currencies: Array<Scalars['String']['output']>;
  /** Division Name */
  divisionName: Scalars['String']['output'];
  /** Division UUID */
  divisionUuid: Scalars['String']['output'];
};

export type BuyerAppDivisionRolesOutput = {
  __typename?: 'BuyerAppDivisionRolesOutput';
  /** Division uuid */
  divisionUuid: Scalars['String']['output'];
  /** Is the income to be displayed? */
  showIncome: Scalars['Boolean']['output'];
  /** Is the yield to be displayed? */
  showYield: Scalars['Boolean']['output'];
};

/** Role Assigned to a Division User */
export type BuyerAppDivisionUserRole = {
  __typename?: 'BuyerAppDivisionUserRole';
  id: Scalars['ID']['output'];
  /** Role Name */
  name: Scalars['String']['output'];
  /** Readable Role Name To Display */
  readableName: Scalars['String']['output'];
};

export type BuyerAppDivisionsUsersRoles = {
  __typename?: 'BuyerAppDivisionsUsersRoles';
  created: Scalars['DateTime']['output'];
  /** Division UUID of the division the user has access to */
  divisionUuid: Scalars['String']['output'];
  role: BuyerAppRole;
  /** Role assigned to the user on the division */
  roleId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['output'];
};

export type BuyerAppDivisionsUsersRolesDeleteFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionsUsersRolesDeleteFilter>>;
  divisionUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionsUsersRolesDeleteFilter>>;
  roleId?: InputMaybe<IdFilterComparison>;
  userUuid?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppDivisionsUsersRolesEdge = {
  __typename?: 'BuyerAppDivisionsUsersRolesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppDivisionsUsersRoles */
  node: BuyerAppDivisionsUsersRoles;
};

export type BuyerAppDivisionsUsersRolesFilter = {
  /** Division UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** Auth Service UUID of the division user */
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppDivisionsUsersRolesInput = {
  /** Division UUID of the division the user must have access to */
  divisionUuid: Scalars['String']['input'];
  /** Role that must be assigned to the user on the division */
  roleId: Scalars['ID']['input'];
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['input'];
};

export type BuyerAppDivisionsUsersRolesNode = {
  __typename?: 'BuyerAppDivisionsUsersRolesNode';
  /** Division UUID of the division the user has access to */
  divisionUuid: Scalars['String']['output'];
  /** Roles assigned to the user on the division */
  roles: Array<BuyerAppDivisionUserRole>;
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['output'];
};

export type BuyerAppDivisionsUsersRolesOutput = {
  __typename?: 'BuyerAppDivisionsUsersRolesOutput';
  /** Divisions Users Information */
  nodes: Array<BuyerAppDivisionsUsersRolesNode>;
  /** Total count of divisions users */
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppDpeAnalysisDetailsOutput = {
  __typename?: 'BuyerAppDpeAnalysisDetailsOutput';
  /** awarded DPE */
  awardedDpe: Scalars['Float']['output'];
  /** discount */
  discount: Scalars['Float']['output'];
  /** network DPE */
  networkDpe: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
};

export type BuyerAppDualAuthorization = {
  __typename?: 'BuyerAppDualAuthorization';
  /** action */
  action: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** data */
  data: Scalars['JSON']['output'];
  /** uuid of division */
  divisionUuid: Scalars['String']['output'];
  /** Id of dual auth */
  id: Scalars['ID']['output'];
  /** user auth uuid if initiating user */
  initiatingUserUuid: Scalars['String']['output'];
  /** represent dual auth is approved or not */
  isApproved: Scalars['Boolean']['output'];
  /** represent dual auth is canceled or not */
  isCancelled: Scalars['Boolean']['output'];
  /** user auth uuid if responding user */
  respondingUserUuid?: Maybe<Scalars['String']['output']>;
  /** Role assigned to the user on the division */
  roleId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppDualAuthorizationRoles = {
  __typename?: 'BuyerAppDualAuthorizationRoles';
  created: Scalars['DateTime']['output'];
  /** Division UUID of the division for which dual auth is enabled */
  divisionUuid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: BuyerAppRole;
  /** Role ID for which dual auth is enabled on the division */
  roleId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppDualAuthorizationRolesDeleteFilter = {
  and?: InputMaybe<Array<BuyerAppDualAuthorizationRolesDeleteFilter>>;
  divisionUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDualAuthorizationRolesDeleteFilter>>;
  roleId?: InputMaybe<IdFilterComparison>;
};

export type BuyerAppDualAuthorizationRolesEdge = {
  __typename?: 'BuyerAppDualAuthorizationRolesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppDualAuthorizationRoles */
  node: BuyerAppDualAuthorizationRoles;
};

export type BuyerAppDualAuthorizationRolesEnabledInput = {
  /** Division for which dual auth is to be checked */
  divisionUuid: Scalars['String']['input'];
};

export type BuyerAppDualAuthorizationRolesEnabledOutput = {
  __typename?: 'BuyerAppDualAuthorizationRolesEnabledOutput';
  /** Boolean field denoting dual auth is enabled for the given division or no */
  isDualAuthEnabled: Scalars['Boolean']['output'];
};

export type BuyerAppDualAuthorizationRolesInput = {
  /** Division UUID of the division for which dual auth is to be enabled */
  divisionUuid: Scalars['String']['input'];
  /** Specific Role ID for which dual auth is to be enabled on the division */
  roleId: Scalars['ID']['input'];
};

export type BuyerAppEverafterBuyerConfig = {
  __typename?: 'BuyerAppEverafterBuyerConfig';
  accountId: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  divisionUuid: Scalars['String']['output'];
  embedLocationId: Scalars['String']['output'];
  personaName: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type BuyerAppEverafterBuyerConfigEdge = {
  __typename?: 'BuyerAppEverafterBuyerConfigEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppEverafterBuyerConfig */
  node: BuyerAppEverafterBuyerConfig;
};

export type BuyerAppFetchAllSuppliersPaging = {
  pageNum?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export type BuyerAppFileHistory = {
  __typename?: 'BuyerAppFileHistory';
  created: Scalars['DateTime']['output'];
  fileId: Scalars['String']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  serviceProvider: Service_Provider;
  status: File_History_Status;
  updated: Scalars['DateTime']['output'];
  userUuid: Scalars['String']['output'];
};

export type BuyerAppFileHistoryConnection = {
  __typename?: 'BuyerAppFileHistoryConnection';
  /** Array of edges. */
  edges: Array<BuyerAppFileHistoryEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type BuyerAppFileHistoryEdge = {
  __typename?: 'BuyerAppFileHistoryEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppFileHistory */
  node: BuyerAppFileHistory;
};

export type BuyerAppFileHistoryFilter = {
  and?: InputMaybe<Array<BuyerAppFileHistoryFilter>>;
  fileId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppFileHistoryFilter>>;
  userUuid?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppFileHistorySort = {
  direction: SortDirection;
  field: BuyerAppFileHistorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppFileHistorySortFields =
  | 'fileId'
  | 'userUuid';

export type BuyerAppFileHistoryUpsertFields = {
  filePath: Scalars['String']['input'];
  region: Scalars['String']['input'];
  serviceProvider: Service_Provider;
  status: File_History_Status;
};

export type BuyerAppFileHistoryUpsertFilter = {
  fileId: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type BuyerAppFileHistoryUpsertInput = {
  filter: BuyerAppFileHistoryUpsertFilter;
  upsert: BuyerAppFileHistoryUpsertFields;
};

export type BuyerAppFileHistoryUpsertOutput = {
  __typename?: 'BuyerAppFileHistoryUpsertOutput';
  created: Scalars['DateTime']['output'];
  fileId: Scalars['String']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  serviceProvider: Service_Provider;
  status: File_History_Status;
  updated: Scalars['DateTime']['output'];
  userUuid: Scalars['String']['output'];
};

export type BuyerAppFundedMarketInfo = {
  /** Name of Funder */
  funderName: Scalars['String']['input'];
  /** Market UUID of Third Party Funded Market */
  marketUuid: Scalars['String']['input'];
};

export type BuyerAppFunderPaymentBaseCurrencyStats = {
  __typename?: 'BuyerAppFunderPaymentBaseCurrencyStats';
  invoiceAmountCurrentOutstanding: Scalars['Float']['output'];
};

export type BuyerAppFunderPaymentClientCurrencyDetails = {
  __typename?: 'BuyerAppFunderPaymentClientCurrencyDetails';
  baseCurrencyInvoiceAmountCurrentOutstanding: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  invoiceAmountCurrentOutstanding: Scalars['Float']['output'];
};

export type BuyerAppFunderPaymentFundersStats = {
  __typename?: 'BuyerAppFunderPaymentFundersStats';
  funderName: Scalars['String']['output'];
  stats: Array<BuyerAppFunderPaymentStatsDetails>;
};

export type BuyerAppFunderPaymentStatsDetails = {
  __typename?: 'BuyerAppFunderPaymentStatsDetails';
  baseCurrencyStats: BuyerAppFunderPaymentBaseCurrencyStats;
  clientCurrencyStats: Array<BuyerAppFunderPaymentClientCurrencyDetails>;
  dueDate: Scalars['String']['output'];
};

export type BuyerAppFunderPaymentStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** Division uuid */
  divisionUuid: Scalars['String']['input'];
};

export type BuyerAppFunderPaymentStatsOutput = {
  __typename?: 'BuyerAppFunderPaymentStatsOutput';
  baseCurrency: Scalars['String']['output'];
  funderStats?: Maybe<Array<BuyerAppFunderPaymentFundersStats>>;
};

export type BuyerAppFunderWiseScfTimeframeBoundaries = {
  __typename?: 'BuyerAppFunderWiseScfTimeframeBoundaries';
  fundingPartnerUuid: Scalars['String']['output'];
  /** The end date of the available data */
  maxDate: Scalars['DateTime']['output'];
  /** The start date of the available data */
  minDate: Scalars['DateTime']['output'];
};

export type BuyerAppGetDivisionRolesInput = {
  /** Division uuid */
  divisionUuid: Scalars['String']['input'];
};

export type BuyerAppLiveHistoryStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppLiveStatsOutput = {
  __typename?: 'BuyerAppLiveStatsOutput';
  blendedClearingDPE?: Maybe<Scalars['Float']['output']>;
  blendedClearingEarn?: Maybe<Scalars['Float']['output']>;
  blendedClearingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  blendedClearingSupplierCount?: Maybe<Scalars['Float']['output']>;
  blendedClearingYield?: Maybe<Scalars['Float']['output']>;
  notAcceptedDPE?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedSupplierCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppMakerMarketClearHistoryDetails = {
  __typename?: 'BuyerAppMakerMarketClearHistoryDetails';
  baseCurrency: Scalars['String']['output'];
  baseCurrencyClearedEarn: Scalars['Float']['output'];
  baseCurrencyClearedInvoiceAmount: Scalars['Float']['output'];
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  divisionId: Scalars['Float']['output'];
  funder: Scalars['String']['output'];
  isAwardFileCreated?: Maybe<Scalars['Boolean']['output']>;
  isCreditNoteEnabled: Scalars['Boolean']['output'];
  marketId: Scalars['Float']['output'];
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  payDate: Scalars['String']['output'];
};

export type BuyerAppMakerMarketClearHistoryInputDto = {
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isPendingClear: Scalars['Boolean']['input'];
  marketUuids: Array<Scalars['String']['input']>;
  paging: BuyerAppOffsetPaging;
  startDate: Scalars['String']['input'];
};

export type BuyerAppMakerMarketClearHistoryOutputDto = {
  __typename?: 'BuyerAppMakerMarketClearHistoryOutputDto';
  history: Array<BuyerAppMakerMarketClearHistoryDetails>;
  /** total count */
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppManualUploadProcessorHistoryDetails = {
  __typename?: 'BuyerAppManualUploadProcessorHistoryDetails';
  /** created on */
  created: Scalars['String']['output'];
  /** error message */
  errorMessage: Scalars['String']['output'];
  /** file name */
  fileName: Scalars['String']['output'];
  /** id */
  id: Scalars['Float']['output'];
  /** file status */
  status: Scalars['String']['output'];
  /** uploaded on */
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppManualUploadProcessorHistoryInput = {
  divisionUuid: Scalars['String']['input'];
  order: Order_Type;
  paging: BuyerAppOffsetPaging;
};

export type BuyerAppManualUploadProcessorHistoryOutput = {
  __typename?: 'BuyerAppManualUploadProcessorHistoryOutput';
  manualUploadHistory: Array<BuyerAppManualUploadProcessorHistoryDetails>;
  /** total count */
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppMarket = {
  __typename?: 'BuyerAppMarket';
  /** Blended Clearing Earn */
  blendedClearingEarn: Scalars['Float']['output'];
  /** Cash Pool Used */
  cashPoolUsed: Scalars['Float']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Market ID */
  id: Scalars['Float']['output'];
  /** Market Type */
  marketType?: Maybe<Scalars['String']['output']>;
  /** Market Yield */
  marketYield: Scalars['Float']['output'];
  /** Not Accepted Earn */
  notAcceptedEarn: Scalars['Float']['output'];
  /** Product Type */
  productType?: Maybe<Scalars['String']['output']>;
  /** Market UUID */
  uuid: Scalars['String']['output'];
};

export type BuyerAppMarketSettingsDualAuthorizationOutput = {
  __typename?: 'BuyerAppMarketSettingsDualAuthorizationOutput';
  /** Pending Dual Auth Request for adjustment tolerance update */
  adjustmentTolerance?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for apr update */
  aprSettings?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for cash pool update */
  cashPool?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for cash pool schedule update */
  cashPoolSchedule?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for min income update */
  minimumIncome?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for reserve update */
  reserve?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for restriction update */
  restriction?: Maybe<BuyerAppDualAuthorization>;
};

export type BuyerAppMarketTakerConfiguration = {
  __typename?: 'BuyerAppMarketTakerConfiguration';
  minReturnAmount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppMarketTakerReserveSetting = {
  __typename?: 'BuyerAppMarketTakerReserveSetting';
  allowEslapUpdates?: Maybe<Scalars['Boolean']['output']>;
  invoicePriority?: Maybe<Scalars['String']['output']>;
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  reserveReason?: Maybe<Scalars['String']['output']>;
  runBeforeAdjustments?: Maybe<Scalars['Boolean']['output']>;
};

export type BuyerAppMinEarnSettingsInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Minimum Income from the market */
  minEarn: Scalars['Float']['input'];
};

export type BuyerAppMonthlyCurrencyWiseScfDisclosure = {
  __typename?: 'BuyerAppMonthlyCurrencyWiseScfDisclosure';
  currency: Scalars['String']['output'];
  monthlyDisclosures: Array<BuyerAppMonthlyDisclosures>;
};

export type BuyerAppMonthlyDisclosures = {
  __typename?: 'BuyerAppMonthlyDisclosures';
  endingBalance: Scalars['Float']['output'];
  grossAmountExpedited: Scalars['Float']['output'];
  grossAmountReimbursed: Scalars['Float']['output'];
  period: Scalars['DateTime']['output'];
};

export type BuyerAppMonthlyScfDisclosure = {
  __typename?: 'BuyerAppMonthlyScfDisclosure';
  currencyWiseMonthlyDisclosure: Array<BuyerAppMonthlyCurrencyWiseScfDisclosure>;
  fundingPartnerUuid: Scalars['String']['output'];
};

export type BuyerAppMonthlyScfDisclosureFundingPartnerInput = {
  /** Funded in currency */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Funding Partner Uuid */
  fundingPartnerUuid: Scalars['String']['input'];
};

export type BuyerAppMonthlyScfDisclosureInput = {
  /** Division Uuid */
  divisionUuid: Scalars['String']['input'];
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Funding Partner Info */
  fundingPartners: Array<BuyerAppMonthlyScfDisclosureFundingPartnerInput>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

/** Monthly SCF disclosure data with data gap metadata for incomplete funder-currency combinations */
export type BuyerAppMonthlyScfDisclosureOutput = {
  __typename?: 'BuyerAppMonthlyScfDisclosureOutput';
  /** Data gaps detected for funder-currency combinations */
  dataGaps: Array<BuyerAppScfDataGap>;
  /** Monthly disclosure data per funder */
  disclosures: Array<BuyerAppMonthlyScfDisclosure>;
};

export type BuyerAppNetworkGrowthDetailsOutput = {
  __typename?: 'BuyerAppNetworkGrowthDetailsOutput';
  /** awarded vendors count */
  awardedVendorsCount: Scalars['Float']['output'];
  /** loaded vendors count */
  loadedVendorsCount: Scalars['Float']['output'];
  /** participated vendors count */
  participatedVendorsCount: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** registered vendors count */
  registeredVendorsCount: Scalars['Float']['output'];
};

export type BuyerAppNonClearingTopOffers = {
  __typename?: 'BuyerAppNonClearingTopOffers';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyNotAcceptedEarn: Scalars['Float']['output'];
  baseCurrencyNotAcceptedInvoiceAmount: Scalars['Float']['output'];
  displayCurrency: Scalars['String']['output'];
  funder: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  notAcceptedAboveMinDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
};

export type BuyerAppNonClearingTopOffersInput = {
  filters: BuyerAppTopOffersFilters;
  paging: BuyerAppCursorPaging;
  sorting: BuyerAppNonClearingTopOffersSorting;
};

export type BuyerAppNonClearingTopOffersOutput = {
  __typename?: 'BuyerAppNonClearingTopOffersOutput';
  offers: Array<BuyerAppNonClearingTopOffers>;
  pageInfo: BuyerAppCursorPagingInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppNonClearingTopOffersSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Non_Clearing_Top_Offers_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppOffsetPaging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type BuyerAppParticipationBreakdownDetailsOutput = {
  __typename?: 'BuyerAppParticipationBreakdownDetailsOutput';
  /** new participants count */
  newParticipantsCount: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** repeat participants count */
  repeatParticipantsCount: Scalars['Float']['output'];
};

export type BuyerAppPerformanceByCurrencyData = {
  __typename?: 'BuyerAppPerformanceByCurrencyData';
  awardedAp?: Maybe<Scalars['Float']['output']>;
  awardedRate?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  loadedAp?: Maybe<Scalars['Float']['output']>;
  participatedAp?: Maybe<Scalars['Float']['output']>;
  participationRate?: Maybe<Scalars['Float']['output']>;
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppPerformanceByCurrencyDataInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Date */
  endDate: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppPerformanceByCurrencyDataOutput = {
  __typename?: 'BuyerAppPerformanceByCurrencyDataOutput';
  all?: Maybe<BuyerAppPerformanceByCurrencyData>;
  currency: Scalars['String']['output'];
  self?: Maybe<BuyerAppPerformanceByCurrencyData>;
  thirdParty?: Maybe<BuyerAppPerformanceByCurrencyData>;
};

export type BuyerAppPerformanceByCurrencyStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Date */
  endDate: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppPerformanceByCurrencyStatsOutput = {
  __typename?: 'BuyerAppPerformanceByCurrencyStatsOutput';
  awardedAp?: Maybe<Scalars['Float']['output']>;
  awardedRate?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  loadedAp?: Maybe<Scalars['Float']['output']>;
  participatedAp?: Maybe<Scalars['Float']['output']>;
  participationRate?: Maybe<Scalars['Float']['output']>;
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppPrematurityAdviceFilters = {
  /** end Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funder market UUIDs */
  marketUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppPrematurityAdviceInput = {
  divisionUuids: Array<Scalars['String']['input']>;
  filters: BuyerAppPrematurityAdviceFilters;
  organizationUuid: Scalars['String']['input'];
  paging: BuyerAppPrematurityAdvicePaging;
};

export type BuyerAppPrematurityAdviceOutput = {
  __typename?: 'BuyerAppPrematurityAdviceOutput';
  pageInfo: BuyerAppPrematurityAdvicePageInfo;
  rows: Array<BuyerAppPrematurityAdviceRow>;
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppPrematurityAdvicePageInfo = {
  __typename?: 'BuyerAppPrematurityAdvicePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppPrematurityAdvicePaging = {
  /** Keyset cursor of the last row on the current page. Set when moving forward. */
  end?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Int']['input'];
  /** Keyset cursor of the first row on the current page. Set when moving backward. */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppPrematurityAdviceRow = {
  __typename?: 'BuyerAppPrematurityAdviceRow';
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Invoice due date used for the report range */
  dueDate?: Maybe<Scalars['String']['output']>;
  fiscalYear?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['String']['output']>;
  originalAmountGrossVat?: Maybe<Scalars['String']['output']>;
  originalAmountNetVat?: Maybe<Scalars['String']['output']>;
  originalDueDate?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['String']['output'];
  survivingInvoiceDueDate?: Maybe<Scalars['String']['output']>;
  survivingInvoiceId?: Maybe<Scalars['String']['output']>;
  transactionType: Scalars['Float']['output'];
  voucherId?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppRepeatVsNewLoadedApOutput = {
  __typename?: 'BuyerAppRepeatVSNewLoadedApOutput';
  /** Newly Loaded AP */
  newlyLoadedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Repeat Loaded AP */
  repeatLoadedAp: Scalars['Float']['output'];
};

export type BuyerAppRepeatVsNewIncomeOutput = {
  __typename?: 'BuyerAppRepeatVsNewIncomeOutput';
  /** New Participants Income */
  newParticipantsIncome: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Repeat Participants Income */
  repeatParticipantsIncome: Scalars['Float']['output'];
};

export type BuyerAppRestrictionInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Restriction object */
  restriction: BuyerAppRestrictions;
};

export type BuyerAppRestrictions = {
  /** Max DPE value */
  maxDPE?: InputMaybe<Scalars['Float']['input']>;
  /** Max due Date */
  maxDueDate?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppRevShareGraphInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Pay Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Starting Pay Date */
  startDate: Scalars['String']['input'];
  timePeriod?: Time_Periods;
};

export type BuyerAppRevShareOutput = {
  __typename?: 'BuyerAppRevShareOutput';
  currency: Scalars['String']['output'];
  /** Name of the funder */
  funderName: Scalars['String']['output'];
  /** Funder's UUID */
  funderUuid: Scalars['String']['output'];
  payDate: Scalars['String']['output'];
  /** The buyer's region */
  region: Scalars['String']['output'];
  /** The revenue share amount */
  revShareAmount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppRole = {
  __typename?: 'BuyerAppRole';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Role Name */
  name: Scalars['String']['output'];
  /** Readable Role Name To Display */
  readableName: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppRoleConnection = {
  __typename?: 'BuyerAppRoleConnection';
  /** Array of edges. */
  edges: Array<BuyerAppRoleEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppRoleEdge = {
  __typename?: 'BuyerAppRoleEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppRole */
  node: BuyerAppRole;
};

export type BuyerAppRoleFilter = {
  and?: InputMaybe<Array<BuyerAppRoleFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppRoleFilter>>;
  readableName?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppRoleSort = {
  direction: SortDirection;
  field: BuyerAppRoleSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppRoleSortFields =
  | 'id'
  | 'name'
  | 'readableName';

/** Represents a data gap detected for a specific funder-currency combination */
export type BuyerAppScfDataGap = {
  __typename?: 'BuyerAppScfDataGap';
  /** Currency code affected */
  currency: Scalars['String']['output'];
  /** Funding partner UUID with the data gap */
  fundingPartnerUuid: Scalars['String']['output'];
  /** List of missing month periods (YYYY-MM-DD format) */
  missingMonths: Array<Scalars['String']['output']>;
};

export type BuyerAppScfDisclosureTimeframeBoundariesInput = {
  /** Division Uuids */
  divisionUuids: Array<Scalars['String']['input']>;
};

export type BuyerAppScfDisclosureTimeframeBoundariesOutput = {
  __typename?: 'BuyerAppScfDisclosureTimeframeBoundariesOutput';
  divisionUuid: Scalars['String']['output'];
  funderWiseTimeframeBoundaries: Array<BuyerAppFunderWiseScfTimeframeBoundaries>;
};

export type BuyerAppSubprocessorsSubscription = {
  __typename?: 'BuyerAppSubprocessorsSubscription';
  /** created */
  created: Scalars['DateTime']['output'];
  /** Email Address */
  emailAddress: Scalars['String']['output'];
  /** Entity Name */
  entityName: Scalars['String']['output'];
  /** id */
  id: Scalars['Float']['output'];
  /** Subscription status */
  isActive: Scalars['Boolean']['output'];
  /** Organization Uuid */
  organizationUuid: Scalars['String']['output'];
  /** Role at Entity */
  role: Scalars['String']['output'];
  /** Subscribed By */
  subscribedBy: Scalars['String']['output'];
  /** updated */
  updated: Scalars['DateTime']['output'];
};

export type BuyerAppSubprocessorsSubscriptionFilter = {
  and?: InputMaybe<Array<BuyerAppSubprocessorsSubscriptionFilter>>;
  id?: InputMaybe<NumberFieldComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<BuyerAppSubprocessorsSubscriptionFilter>>;
  organizationUuid?: InputMaybe<StringFieldComparison>;
  subscribedBy?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppSubprocessorsSubscriptionSort = {
  direction: SortDirection;
  field: BuyerAppSubprocessorsSubscriptionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppSubprocessorsSubscriptionSortFields =
  | 'id'
  | 'isActive'
  | 'organizationUuid'
  | 'subscribedBy';

export type BuyerAppSupplierAdjustedInvoices = {
  __typename?: 'BuyerAppSupplierAdjustedInvoices';
  adjInvoiceId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  /** The status of the adjusted invoice */
  status: Adjustment_Status;
  voucherId: Scalars['String']['output'];
};

export type BuyerAppSupplierAdjustmentsFilters = {
  /** Buyer's Market UUID */
  marketUuid: Scalars['String']['input'];
  /** The status of the adjusted invoice */
  status?: Adjustment_Status;
  /** Supplier UUID */
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierAdjustmentsInput = {
  filters: BuyerAppSupplierAdjustmentsFilters;
  paging: BuyerAppOffsetPaging;
  sorting?: InputMaybe<BuyerAppSupplierAdjustmentsSorting>;
};

export type BuyerAppSupplierAdjustmentsOutput = {
  __typename?: 'BuyerAppSupplierAdjustmentsOutput';
  adjustedInvoices: Array<BuyerAppSupplierAdjustedInvoices>;
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppSupplierAdjustmentsSorting = {
  orderLevel: Supplier_Adjustments_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppSupplierClearHistoryInput = {
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  marketUuid: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
  timePeriod?: Scalars['String']['input'];
};

export type BuyerAppSupplierClearHistoryOutput = {
  __typename?: 'BuyerAppSupplierClearHistoryOutput';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppSupplierDetailsInput = {
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierDetailsOutput = {
  __typename?: 'BuyerAppSupplierDetailsOutput';
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  isParticipating?: Maybe<Scalars['Boolean']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppSupplierInvoices = {
  __typename?: 'BuyerAppSupplierInvoices';
  adjustmentAmount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  /** Yield on the invoice */
  blendedReturnAmount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  earn?: Maybe<Scalars['Float']['output']>;
  /** Invoice Id */
  id: Scalars['Float']['output'];
  isPastDue: Scalars['Boolean']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  makerExcluded: Scalars['Boolean']['output'];
  minDiscount?: Maybe<Scalars['Float']['output']>;
  originalAmount?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the invoice */
  status: Scalars['String']['output'];
  voucherId: Scalars['String']['output'];
};

export type BuyerAppSupplierInvoicesFilters = {
  /** The status of the invoice */
  invoiceType: Invoice_Type;
  /** Is the market third party funded? */
  isFundedMarket?: Scalars['Boolean']['input'];
  /** Buyer's Market UUID */
  marketUuid: Scalars['String']['input'];
  /** Invoice ID search string */
  search?: InputMaybe<Scalars['String']['input']>;
  /** The status of the invoice */
  status: Scalars['String']['input'];
  /** Supplier UUID */
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierInvoicesInput = {
  filters: BuyerAppSupplierInvoicesFilters;
  paging: BuyerAppOffsetPaging;
  sorting?: InputMaybe<BuyerAppSupplierInvoicesSorting>;
};

export type BuyerAppSupplierInvoicesOutput = {
  __typename?: 'BuyerAppSupplierInvoicesOutput';
  invoices: Array<BuyerAppSupplierInvoices>;
  makerUuid: Scalars['String']['output'];
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppSupplierInvoicesSorting = {
  orderLevel: Supplier_Invoices_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppSupplierOffer = {
  __typename?: 'BuyerAppSupplierOffer';
  acceptedDpeWeightedAvg: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedYield: Scalars['Float']['output'];
  audit: BuyerAppSupplierOfferAudit;
  config: BuyerAppSupplierOfferConfig;
  currency: Scalars['String']['output'];
  divisionUuid: Scalars['String']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  isParticipating: Scalars['Boolean']['output'];
  lastClearDate?: Maybe<Scalars['String']['output']>;
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  notAcceptedAboveMinDiscountedAmount: Scalars['Float']['output'];
  notAcceptedAboveMinEarn: Scalars['Float']['output'];
  notAcceptedAboveMinInvoiceAmount: Scalars['Float']['output'];
  notAcceptedAprWeightedAvg: Scalars['Float']['output'];
  notAcceptedDpeWeightedAvg: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield: Scalars['Float']['output'];
  orgUuid: Scalars['String']['output'];
  reserve: BuyerAppSupplierOfferReserve;
  takerDivisionName: Scalars['String']['output'];
  takerMakerId: Scalars['String']['output'];
  takerOrganizationName: Scalars['String']['output'];
  takerUuid: Scalars['String']['output'];
};

export type BuyerAppSupplierOfferAudit = {
  __typename?: 'BuyerAppSupplierOfferAudit';
  adjustmentInvoiceAmount: Scalars['Float']['output'];
  coveringAdjustmentAmount: Scalars['Float']['output'];
  reservedAmount: Scalars['Float']['output'];
  totalAp?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppSupplierOfferConfig = {
  __typename?: 'BuyerAppSupplierOfferConfig';
  minReturnAmount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppSupplierOfferReserve = {
  __typename?: 'BuyerAppSupplierOfferReserve';
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppSupplierPerformanceReportInput = {
  /** market uuids */
  marketUuids: Array<Scalars['String']['input']>;
  /** display currency */
  periods: Array<BuyerAppYoyReportPeriod>;
};

export type BuyerAppSupplierPerformanceReportOutput = {
  __typename?: 'BuyerAppSupplierPerformanceReportOutput';
  /** Awarded Vendors */
  awardedSuppliers?: Maybe<Scalars['Float']['output']>;
  /** Loaded Vendors */
  eligibleSuppliers: Scalars['Float']['output'];
  /** Newly Loaded Vendors */
  newlyLoadedSuppliers: Scalars['Float']['output'];
  /** Newly Participated Vendors */
  newlyParticipatedSuppliers: Scalars['Float']['output'];
  /** Participated Vendors */
  participatedSuppliers: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Registered Suppliers */
  registeredSuppliers: Scalars['Float']['output'];
  /** Total Loaded Vendors */
  totalLoadedSuppliers: Scalars['Float']['output'];
};

export type BuyerAppSupplierSettingsInput = {
  /** Market Uuid of the Buyer */
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierSettingsOutput = {
  __typename?: 'BuyerAppSupplierSettingsOutput';
  config: BuyerAppMarketTakerConfiguration;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  reserve: BuyerAppMarketTakerReserveSetting;
};

export type BuyerAppSupplierStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  marketUuids?: Array<Scalars['String']['input']>;
};

export type BuyerAppSupplierStatsOutput = {
  __typename?: 'BuyerAppSupplierStatsOutput';
  clearingAp?: Maybe<Scalars['Float']['output']>;
  clearingSuppliersCount: Scalars['Int']['output'];
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  eligibleSuppliersCount: Scalars['Int']['output'];
  nonClearingAp?: Maybe<Scalars['Float']['output']>;
  nonClearingSuppliersCount: Scalars['Int']['output'];
  overallTotal: Scalars['Int']['output'];
  overallWithAp: Scalars['Int']['output'];
  overallWithoutAp: Scalars['Int']['output'];
  participatingAp?: Maybe<Scalars['Float']['output']>;
  participatingSuppliersCount: Scalars['Int']['output'];
  participatingTotal: Scalars['Int']['output'];
  participatingWithAp: Scalars['Int']['output'];
  participatingWithoutAp: Scalars['Int']['output'];
  registeredTotal: Scalars['Int']['output'];
  registeredWithAp: Scalars['Int']['output'];
  registeredWithoutAp: Scalars['Int']['output'];
};

export type BuyerAppSuppliersOffersFilters = {
  advancedFilters: Array<Suppliers_Offers_Advanced_Filter>;
  displayCurrency?: Scalars['String']['input'];
  fundedMarkets: Array<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppSuppliersOffersInput = {
  filters: BuyerAppSuppliersOffersFilters;
  paging: BuyerAppSuppliersOffersPaging;
  sorting: BuyerAppSuppliersOffersSorting;
};

export type BuyerAppSuppliersOffersOutput = {
  __typename?: 'BuyerAppSuppliersOffersOutput';
  offers: Array<BuyerAppSupplierOffer>;
  pageInfo: BuyerAppSuppliersOffersPageInfo;
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppSuppliersOffersPageInfo = {
  __typename?: 'BuyerAppSuppliersOffersPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppSuppliersOffersPaging = {
  end?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Float']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppSuppliersOffersSorting = {
  orderLevel?: Suppliers_Offers_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppTopOffersFilters = {
  displayCurrency?: Scalars['String']['input'];
  /** Funded Markets Information */
  fundedMarkets: Array<BuyerAppFundedMarketInfo>;
  /** The market UUIDs of self funded markets */
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppTriggerManualAwardInput = {
  awardWithCashPool: Scalars['Boolean']['input'];
  divisionUuid: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppTriggerManualAwardOutput = {
  __typename?: 'BuyerAppTriggerManualAwardOutput';
  isAwarded: Scalars['Boolean']['output'];
};

export type BuyerAppUpdateMarketTakerReserveInput = {
  allowEslapUpdates: Scalars['Boolean']['input'];
  divisionUuid: Scalars['String']['input'];
  invoicePriority: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  reserveAmount?: InputMaybe<Scalars['Float']['input']>;
  reservePercentage?: InputMaybe<Scalars['Float']['input']>;
  reserveReason?: InputMaybe<Scalars['String']['input']>;
  runBeforeAdjustments: Scalars['Boolean']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppUpdateMarketTakerReserveOutput = {
  __typename?: 'BuyerAppUpdateMarketTakerReserveOutput';
  allowEslapUpdates: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoicePriority: Scalars['String']['output'];
  marketId: Scalars['Int']['output'];
  publishMessages: Scalars['Boolean']['output'];
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  reserveReason?: Maybe<Scalars['String']['output']>;
  runBeforeAdjustments: Scalars['Boolean']['output'];
  takerId: Scalars['Int']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppUpsertDivisionRolesInput = {
  /** Division uuid */
  divisionUuid: Scalars['String']['input'];
  /** Is the income to be displayed? */
  showIncome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the yield to be displayed? */
  showYield?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuyerAppUserDetails = {
  __typename?: 'BuyerAppUserDetails';
  /** Email address of the user */
  emailAddress: Scalars['String']['output'];
  /** First name of the user */
  firstName: Scalars['String']['output'];
  /** True if the user is a C2FO employee */
  isC2FO: Scalars['Boolean']['output'];
  /** Last login timestamp (ISO string) */
  lastLogin?: Maybe<Scalars['String']['output']>;
  /** Last name of the user */
  lastName: Scalars['String']['output'];
  /** Locale of the user */
  locale: Scalars['String']['output'];
  /** Auth service UUID of the user */
  userUuid: Scalars['String']['output'];
};

export type BuyerAppUserFiltersOutput = {
  __typename?: 'BuyerAppUserFiltersOutput';
  /** Division ID */
  divisionId: Scalars['Float']['output'];
  /** Division Name */
  divisionName: Scalars['String']['output'];
  /** Division UUID */
  divisionUuid: Scalars['String']['output'];
  /** Whether the division has COGS market */
  isDivisionHasCogsMarket: Scalars['Boolean']['output'];
  /** Maker Organization Name */
  makerOrganizationName: Scalars['String']['output'];
  /** Maker Organization UUID */
  makerOrganizationUuid: Scalars['String']['output'];
  /** List of markets */
  markets: Array<BuyerAppMarket>;
  /** Whether the income is to be shown */
  showIncome?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the revenue share is to be shown */
  showRevShare: Scalars['Boolean']['output'];
  /** Whether the yield is to be shown */
  showYield?: Maybe<Scalars['Boolean']['output']>;
};

export type BuyerAppUserPreference = {
  __typename?: 'BuyerAppUserPreference';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** User preference settings */
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type BuyerAppYoyReportPeriod = {
  /** End Date */
  endDate: Scalars['String']['input'];
  /** Starting Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAuditConfigDefaultResponse = {
  __typename?: 'BuyerAuditConfigDefaultResponse';
  message: Scalars['String']['output'];
};

export type BuyerAuditConfigDto = {
  auditFileCount: Scalars['Float']['input'];
  effectiveTillDate: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
};

export type BuyerAuditConfigType =
  | 'dynamic'
  | 'static';

export type BuyerFileConfigs = {
  /** Benchmark strategy configuration */
  benchmarkStrategyConfig: BenchmarkStrategyInput;
  /** Economic value */
  economicValueConfig: Scalars['Float']['input'];
  /** Supplier segmentation rules */
  supplierSegmentationConfig: SegmentationRules;
};

export type BuyerReportingCurrencies = {
  __typename?: 'BuyerReportingCurrencies';
  created: Scalars['DateTime']['output'];
  /** Custom currency configured for the buyer */
  currency: Scalars['String']['output'];
  /** Organization Name */
  organizationName: Scalars['String']['output'];
  /** Organization UUID */
  organizationUuid: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerReportingCurrenciesDeleteFilter = {
  and?: InputMaybe<Array<BuyerReportingCurrenciesDeleteFilter>>;
  currency: StringFieldComparison;
  or?: InputMaybe<Array<BuyerReportingCurrenciesDeleteFilter>>;
  organizationUuid: StringFieldComparison;
};

export type BuyerReportingCurrenciesEdge = {
  __typename?: 'BuyerReportingCurrenciesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerReportingCurrencies */
  node: BuyerReportingCurrencies;
};

export type BuyerReportingCurrenciesInput = {
  /** Organization UUID */
  organizationUuid: Scalars['String']['input'];
};

export type BuyerReportingCurrenciesOutput = {
  __typename?: 'BuyerReportingCurrenciesOutput';
  /** Custom currencies configured for the buyer */
  currencies: Array<Scalars['String']['output']>;
};

export type C2foColumnMaster = {
  __typename?: 'C2foColumnMaster';
  columnName: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  source: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type C2foColumnMasterConnection = {
  __typename?: 'C2foColumnMasterConnection';
  /** Array of nodes. */
  nodes: Array<C2foColumnMaster>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type C2foColumnMasterFilter = {
  and?: InputMaybe<Array<C2foColumnMasterFilter>>;
  or?: InputMaybe<Array<C2foColumnMasterFilter>>;
  source?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type C2foColumnMasterSort = {
  direction: SortDirection;
  field: C2foColumnMasterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type C2foColumnMasterSortFields =
  | 'source'
  | 'uuid';

export type Clearing_Top_Offers_Order_Level =
  | 'ACCEPTED_DPE_WEIGHTED_AVG'
  | 'ACCEPTED_EARN'
  | 'ACCEPTED_INVOICE_AMOUNT'
  | 'ACCEPTED_YIELD'
  | 'ELIGIBLE_INVOICE_AMOUNT';

export type CashInvested = {
  __typename?: 'CashInvested';
  investmentDate?: Maybe<Scalars['DateTime']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  normalizedCashInvested?: Maybe<Scalars['Float']['output']>;
};

export type CashInvestedGroupByInput = {
  aggregationLevel?: InputMaybe<AggregationLevel>;
  timePeriod?: GroupByTimePeriod;
};

export type CashInvestedInput = {
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy: CashInvestedGroupByInput;
  makerOrganizationUuids?: Array<Scalars['String']['input']>;
  makerUuids?: Array<Scalars['String']['input']>;
  marketUuids?: Array<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<TimeRange>;
};

export type CashPoolScheduleOutput = {
  __typename?: 'CashPoolScheduleOutput';
  /** Cash Pool amount to be replenished  */
  cashPool?: Maybe<Scalars['Float']['output']>;
  /** Recurring replenishment rule */
  rrule?: Maybe<Scalars['String']['output']>;
  /** Cash Pool Replenishment Schedule Uuid */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CashPoolSettingsOutput = {
  __typename?: 'CashPoolSettingsOutput';
  /** Market APR */
  apr?: Maybe<Scalars['Float']['output']>;
  /** Cash Available for the market */
  cashPool?: Maybe<Scalars['Float']['output']>;
  /** Cash pool limit */
  cashPoolLimit?: Maybe<Scalars['Float']['output']>;
  /** Outstanding cash pool amount */
  cashPoolOutstanding?: Maybe<Scalars['Float']['output']>;
  /** Cash pool management strategy */
  managementStrategy?: Maybe<Scalars['String']['output']>;
  /** Minimum APR from the market */
  minApr?: Maybe<Scalars['Float']['output']>;
  /** Minimum Income from the market */
  minEarn?: Maybe<Scalars['Float']['output']>;
};

export type CashPoolSettingsUnionBuyerAppDualAuthorization = BuyerAppDualAuthorization | CashPoolSettingsOutput;

export type CashUsed = {
  __typename?: 'CashUsed';
  normalizedCashUsed?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CashUsedInput = {
  aggregationLevel: AggregationLevel;
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: GroupByTimePeriod;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<TimeRange>;
  uuids?: Array<Scalars['String']['input']>;
};

export type ChangeStatusWcmPaymentTermConfigInput = {
  /** Active status */
  isActive: Scalars['Boolean']['input'];
};

/** Audit action for cleanup non-paid buyer mappings operation */
export type CleanupNonPaidMappingsAuditAction =
  | 'WCM_OTHER_NON_PAID_USERS_MAPPINGS_DELETED_BECAUSE_OF_FIRST_ENRICHED_FILE_UPLOAD';

export type CleanupOtherWcmNonPaidMappingsForBuyerUsersInput = {
  /** UUID of the actor user performing the cleanup */
  actorUserUuid: Scalars['String']['input'];
  /** Audit action for the cleanup operation */
  auditAction: CleanupNonPaidMappingsAuditAction;
  /** If true, validates that the provided buyer is a Trial buyer before performing cleanup. Skips cleanup if buyer is not Trial type. */
  cleanupOnlyIfProvidedBuyerIsTrial?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of the buyer to clean up other non-paid mappings for */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CleanupOtherWcmNonPaidMappingsForBuyerUsersOutput = {
  __typename?: 'CleanupOtherWcmNonPaidMappingsForBuyerUsersOutput';
  /** Number of other non-paid buyer mappings deleted for non-C2FO users associated with the given buyer */
  deletedCount: Scalars['Int']['output'];
  /** UUIDs of the users affected */
  userUuids: Array<Scalars['String']['output']>;
};

export type ClearingStatsInput = {
  makerUuids?: Array<Scalars['String']['input']>;
  marketUuids?: Array<Scalars['String']['input']>;
  orgUuids?: Array<Scalars['String']['input']>;
};

export type ClearingStatsOutput = {
  __typename?: 'ClearingStatsOutput';
  acceptedDiscountedAmount: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedCompanies: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedTakersCount: Scalars['Float']['output'];
  notAcceptedWeightedYield: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  weightedClearedYield: Scalars['Float']['output'];
};

export type CompanyGroup = {
  __typename?: 'CompanyGroup';
  companyGroupName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  epCompanyGroupUuid?: Maybe<Scalars['String']['output']>;
  programUuid: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyGroupFilter = {
  and?: InputMaybe<Array<CompanyGroupFilter>>;
  or?: InputMaybe<Array<CompanyGroupFilter>>;
  programUuid: StringFieldComparison;
};

export type CompanyGroupInput = {
  companyGroupUuid: Scalars['String']['input'];
  isDsf: Scalars['Boolean']['input'];
};

export type CompanyGroupSort = {
  direction: SortDirection;
  field: CompanyGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type CompanyGroupSortFields =
  | 'programUuid';

export type CompanyIdGroupOutputResponse = {
  __typename?: 'CompanyIdGroupOutputResponse';
  message: Scalars['String']['output'];
};

export type CompanyIdUpload = {
  __typename?: 'CompanyIdUpload';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  makerDataCenter: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  processed: Scalars['Boolean']['output'];
  programUuid: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyIntersectionSortField =
  | 'COMPANY_GROUP'
  | 'COMPANY_ID'
  | 'CURRENCY'
  | 'LOCATION'
  | 'SUPPLIER_NAME';

export type CreateAgreementInput = {
  cmsId: Scalars['String']['input'];
  marketId: Scalars['ID']['input'];
};

export type CreateBuyerAppDivisionReportingCurrenciesInput = {
  /** currency */
  currency: Scalars['String']['input'];
  /** Division Name */
  divisionName: Scalars['String']['input'];
  /** Division UUID */
  divisionUuid: Scalars['String']['input'];
  /** Report Type */
  reportType: Report_Type;
};

export type CreateBuyerAppEverafterBuyerConfig = {
  accountId: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  divisionUuid: Scalars['String']['input'];
  embedLocationId: Scalars['String']['input'];
  personaName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateBuyerReportingCurrenciesInput = {
  /** Custom currency configured for the buyer */
  currency: Scalars['String']['input'];
  /** Organization name */
  organizationName: Scalars['String']['input'];
  /** Organization UUID */
  organizationUuid: Scalars['String']['input'];
};

export type CreateCompanyGroupInput = {
  companyGroupName: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
  qualifiedSupplierInput: Array<QualifiedSupplierInput>;
};

export type CreateCompanyGroupOutput = {
  __typename?: 'CreateCompanyGroupOutput';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreateCustomAgreementInput = {
  /** Name of the agreement */
  agreementName: Scalars['String']['input'];
  /** Content of the agreement */
  content: Scalars['String']['input'];
  /** Is agreement for 3rd party funders */
  is3rdPartyAgreement: Scalars['Boolean']['input'];
  /** Jira Reference required for agreement creation */
  jiraReference: Scalars['String']['input'];
  /** Path is a combination of region, country and locale */
  path: Scalars['String']['input'];
  /** Status of the agreement */
  status: Scalars['String']['input'];
  /** Title of the agreement */
  title: Scalars['String']['input'];
};

export type CreateCustomAgreementResponse = {
  __typename?: 'CreateCustomAgreementResponse';
  message: Scalars['String']['output'];
};

export type CreateFunderCalculationsInput = {
  funderUuid: Scalars['String']['input'];
  interestCalcOutputStrategy: Scalars['String']['input'];
  paymentMethods: Scalars['String']['input'];
  priceTypes: Scalars['String']['input'];
  rateSelectionStrategy: Scalars['String']['input'];
};

export type CreateFunderCurrenciesInput = {
  bankingDays: Scalars['Float']['input'];
  currencyLookupId: Scalars['Float']['input'];
  funderUuid: Scalars['String']['input'];
  rateSource: Scalars['String']['input'];
  refRateFloor: Scalars['Float']['input'];
  referenceRate: Scalars['String']['input'];
};

export type CreateFunderFeedbackConfigInputDto = {
  funderUuid: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  isInvoiceAmountComputed: Scalars['Boolean']['input'];
};

export type CreateFunderFeedbackPipelineConfigInput = {
  ackType: Scalars['String']['input'];
  aggregationConfig?: InputMaybe<Scalars['JSON']['input']>;
  filenamePattern: Scalars['String']['input'];
  funderUuid: Scalars['String']['input'];
  lookupType: Scalars['String']['input'];
  parserConfig: Scalars['JSON']['input'];
  parserType: Scalars['String']['input'];
  targetDcs?: InputMaybe<Array<Scalars['String']['input']>>;
  transformConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateFunderGeographiesInput = {
  funderUuid: Scalars['String']['input'];
  geographyLookupId: Scalars['Float']['input'];
  includeExclude: Scalars['String']['input'];
};

export type CreateFunderLegalSetupInput = {
  agreementType: Scalars['String']['input'];
  funderUuid: Scalars['String']['input'];
  termsAndConditionsUrl: Scalars['String']['input'];
};

export type CreateManyAgreementAuditsInput = {
  /** Array of records to create */
  agreementAudits: Array<AgreementAuditInput>;
};

export type CreateManyAgreementsInput = {
  /** Array of records to create */
  agreements: Array<CreateAgreementInput>;
};

export type CreateManyBuyerAppDivisionRegionsInput = {
  /** Array of records to create */
  buyerAppDivisionRegions: Array<BuyerAppDivisionRegionInput>;
};

export type CreateManyBuyerAppDivisionReportingCurrenciesInput = {
  /** Array of records to create */
  buyerAppDivisionReportingCurrencies: Array<CreateBuyerAppDivisionReportingCurrenciesInput>;
};

export type CreateManyBuyerAppDivisionsUsersRolesInput = {
  /** Array of records to create */
  buyerAppDivisionsUsersRoles: Array<BuyerAppDivisionsUsersRolesInput>;
};

export type CreateManyBuyerAppDualAuthorizationRolesInput = {
  /** Array of records to create */
  buyerAppDualAuthorizationRoles: Array<BuyerAppDualAuthorizationRolesInput>;
};

export type CreateManyBuyerReportingCurrenciesInput = {
  /** Array of records to create */
  buyerReportingCurrencies: Array<CreateBuyerReportingCurrenciesInput>;
};

export type CreateManyFunderVariablesInput = {
  /** Array of records to create */
  funderVariables: Array<FunderVariableInput>;
};

export type CreateManyRecordGroupColumnDtosInput = {
  /** Array of records to create */
  recordGroupColumnDtos: Array<CreateRecordGroupColumnDto>;
};

export type CreateManyWcmUserBuyerMappingDetailsInput = {
  /** User buyer mapping details, max limit 50 */
  wcmUserBuyerMappingDetails: Array<WcmUserBuyerMapping>;
};

export type CreateOneAgreementAuditInput = {
  /** The record to create */
  agreementAudit: AgreementAuditInput;
};

export type CreateOneAgreementInput = {
  /** The record to create */
  agreement: CreateAgreementInput;
};

export type CreateOneBuyerAppEverafterBuyerConfigInput = {
  /** The record to create */
  buyerAppEverafterBuyerConfig: CreateBuyerAppEverafterBuyerConfig;
};

export type CreateOneFunderDeliverySettingsDtoInput = {
  /** The record to create */
  funderDeliverySettingsDto: FunderDeliverySettingsInputDto;
};

export type CreateOneFunderFeedbackConfigInput = {
  /** The record to create */
  funderFeedbackConfig: CreateFunderFeedbackConfigInputDto;
};

export type CreateOneFunderFileInput = {
  buyerGeneratedUseForReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  deliverySettings: FunderFileDeliverySettingsInput;
  fileNameFormat: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  funder: Scalars['String']['input'];
  funderFileType: Scalars['String']['input'];
  reconColumnDetails?: InputMaybe<ReconColumnDetailsInput>;
  serializer: SerializerSettingsInput;
  subType: Scalars['String']['input'];
  writerType: Scalars['String']['input'];
  x509SignedZipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneFunderInput = {
  name: Scalars['String']['input'];
};

export type CreateOneFunderNotificationConfigInput = {
  email: Array<Scalars['String']['input']>;
  funder: Scalars['String']['input'];
  funderFiles: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFunderVariableInput = {
  /** The record to create */
  funderVariable: FunderVariableInput;
};

export type CreateOneRecordGroupColumnDtoInput = {
  /** The record to create */
  recordGroupColumnDto: CreateRecordGroupColumnDto;
};

/** Basic users personal information. */
export type CreatePersonalInfoInput = {
  address: CreateUserAddressInput;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiscalYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProgramFileSetDetails = {
  filterColumn: Scalars['String']['input'];
  funderFileType?: InputMaybe<FunderFileType>;
  name: Scalars['String']['input'];
  paymentWriterType: Scalars['String']['input'];
};

export type CreateProgramInput = {
  funderUuid: Scalars['ID']['input'];
  makerUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  programName: Scalars['String']['input'];
};

export type CreateRecordGroupColumnDto = {
  columnOrder: Scalars['Float']['input'];
  displayName: Scalars['String']['input'];
  funderFileColumnId: Scalars['String']['input'];
  groupBy: Scalars['Boolean']['input'];
  isBatchColumn: Scalars['Boolean']['input'];
  isInvoiceColumn: Scalars['Boolean']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isTransactionColumn: Scalars['Boolean']['input'];
  mergeConfig?: InputMaybe<MergeConfigInput>;
  recordGroupId: Scalars['String']['input'];
  serializerConfig?: InputMaybe<SerializerColumnSettingsInput>;
  sortBy: Scalars['Boolean']['input'];
  transformationConfig?: InputMaybe<Scalars['JSON']['input']>;
  uuid: Scalars['String']['input'];
};

export type CreateRecordGroupColumnInputDto = {
  columnOrder: Scalars['Float']['input'];
  displayName: Scalars['String']['input'];
  funderFileColumnId: Scalars['String']['input'];
  groupBy: Scalars['Boolean']['input'];
  isBatchColumn: Scalars['Boolean']['input'];
  isInvoiceColumn: Scalars['Boolean']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isTransactionColumn: Scalars['Boolean']['input'];
  mergeConfig?: InputMaybe<MergeConfigInput>;
  recordGroupId?: InputMaybe<Scalars['String']['input']>;
  serializerConfig?: InputMaybe<SerializerColumnSettingsInput>;
  sortBy?: InputMaybe<Scalars['Boolean']['input']>;
  transformationConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateRecordGroupInput = {
  funderFileTemplateId: Scalars['String']['input'];
  isBatchRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isTransactionRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  recordGroupColumns: Array<CreateRecordGroupColumnInputDto>;
  recordGroupColumnsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  rgOrder: Scalars['Float']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** Requires a country code to help with data placement */
export type CreateUserAddressInput = {
  /** The 3 digit ISO-3166 code for country. We attempt to cleanse whatever is sent in into a supported code. */
  country: Scalars['String']['input'];
  /** Zip or postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** Information required to creating a user. Keep this slim. */
export type CreateUserInput = {
  createdBy: Scalars['String']['input'];
  createdSource: Scalars['String']['input'];
  divisionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  needsPasswordReset?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  personalInfo: CreatePersonalInfoInput;
  registration?: InputMaybe<RegistrationInfoInput>;
};

export type CreateUserMutationResponse = MutationResponse & {
  __typename?: 'CreateUserMutationResponse';
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type CreateUsersViaWcmInput = {
  /** List of users to create */
  users: Array<UserInputViaWcm>;
};

export type CreateUsersViaWcmOutput = {
  __typename?: 'CreateUsersViaWcmOutput';
  /** Number of users that already existed (200) */
  alreadyExisted: Scalars['Float']['output'];
  /** Number of failed user creations */
  failedCreations: Scalars['Float']['output'];
  /** Number of newly created users (201) */
  newlyCreated: Scalars['Float']['output'];
  /** Number of users onboarded to WCM */
  onboardedToWcm: Scalars['Float']['output'];
  /** Total number of users processed */
  totalUsers: Scalars['Float']['output'];
  /** List of created users with their results */
  users: Array<CreatedUserViaWcm>;
};

export type CreateWcmBuyerExclusionRemarkInput = {
  remark: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmCustomAttributeValueInput = {
  /** The value to add to the custom attribute */
  value: Scalars['String']['input'];
};

export type CreateWcmDashboardInput = {
  /** Dashboard description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional initial draft config (e.g. from a template) */
  draftConfig?: InputMaybe<Scalars['JSON']['input']>;
  /** Dashboard name. Defaults to "Untitled" when omitted or blank. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWcmDomainBuyerMappingsInput = {
  /** Array of buyer UUIDs to map to the domain */
  buyerUuids: Array<Scalars['String']['input']>;
  /** Domain name */
  domain: Scalars['String']['input'];
};

export type CreateWcmExternalBuyerMapInput = {
  /** Timestamp through which negotiations have been ingested in UTC */
  negotiationIngestedThroughAtUtc?: InputMaybe<Scalars['String']['input']>;
  /** Whether negotiation sync is enabled */
  negotiationSyncEnabled: Scalars['Boolean']['input'];
  /** External source id */
  sourceId: Scalars['String']['input'];
  /** External source name */
  sourceName: Scalars['String']['input'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmMasterBuyerList = {
  /** WCM Buyer Type */
  buyerType?: InputMaybe<Wcm_Buyer_Type>;
  /** WCM buyer data center */
  dataCenter: Scalars['String']['input'];
  /** WCM buyer name */
  wcmBuyerName: Scalars['String']['input'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmNewUserRegistrationInput = {
  businessEmail: Scalars['String']['input'];
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Wcm_User_Roles_For_Registration_Request;
};

export type CreateWcmNewUserRegistrationResponse = {
  __typename?: 'CreateWcmNewUserRegistrationResponse';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type CreateWcmPaymentTermConfigInput = {
  /** Effective payment term in days */
  effectiveTermDays?: InputMaybe<Scalars['Int']['input']>;
  /** Internal notes */
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Active status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the payment term is EOM-based */
  isEom: Scalars['Boolean']['input'];
  /** Payment term code */
  paymentTermCode: Scalars['String']['input'];
  /** Payment term description */
  paymentTermDescription: Scalars['String']['input'];
  /** Payment term tiers */
  tiers: Array<WcmPaymentTermConfigTierInput>;
};

export type CreateWcmPlanWaveInput = {
  /** Wave end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Wave name */
  name: Scalars['String']['input'];
  /** Owner of the wave */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Wave start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateWcmRoleWithAdminLevelPermissionsInput = {
  permissionNames: Array<Scalars['String']['input']>;
  roleName: Scalars['String']['input'];
  /** Auth service UUIDs of users to assign the role to (max 100). */
  userAuthUuids: Array<Scalars['String']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmRolesInput = {
  managedByC2foUsers?: InputMaybe<Scalars['Boolean']['input']>;
  permissionIds: Array<Scalars['ID']['input']>;
  roleName: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmSupplierGroupNoteInput = {
  /** Note content */
  content: Scalars['String']['input'];
  /** Vendor master ID identifying the supplier group */
  vendorMasterId: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmWcmRolesOutput = {
  __typename?: 'CreateWcmWcmRolesOutput';
  /** Number of new user–role assignments created (admin bulk assign mutation only). */
  assignedCount?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Boolean']['output'];
};

export type CreatedUserViaWcm = {
  __typename?: 'CreatedUserViaWcm';
  /** User email address */
  emailAddress: Scalars['String']['output'];
  /** Error message if operation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether user was newly created (true) or already existed (false) */
  isNewlyCreated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user needs password reset */
  needsPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user was onboarded to WCM */
  onboardedToWcm?: Maybe<Scalars['Boolean']['output']>;
  /** User password */
  password?: Maybe<Scalars['String']['output']>;
  /** Whether operation was successful */
  success: Scalars['Boolean']['output'];
  /** User UUID */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CryptographicSettings = {
  __typename?: 'CryptographicSettings';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  keys: Array<Scalars['String']['output']>;
  useBuyerKeys?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrenciesDto = {
  __typename?: 'CurrenciesDto';
  currencies: Array<Scalars['String']['output']>;
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomAgreement = {
  __typename?: 'CustomAgreement';
  /** Name of the agreement stored in S3 */
  agreementName: Scalars['String']['output'];
  /** Timestamp of creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** IP address of the creator */
  createdByIpAddress: Scalars['String']['output'];
  /** Is agreement for 3rd party funders */
  is3rdPartyAgreement: Scalars['Boolean']['output'];
  /** Reference ticket to create the agreement */
  jiraReference: Scalars['String']['output'];
  /** Latest version ID of the agreement */
  latestVersionId: Scalars['String']['output'];
  /** s3 path combined from region, country and locale */
  path: Scalars['String']['output'];
  /** Status of the agreement (draft, stage, or live) */
  status: AgreementStatusEnum;
  /** Timestamp of the last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** IP address of the last updater */
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  /** UUID of the custom agreement */
  uuid: Scalars['String']['output'];
};

export type CustomAgreementVersionHistory = {
  __typename?: 'CustomAgreementVersionHistory';
  /** Timestamp of the last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** IP address of the last updater */
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  /** Version ID of the agreement */
  versionId: Scalars['String']['output'];
};

export type CustomAgreementWithContent = {
  __typename?: 'CustomAgreementWithContent';
  /** Name of the agreement stored in S3 */
  agreementName: Scalars['String']['output'];
  /** Title of the agreement */
  agreementTitle: Scalars['String']['output'];
  /** Content of the agreement */
  content: Scalars['String']['output'];
  /** Timestamp of creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** IP address of the creator */
  createdByIpAddress: Scalars['String']['output'];
  /** Is agreement for 3rd party funders */
  is3rdPartyAgreement: Scalars['Boolean']['output'];
  /** Reference ticket to create the agreement */
  jiraReference: Scalars['String']['output'];
  /** Latest version ID of the agreement */
  latestVersionId: Scalars['String']['output'];
  /** s3 path combined from region, country and locale */
  path: Scalars['String']['output'];
  /** Status of the agreement (draft, stage, or live) */
  status: AgreementStatusEnum;
  /** Timestamp of the last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** IP address of the last updater */
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  /** UUID of the custom agreement */
  uuid: Scalars['String']['output'];
};

export type CustomAttributeInfo = {
  __typename?: 'CustomAttributeInfo';
  /** Display name of the custom attribute */
  displayName: Scalars['String']['output'];
  /** Internal name of the custom attribute */
  internalName: Scalars['String']['output'];
  /** Value assigned to the custom attribute, null if unassigned */
  value?: Maybe<Scalars['String']['output']>;
  /** ID of the value assigned to the custom attribute, null if unassigned */
  valueId?: Maybe<Scalars['Int']['output']>;
};

export type CustomAttributeValueDto = {
  __typename?: 'CustomAttributeValueDto';
  /** Number of spend assignments using this value (informational only) */
  assignmentCount: Scalars['Int']['output'];
  /** Unique ID of the value mapping */
  id: Scalars['Int']['output'];
  /** The actual text value */
  value: Scalars['String']['output'];
};

export type CustomAttributeValueResponseDto = {
  __typename?: 'CustomAttributeValueResponseDto';
  /** Unique ID of the value mapping */
  id: Scalars['Int']['output'];
  /** The actual text value */
  value: Scalars['String']['output'];
};

export type CustomerInput = {
  field?: IdentityFieldType;
  id: Scalars['String']['input'];
};

export type Dbt_Model =
  | 'BUYER_SUPPLIER_COUNT'
  | 'CORE_METRICS_BY_MARKET'
  | 'DPE_ANALYSIS'
  | 'NETWORK_GROWTH'
  | 'NEW_VS_REPEAT_PARTICIPANTS'
  | 'PARTICIPATION_SUMMARY'
  | 'REPEAT_VS_NEW_INCOME'
  | 'REPEAT_VS_NEW_LOADED_AP'
  | 'SCF_DISCLOSURE'
  | 'TOTAL_VS_NEW_SUPPLIERS';

export type DataMigrationOutput = {
  __typename?: 'DataMigrationOutput';
  message: Scalars['String']['output'];
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DeleteBuyerAppDualAuthInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be deleted */
  dualAuthId: Scalars['ID']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type DeleteManyBuyerAppDivisionReportingCurrenciesInput = {
  /** Filter to find records to delete */
  filter: BuyerAppDivisionReportingCurrenciesDeleteFilter;
};

export type DeleteManyBuyerAppDivisionsUsersRolesInput = {
  /** Filter to find records to delete */
  filter: BuyerAppDivisionsUsersRolesDeleteFilter;
};

export type DeleteManyBuyerAppDualAuthorizationRolesInput = {
  /** Filter to find records to delete */
  filter: BuyerAppDualAuthorizationRolesDeleteFilter;
};

export type DeleteManyBuyerReportingCurrenciesInput = {
  /** Filter to find records to delete */
  filter: BuyerReportingCurrenciesDeleteFilter;
};

export type DeleteManyFunderVariablesInput = {
  /** Filter to find records to delete */
  filter: FunderVariableDeleteFilter;
};

export type DeleteManyRecordGroupColumnDtosInput = {
  /** Filter to find records to delete */
  filter: RecordGroupColumnDtoDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int']['output'];
};

export type DeleteManyWcmBuyerUserMappingOutput = {
  __typename?: 'DeleteManyWcmBuyerUserMappingOutput';
  deletedCount: Scalars['Float']['output'];
  deletedWcmUserBuyerMappingDetails: Array<WcmBuyerUserMappingOutput>;
};

export type DeleteManyWcmMasterBuyersInput = {
  /** WCM buyer UUIDs to delete */
  wcmBuyerUuids: Array<Scalars['String']['input']>;
};

export type DeleteManyWcmUserBuyerMappingDetailsInput = {
  /** User buyer mapping details, max limit 50 */
  wcmUserBuyerMappingDetails: Array<WcmUserBuyerMapping>;
};

export type DeleteOneBuyerAppDivisionRegionInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneFunderFeedbackConfigInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneFunderVariableInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneRecordGroupColumnDtoInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteWcmBuyerExclusionRemarkInput = {
  id: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type DeleteWcmCustomAttributeValueResponse = {
  __typename?: 'DeleteWcmCustomAttributeValueResponse';
  /** Array of deleted values with their IDs */
  deletedValues: Array<DeletedCustomAttributeValue>;
  /** Confirmation message */
  message: Scalars['String']['output'];
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteWcmCustomAttributeValuesAllSelectedInput = {
  /** Optional filters applied when all values are selected */
  additionalFilters?: InputMaybe<DeleteWcmCustomAttributeValuesFiltersInput>;
  /** Must be true to indicate all matching values are selected */
  value?: Scalars['Boolean']['input'];
};

export type DeleteWcmCustomAttributeValuesFiltersInput = {
  /** Optional case-insensitive search filter applied when all values are selected */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteWcmCustomAttributeValuesInput = {
  /** All selected configuration */
  allSelected: DeleteWcmCustomAttributeValuesAllSelectedInput;
  currency: Scalars['String']['input'];
  /** Value IDs to exclude when allSelected.value is true */
  deselectedValueIds?: Array<Scalars['Float']['input']>;
  internalName: Scalars['String']['input'];
  /** Value IDs to delete when allSelected.value is false */
  selectedValueIds?: Array<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type DeleteWcmRoleInput = {
  roleId: Scalars['ID']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type DeleteWcmRoleOutput = {
  __typename?: 'DeleteWcmRoleOutput';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteWcmUsersInput = {
  userUuids: Array<Scalars['String']['input']>;
};

export type DeleteWcmUsersOutput = {
  __typename?: 'DeleteWcmUsersOutput';
  message: Scalars['String']['output'];
  totalUsersOffBoarded: Scalars['Float']['output'];
};

export type DeletedCustomAttributeValue = {
  __typename?: 'DeletedCustomAttributeValue';
  /** ID of the deleted value */
  id: Scalars['Int']['output'];
  /** Value that was deleted */
  value: Scalars['String']['output'];
};

export type DeliverySetting = {
  __typename?: 'DeliverySetting';
  fileName: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  funderName: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  programName: Scalars['String']['output'];
  settings: Settings;
};

export type DeliverySettingsOutput = {
  __typename?: 'DeliverySettingsOutput';
  deliverySettings: Array<DeliverySetting>;
};

export type Direction =
  | 'ASC'
  | 'DESC';

/**
 * The low level business entity that pays invoices (maker/buyer),
 * receives payment for invoices (taker/supplier), or both.
 * An organization can contain many divisions.
 * The backing data source is the `division` table.
 * NOTE: When querying for a single division by ID, the id field takes the division uuid as input.
 */
export type Division = {
  __typename?: 'Division';
  /** The Account for the Division. */
  account?: Maybe<Account>;
  /** The account this division belongs to. */
  accountId?: Maybe<Scalars['String']['output']>;
  annualSpend?: Maybe<Scalars['Float']['output']>;
  companyInfo?: Maybe<Scalars['JSON']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  eslap?: Maybe<Scalars['JSON']['output']>;
  eslapId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  /** Is the company a buyer (customer). A division can only be a supplier or buyer not both. */
  isBuyer?: Maybe<Scalars['Boolean']['output']>;
  /** Is the company a supplier (vendor). A division can only be a supplier or buyer not both. */
  isSupplier?: Maybe<Scalars['Boolean']['output']>;
  naics?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  /** List of services to include */
  serviceScope?: Maybe<Scalars['String']['output']>;
  /** SRM user associated with this Division through the Account assignment. */
  srm?: Maybe<Srm>;
  taxId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
  /** Division UUID */
  uuid: Scalars['String']['output'];
  wfcId?: Maybe<Scalars['Float']['output']>;
};

export type DivisionConnection = {
  __typename?: 'DivisionConnection';
  /** Array of edges. */
  edges: Array<DivisionEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DivisionEdge = {
  __typename?: 'DivisionEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Division */
  node: Division;
};

export type DivisionFilter = {
  and?: InputMaybe<Array<DivisionFilter>>;
  eslapId?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<NumberFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DivisionFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  serviceScope?: InputMaybe<DivisionServiceScopeFilterComparison>;
  taxId?: InputMaybe<StringFieldComparison>;
  users?: InputMaybe<DivisionFilterUserFilter>;
  uuid?: InputMaybe<StringFieldComparison>;
  wfcId?: InputMaybe<NumberFieldComparison>;
};

export type DivisionFilterUserFilter = {
  and?: InputMaybe<Array<DivisionFilterUserFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DivisionFilterUserFilter>>;
};

export type DivisionServiceScopeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DivisionSort = {
  direction: SortDirection;
  field: DivisionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type DivisionSortFields =
  | 'eslapId'
  | 'id'
  | 'name'
  | 'organizationId'
  | 'serviceScope'
  | 'taxId'
  | 'uuid'
  | 'wfcId';

export type DuplicateWcmDashboardInput = {
  /** Optional name override. Defaults to "{original name} (Copy)". */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EnabledDisabledWcmExternalBuyerNegotiationSyncInput = {
  /** External buyer map id */
  id: Scalars['String']['input'];
  /** Whether negotiation sync is enabled */
  negotiationSyncEnabled: Scalars['Boolean']['input'];
};

export type EnabledDisabledWcmExternalBuyerNegotiationSyncOutput = {
  __typename?: 'EnabledDisabledWcmExternalBuyerNegotiationSyncOutput';
  /** External buyer map id */
  id: Scalars['ID']['output'];
  /** Whether negotiation sync is enabled */
  negotiationSyncEnabled: Scalars['Boolean']['output'];
};

export type EncryptionSetting = {
  __typename?: 'EncryptionSetting';
  cryptographicSettings: CryptographicSettings;
  fileName: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
};

export type EncryptionSettingsOutput = {
  __typename?: 'EncryptionSettingsOutput';
  encryptionSettings: Array<EncryptionSetting>;
};

export type Error = {
  __typename?: 'Error';
  /** An HTTP status code if an underlying service gives us one. */
  code?: Maybe<Scalars['String']['output']>;
  msg?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export type File_History_Status =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING';

export type File_Upload_Status =
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'UPLOADED';

export type FetchCompanyGroupOutputDto = {
  __typename?: 'FetchCompanyGroupOutputDto';
  companyGroupName: Scalars['String']['output'];
  companyGroupUuid: Scalars['String']['output'];
  isDsf: Scalars['Boolean']['output'];
};

export type FetchCompanyGroupsIntersectionFilters = {
  companyId?: InputMaybe<StringComparison>;
  currency?: InputMaybe<StringComparison>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<StringComparison>;
  supplierName?: InputMaybe<StringComparison>;
};

export type FetchCompanyGroupsIntersectionInput = {
  filters?: InputMaybe<FetchCompanyGroupsIntersectionFilters>;
  leftCompanyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  paging?: InputMaybe<FetchCompanyGroupsIntersectionPaging>;
  rightCompanyGroupUuid: Scalars['String']['input'];
  sorting: FetchCompanyGroupsIntersectionSorting;
};

export type FetchCompanyGroupsIntersectionOutput = {
  __typename?: 'FetchCompanyGroupsIntersectionOutput';
  supplierDetails: Array<SupplierIntersectionDetails>;
  totalCount: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FetchCompanyGroupsIntersectionPaging = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};

export type FetchCompanyGroupsIntersectionSorting = {
  orderBy?: Direction;
  sortingField?: CompanyIntersectionSortField;
};

export type FetchUniqueCurrenciesLocationsForCgIntersectionInput = {
  leftCompanyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  rightCompanyGroupUuid: Scalars['String']['input'];
};

export type FetchUploadWcmDashboardMediaSignedUrlInput = {
  /** MIME type of the file to upload */
  contentType: Scalars['String']['input'];
  /** Original file name including an allowed image extension */
  fileName: Scalars['String']['input'];
};

export type FetchWcmSupplierSegmentConfigInput = {
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type FetchWcmSupplierSegmentConfigOutput = {
  __typename?: 'FetchWcmSupplierSegmentConfigOutput';
  /** Display FX rate from source currency to the requested display currency. Source thresholds stay unconverted. */
  fxRate: Scalars['Float']['output'];
  /** Maximum spend value across all supplier groups */
  maxGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend value across all supplier groups */
  minGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend for strategic suppliers */
  strategicMinSpend?: Maybe<Scalars['Float']['output']>;
  /** Maximum spend for tail suppliers */
  tailMaxSpend?: Maybe<Scalars['Float']['output']>;
};

export type FileConfigurationV1 = {
  __typename?: 'FileConfigurationV1';
  fileSettingsUuid?: Maybe<Scalars['String']['output']>;
  funderFileTemplateUuid: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNo: Scalars['Float']['output'];
  subType: Scalars['String']['output'];
};

export type FileSetSettingsConfigurationV1 = {
  __typename?: 'FileSetSettingsConfigurationV1';
  fileSetSettingsUuid?: Maybe<Scalars['String']['output']>;
  fileSettings?: Maybe<Array<FileConfigurationV1>>;
  writerType?: Maybe<Scalars['String']['output']>;
};

export type FilterCriteria = {
  __typename?: 'FilterCriteria';
  filterColumn: Scalars['String']['output'];
  filterValue: Scalars['String']['output'];
};

export type FilterCriteriaDetails = {
  __typename?: 'FilterCriteriaDetails';
  filterCriteria: FilterCriteria;
  filterVariables?: Maybe<Array<Variable>>;
  variables?: Maybe<Array<Variable>>;
};

export type FloatFieldComparison = {
  between?: InputMaybe<FloatFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<FloatFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type FormatPreferences = Node & {
  __typename?: 'FormatPreferences';
  aggregateCurrencyFormat?: Maybe<Scalars['String']['output']>;
  dateDisplayFormat?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  numberDisplayFormat?: Maybe<Scalars['String']['output']>;
  useCustomFormatting: Scalars['Boolean']['output'];
};

export type FormatPreferencesInput = {
  aggregateCurrencyFormat?: InputMaybe<Scalars['String']['input']>;
  dateDisplayFormat?: InputMaybe<Scalars['String']['input']>;
  numberDisplayFormat?: InputMaybe<Scalars['String']['input']>;
  useCustomFormatting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Funder = {
  __typename?: 'Funder';
  created: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderBuyer = {
  __typename?: 'FunderBuyer';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  makerDataCenter: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
  programEntity?: Maybe<Program>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderBuyerConnection = {
  __typename?: 'FunderBuyerConnection';
  /** Array of edges. */
  edges: Array<FunderBuyerEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderBuyerEdge = {
  __typename?: 'FunderBuyerEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderBuyer */
  node: FunderBuyer;
};

export type FunderBuyerFilter = {
  and?: InputMaybe<Array<FunderBuyerFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  makerDataCenter?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderBuyerFilter>>;
  organizationUuid?: InputMaybe<StringFieldComparison>;
  programEntity?: InputMaybe<FunderBuyerFilterProgramFilter>;
};

export type FunderBuyerFilterProgramFilter = {
  and?: InputMaybe<Array<FunderBuyerFilterProgramFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderBuyerFilterProgramFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderBuyerProgramFileSetOutput = {
  __typename?: 'FunderBuyerProgramFileSetOutput';
  basePaymentConfig: Scalars['JSON']['output'];
  funderUuid: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  programsData: Array<ProgramsData>;
};

export type FunderBuyerSort = {
  direction: SortDirection;
  field: FunderBuyerSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderBuyerSortFields =
  | 'funderUuid'
  | 'makerDataCenter'
  | 'makerUuid'
  | 'organizationUuid';

export type FunderCalculations = {
  __typename?: 'FunderCalculations';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  interestCalcOutputStrategy: Scalars['String']['output'];
  paymentMethods: Scalars['String']['output'];
  priceTypes: Scalars['String']['output'];
  rateSelectionStrategy: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderCalculationsConnection = {
  __typename?: 'FunderCalculationsConnection';
  /** Array of edges. */
  edges: Array<FunderCalculationsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderCalculationsEdge = {
  __typename?: 'FunderCalculationsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderCalculations */
  node: FunderCalculations;
};

export type FunderCalculationsFilter = {
  and?: InputMaybe<Array<FunderCalculationsFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  interestCalcOutputStrategy?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderCalculationsFilter>>;
  rateSelectionStrategy?: InputMaybe<StringFieldComparison>;
};

export type FunderCalculationsOutput = {
  __typename?: 'FunderCalculationsOutput';
  interestCalcOutputStrategy: Scalars['String']['output'];
  paymentMethods: Scalars['String']['output'];
  priceTypes: Scalars['String']['output'];
  rateSelectionStrategy: Scalars['String']['output'];
};

export type FunderCalculationsSort = {
  direction: SortDirection;
  field: FunderCalculationsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderCalculationsSortFields =
  | 'funderUuid'
  | 'interestCalcOutputStrategy'
  | 'rateSelectionStrategy';

export type FunderConnection = {
  __typename?: 'FunderConnection';
  /** Array of edges. */
  edges: Array<FunderEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderCurrencies = {
  __typename?: 'FunderCurrencies';
  bankingDays: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  currencyLookupId: Scalars['Float']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  rateSource: Scalars['String']['output'];
  refRateFloor: Scalars['Float']['output'];
  referenceRate: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderCurrenciesFilter = {
  and?: InputMaybe<Array<FunderCurrenciesFilter>>;
  bankingDays?: InputMaybe<NumberFieldComparison>;
  currencyLookupId?: InputMaybe<NumberFieldComparison>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderCurrenciesFilter>>;
  rateSource?: InputMaybe<StringFieldComparison>;
  refRateFloor?: InputMaybe<NumberFieldComparison>;
  referenceRate?: InputMaybe<StringFieldComparison>;
};

export type FunderCurrenciesOutput = {
  __typename?: 'FunderCurrenciesOutput';
  bankingDays: Scalars['Float']['output'];
  currencyLookupId: Scalars['Float']['output'];
  rateSource: Scalars['String']['output'];
  refRateFloor: Scalars['Float']['output'];
  referenceRate: Scalars['String']['output'];
};

export type FunderCurrenciesSort = {
  direction: SortDirection;
  field: FunderCurrenciesSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderCurrenciesSortFields =
  | 'bankingDays'
  | 'currencyLookupId'
  | 'funderUuid'
  | 'rateSource'
  | 'refRateFloor'
  | 'referenceRate';

export type FunderDeliveryRetryPolicy = {
  __typename?: 'FunderDeliveryRetryPolicy';
  funderUuid: Scalars['String']['output'];
  maxRetry?: Maybe<Scalars['Int']['output']>;
  maxTimeout?: Maybe<Scalars['Int']['output']>;
  useCustomDeliveryRetryPolicy: Scalars['Boolean']['output'];
};

export type FunderDeliverySettingsDto = {
  __typename?: 'FunderDeliverySettingsDto';
  created: Scalars['DateTime']['output'];
  fdsAuthId?: Maybe<Scalars['String']['output']>;
  fdsLocationId?: Maybe<Scalars['String']['output']>;
  fdsLocationName?: Maybe<Scalars['String']['output']>;
  fdsLocationUri?: Maybe<Scalars['String']['output']>;
  fundingPartnerUuid: Scalars['String']['output'];
  isBuyerAddress: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderDeliverySettingsDtoConnection = {
  __typename?: 'FunderDeliverySettingsDtoConnection';
  /** Array of edges. */
  edges: Array<FunderDeliverySettingsDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderDeliverySettingsDtoEdge = {
  __typename?: 'FunderDeliverySettingsDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderDeliverySettingsDto */
  node: FunderDeliverySettingsDto;
};

export type FunderDeliverySettingsDtoFilter = {
  and?: InputMaybe<Array<FunderDeliverySettingsDtoFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  fundingPartnerUuid?: InputMaybe<StringFieldComparison>;
  isBuyerAddress?: InputMaybe<BooleanFieldComparison>;
  isInternal?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FunderDeliverySettingsDtoFilter>>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderDeliverySettingsDtoSort = {
  direction: SortDirection;
  field: FunderDeliverySettingsDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderDeliverySettingsDtoSortFields =
  | 'created'
  | 'fundingPartnerUuid'
  | 'isBuyerAddress'
  | 'isInternal'
  | 'status'
  | 'uuid';

export type FunderDeliverySettingsInputDto = {
  fdsAuthId: Scalars['String']['input'];
  fdsLocationId: Scalars['String']['input'];
  fdsLocationName: Scalars['String']['input'];
  fdsLocationUri: Scalars['String']['input'];
  fundingPartnerUuid: Scalars['String']['input'];
  isBuyerAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type FunderEdge = {
  __typename?: 'FunderEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Funder */
  node: Funder;
};

export type FunderFeedbackConfig = {
  __typename?: 'FunderFeedbackConfig';
  created: Scalars['DateTime']['output'];
  funder?: Maybe<Funder>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isInvoiceAmountComputed: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
};

export type FunderFeedbackConfigConnection = {
  __typename?: 'FunderFeedbackConfigConnection';
  /** Array of edges. */
  edges: Array<FunderFeedbackConfigEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFeedbackConfigDeleteResponse = {
  __typename?: 'FunderFeedbackConfigDeleteResponse';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isInvoiceAmountComputed?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type FunderFeedbackConfigEdge = {
  __typename?: 'FunderFeedbackConfigEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFeedbackConfig */
  node: FunderFeedbackConfig;
};

export type FunderFeedbackConfigFilter = {
  and?: InputMaybe<Array<FunderFeedbackConfigFilter>>;
  funder?: InputMaybe<FunderFeedbackConfigFilterFunderFilter>;
  id?: InputMaybe<IdFilterComparison>;
  isEnabled?: InputMaybe<BooleanFieldComparison>;
  isInvoiceAmountComputed?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FunderFeedbackConfigFilter>>;
};

export type FunderFeedbackConfigFilterFunderFilter = {
  and?: InputMaybe<Array<FunderFeedbackConfigFilterFunderFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFeedbackConfigFilterFunderFilter>>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFeedbackConfigSort = {
  direction: SortDirection;
  field: FunderFeedbackConfigSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFeedbackConfigSortFields =
  | 'id'
  | 'isEnabled'
  | 'isInvoiceAmountComputed';

export type FunderFeedbackPipelineConfigDto = {
  __typename?: 'FunderFeedbackPipelineConfigDto';
  ackType: Scalars['String']['output'];
  aggregationConfig?: Maybe<Scalars['JSON']['output']>;
  created: Scalars['DateTime']['output'];
  filenamePattern: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lookupType: Scalars['String']['output'];
  parserConfig: Scalars['JSON']['output'];
  parserType: Scalars['String']['output'];
  targetDcs?: Maybe<Array<Scalars['String']['output']>>;
  transformConfig?: Maybe<Scalars['JSON']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type FunderFile = {
  __typename?: 'FunderFile';
  buyerGeneratedReconColumnConfig?: Maybe<ReconColumnDetails>;
  buyerGeneratedUseForReconciliation?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  fileNameFormat: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  funder: Scalars['String']['output'];
  funderFileDeliverySettings?: Maybe<FunderFileDeliveryDto>;
  funderFileType: Scalars['String']['output'];
  serialNo?: Maybe<Scalars['Float']['output']>;
  settings?: Maybe<SerializerSettingsOuput>;
  subType: Scalars['String']['output'];
  supplierFilterName: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  writerType: Scalars['String']['output'];
  x509SignedZipEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type FunderFileColumnMaster = {
  __typename?: 'FunderFileColumnMaster';
  columnName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  groupByEnabled: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderFileColumnMasterConnection = {
  __typename?: 'FunderFileColumnMasterConnection';
  /** Array of nodes. */
  nodes: Array<FunderFileColumnMaster>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFileColumnMasterFilter = {
  and?: InputMaybe<Array<FunderFileColumnMasterFilter>>;
  columnName?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileColumnMasterFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileColumnMasterSort = {
  direction: SortDirection;
  field: FunderFileColumnMasterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileColumnMasterSortFields =
  | 'columnName'
  | 'uuid';

export type FunderFileConnection = {
  __typename?: 'FunderFileConnection';
  /** Array of edges. */
  edges: Array<FunderFileEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFileDeliveryDto = {
  __typename?: 'FunderFileDeliveryDto';
  delayInSeconds?: Maybe<Scalars['Float']['output']>;
  funderFileTemplateId: Scalars['String']['output'];
  funderTargetLocation?: Maybe<Scalars['String']['output']>;
  useBuyerLocation?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FunderFileDeliveryDtoConnection = {
  __typename?: 'FunderFileDeliveryDtoConnection';
  /** Array of edges. */
  edges: Array<FunderFileDeliveryDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFileDeliveryDtoEdge = {
  __typename?: 'FunderFileDeliveryDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFileDeliveryDto */
  node: FunderFileDeliveryDto;
};

export type FunderFileDeliveryDtoFilter = {
  and?: InputMaybe<Array<FunderFileDeliveryDtoFilter>>;
  funderFileTemplateId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileDeliveryDtoFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileDeliveryDtoSort = {
  direction: SortDirection;
  field: FunderFileDeliveryDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileDeliveryDtoSortFields =
  | 'funderFileTemplateId'
  | 'uuid';

export type FunderFileDeliverySettingsInput = {
  allowWeekendDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  delayInSeconds?: InputMaybe<Scalars['Float']['input']>;
  delivery?: InputMaybe<Scalars['String']['input']>;
  funderSourceLocation?: InputMaybe<Scalars['String']['input']>;
  funderTargetLocation?: InputMaybe<Scalars['String']['input']>;
  nextDayDeliveryTime?: InputMaybe<Scalars['String']['input']>;
  nextDayDeliveryTimezone?: InputMaybe<Scalars['String']['input']>;
  useBuyerLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FunderFileEdge = {
  __typename?: 'FunderFileEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFile */
  node: FunderFile;
};

export type FunderFileFilter = {
  and?: InputMaybe<Array<FunderFileFilter>>;
  funder?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileFilter>>;
  updatedBy?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileNotification = {
  __typename?: 'FunderFileNotification';
  funderFile: Scalars['String']['output'];
  funderFileTemplate: FunderFile;
  uuid: Scalars['String']['output'];
};

export type FunderFileNotificationEdge = {
  __typename?: 'FunderFileNotificationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFileNotification */
  node: FunderFileNotification;
};

export type FunderFileNotificationFilter = {
  and?: InputMaybe<Array<FunderFileNotificationFilter>>;
  funderFile?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileNotificationFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileNotificationSort = {
  direction: SortDirection;
  field: FunderFileNotificationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileNotificationSortFields =
  | 'funderFile'
  | 'uuid';

export type FunderFileSort = {
  direction: SortDirection;
  field: FunderFileSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileSortFields =
  | 'funder'
  | 'updatedBy'
  | 'uuid';

export type FunderFileSummary = {
  __typename?: 'FunderFileSummary';
  fileNameFormat: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderFileType =
  | 'BUYER_GENERATED'
  | 'FEEDBACK'
  | 'MATURITY'
  | 'PAYMENT';

export type FunderFilter = {
  and?: InputMaybe<Array<FunderFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFilter>>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderGeographies = {
  __typename?: 'FunderGeographies';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  geographyLookupId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  includeExclude: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderGeographiesFilter = {
  and?: InputMaybe<Array<FunderGeographiesFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  geographyLookupId?: InputMaybe<NumberFieldComparison>;
  includeExclude?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderGeographiesFilter>>;
};

export type FunderGeographiesOutput = {
  __typename?: 'FunderGeographiesOutput';
  geographyLookupId: Scalars['Float']['output'];
  includeExclude: Scalars['String']['output'];
};

export type FunderGeographiesSort = {
  direction: SortDirection;
  field: FunderGeographiesSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderGeographiesSortFields =
  | 'funderUuid'
  | 'geographyLookupId'
  | 'includeExclude';

export type FunderLegalAgreement = {
  __typename?: 'FunderLegalAgreement';
  agreementType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderLegalAgreementConnection = {
  __typename?: 'FunderLegalAgreementConnection';
  /** Array of edges. */
  edges: Array<FunderLegalAgreementEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderLegalAgreementEdge = {
  __typename?: 'FunderLegalAgreementEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderLegalAgreement */
  node: FunderLegalAgreement;
};

export type FunderLegalAgreementFilter = {
  agreementType?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<FunderLegalAgreementFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderLegalAgreementFilter>>;
  termsAndConditionsUrl?: InputMaybe<StringFieldComparison>;
};

export type FunderLegalAgreementSort = {
  direction: SortDirection;
  field: FunderLegalAgreementSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderLegalAgreementSortFields =
  | 'agreementType'
  | 'funderUuid'
  | 'termsAndConditionsUrl';

export type FunderLegalSetupOutput = {
  __typename?: 'FunderLegalSetupOutput';
  agreementType: Scalars['String']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
};

export type FunderNotification = {
  __typename?: 'FunderNotification';
  created: Scalars['DateTime']['output'];
  email: Array<Scalars['String']['output']>;
  funder: Scalars['String']['output'];
  funderFileNotificationSettings: Array<FunderFileNotification>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};


export type FunderNotificationFunderFileNotificationSettingsArgs = {
  filter?: FunderFileNotificationFilter;
  sorting?: Array<FunderFileNotificationSort>;
};

export type FunderNotificationConnection = {
  __typename?: 'FunderNotificationConnection';
  /** Array of edges. */
  edges: Array<FunderNotificationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderNotificationEdge = {
  __typename?: 'FunderNotificationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderNotification */
  node: FunderNotification;
};

export type FunderNotificationFilter = {
  and?: InputMaybe<Array<FunderNotificationFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  funder?: InputMaybe<StringFieldComparison>;
  funderFileNotificationSettings?: InputMaybe<FunderNotificationFilterFunderFileNotificationFilter>;
  or?: InputMaybe<Array<FunderNotificationFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderNotificationFilterFunderFileNotificationFilter = {
  and?: InputMaybe<Array<FunderNotificationFilterFunderFileNotificationFilter>>;
  funderFile?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderNotificationFilterFunderFileNotificationFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderNotificationSort = {
  direction: SortDirection;
  field: FunderNotificationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderNotificationSortFields =
  | 'created'
  | 'funder'
  | 'uuid';

export type FunderSort = {
  direction: SortDirection;
  field: FunderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderSortFields =
  | 'name'
  | 'status'
  | 'uuid';

export type FunderSummary = {
  __typename?: 'FunderSummary';
  files: Array<FunderFileSummary>;
  uuid: Scalars['String']['output'];
};

export type FunderVariable = {
  __typename?: 'FunderVariable';
  funderId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FunderVariableConnection = {
  __typename?: 'FunderVariableConnection';
  /** Array of edges. */
  edges: Array<FunderVariableEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderVariableDeleteFilter = {
  and?: InputMaybe<Array<FunderVariableDeleteFilter>>;
  funderId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderVariableDeleteFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderVariableDeleteResponse = {
  __typename?: 'FunderVariableDeleteResponse';
  funderId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FunderVariableEdge = {
  __typename?: 'FunderVariableEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderVariable */
  node: FunderVariable;
};

export type FunderVariableFilter = {
  and?: InputMaybe<Array<FunderVariableFilter>>;
  funderId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderVariableFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderVariableInput = {
  funderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FunderVariableSort = {
  direction: SortDirection;
  field: FunderVariableSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderVariableSortFields =
  | 'funderId'
  | 'uuid';

export type GetBuyerAppEverafterEmbedUrlInput = {
  divisionUuid: Scalars['String']['input'];
  embedLocationUrl: Scalars['String']['input'];
};

export type GetBuyerAppUserPreferenceInput = {
  /** Preference name */
  preferenceName?: InputMaybe<Scalars['String']['input']>;
};

export type GetBuyerAppUserPreferenceOutput = {
  __typename?: 'GetBuyerAppUserPreferenceOutput';
  /** User preferences */
  preferences: Array<BuyerAppUserPreference>;
};

export type GetIncomeOverTime = {
  aggregationLevel: AggregationLevel;
  currency: Scalars['String']['input'];
  groupBy: GroupByTimePeriod;
  organizeDataOnMakerLevel?: InputMaybe<Scalars['Boolean']['input']>;
  timeRange: TimeRange;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetWcmAggregatedSpendsInput = {
  /** Aggregators for data grouping (min: 1, max: 3). Can be enum values or custom attributes (custom_attribute_1, etc.) */
  aggregators: Array<Scalars['String']['input']>;
  /** List of benchmarking strategies to use for aggregated spends. Must be one of the defined BenchmarkingStrategies (excluding custom). */
  benchmarkingStrategies?: InputMaybe<Array<Benchmarking_Strategies_With_Harmonization>>;
  filters: WcmAggregatedSpendsFilters;
  paging: WcmAggregatedSpendsPaging;
  /** Whether to show target terms in the response */
  showTargetTerms?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<GetWcmAggregatedSpendsSorting>;
};

export type GetWcmAggregatedSpendsOutput = {
  __typename?: 'GetWcmAggregatedSpendsOutput';
  spendsData: Array<WcmAggregatedSpends>;
  totalRows: Scalars['Float']['output'];
};

export type GetWcmAggregatedSpendsSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Scalars['String']['input'];
  orderType?: Order_Type;
};

export type GetWcmAllNegotiationSyncEnabledExternalBuyerMapsInput = {
  /** Filter by buyer data center */
  dataCenter?: InputMaybe<Buyer_Data_Center>;
  /** Filter by external source name */
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type GetWcmBenchmarkConfigInput = {
  currency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBenchmarkCountryRegulationsInput = {
  /** Currency code */
  currency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerFileConfigsInput = {
  /** Transaction UUID */
  transactionUuid: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerFileConfigsOutput = {
  __typename?: 'GetWcmBuyerFileConfigsOutput';
  /** Benchmark strategy configuration */
  benchmarkStrategyConfig: BenchmarkStrategyOutput;
  /** Economic value */
  economicValueConfig: Scalars['Float']['output'];
  /** Supplier segmentation rules */
  supplierSegmentationConfig: SupplierSegmentationConfig;
  /** Transaction UUID */
  transactionUuid: Scalars['String']['output'];
};

export type GetWcmBuyerUserDetailsForAdmin = {
  __typename?: 'GetWcmBuyerUserDetailsForAdmin';
  total: Scalars['Float']['output'];
  users: Array<WcmBuyerUserDetailsForAdmin>;
};

export type GetWcmBuyerUsersInput = {
  paging: WcmBuyerUsersDetailsPaging;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerUsersOutput = {
  __typename?: 'GetWcmBuyerUsersOutput';
  total: Scalars['Float']['output'];
  users: Array<WcmBuyerUser>;
};

export type GetWcmBuyersUsersCountInput = {
  /** Filter by WCM buyer UUIDs */
  wcmBuyerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetWcmExclusionsConfigInput = {
  /** Display Currency */
  displayCurrency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmExternalBuyerMapsInput = {
  /** Filter by external source name */
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

export type GetWcmNegotiationsInput = {
  /** Array of vendor variant IDs to get negotiations for */
  vendorVariantIds: Array<Scalars['String']['input']>;
};

export type GetWcmPaymentTermsConfigInput = {
  /** Include inactive terms. Defaults to false. */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetWcmPlansForSupplierGroupInput = {
  /** Currency */
  fileCurrency: Scalars['String']['input'];
  /** Vendor Variant ID */
  vendorVariantId: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmPlansInput = {
  /** Currency */
  fileCurrency: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmRegistrationRequest = {
  __typename?: 'GetWcmRegistrationRequest';
  /** Business email */
  businessEmail: Scalars['String']['output'];
  /** Business phone */
  businessPhone?: Maybe<Scalars['String']['output']>;
  /** Company name */
  companyName: Scalars['String']['output'];
  /** Created date */
  created: Scalars['DateTime']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Registration request ID */
  id: Scalars['ID']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** User role */
  role: Scalars['String']['output'];
  /** Registration request status */
  status: Scalars['String']['output'];
  /** Updated date */
  updated: Scalars['DateTime']['output'];
};

export type GetWcmRegistrationRequestsFilter = {
  /** Array of registration request IDs (max 100) */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by registration request status */
  status?: InputMaybe<Wcm_User_Self_Registration_Request_Status>;
};

export type GetWcmRegistrationRequestsInput = {
  /** Filter criteria */
  filter?: InputMaybe<GetWcmRegistrationRequestsFilter>;
  /** Number of items to return (max: 100, min: 1) */
  limit: Scalars['Float']['input'];
  /** Number of items to skip (default: 0) */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** Sort criteria */
  sort?: InputMaybe<GetWcmRegistrationRequestsSort>;
};

export type GetWcmRegistrationRequestsResponse = {
  __typename?: 'GetWcmRegistrationRequestsResponse';
  /** Number of items returned */
  count: Scalars['Float']['output'];
  /** List of registration requests */
  requests?: Maybe<Array<GetWcmRegistrationRequest>>;
  /** Total number of registration requests matching the criteria */
  total: Scalars['Float']['output'];
};

export type GetWcmRegistrationRequestsSort = {
  /** Field to sort by */
  field: Wcm_User_Self_Registration_Order_By;
  /** Sort order */
  order: Order_Type;
};

export type GetWcmSegmentConversionRateInput = {
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmSupplierGroupNotesInput = {
  /** Pagination Info */
  paging?: InputMaybe<WcmSupplierGroupNotesPaging>;
  /** Vendor master ID identifying the supplier group */
  vendorMasterId: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmSupplierHealthMetricsInput = {
  /** Supplier Profile Common Filters */
  filters?: InputMaybe<WcmSupplierProfileCommonFilters>;
  /** Supplier ID (entity ID) */
  supplierId: Scalars['Float']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmSuppliersBenchmarkStrategyBySegmentInput = {
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmUserPreferenceInput = {
  /** Preference name */
  preferenceName?: InputMaybe<Scalars['String']['input']>;
};

export type GetWcmUserPreferenceOutput = {
  __typename?: 'GetWcmUserPreferenceOutput';
  /** User preferences */
  preferences: Array<WcmUserPreference>;
};

export type GroupByDto = {
  aggregationLevels?: InputMaybe<Array<HistoryInfoAggregationLevelEnums>>;
  timePeriod?: InputMaybe<GroupByTimePeriod>;
};

export type GroupByTimePeriod =
  | 'ALL'
  | 'DAY'
  | 'MONTH'
  | 'QUARTER'
  | 'WEEK'
  | 'YEAR';

export type HistoryData = {
  __typename?: 'HistoryData';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedYield?: Maybe<Scalars['Float']['output']>;
  clearedAprAvg?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmountAvgByPayDate?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  divisionId?: Maybe<Scalars['Float']['output']>;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  makerMarketClearIdsForFundedMarkets?: Maybe<Array<Scalars['Float']['output']>>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  marketUuids?: Maybe<Array<Scalars['String']['output']>>;
  maxClearedApr?: Maybe<Scalars['Float']['output']>;
  minClearedApr?: Maybe<Scalars['Float']['output']>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  participatingSuppliersCount?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payDatesCount?: Maybe<Scalars['Float']['output']>;
  totalSuppliersCount?: Maybe<Scalars['Float']['output']>;
};

export type HistoryInfoAggregationLevelEnums =
  | 'CURRENCY'
  | 'DIVISION'
  | 'MARKET'
  | 'ORGANIZATION'
  | 'PAY_DATE';

export type HistoryInfoFilters = {
  clearedInvoiceAmount?: InputMaybe<NumberComparison>;
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isPendingClear?: InputMaybe<Scalars['Boolean']['input']>;
  markets: Array<MarketDetails>;
  startDate: Scalars['DateTime']['input'];
};

export type HistoryInfoInput = {
  filters: HistoryInfoFilters;
  paging: Paging;
  sorting: Sorting;
};

export type HistoryInfoOutput = {
  __typename?: 'HistoryInfoOutput';
  history?: Maybe<Array<HistoryData>>;
  totalRows?: Maybe<Scalars['Float']['output']>;
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  iLike?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notILike?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notLike?: InputMaybe<Scalars['ID']['input']>;
};

export type Invoice_Type =
  | 'ELIGIBLE'
  | 'INELIGIBLE';

export type IdentityFieldType =
  | 'auth_service_uuid';

export type IncludeExcludeWcmSuppliersInputDto = {
  /** Additional Exclusion Remark */
  additionalExclusionRemark?: InputMaybe<Scalars['String']['input']>;
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** List of supplier IDs explicitly not selected (excluded) */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Exclusion Remark id */
  exclusionRemarkId?: InputMaybe<Scalars['Float']['input']>;
  operationType: Supplier_Operation_Type;
  reason: Scalars['String']['input'];
  /** List of supplier IDs selected for inclusion or exclusion */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type IncludeExcludeWcmSuppliersOutput = {
  __typename?: 'IncludeExcludeWcmSuppliersOutput';
  status: Scalars['Boolean']['output'];
};

export type IncomeOverTimeReturnType = {
  __typename?: 'IncomeOverTimeReturnType';
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedYield: Scalars['Float']['output'];
  created: Scalars['String']['output'];
  makerUuid?: Maybe<Scalars['String']['output']>;
  weightedAvgDesiredAprSum: Scalars['Float']['output'];
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type InvoiceStatsFilterForMarket = {
  dateGroupBy: GroupByTimePeriod;
  marketUuid: Scalars['String']['input'];
  timeRange: TimeRange;
};

export type InvoiceStatsOutput = {
  __typename?: 'InvoiceStatsOutput';
  aggEligibleInvoiceAmount: Scalars['Float']['output'];
  aggNewAdjustmentAmount: Scalars['Float']['output'];
  aggNewAdjustmentCount: Scalars['Float']['output'];
  aggNewInvoiceAmount: Scalars['Float']['output'];
  aggNewInvoiceCount: Scalars['Float']['output'];
  aggParticipatingInvoiceAmount: Scalars['Float']['output'];
  aggRegisteredInvoiceAmount: Scalars['Float']['output'];
  aggUnpaidInvoiceAmount: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

export type LiveMarketStatsData = {
  __typename?: 'LiveMarketStatsData';
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedTakerCount?: Maybe<Scalars['Float']['output']>;
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedTakerCount?: Maybe<Scalars['Float']['output']>;
  blendedClearingInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  blendedClearingYieldWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearingAp?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  nonClearingAp?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedTakerCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYieldWeightedSum?: Maybe<Scalars['Float']['output']>;
  participatingAp?: Maybe<Scalars['Float']['output']>;
  participatingWithApCount?: Maybe<Scalars['Float']['output']>;
  thirdPartyBlendedClearingInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  thirdPartyNotAcceptedInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
};

export type LiveMarketStatsInput = {
  allMarketUuids?: Array<Scalars['String']['input']>;
  fundedMarketUuids?: Array<Scalars['String']['input']>;
};

export type LocationsDto = {
  __typename?: 'LocationsDto';
  locations: Array<Scalars['String']['output']>;
};

export type LoginHistory = {
  __typename?: 'LoginHistory';
  application?: Maybe<Application>;
  authType: Scalars['String']['output'];
  created: Scalars['String']['output'];
  userUuid: Scalars['ID']['output'];
};

export type LookupConfigValues = {
  __typename?: 'LookupConfigValues';
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  lookupMaster?: Maybe<LookupMaster>;
  lookupMasterId: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
  userUuid: Scalars['Float']['output'];
};

export type LookupConfigValuesFilter = {
  and?: InputMaybe<Array<LookupConfigValuesFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  displayName?: InputMaybe<StringFieldComparison>;
  lookupMaster?: InputMaybe<LookupConfigValuesFilterLookupMasterFilter>;
  lookupMasterId?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<LookupConfigValuesFilter>>;
  userUuid?: InputMaybe<NumberFieldComparison>;
};

export type LookupConfigValuesFilterLookupMasterFilter = {
  and?: InputMaybe<Array<LookupConfigValuesFilterLookupMasterFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LookupConfigValuesFilterLookupMasterFilter>>;
};

export type LookupConfigValuesSort = {
  direction: SortDirection;
  field: LookupConfigValuesSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type LookupConfigValuesSortFields =
  | 'code'
  | 'displayName'
  | 'lookupMasterId'
  | 'userUuid';

export type LookupMaster = {
  __typename?: 'LookupMaster';
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
};

export type LookupMasterConnection = {
  __typename?: 'LookupMasterConnection';
  /** Array of edges. */
  edges: Array<LookupMasterEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type LookupMasterEdge = {
  __typename?: 'LookupMasterEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the LookupMaster */
  node: LookupMaster;
};

export type LookupMasterFilter = {
  and?: InputMaybe<Array<LookupMasterFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LookupMasterFilter>>;
};

export type LookupMasterSort = {
  direction: SortDirection;
  field: LookupMasterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type LookupMasterSortFields =
  | 'code';

export type MakerMarketClear = {
  __typename?: 'MakerMarketClear';
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate: Scalars['DateTime']['output'];
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedAvg: Scalars['Float']['output'];
  clearedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount: Scalars['Float']['output'];
  clearedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  clearedDpeWeightedSum: Scalars['Float']['output'];
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedTakerCount: Scalars['Float']['output'];
  clearedYield?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  dataCenterCode: Scalars['String']['output'];
  exchangeRates?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of `created` */
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated in favor of `updated` */
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketAwardEventId?: Maybe<Scalars['Float']['output']>;
  marketCashPool?: Maybe<Scalars['Float']['output']>;
  marketId: Scalars['Int']['output'];
  marketReturnAmount: Scalars['Float']['output'];
  marketUuid: Scalars['String']['output'];
  maxAcceptedApr?: Maybe<Scalars['Float']['output']>;
  maxAcceptedDpe?: Maybe<Scalars['Float']['output']>;
  maxClearedApr?: Maybe<Scalars['Float']['output']>;
  maxClearedDpe?: Maybe<Scalars['Float']['output']>;
  minAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minAcceptedDpe?: Maybe<Scalars['Float']['output']>;
  minClearedApr?: Maybe<Scalars['Float']['output']>;
  minClearedDpe?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg: Scalars['Float']['output'];
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearAggregateFilter = {
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<MakerMarketClearAggregateFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<FloatFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  legacyDbCreated?: InputMaybe<DateFieldComparison>;
  legacyDbUpdated?: InputMaybe<DateFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketReturnAmount?: InputMaybe<FloatFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<FloatFieldComparison>;
  or?: InputMaybe<Array<MakerMarketClearAggregateFilter>>;
  payDate?: InputMaybe<DateFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type MakerMarketClearAggregateGroupBy = {
  __typename?: 'MakerMarketClearAggregateGroupBy';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPendingClear?: Maybe<Scalars['Boolean']['output']>;
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearAggregateResponse = {
  __typename?: 'MakerMarketClearAggregateResponse';
  avg?: Maybe<MakerMarketClearAvgAggregate>;
  count?: Maybe<MakerMarketClearCountAggregate>;
  groupBy?: Maybe<MakerMarketClearAggregateGroupBy>;
  max?: Maybe<MakerMarketClearMaxAggregate>;
  min?: Maybe<MakerMarketClearMinAggregate>;
  sum?: Maybe<MakerMarketClearSumAggregate>;
};

export type MakerMarketClearAvgAggregate = {
  __typename?: 'MakerMarketClearAvgAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type MakerMarketClearConnection = {
  __typename?: 'MakerMarketClearConnection';
  /** Array of edges. */
  edges: Array<MakerMarketClearEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type MakerMarketClearCountAggregate = {
  __typename?: 'MakerMarketClearCountAggregate';
  acceptedEarn?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  acceptedYield?: Maybe<Scalars['Int']['output']>;
  awardDate?: Maybe<Scalars['Int']['output']>;
  awardedEarn?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  awardedYield?: Maybe<Scalars['Int']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  dataCenterCode?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPendingClear?: Maybe<Scalars['Int']['output']>;
  legacyDbCreated?: Maybe<Scalars['Int']['output']>;
  legacyDbUpdated?: Maybe<Scalars['Int']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['Int']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  notAcceptedYield?: Maybe<Scalars['Int']['output']>;
  payDate?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type MakerMarketClearEdge = {
  __typename?: 'MakerMarketClearEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the MakerMarketClear */
  node: MakerMarketClear;
};

export type MakerMarketClearFilter = {
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<MakerMarketClearFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<FloatFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  legacyDbCreated?: InputMaybe<DateFieldComparison>;
  legacyDbUpdated?: InputMaybe<DateFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketReturnAmount?: InputMaybe<FloatFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<FloatFieldComparison>;
  or?: InputMaybe<Array<MakerMarketClearFilter>>;
  payDate?: InputMaybe<DateFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type MakerMarketClearMaxAggregate = {
  __typename?: 'MakerMarketClearMaxAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearMinAggregate = {
  __typename?: 'MakerMarketClearMinAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearSort = {
  direction: SortDirection;
  field: MakerMarketClearSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type MakerMarketClearSortFields =
  | 'acceptedEarn'
  | 'acceptedInvoiceAmount'
  | 'acceptedInvoiceCount'
  | 'acceptedYield'
  | 'awardDate'
  | 'awardedEarn'
  | 'awardedInvoiceAmount'
  | 'awardedInvoiceCount'
  | 'awardedYield'
  | 'clearedDiscountedAmount'
  | 'created'
  | 'currency'
  | 'dataCenterCode'
  | 'id'
  | 'isPendingClear'
  | 'legacyDbCreated'
  | 'legacyDbUpdated'
  | 'makerId'
  | 'makerUuid'
  | 'marketId'
  | 'marketReturnAmount'
  | 'marketUuid'
  | 'notAcceptedInvoiceCount'
  | 'notAcceptedYield'
  | 'payDate'
  | 'updated';

export type MakerMarketClearSumAggregate = {
  __typename?: 'MakerMarketClearSumAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type MakersTakersOrganizations = {
  __typename?: 'MakersTakersOrganizations';
  /** @deprecated Deprecated in favor of `divisionId` */
  buyerSupplierId?: Maybe<Scalars['String']['output']>;
  dataCenterCode: Scalars['String']['output'];
  divisionId?: Maybe<Scalars['String']['output']>;
  isImported?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of `makerId` */
  makerDivisionId?: Maybe<Scalars['Int']['output']>;
  makerDivisionUuid?: Maybe<Scalars['String']['output']>;
  makerId: Scalars['Int']['output'];
  makerOrganizationId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of `takerId` */
  takerDivisionId?: Maybe<Scalars['Int']['output']>;
  takerId: Scalars['Int']['output'];
  takerOrganizationId?: Maybe<Scalars['Int']['output']>;
  takerOrganizationUuid?: Maybe<Scalars['String']['output']>;
};

export type MakersTakersOrganizationsConnection = {
  __typename?: 'MakersTakersOrganizationsConnection';
  /** Array of edges. */
  edges: Array<MakersTakersOrganizationsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type MakersTakersOrganizationsEdge = {
  __typename?: 'MakersTakersOrganizationsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the MakersTakersOrganizations */
  node: MakersTakersOrganizations;
};

export type MakersTakersOrganizationsFilter = {
  and?: InputMaybe<Array<MakersTakersOrganizationsFilter>>;
  buyerSupplierId?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  isImported?: InputMaybe<BooleanFieldComparison>;
  makerDivisionId?: InputMaybe<IntFieldComparison>;
  makerDivisionUuid?: InputMaybe<StringFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationId?: InputMaybe<IntFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<MakersTakersOrganizationsFilter>>;
  takerDivisionId?: InputMaybe<IntFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerOrganizationId?: InputMaybe<IntFieldComparison>;
  takerOrganizationUuid?: InputMaybe<StringFieldComparison>;
};

export type MakersTakersOrganizationsSort = {
  direction: SortDirection;
  field: MakersTakersOrganizationsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type MakersTakersOrganizationsSortFields =
  | 'buyerSupplierId'
  | 'dataCenterCode'
  | 'isImported'
  | 'makerDivisionId'
  | 'makerDivisionUuid'
  | 'makerId'
  | 'makerOrganizationId'
  | 'makerOrganizationUuid'
  | 'takerDivisionId'
  | 'takerId'
  | 'takerOrganizationId'
  | 'takerOrganizationUuid';

export type MarketDetails = {
  excludeIncome?: Scalars['Boolean']['input'];
  excludeYield?: Scalars['Boolean']['input'];
  isFunderMarket?: Scalars['Boolean']['input'];
  marketUuid: Scalars['String']['input'];
};

export type MarketSettingsInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type MarketSettingsOutput = {
  __typename?: 'MarketSettingsOutput';
  /** Adjustment Tolerance for the market */
  adjTolerance?: Maybe<Scalars['Float']['output']>;
  /** Cash Replenishment Schedule for the market cash pool */
  cashPoolSchedule: CashPoolScheduleOutput;
  /** Cash Pool Settings for the market cash pool */
  cashPoolSettings: CashPoolSettingsOutput;
  /** Market Currency */
  currency: Scalars['String']['output'];
  /** Dual Authorization Pending Requests for the market settings */
  dualAuthorizations: BuyerAppMarketSettingsDualAuthorizationOutput;
  /** Market Uuid */
  marketUuid: Scalars['String']['output'];
  /** Reserve settings for the market */
  reserveSettings: ReserveSettingsOutput;
  /** Restriction settings for the market */
  restriction: RestrictionSettingsOutput;
};

export type MarketStatsData = {
  __typename?: 'MarketStatsData';
  blendedClearingEarn: Scalars['Float']['output'];
  cashPoolUsed: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  divisionId?: Maybe<Scalars['Int']['output']>;
  divisionName?: Maybe<Scalars['String']['output']>;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Int']['output'];
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid: Scalars['String']['output'];
  marketYield: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  productType?: Maybe<Scalars['String']['output']>;
};

export type MarketStatsInput = {
  makerUuids: Array<Scalars['String']['input']>;
};

export type MergeConfigInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  mergeOperation: Scalars['String']['input'];
};

export type MergeConfigOutput = {
  __typename?: 'MergeConfigOutput';
  config?: Maybe<Scalars['JSON']['output']>;
  mergeOperation: Scalars['String']['output'];
};

export type MoveSuppliersInput = {
  companyIds: Array<Scalars['String']['input']>;
  fromCompanyGroup: CompanyGroupInput;
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  toCompanyGroup: CompanyGroupInput;
};

/** For multi-node responses */
export type MultiMutationResponse = {
  /** HTTP Status Code of the Response */
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  /** For developers not for frontend */
  message: Scalars['String']['output'];
  nodes?: Maybe<Array<Maybe<Node>>>;
  /** True/False if the mutation worked. Patial success will show true */
  success: Scalars['Boolean']['output'];
};

/** For multi-node responses */
export type MultiQueryResponse = {
  count?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  nodes?: Maybe<Array<Maybe<Node>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add suppliers to an existing WCM plan */
  addSuppliersToWcmPlan: WcmSuppliersOperationResponse;
  /** Add suppliers to a WCM plan wave */
  addSuppliersToWcmPlanWave: WcmSuppliersOperationResponse;
  /** Adds a user to divisions. It will return ALL divisions the users is on, not just the divisions added. This can partially work because of DC failures. If you care about failures then look at the errors response. */
  addUserToDivisions?: Maybe<CreateUserMutationResponse>;
  /** API to assign default roles to the user on the given division */
  assignDefaultBuyerAppDivisionsUsersRolesToUser: Array<BuyerAppDivisionsUsersRoles>;
  /** Activate or deactivate a payment term configuration */
  changeWcmPaymentTermConfigStatus: WcmPaymentTermConfigType;
  /** Mutation to clean up mappings to other non-paid buyers for non-C2FO users associated with a given buyer */
  cleanupOtherWcmNonPaidMappingForBuyerUsers: CleanupOtherWcmNonPaidMappingsForBuyerUsersOutput;
  cloneFileTemplate: FunderFile;
  /** create a new account config - fails if one already exists for the account. */
  createAccountConfig?: Maybe<AccountConfig>;
  createBuyerAppEverafterBuyerConfig: BuyerAppEverafterBuyerConfig;
  createBuyerAppManyDivisionRegions: Array<BuyerAppDivisionRegion>;
  /** API to create reserve of the market */
  createBuyerAppMarketReserve: ReserveSettingsUnionBuyerAppDualAuthorization;
  /** API to update company Group mapping for suppliers */
  createCompanyGroup: CreateCompanyGroupOutput;
  createCustomAgreement: CreateCustomAgreementResponse;
  /** Mutation to create file set along with its default settings */
  createFileSetSettings: SummaryDetails;
  createFunderFeedbackPipelineConfig: FunderFeedbackPipelineConfigDto;
  createManyAgreementAudits: Array<AgreementAudit>;
  createManyAgreements: Array<Agreement>;
  createManyBuyerAppDivisionsUsersRoles: Array<BuyerAppDivisionsUsersRoles>;
  createManyBuyerAppDualAuthorizationRoles: Array<BuyerAppDualAuthorizationRoles>;
  createManyBuyerReportingCurrencies: Array<BuyerReportingCurrencies>;
  createManyDivisionReportingCurrencies: Array<BuyerAppDivisionReportingCurrencies>;
  createManyFunderVariables: Array<FunderVariable>;
  createManyRecordGroupColumnDtos: Array<RecordGroupColumnDto>;
  /** Create multiple buyer mappings for a domain */
  createManyWcmDomainBuyerMappings: WcmDomainConfigResponse;
  /** Mutation to create multiple WCM master buyers by wcm admin */
  createManyWcmMasterBuyersDetails: Array<WcmMasterBuyerList>;
  /** Mutation to add multiple buyers and users mapping by wcm admin */
  createManyWcmUserBuyerMappingDetails: Array<WcmBuyerUserMappingOutput>;
  /** API to create new funder-currencies */
  createMultipleFunderCurrencies: Array<FunderCurrenciesOutput>;
  /** API to create new funder-geographies */
  createMultipleFunderGeographies: Array<FunderGeographiesOutput>;
  createOneAgreement: Agreement;
  createOneAgreementAudit: AgreementAudit;
  /** API to create new funder */
  createOneFunder: Funder;
  /** API to create new funder-calculations */
  createOneFunderCalculations: FunderCalculationsOutput;
  createOneFunderDeliverySettingsDto: FunderDeliverySettingsDto;
  createOneFunderFeedbackConfig: FunderFeedbackConfig;
  createOneFunderFile: FunderFile;
  /** API to create new funder-legal-aggrement */
  createOneFunderLegalAgreement: FunderLegalSetupOutput;
  createOneFunderNotification: FunderNotification;
  createOneFunderVariable: FunderVariable;
  createOneRecordGroup: RecordGroup;
  createOneRecordGroupColumnDto: RecordGroupColumnDto;
  /** API to create a new program */
  createProgram: ProgramDefaultResponse;
  /** Mutation to create users via WCM with optional WCM onboarding */
  createUsersViaWcm: CreateUsersViaWcmOutput;
  /** Mutation to create buyer exclusion remark */
  createWcmBuyerExclusionRemark: WcmBuyerExclusionRemarkOutput;
  /** Create a new value for a custom attribute */
  createWcmCustomAttributeValue: CustomAttributeValueResponseDto;
  /** Create a new draft dashboard */
  createWcmDashboard: WcmDashboard;
  /** Create a dashboard media upload URL and return a presigned S3 POST */
  createWcmDashboardMediaUploadUrl: WcmDashboardMediaUploadSignedUrl;
  /** Mutation to create a WCM external buyer map */
  createWcmExternalBuyerMap: WcmExternalBuyerMap;
  /** Create a new payment term configuration */
  createWcmPaymentTermConfig: WcmPaymentTermConfigType;
  /** Create a new WCM plan */
  createWcmPlan: WcmPlanOutput;
  /** Create a new WCM plan wave */
  createWcmPlanWave: WcmPlanWaveOutput;
  /** Mutation to create wcm roles with admin level permissions by wcm admin */
  createWcmRoleWithAdminLevelPermissions: CreateWcmWcmRolesOutput;
  /** Mutation to create wcm roles by buyer permission manager */
  createWcmRoles: CreateWcmWcmRolesOutput;
  /** Create a new note for a supplier group */
  createWcmSupplierGroupNote: WcmSupplierGroupNote;
  /** Create a new wcm user registration request */
  createWcmUserRegistrationRequest: CreateWcmNewUserRegistrationResponse;
  /** API to unload buyer reporting dbt model data from s3 to buyer db */
  dbtUnloadBuyerAppReportData: BuyerAppBuyerReportsDbtUnloadOutput;
  /** Unload Navigator DBT model data from S3 to PostgreSQL */
  dbtUnloadNavigatorData: NavigatorUnloadOutput;
  /** API to soft delete buyer app dual auth entry */
  deleteBuyerAppDualAuth: BuyerAppDualAuthorization;
  deleteBuyerAppOneDivisionRegion: BuyerAppDivisionRegionDeleteResponse;
  deleteFunderFeedbackPipelineConfig: Scalars['Boolean']['output'];
  deleteManyBuyerAppDivisionsUsersRoles: DeleteManyResponse;
  deleteManyBuyerAppDualAuthorizationRoles: DeleteManyResponse;
  deleteManyBuyerReportingCurrencies: DeleteManyResponse;
  deleteManyDivisionReportingCurrencies: DeleteManyResponse;
  deleteManyFunderVariables: DeleteManyResponse;
  deleteManyRecordGroupColumnDtos: DeleteManyResponse;
  /** Delete multiple buyer mappings for a domain */
  deleteManyWcmDomainBuyerMappings: WcmDomainConfigResponse;
  /** Mutation to delete multiple WCM master buyers by wcm admin */
  deleteManyWcmMasterBuyersDetails: Array<WcmMasterBuyerList>;
  /** Mutation to delete multiple buyers and users mapping by wcm admin */
  deleteManyWcmUserBuyerMappingDetails: DeleteManyWcmBuyerUserMappingOutput;
  deleteMarketSettingsRoles: DataMigrationOutput;
  deleteOneFunderFeedbackConfig: FunderFeedbackConfigDeleteResponse;
  deleteOneFunderVariable: FunderVariableDeleteResponse;
  deleteOneRecordGroupColumnDto: RecordGroupColumnDtoDeleteResponse;
  /** Mutation to delete buyer exclusion remark */
  deleteWcmBuyerExclusionRemark: WcmBuyerExclusionRemarkOutput;
  /** Delete custom attribute value(s) - accepts array of IDs for single or bulk delete (CASCADE deletes all related assignments) */
  deleteWcmCustomAttributeValues: DeleteWcmCustomAttributeValueResponse;
  /** Delete a dashboard (owner only) */
  deleteWcmDashboard: WcmDeleteDashboardResponse;
  /** Delete a display FX rate for a target currency. */
  deleteWcmDisplayCurrencyRate: WcmDisplayCurrencyConfig;
  /** Delete a WCM plan */
  deleteWcmPlan: WcmOperationMessageOutput;
  /** Delete a WCM plan wave */
  deleteWcmPlanWave: WcmOperationMessageOutput;
  /** Mutation to delete wcm role */
  deleteWcmRole: DeleteWcmRoleOutput;
  /** Mutation to delete WCM users with cascading deletes for wcm admin */
  deleteWcmUsersAdmin: DeleteWcmUsersOutput;
  /** Duplicate a published dashboard into a new draft owned by the caller */
  duplicateWcmDashboard: WcmDashboard;
  /** API to enable and disable program fileset for a given program fileset uuid */
  enableProgramFileSet: ProgramDefaultResponse;
  /** Mutation to enable or disable negotiation sync on a WCM external buyer map */
  enabledDisabledWcmExternalBuyerNegotiationSync: EnabledDisabledWcmExternalBuyerNegotiationSyncOutput;
  /** Forgets 1...100 users by email address. This will remove the user's PII from C2FO */
  forgetUsers?: Maybe<UserMutationResponse>;
  importDataFromCSV: DataMigrationOutput;
  /** Mutation to include or exclude suppliers */
  includeExcludeWcmSuppliers: IncludeExcludeWcmSuppliersOutput;
  /** API to move suppliers from one company group to another */
  moveSuppliersAcrossCompanyGroups: CompanyIdGroupOutputResponse;
  /** Notify for dashboard media upload completion */
  notifyWcmDashboardMediaUploadCompletion: Scalars['Boolean']['output'];
  /** API to pin/unpin suppliersr */
  pinUnpinSuppliers: CompanyIdGroupOutputResponse;
  publishAgreement: CreateCustomAgreementResponse;
  /** Publish or re-publish a dashboard (owner only) */
  publishWcmDashboard: WcmDashboard;
  /** Remove suppliers from an existing WCM plan */
  removeSuppliersFromWcmPlan: WcmSuppliersOperationResponse;
  /** Remove suppliers from a WCM plan wave */
  removeSuppliersFromWcmPlanWave: WcmSuppliersOperationResponse;
  /** API to notify all buyer app users via email about the monthly report being ready for access */
  sendBuyerReportEmails: BuyerAppBuyerReportEmailOutput;
  /** Admin API to set buyer audit config type and static file count */
  setBuyerAuditConfig: ProgramAuditConfigOutput;
  /** Mutation to set access validity expiry date for WCM users by wcm admin */
  setWcmUserAccessValidity: SetWcmUserAccessValidityOutput;
  softDeleteAgreements: Scalars['Boolean']['output'];
  /** Mutation to subscribe subprocessors notification */
  subscribeBuyerAppSubprocessorsNotification: BuyerAppSubprocessorsSubscription;
  /** API to sync DSF company Group */
  syncDsfCompanyGroup: CreateCompanyGroupOutput;
  /** Grabs users in C2FO DB with no authServiceUuid and creates them in the User Auth DB. Then it syncs those Auth Service UUIDs back to the C2FO DB. This needs to be run in all data-centers. */
  syncUsersToUserAuthService?: Maybe<SyncUsersResponse>;
  /** Sync a WCM plan with the latest transaction */
  syncWcmPlanWithLatestTransaction: SyncWcmPlanResponse;
  unforgetUser?: Maybe<CreateUserMutationResponse>;
  /** Mutation to unsubscribe subprocessors notification */
  unsubscribeBuyerAppSubprocessorsNotification: Scalars['Boolean']['output'];
  /** Mutation to update wcm suppliers group benchmarking strategy */
  updateBenchmarkingStrategyForWcmSuppliersGroup: UpdateWcmSupplierGroupBenchmarkingStrategyOutput;
  /** API to update adjustment tolerance of the market */
  updateBuyerAppAdjustmentToleranceSettings: AdjustmentToleranceUnionBuyerAppDualAuthorization;
  /** API to update minimum income settings of the market */
  updateBuyerAppAprSettings: CashPoolSettingsUnionBuyerAppDualAuthorization;
  /** API to update cash pool settings of the market */
  updateBuyerAppCashPoolSettings: CashPoolSettingsUnionBuyerAppDualAuthorization;
  updateBuyerAppEverafterBuyerConfig: BuyerAppEverafterBuyerConfig;
  /** API to update exclusion status of invoices */
  updateBuyerAppInvoices: Array<UpdateBuyerAppInvoiceOutput>;
  updateBuyerAppManyDivisionRegions: UpdateManyResponse;
  /** API to update reserve of the market */
  updateBuyerAppMarketReserve: ReserveSettingsUnionBuyerAppDualAuthorization;
  /** API to update restriction of the market */
  updateBuyerAppMarketRestriction: RestrictionUnionBuyerAppDualAuthorization;
  /** API to update minimum income settings of the market */
  updateBuyerAppMinEarnSettings: CashPoolSettingsUnionBuyerAppDualAuthorization;
  /** API to update buyer audit config */
  updateBuyerAuditConfig: BuyerAuditConfigDefaultResponse;
  /** Muatation to update buyer delivery location */
  updateBuyerDeliveryLocation: UpdateBuyerDeliveryLocationOutput;
  /** API to update company Group mapping for suppliers */
  updateCompanyGroupForSuppliers: CompanyIdGroupOutputResponse;
  updateCustomAgreement: CreateCustomAgreementResponse;
  /** Mutation to update file settings for a file type */
  updateFileSetSettings: ProgramFileSetSettings;
  /** Create or update the custom delivery retry policy for a funder */
  updateFunderDeliveryRetryPolicy: FunderDeliveryRetryPolicy;
  updateFunderFeedbackPipelineConfig: FunderFeedbackPipelineConfigDto;
  /** Muatation to update delivery setting - timezone and deliveryTime */
  updateManyFileDeliverSettings: Array<UpdateDeliverySettingsOutput>;
  updateManyQualifiedSuppliers: UpdateManyResponse;
  /** API to update existing funder-currencies data */
  updateMultipleFunderCurrencies: Array<FunderCurrenciesOutput>;
  /** API to update existing funder-geographies */
  updateMultipleFunderGeographies: Array<FunderGeographiesOutput>;
  updateMultipleRecordGroupInput: Array<RecordGroup>;
  /** API to update existing funder */
  updateOneFunder: Funder;
  /** API to update existing funder-calculations */
  updateOneFunderCalculations: FunderCalculationsOutput;
  updateOneFunderDeliverySettingsDto: FunderDeliverySettingsDto;
  updateOneFunderFeedbackConfig: FunderFeedbackConfig;
  updateOneFunderFile: FunderFile;
  /** API to update existing funder-legal-agreement */
  updateOneFunderLegalAgreement: FunderLegalSetupOutput;
  updateOneFunderNotification: FunderNotification;
  updateOneQualifiedSupplier: QualifiedSupplier;
  updateOneRecordGroup: RecordGroup;
  updateOneRecordGroupColumnDto: RecordGroupColumnDto;
  /** API to update program fileset table for a given program fileset uuid */
  updateProgramFileSetConfigurations: ProgramFileSetResponse;
  updateRecordGroupColumns: Array<RecordGroupColumnDto>;
  /** Update or add buyer configuration */
  updateWcmBuyerConfig: BuyerAppBuyerConfigResponse;
  /** Mutation to update buyer exclusion remark */
  updateWcmBuyerExclusionRemark: UpdateWcmBuyerExclusionRemarkOutput;
  /** Mutation to set the negotiation ingested-through timestamp for a WCM external buyer map */
  updateWcmBuyerNegotiationIngestedThroughAt: UpdateWcmBuyerNegotiationIngestedThroughAtOutput;
  /** Mutation to update a buyer type from Trial to Paid and clean up non-paid buyer mappings, and user access expiry date for non-C2FO users */
  updateWcmBuyerTypeToPaid: UpdateWcmBuyerTypeToPaidOutput;
  /** Update a custom attribute definition */
  updateWcmCustomAttributeDefinition: WcmCustomAttributeDefinitionResponse;
  /** Mutation to update custom attribute for selected suppliers */
  updateWcmCustomAttributeForSuppliers: UpdateWcmCustomAttributeForSuppliersOutput;
  /** Update an existing custom attribute value */
  updateWcmCustomAttributeValue: UpdateCustomAttributeValueResponseDto;
  /** Update draft config and/or rename a dashboard (owner only) */
  updateWcmDashboard: WcmDashboard;
  /** Mutation to update supplier diversity status */
  updateWcmDiversityStatus: UpdateWcmDiversityStatusOutput;
  /** Mutation to update file status */
  updateWcmEnrichedFileStatus: UpdateFileStatusOutput;
  /** Replace the buyer NAICS exclusion set and return the recomposed editor payload. */
  updateWcmNaicsExclusions: WcmNaicsExclusions;
  /** Update Wcm Naics Payment Terms */
  updateWcmNaicsPaymentTerms: UpdateWcmNaicsPaymentTermsOutput;
  /** Update an existing payment term configuration */
  updateWcmPaymentTermConfig: WcmPaymentTermConfigType;
  /** Mutation to update payment terms version */
  updateWcmPaymentTermsVersion: UpdateWcmPaymentTermsVersionOutput;
  /** Update an existing WCM plan */
  updateWcmPlan: WcmPlanOutput;
  /** Update an existing WCM plan wave */
  updateWcmPlanWave: WcmPlanWaveOutput;
  /** Mutation to update wcm role permissions by buyer permission manager */
  updateWcmRolePermissions: UpdateWcmRolePermissionsOutput;
  /** Mutation to update wcm role users by buyer permission manager */
  updateWcmRoleUsers: UpdateWcmRoleUsersOutput;
  /** Edit an existing supplier-group note. Only the most recent note for the group may be edited. */
  updateWcmSupplierGroupNote: WcmSupplierGroupNote;
  /** Mutation to update preferred segment and/or conversion rate attributes for WCM suppliers */
  updateWcmSupplierPreferredAttributes: UpdateWcmSupplierPreferredAttributesOutput;
  /** Mutation to update wcm supplier segment config */
  updateWcmSupplierSegmentConfig: UpdateWcmSupplierSegmentConfigOutput;
  /** Mutation to bulk update supplier attributes */
  updateWcmSuppliers: UpdateWcmSuppliersOutput;
  /** Mutation to update benchmark strategy for suppliers */
  updateWcmSuppliersBenchmarkStrategy: UpdateWcmSuppliersBenchmarkStrategyOutput;
  /** Mutation to update benchmark strategy for suppliers by segment */
  updateWcmSuppliersBenchmarkStrategyBySegment: UpdateWcmSuppliersBenchmarkStrategyBySegmentOutput;
  /** Mutation to update current payment terms for selected suppliers */
  updateWcmSuppliersCurrentTerms: UpdateWcmSuppliersCurrentTermsOutput;
  /** Update status of registration request by id */
  updateWcmUserRegistrationStatus: UpdateWcmUserRegistrationRequestResponse;
  /** API to upsert the division roles showIncome and showYield */
  upsertBuyerAppDivisionRoles: BuyerAppDivisionRolesOutput;
  upsertBuyerAppFileHistory: BuyerAppFileHistoryUpsertOutput;
  /** Mutation to upsert market taker configuration data. */
  upsertBuyerAppMarketTakerConfiguration: UpsertBuyerAppMarketTakerConfigurationOutput;
  /** API to update market taker reserve setting */
  upsertBuyerAppMarketTakerReserveSettings: BuyerAppUpdateMarketTakerReserveOutput;
  /** Creates or updates a buyer-platform user preference (JWT user scope). */
  upsertBuyerAppUserPreference: UpsertBuyerAppUserPreferenceOutput;
  /** Upsert WCM Benchmark Config */
  upsertWcmBenchmarkConfig: WcmBenchmarkConfigOutput;
  /** Upsert WCM Benchmark Country Regulations */
  upsertWcmBenchmarkCountryRegulations: WcmBenchmarkCountryRegulationsOutput;
  /** Create or update a display FX rate for a target currency. */
  upsertWcmDisplayCurrencyRate: WcmDisplayCurrencyConfig;
  /** Upsert domain configuration (create or update) */
  upsertWcmDomainConfig: WcmDomainConfigResponse;
  /** Upsert Wcm Economic Value Config */
  upsertWcmEconomicValueConfig: WcmEconomicValueConfigOutput;
  /** Upsert Wcm Exclusions Config */
  upsertWcmExclusionsConfig: WcmExclusionsConfigOutput;
  /** Upsert a new WCM supplier negotiation */
  upsertWcmNegotiation: WcmNegotiationOutput;
  /** Create or update multiple negotiation status-to-phase mappings */
  upsertWcmNegotiationStatusPhaseMappings: WcmStatusPhaseMappings;
  /** Upsert WCM negotiations for multiple supplier entities */
  upsertWcmNegotiations: WcmNegotiationsOutput;
  /** Upsert Wcm Segment Conversion Rate Config */
  upsertWcmSegmentConversionRate: WcmSegmentConversionRateConfigOutput;
  /** This mutation is used to create or update user preference settings */
  upsertWcmUserPreference: UpsertWcmUserPreferenceOutput;
  /** Mutation to add or update wcm users by wcm admin */
  upsertWcmUsers: UpsertWcmUsersOutput;
  /** Create a new user. This will add the user to User Auth and User PII stores. */
  user?: Maybe<CreateUserMutationResponse>;
  userReconcile?: Maybe<UserMutationResponse>;
  /** Update users info. This will update all backing services, User Auth, C2FO, PII. */
  users?: Maybe<UserMutationResponse>;
  /** Delete a conversation and all its messages. */
  wcmInsightsDeleteConversation: WcmInsightsDeleteResultDto;
  /** Submit feedback for an assistant message. */
  wcmInsightsFeedback: WcmInsightsFeedbackResultDto;
  /** Submit a question to WCM Insights. */
  wcmInsightsQuery: WcmInsightsQueryResultDto;
};


export type MutationAddSuppliersToWcmPlanArgs = {
  input: AddSuppliersInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationAddSuppliersToWcmPlanWaveArgs = {
  input: AddSuppliersInput;
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationAddUserToDivisionsArgs = {
  authServiceUuid: Scalars['ID']['input'];
  divisionUuids: Array<Scalars['ID']['input']>;
};


export type MutationAssignDefaultBuyerAppDivisionsUsersRolesToUserArgs = {
  input: AssignDefaultBuyerAppDivisionsUsersRolesToUserInput;
};


export type MutationChangeWcmPaymentTermConfigStatusArgs = {
  id: Scalars['Int']['input'];
  input: ChangeStatusWcmPaymentTermConfigInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCleanupOtherWcmNonPaidMappingForBuyerUsersArgs = {
  input: CleanupOtherWcmNonPaidMappingsForBuyerUsersInput;
};


export type MutationCloneFileTemplateArgs = {
  existingFunderFileId: Scalars['String']['input'];
  funderId: Scalars['String']['input'];
};


export type MutationCreateAccountConfigArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationCreateBuyerAppEverafterBuyerConfigArgs = {
  input: CreateOneBuyerAppEverafterBuyerConfigInput;
};


export type MutationCreateBuyerAppManyDivisionRegionsArgs = {
  input: CreateManyBuyerAppDivisionRegionsInput;
};


export type MutationCreateBuyerAppMarketReserveArgs = {
  input: BuyerAppCreateReserveInputDto;
};


export type MutationCreateCompanyGroupArgs = {
  createCompanyGroupInput: CreateCompanyGroupInput;
  deleteEmptyCompanyGroup: Scalars['Boolean']['input'];
  updateFromCompanyGroups: Scalars['Boolean']['input'];
};


export type MutationCreateCustomAgreementArgs = {
  createCustomAgreementInput: CreateCustomAgreementInput;
};


export type MutationCreateFileSetSettingsArgs = {
  fileSetDetails: CreateProgramFileSetDetails;
  funderUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};


export type MutationCreateFunderFeedbackPipelineConfigArgs = {
  input: CreateFunderFeedbackPipelineConfigInput;
};


export type MutationCreateManyAgreementAuditsArgs = {
  input: CreateManyAgreementAuditsInput;
};


export type MutationCreateManyAgreementsArgs = {
  input: CreateManyAgreementsInput;
};


export type MutationCreateManyBuyerAppDivisionsUsersRolesArgs = {
  input: CreateManyBuyerAppDivisionsUsersRolesInput;
};


export type MutationCreateManyBuyerAppDualAuthorizationRolesArgs = {
  input: CreateManyBuyerAppDualAuthorizationRolesInput;
};


export type MutationCreateManyBuyerReportingCurrenciesArgs = {
  input: CreateManyBuyerReportingCurrenciesInput;
};


export type MutationCreateManyDivisionReportingCurrenciesArgs = {
  input: CreateManyBuyerAppDivisionReportingCurrenciesInput;
};


export type MutationCreateManyFunderVariablesArgs = {
  input: CreateManyFunderVariablesInput;
};


export type MutationCreateManyRecordGroupColumnDtosArgs = {
  input: CreateManyRecordGroupColumnDtosInput;
};


export type MutationCreateManyWcmDomainBuyerMappingsArgs = {
  input: CreateWcmDomainBuyerMappingsInput;
};


export type MutationCreateManyWcmMasterBuyersDetailsArgs = {
  input: Array<CreateWcmMasterBuyerList>;
};


export type MutationCreateManyWcmUserBuyerMappingDetailsArgs = {
  input: CreateManyWcmUserBuyerMappingDetailsInput;
};


export type MutationCreateMultipleFunderCurrenciesArgs = {
  inputs: Array<CreateFunderCurrenciesInput>;
};


export type MutationCreateMultipleFunderGeographiesArgs = {
  inputs: Array<CreateFunderGeographiesInput>;
};


export type MutationCreateOneAgreementArgs = {
  input: CreateOneAgreementInput;
};


export type MutationCreateOneAgreementAuditArgs = {
  input: CreateOneAgreementAuditInput;
};


export type MutationCreateOneFunderArgs = {
  input: CreateOneFunderInput;
};


export type MutationCreateOneFunderCalculationsArgs = {
  input: CreateFunderCalculationsInput;
};


export type MutationCreateOneFunderDeliverySettingsDtoArgs = {
  input: CreateOneFunderDeliverySettingsDtoInput;
};


export type MutationCreateOneFunderFeedbackConfigArgs = {
  input: CreateOneFunderFeedbackConfigInput;
};


export type MutationCreateOneFunderFileArgs = {
  input: CreateOneFunderFileInput;
};


export type MutationCreateOneFunderLegalAgreementArgs = {
  input: CreateFunderLegalSetupInput;
};


export type MutationCreateOneFunderNotificationArgs = {
  input: CreateOneFunderNotificationConfigInput;
};


export type MutationCreateOneFunderVariableArgs = {
  input: CreateOneFunderVariableInput;
};


export type MutationCreateOneRecordGroupArgs = {
  input: CreateRecordGroupInput;
};


export type MutationCreateOneRecordGroupColumnDtoArgs = {
  input: CreateOneRecordGroupColumnDtoInput;
};


export type MutationCreateProgramArgs = {
  createProgramInput: CreateProgramInput;
};


export type MutationCreateUsersViaWcmArgs = {
  input: CreateUsersViaWcmInput;
};


export type MutationCreateWcmBuyerExclusionRemarkArgs = {
  input: CreateWcmBuyerExclusionRemarkInput;
};


export type MutationCreateWcmCustomAttributeValueArgs = {
  currency: Scalars['String']['input'];
  input: CreateWcmCustomAttributeValueInput;
  internalName: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmDashboardArgs = {
  input: CreateWcmDashboardInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmDashboardMediaUploadUrlArgs = {
  input: FetchUploadWcmDashboardMediaSignedUrlInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmExternalBuyerMapArgs = {
  input: CreateWcmExternalBuyerMapInput;
};


export type MutationCreateWcmPaymentTermConfigArgs = {
  input: CreateWcmPaymentTermConfigInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmPlanArgs = {
  input: WcmCreatePlanInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmPlanWaveArgs = {
  input: CreateWcmPlanWaveInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmRoleWithAdminLevelPermissionsArgs = {
  input: CreateWcmRoleWithAdminLevelPermissionsInput;
};


export type MutationCreateWcmRolesArgs = {
  input: CreateWcmRolesInput;
};


export type MutationCreateWcmSupplierGroupNoteArgs = {
  input: CreateWcmSupplierGroupNoteInput;
};


export type MutationCreateWcmUserRegistrationRequestArgs = {
  input: CreateWcmNewUserRegistrationInput;
};


export type MutationDbtUnloadBuyerAppReportDataArgs = {
  input: BuyerAppBuyerReportsDbtUnloadInput;
};


export type MutationDbtUnloadNavigatorDataArgs = {
  input: NavigatorUnloadInput;
};


export type MutationDeleteBuyerAppDualAuthArgs = {
  input: DeleteBuyerAppDualAuthInput;
};


export type MutationDeleteBuyerAppOneDivisionRegionArgs = {
  input: DeleteOneBuyerAppDivisionRegionInput;
};


export type MutationDeleteFunderFeedbackPipelineConfigArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteManyBuyerAppDivisionsUsersRolesArgs = {
  input: DeleteManyBuyerAppDivisionsUsersRolesInput;
};


export type MutationDeleteManyBuyerAppDualAuthorizationRolesArgs = {
  input: DeleteManyBuyerAppDualAuthorizationRolesInput;
};


export type MutationDeleteManyBuyerReportingCurrenciesArgs = {
  input: DeleteManyBuyerReportingCurrenciesInput;
};


export type MutationDeleteManyDivisionReportingCurrenciesArgs = {
  input: DeleteManyBuyerAppDivisionReportingCurrenciesInput;
};


export type MutationDeleteManyFunderVariablesArgs = {
  input: DeleteManyFunderVariablesInput;
};


export type MutationDeleteManyRecordGroupColumnDtosArgs = {
  input: DeleteManyRecordGroupColumnDtosInput;
};


export type MutationDeleteManyWcmDomainBuyerMappingsArgs = {
  input: WcmDeleteDomainBuyerMappingsInput;
};


export type MutationDeleteManyWcmMasterBuyersDetailsArgs = {
  input: DeleteManyWcmMasterBuyersInput;
};


export type MutationDeleteManyWcmUserBuyerMappingDetailsArgs = {
  input: DeleteManyWcmUserBuyerMappingDetailsInput;
};


export type MutationDeleteOneFunderFeedbackConfigArgs = {
  input: DeleteOneFunderFeedbackConfigInput;
};


export type MutationDeleteOneFunderVariableArgs = {
  input: DeleteOneFunderVariableInput;
};


export type MutationDeleteOneRecordGroupColumnDtoArgs = {
  input: DeleteOneRecordGroupColumnDtoInput;
};


export type MutationDeleteWcmBuyerExclusionRemarkArgs = {
  input: DeleteWcmBuyerExclusionRemarkInput;
};


export type MutationDeleteWcmCustomAttributeValuesArgs = {
  input: DeleteWcmCustomAttributeValuesInput;
};


export type MutationDeleteWcmDashboardArgs = {
  id: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationDeleteWcmDisplayCurrencyRateArgs = {
  input: WcmDeleteDisplayCurrencyRateInput;
};


export type MutationDeleteWcmPlanArgs = {
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationDeleteWcmPlanWaveArgs = {
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationDeleteWcmRoleArgs = {
  input: DeleteWcmRoleInput;
};


export type MutationDeleteWcmUsersAdminArgs = {
  input: DeleteWcmUsersInput;
};


export type MutationDuplicateWcmDashboardArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<DuplicateWcmDashboardInput>;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationEnableProgramFileSetArgs = {
  isEnabled: Scalars['Boolean']['input'];
  programFileSetUuid: Scalars['String']['input'];
};


export type MutationEnabledDisabledWcmExternalBuyerNegotiationSyncArgs = {
  input: EnabledDisabledWcmExternalBuyerNegotiationSyncInput;
};


export type MutationForgetUsersArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
};


export type MutationImportDataFromCsvArgs = {
  filePath: Scalars['String']['input'];
  isUpdateDualAuth: Scalars['Boolean']['input'];
  tableName: Scalars['String']['input'];
};


export type MutationIncludeExcludeWcmSuppliersArgs = {
  input: IncludeExcludeWcmSuppliersInputDto;
};


export type MutationMoveSuppliersAcrossCompanyGroupsArgs = {
  deleteEmptyCompanyGroup: Scalars['Boolean']['input'];
  updateCompanyIdGroupInput: MoveSuppliersInput;
};


export type MutationNotifyWcmDashboardMediaUploadCompletionArgs = {
  input: NotifyWcmDashboardMediaUploadCompletionInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationPinUnpinSuppliersArgs = {
  updateCompanyIdGroupInput: PinUnpinSuppliersInput;
};


export type MutationPublishAgreementArgs = {
  agreementUuid: Scalars['String']['input'];
};


export type MutationPublishWcmDashboardArgs = {
  id: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationRemoveSuppliersFromWcmPlanArgs = {
  input: RemoveSuppliersInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationRemoveSuppliersFromWcmPlanWaveArgs = {
  input: RemoveSuppliersInput;
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationSendBuyerReportEmailsArgs = {
  input: BuyerAppBuyerReportsEmailsInput;
};


export type MutationSetBuyerAuditConfigArgs = {
  setBuyerAuditConfig: SetBuyerAuditConfigDto;
};


export type MutationSetWcmUserAccessValidityArgs = {
  input: SetWcmUserAccessValidityInput;
};


export type MutationSoftDeleteAgreementsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationSubscribeBuyerAppSubprocessorsNotificationArgs = {
  input: SubscribeBuyerAppSubprocessorsNotificationInput;
};


export type MutationSyncDsfCompanyGroupArgs = {
  syncDsfCompanyGroupInput: SyncDsfCompanyGroupInput;
};


export type MutationSyncUsersToUserAuthServiceArgs = {
  filters?: InputMaybe<UserSyncInput>;
};


export type MutationSyncWcmPlanWithLatestTransactionArgs = {
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUnforgetUserArgs = {
  emailAddress: Scalars['String']['input'];
};


export type MutationUnsubscribeBuyerAppSubprocessorsNotificationArgs = {
  id: Scalars['Float']['input'];
};


export type MutationUpdateBenchmarkingStrategyForWcmSuppliersGroupArgs = {
  input: UpdateWcmSupplierGroupBenchmarkingStrategyInputDto;
};


export type MutationUpdateBuyerAppAdjustmentToleranceSettingsArgs = {
  input: BuyerAppAdjustmentToleranceInputDto;
};


export type MutationUpdateBuyerAppAprSettingsArgs = {
  input: BuyerAppAprSettingsInput;
};


export type MutationUpdateBuyerAppCashPoolSettingsArgs = {
  input: BuyerAppCashPoolSettingsInput;
};


export type MutationUpdateBuyerAppEverafterBuyerConfigArgs = {
  input: UpdateOneBuyerAppEverafterBuyerConfigInput;
};


export type MutationUpdateBuyerAppInvoicesArgs = {
  input: UpdateBuyerAppInvoiceInput;
};


export type MutationUpdateBuyerAppManyDivisionRegionsArgs = {
  input: UpdateManyBuyerAppDivisionRegionsInput;
};


export type MutationUpdateBuyerAppMarketReserveArgs = {
  input: UpdateReserveInputDto;
};


export type MutationUpdateBuyerAppMarketRestrictionArgs = {
  input: BuyerAppRestrictionInput;
};


export type MutationUpdateBuyerAppMinEarnSettingsArgs = {
  input: BuyerAppMinEarnSettingsInput;
};


export type MutationUpdateBuyerAuditConfigArgs = {
  updateBuyerAuditConfig: BuyerAuditConfigDto;
};


export type MutationUpdateBuyerDeliveryLocationArgs = {
  input: UpdateBuyerDeliveryLocationInput;
};


export type MutationUpdateCompanyGroupForSuppliersArgs = {
  deleteEmptyCompanyGroup: Scalars['Boolean']['input'];
  updateCompanyIdGroupInput: UpdateCompanyIdGroupInput;
  updateFromCompanyGroups: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomAgreementArgs = {
  agreementUuid: Scalars['String']['input'];
  update: CreateCustomAgreementInput;
};


export type MutationUpdateFileSetSettingsArgs = {
  fileSetSettingsUuid: Scalars['String']['input'];
  programFileSetSettings: UpdateProgramFileSetSettings;
};


export type MutationUpdateFunderDeliveryRetryPolicyArgs = {
  input: UpdateFunderDeliveryRetryPolicyInput;
};


export type MutationUpdateFunderFeedbackPipelineConfigArgs = {
  id: Scalars['Int']['input'];
  input: UpdateFunderFeedbackPipelineConfigInput;
};


export type MutationUpdateManyFileDeliverSettingsArgs = {
  inputs: Array<UpdateDeliverySettingsInput>;
};


export type MutationUpdateManyQualifiedSuppliersArgs = {
  input: UpdateManyQualifiedSuppliersInput;
};


export type MutationUpdateMultipleFunderCurrenciesArgs = {
  inputs: Array<UpdateFunderCurrenciesInput>;
};


export type MutationUpdateMultipleFunderGeographiesArgs = {
  inputs: Array<UpdateFunderGeographiesInput>;
};


export type MutationUpdateMultipleRecordGroupInputArgs = {
  input: Array<UpdateMultipleRecordGroupInput>;
};


export type MutationUpdateOneFunderArgs = {
  input: UpdateOneFunderInput;
};


export type MutationUpdateOneFunderCalculationsArgs = {
  input: UpdateFunderCalculationsInput;
};


export type MutationUpdateOneFunderDeliverySettingsDtoArgs = {
  input: UpdateOneFunderDeliverySettingsDtoInput;
};


export type MutationUpdateOneFunderFeedbackConfigArgs = {
  input: UpdateOneFunderFeedbackConfigInput;
};


export type MutationUpdateOneFunderFileArgs = {
  input: UpdateOneFunderFileInput;
};


export type MutationUpdateOneFunderLegalAgreementArgs = {
  input: UpdateFunderLegalSetupInput;
};


export type MutationUpdateOneFunderNotificationArgs = {
  input: UpdateOneFunderNotificationConfigInput;
};


export type MutationUpdateOneQualifiedSupplierArgs = {
  input: UpdateOneQualifiedSupplierInput;
};


export type MutationUpdateOneRecordGroupArgs = {
  input: UpdateOneRecordGroupInput;
};


export type MutationUpdateOneRecordGroupColumnDtoArgs = {
  input: UpdateOneRecordGroupColumnDtoInput;
};


export type MutationUpdateProgramFileSetConfigurationsArgs = {
  programFileSetUuid: Scalars['String']['input'];
  updateFilterCriteriaDetails: UpdateProgramFileSetInput;
};


export type MutationUpdateRecordGroupColumnsArgs = {
  input: Array<UpdateRecordGroupColumnInput>;
};


export type MutationUpdateWcmBuyerConfigArgs = {
  input: UpdateBuyerAppBuyerConfigInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmBuyerExclusionRemarkArgs = {
  input: UpdateWcmBuyerExclusionRemarkInput;
};


export type MutationUpdateWcmBuyerNegotiationIngestedThroughAtArgs = {
  input: UpdateWcmBuyerNegotiationIngestedThroughAtInput;
};


export type MutationUpdateWcmBuyerTypeToPaidArgs = {
  input: UpdateWcmBuyerTypeToPaidInput;
};


export type MutationUpdateWcmCustomAttributeDefinitionArgs = {
  currency: Scalars['String']['input'];
  input: UpdateWcmCustomAttributeDefinitionInput;
  internalName: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmCustomAttributeForSuppliersArgs = {
  input: UpdateWcmCustomAttributeForSuppliersInput;
};


export type MutationUpdateWcmCustomAttributeValueArgs = {
  currency: Scalars['String']['input'];
  input: UpdateWcmCustomAttributeValueInput;
  internalName: Scalars['String']['input'];
  valueId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmDashboardArgs = {
  id: Scalars['Int']['input'];
  input: UpdateWcmDashboardInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmDiversityStatusArgs = {
  input: UpdateWcmDiversityStatusInput;
};


export type MutationUpdateWcmEnrichedFileStatusArgs = {
  input: UpdateFileStatusInput;
};


export type MutationUpdateWcmNaicsExclusionsArgs = {
  input: WcmUpdateNaicsExclusionsInput;
};


export type MutationUpdateWcmNaicsPaymentTermsArgs = {
  input: UpdateWcmNaicsPaymentTermsInput;
};


export type MutationUpdateWcmPaymentTermConfigArgs = {
  id: Scalars['Int']['input'];
  input: UpdateWcmPaymentTermConfigInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmPaymentTermsVersionArgs = {
  input: UpdateWcmPaymentTermsVersionInput;
};


export type MutationUpdateWcmPlanArgs = {
  input: WcmUpdatePlanInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmPlanWaveArgs = {
  input: UpdateWcmPlanWaveInput;
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmRolePermissionsArgs = {
  input: UpdateWcmRolesPermissionsInput;
};


export type MutationUpdateWcmRoleUsersArgs = {
  input: UpdateWcmRoleUsersInput;
};


export type MutationUpdateWcmSupplierGroupNoteArgs = {
  input: UpdateWcmSupplierGroupNoteInput;
};


export type MutationUpdateWcmSupplierPreferredAttributesArgs = {
  input: UpdateWcmSupplierPreferredAttributesInput;
};


export type MutationUpdateWcmSupplierSegmentConfigArgs = {
  input: UpdateWcmSupplierSegmentConfigInput;
};


export type MutationUpdateWcmSuppliersArgs = {
  input: UpdateWcmSuppliersInput;
};


export type MutationUpdateWcmSuppliersBenchmarkStrategyArgs = {
  input: UpdateWcmSuppliersBenchmarkStrategyInput;
};


export type MutationUpdateWcmSuppliersBenchmarkStrategyBySegmentArgs = {
  input: UpdateWcmSuppliersBenchmarkStrategyBySegmentInput;
};


export type MutationUpdateWcmSuppliersCurrentTermsArgs = {
  input: UpdateWcmSuppliersCurrentTermsInputDto;
};


export type MutationUpdateWcmUserRegistrationStatusArgs = {
  input: UpdateWcmUserRegistrationRequestInput;
};


export type MutationUpsertBuyerAppDivisionRolesArgs = {
  DivisionRolesUpsertInput: BuyerAppUpsertDivisionRolesInput;
};


export type MutationUpsertBuyerAppFileHistoryArgs = {
  FileHistoryUpsertInput: BuyerAppFileHistoryUpsertInput;
};


export type MutationUpsertBuyerAppMarketTakerConfigurationArgs = {
  input: UpsertBuyerAppMarketTakerConfigurationInput;
};


export type MutationUpsertBuyerAppMarketTakerReserveSettingsArgs = {
  input: BuyerAppUpdateMarketTakerReserveInput;
};


export type MutationUpsertBuyerAppUserPreferenceArgs = {
  input: UpsertBuyerAppUserPreferenceInput;
};


export type MutationUpsertWcmBenchmarkConfigArgs = {
  input: UpsertWcmBenchmarkConfigInput;
};


export type MutationUpsertWcmBenchmarkCountryRegulationsArgs = {
  input: UpsertWcmBenchmarkCountryRegulationsInput;
};


export type MutationUpsertWcmDisplayCurrencyRateArgs = {
  input: WcmUpsertDisplayCurrencyRateInput;
};


export type MutationUpsertWcmDomainConfigArgs = {
  input: UpsertWcmDomainConfigInput;
};


export type MutationUpsertWcmEconomicValueConfigArgs = {
  input: UpsertWcmEconomicValueConfigInput;
};


export type MutationUpsertWcmExclusionsConfigArgs = {
  input: UpsertWcmExclusionsConfigInput;
};


export type MutationUpsertWcmNegotiationArgs = {
  currency: Scalars['String']['input'];
  input: UpsertWcmNegotiationInput;
  vendorVariantId: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpsertWcmNegotiationStatusPhaseMappingsArgs = {
  currency: Scalars['String']['input'];
  input: UpsertWcmStatusPhaseMappingsInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpsertWcmNegotiationsArgs = {
  currency: Scalars['String']['input'];
  input: UpsertWcmNegotiationsInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpsertWcmSegmentConversionRateArgs = {
  input: UpsertWcmSegmentConversionRateInput;
};


export type MutationUpsertWcmUserPreferenceArgs = {
  input: UpsertWcmUserPreferenceInput;
};


export type MutationUpsertWcmUsersArgs = {
  input: UpsertWcmUsersInput;
};


export type MutationUserArgs = {
  user: CreateUserInput;
};


export type MutationUserReconcileArgs = {
  authServiceUuids: Array<Scalars['ID']['input']>;
};


export type MutationUsersArgs = {
  users?: InputMaybe<Array<UserInput>>;
};


export type MutationWcmInsightsDeleteConversationArgs = {
  input: WcmInsightsDeleteConversationInputDto;
};


export type MutationWcmInsightsFeedbackArgs = {
  input: WcmInsightsFeedbackInputDto;
};


export type MutationWcmInsightsQueryArgs = {
  input: WcmInsightsQueryInputDto;
};

/** For mutation responses */
export type MutationResponse = {
  /** HTTP Status Code of the Response */
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  /** For developers not for frontend */
  message: Scalars['String']['output'];
  /** True/False if the mutation worked. Patial success will show true */
  success: Scalars['Boolean']['output'];
};

export type Non_Clearing_Top_Offers_Order_Level =
  | 'ELIGIBLE_INVOICE_AMOUNT'
  | 'NOT_ACCEPTED_DPE_WEIGHTED_AVG'
  | 'NOT_ACCEPTED_EARN'
  | 'NOT_ACCEPTED_INVOICE_AMOUNT'
  | 'NOT_ACCEPTED_YIELD';

/** Whether an excluded NAICS code comes from the C2FO default set or buyer customisation */
export type NaicsExclusionSource =
  | 'CUSTOM'
  | 'DEFAULT';

/** Navigator DBT models for S3 to PostgreSQL data sync */
export type NavigatorDbtModel =
  | 'CAPIQ_ANNUAL_REPORT'
  | 'NAICS_GLOBAL_PAYMENT_TERMS'
  | 'NAICS_GLOBAL_PAYMENT_TERMS_12M'
  | 'NAICS_GLOBAL_PAYMENT_TERMS_24M'
  | 'NAICS_GLOBAL_PAYMENT_TERMS_36M'
  | 'NAICS_REGIONAL_PAYMENT_TERMS'
  | 'NAICS_REGIONAL_PAYMENT_TERMS_12M'
  | 'NAICS_REGIONAL_PAYMENT_TERMS_24M'
  | 'NAICS_REGIONAL_PAYMENT_TERMS_36M'
  | 'PENDULUM_ALL_NAICS_2022'
  | 'PENDULUM_PACA_EXCLUSION_FLAGS'
  | 'REGULATED_COUNTRY_TERMS';

export type NavigatorUnloadInput = {
  /** Optional file name to override the default (e.g., 20260324_000). Useful for retrying failed jobs. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Array of Navigator models to unload from S3 */
  models: Array<NavigatorDbtModel>;
};

export type NavigatorUnloadOutput = {
  __typename?: 'NavigatorUnloadOutput';
  /** Message describing the result */
  message?: Maybe<Scalars['String']['output']>;
  /** Status of the unload operation */
  status: Scalars['Boolean']['output'];
};

export type NewSuppliers = {
  __typename?: 'NewSuppliers';
  companyGroupName: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotifyWcmDashboardMediaUploadCompletionInput = {
  /** Media asset id returned by the signed URL mutation */
  assetId: Scalars['String']['input'];
  /** Client error when the upload failed */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Whether the upload completed successfully */
  hasCompleted: Scalars['Boolean']['input'];
};

export type NumberComparison = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type Order_Type =
  | 'ASC'
  | 'DESC';

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Order =
  | 'asc'
  | 'desc';

export type OrderByDto = {
  orderLevel: OrderLevelEnums;
  orderType?: OrderTypeEnums;
};

export type OrderLevelEnums =
  | 'PAY_DATE';

export type OrderTypeEnums =
  | 'ASC'
  | 'DESC';

export type OrgStatsData = {
  __typename?: 'OrgStatsData';
  acceptedAp: Scalars['Float']['output'];
  acceptedDpe: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedYield: Scalars['Float']['output'];
  cashPoolUsed: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid: Scalars['String']['output'];
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedDpe: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedYield: Scalars['Float']['output'];
};

export type OrgStatsInput = {
  aggregationLevel?: AggregationLevelWithMarketType;
  currency?: Scalars['String']['input'];
  marketType?: InputMaybe<Scalars['String']['input']>;
  uuids?: Array<Scalars['String']['input']>;
};

export type OverrideConfig = {
  __typename?: 'OverrideConfig';
  fileNames: Array<SerializerOverride>;
  filesetFunderOverrides: Array<Variable>;
  filesetSecretOverrides: Array<SecretOverride>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type Paging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

/** The Personal Identifiable Information (PII) that is currently in the C2FO DB user table. */
export type PersonalInfo = Node & {
  __typename?: 'PersonalInfo';
  address?: Maybe<Address>;
  arDepartmentEmailAddress?: Maybe<Scalars['String']['output']>;
  c2foDbId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  contactPreference?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fiscalYearEnd?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** A new value for capturing Role. We have set categories. Similar to title but not free form. */
  role?: Maybe<Role>;
  secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Free form entry for the user to explain their title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Any user personal details, nothing app specific */
export type PersonalInfoInput = {
  address?: InputMaybe<UserAddressInput>;
  arDepartmentEmailAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiscalYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  smstoggle?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PinUnpinSuppliersInput = {
  companyIds: Array<Scalars['String']['input']>;
  makerUuid: Scalars['String']['input'];
  pinSupplier: Scalars['Boolean']['input'];
};

export type PlanAllSelectedOptions = {
  /** Additional filters to apply when all suppliers are selected */
  additionalFilters: AllSelectedFiltersInput;
  /** List of vendor master IDs explicitly not selected for operation */
  deselectedVendorVariantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Must be true to indicate all suppliers are selected */
  value?: Scalars['Boolean']['input'];
};

export type Profile = {
  __typename?: 'Profile';
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  traits?: Maybe<Scalars['JSONObject']['output']>;
};

export type ProfileInput = {
  customer: CustomerInput;
  traits: Array<Scalars['String']['input']>;
};

export type Program = {
  __typename?: 'Program';
  created: Scalars['DateTime']['output'];
  funderBuyer?: Maybe<FunderBuyer>;
  funderBuyerUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProgramAuditConfigOutput = {
  __typename?: 'ProgramAuditConfigOutput';
  created: Scalars['DateTime']['output'];
  effectiveTillDate?: Maybe<Scalars['DateTime']['output']>;
  fileCount: Scalars['Float']['output'];
  makerUuid: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProgramConnection = {
  __typename?: 'ProgramConnection';
  /** Array of edges. */
  edges: Array<ProgramEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProgramDefaultResponse = {
  __typename?: 'ProgramDefaultResponse';
  message: Scalars['String']['output'];
};

export type ProgramEdge = {
  __typename?: 'ProgramEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Program */
  node: Program;
};

export type ProgramFileConfig = {
  __typename?: 'ProgramFileConfig';
  buyerGeneratedUseForReconciliation?: Maybe<Scalars['Boolean']['output']>;
  deliverySettings?: Maybe<ProgramFileDeliverySettings>;
  fileNameFormat: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  filesetUuid: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
  reconColumnDetails?: Maybe<ReconColumnDetails>;
  schedulingSettings?: Maybe<ProgramFileSchedulingSettings>;
  subType: Scalars['String']['output'];
  x509SignedZipEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramFileDeliverySettings = {
  __typename?: 'ProgramFileDeliverySettings';
  deliveryLocationName?: Maybe<Scalars['String']['output']>;
  deliveryLocationUri?: Maybe<Scalars['String']['output']>;
};

export type ProgramFileSchedulingSettings = {
  __typename?: 'ProgramFileSchedulingSettings';
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  isDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  loadWindowEndTime?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type ProgramFileSetResponse = {
  __typename?: 'ProgramFileSetResponse';
  filterCriteria: ProgramSetFilterCriteriaDto;
  variables: Array<ProgramSetVariableDto>;
};

export type ProgramFileSetSettings = {
  __typename?: 'ProgramFileSetSettings';
  fileSetSettingsUuid: Scalars['String']['output'];
  programFileSettings: Array<ProgramFileSettings>;
  writerType: Scalars['String']['output'];
};

export type ProgramFileSetsOutputV1 = {
  __typename?: 'ProgramFileSetsOutputV1';
  programFileSets: Array<ProgramFilesetConfigurationV1>;
};

export type ProgramFileSettings = {
  __typename?: 'ProgramFileSettings';
  fileSettingsUuid?: Maybe<Scalars['String']['output']>;
  funderFileTemplateUuid: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNo: Scalars['Float']['output'];
  subType: Scalars['String']['output'];
};

export type ProgramFileset = {
  __typename?: 'ProgramFileset';
  created: Scalars['DateTime']['output'];
  filterCriteria: FilterCriteria;
  name: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProgramFilesetConfigurationV1 = {
  __typename?: 'ProgramFilesetConfigurationV1';
  feedbackFileConfiguration: FileSetSettingsConfigurationV1;
  filterCriteriaDetails: FilterCriteriaDetails;
  maturityFileConfiguration: FileSetSettingsConfigurationV1;
  paymentFileConfiguration: FileSetSettingsConfigurationV1;
  summaryDetails: SummaryDetails;
};

export type ProgramFilesetFilter = {
  and?: InputMaybe<Array<ProgramFilesetFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProgramFilesetFilter>>;
  programUuid?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type ProgramFilesetSort = {
  direction: SortDirection;
  field: ProgramFilesetSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ProgramFilesetSortFields =
  | 'name'
  | 'programUuid'
  | 'status'
  | 'uuid';

export type ProgramFilter = {
  and?: InputMaybe<Array<ProgramFilter>>;
  funderBuyer?: InputMaybe<ProgramFilterFunderBuyerFilter>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProgramFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type ProgramFilterFunderBuyerFilter = {
  and?: InputMaybe<Array<ProgramFilterFunderBuyerFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  makerDataCenter?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProgramFilterFunderBuyerFilter>>;
  organizationUuid?: InputMaybe<StringFieldComparison>;
};

export type ProgramSetFilterCriteriaDto = {
  __typename?: 'ProgramSetFilterCriteriaDto';
  filterColumn: Scalars['String']['output'];
  filterValue: Scalars['String']['output'];
};

export type ProgramSetVariableDto = {
  __typename?: 'ProgramSetVariableDto';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProgramSort = {
  direction: SortDirection;
  field: ProgramSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ProgramSortFields =
  | 'name'
  | 'uuid';

export type QualifiedSupplier = {
  __typename?: 'QualifiedSupplier';
  companyGroupUuid?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyIdUploads: CompanyIdUpload;
  companyName?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isPinned: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  makerId?: Maybe<Scalars['Float']['output']>;
  makerUuid: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uploadUuid: Scalars['String']['output'];
};

export type QualifiedSupplierConnection = {
  __typename?: 'QualifiedSupplierConnection';
  /** Array of edges. */
  edges: Array<QualifiedSupplierEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type QualifiedSupplierEdge = {
  __typename?: 'QualifiedSupplierEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the QualifiedSupplier */
  node: QualifiedSupplier;
};

export type QualifiedSupplierFilter = {
  and?: InputMaybe<Array<QualifiedSupplierFilter>>;
  companyId?: InputMaybe<StringFieldComparison>;
  companyIdUploads?: InputMaybe<QualifiedSupplierFilterCompanyIdUploadFilter>;
  currency?: InputMaybe<StringFieldComparison>;
  location?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<QualifiedSupplierFilter>>;
  supplierName?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type QualifiedSupplierFilterCompanyIdUploadFilter = {
  and?: InputMaybe<Array<QualifiedSupplierFilterCompanyIdUploadFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<QualifiedSupplierFilterCompanyIdUploadFilter>>;
};

export type QualifiedSupplierInput = {
  companyGroupUuid: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  qualifiedSupplierId: Scalars['Float']['input'];
};

export type QualifiedSupplierSort = {
  direction: SortDirection;
  field: QualifiedSupplierSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type QualifiedSupplierSortFields =
  | 'companyId'
  | 'currency'
  | 'location'
  | 'makerUuid'
  | 'supplierName'
  | 'updated';

export type QualifiedSupplierUpdateFilter = {
  and?: InputMaybe<Array<QualifiedSupplierUpdateFilter>>;
  companyId?: InputMaybe<StringFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  location?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<QualifiedSupplierUpdateFilter>>;
  supplierName?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  agreement: Agreement;
  agreementAudit: AgreementAudit;
  agreementAudits: AgreementAuditConnection;
  agreements: AgreementConnection;
  allTakersMarkets: Array<TakersMarketsNoPage>;
  buyer: Buyer;
  /** API to fetch all divisions users roles */
  buyerAppDivisionsUsersRoles: BuyerAppDivisionsUsersRolesOutput;
  /** API to check if dual auth is enabled for the given division */
  buyerAppDualAuthEnabled: BuyerAppDualAuthorizationRolesEnabledOutput;
  buyerAppRoles: BuyerAppRoleConnection;
  /** API to query all buyer level configurations for DSF buyer */
  buyerAuditConfigData?: Maybe<ProgramAuditConfigOutput>;
  buyers: Array<Buyer>;
  c2foColumnMaster: C2foColumnMaster;
  c2foColumnMasters: C2foColumnMasterConnection;
  cashInvested: Array<CashInvested>;
  companyGroup: CompanyGroup;
  companyGroups: Array<CompanyGroup>;
  customAgreementVersionHistory: Array<CustomAgreementVersionHistory>;
  customAgreementWithContent: CustomAgreementWithContent;
  customAgreements: Array<CustomAgreement>;
  division: Division;
  divisions: DivisionConnection;
  /** API to fetch company group for a maker */
  fetchCompanyGroups: Array<FetchCompanyGroupOutputDto>;
  fetchCompanyGroupsIntersection: FetchCompanyGroupsIntersectionOutput;
  /** API to query suppliers companyId and isPinned data */
  fetchSuppliersForCompanyGroup: SuppliersOutputDto;
  fetchUniqueCurrenciesForCGIntersection: CurrenciesDto;
  fetchUniqueLocationsForCGIntersection: LocationsDto;
  funder: Funder;
  funderBuyer: FunderBuyer;
  funderBuyers: FunderBuyerConnection;
  funderCalculations: FunderCalculationsConnection;
  funderCurrencies: Array<FunderCurrencies>;
  funderDeliverySettingsDto: FunderDeliverySettingsDto;
  funderDeliverySettingsDtos: FunderDeliverySettingsDtoConnection;
  funderFeedbackConfig: FunderFeedbackConfig;
  funderFeedbackConfigs: FunderFeedbackConfigConnection;
  funderFeedbackPipelineConfigByAckType?: Maybe<FunderFeedbackPipelineConfigDto>;
  funderFeedbackPipelineConfigs: Array<FunderFeedbackPipelineConfigDto>;
  funderFile: FunderFile;
  funderFileColumnMaster: FunderFileColumnMaster;
  funderFileColumnMasters: FunderFileColumnMasterConnection;
  funderFileDeliveryDto: FunderFileDeliveryDto;
  funderFileDeliveryDtos: FunderFileDeliveryDtoConnection;
  funderFiles: FunderFileConnection;
  funderGeographies: Array<FunderGeographies>;
  funderLegalAgreement: FunderLegalAgreement;
  funderLegalAgreements: FunderLegalAgreementConnection;
  funderNotification: FunderNotification;
  funderNotifications: FunderNotificationConnection;
  funderSummary: FunderSummary;
  funderVariable: FunderVariable;
  funderVariables: FunderVariableConnection;
  funders: FunderConnection;
  getAggregateHistoryInfo: HistoryInfoOutput;
  getAggregatedMarketStats: Array<AggregatedMarketsStatsOutput>;
  getAggregatedSuppliersHistoryInfo: SupplierHistoryInfoOutput;
  /** API to get the aggregated scf disclosure data grouped at funding partner, currency level for the given timeframe, with data gap metadata */
  getBuyerAppAggregatedScfDisclosure?: Maybe<BuyerAppAggregatedScfDisclosureOutput>;
  /** API to get the YoY AP performance report data */
  getBuyerAppApPerformanceReportData?: Maybe<Array<BuyerAppApPerformanceReportOutput>>;
  /** API to get the AP summary data */
  getBuyerAppApSummaryData?: Maybe<Array<BuyerAppApSummaryOutput>>;
  /** API to fetch award history */
  getBuyerAppAwardHistory: BuyerAppMakerMarketClearHistoryOutputDto;
  /** Query to get Awarded Suppliers Info. */
  getBuyerAppAwardedSuppliersHistory: BuyerAppAwardedSuppliersHistoryOutput;
  /** Query to get clear history graph data. */
  getBuyerAppClearHistoryGraph: BuyerAppClearHistoryGraphOutput;
  /** Query to get clear history stats data. */
  getBuyerAppClearHistoryStats: BuyerAppClearHistoryStatsOutput;
  /** Query to get top clearing offers of the given buyer's markets */
  getBuyerAppClearingTopOffers: BuyerAppClearingTopOffersOutput;
  /** API to get the Core Market Metrics data grouped by period */
  getBuyerAppCoreMarketMetricsData?: Maybe<Array<BuyerAppCoreMarketMetricsOutput>>;
  /** API to get the Core Market Metrics data grouped by period for Downloading */
  getBuyerAppCoreMarketMetricsDownloadData?: Maybe<Array<BuyerAppCoreMarketMetricsDownloadOutput>>;
  /** API to get Credit limit and utilisation of divisions */
  getBuyerAppCreditLimit: BuyerAppCreditLimitOutput;
  /** API to get the Cumulative Vendors data */
  getBuyerAppCumulativeVendorsData?: Maybe<Array<BuyerAppCumulativeVendorsDetailsOutput>>;
  getBuyerAppDivisionRegions: Array<BuyerAppDivisionRegion>;
  /** API to get the reporting currencies for the given division uuids and report type */
  getBuyerAppDivisionReportingCurrencies: Array<BuyerAppDivisionReportingCurrenciesOutput>;
  /** API to get the division roles showIncome and showYield */
  getBuyerAppDivisionRoles?: Maybe<BuyerAppDivisionRolesOutput>;
  /** API to get the DPE Analysis data group by period */
  getBuyerAppDpeAnalysisData?: Maybe<Array<BuyerAppDpeAnalysisDetailsOutput>>;
  /** API to get url from everafter for embedding */
  getBuyerAppEverAfterEmbedURL: Scalars['String']['output'];
  getBuyerAppEverafterBuyerConfig: BuyerAppEverafterBuyerConfig;
  getBuyerAppFileHistories: BuyerAppFileHistoryConnection;
  /** Query to get fetch the funder payment stats. */
  getBuyerAppFunderPaymentStats: BuyerAppFunderPaymentStatsOutput;
  /** Query to get live stats data. */
  getBuyerAppLiveStats: BuyerAppLiveStatsOutput;
  /** API to get the monthly scf disclosure data for the given timeframe, with data gap metadata */
  getBuyerAppMonthlyScfDisclosure?: Maybe<BuyerAppMonthlyScfDisclosureOutput>;
  /** API to get the Network Growth data */
  getBuyerAppNetworkGrowthData?: Maybe<Array<BuyerAppNetworkGrowthDetailsOutput>>;
  /** Query to get top non clearing offers of the given buyer's markets */
  getBuyerAppNonClearingTopOffers: BuyerAppNonClearingTopOffersOutput;
  /** API to get the Participation Breakdown data */
  getBuyerAppParticipationBreakdownData?: Maybe<Array<BuyerAppParticipationBreakdownDetailsOutput>>;
  /** Query to get performance by currency data */
  getBuyerAppPerformanceByCurrencyData: Array<BuyerAppPerformanceByCurrencyDataOutput>;
  /** Query to get performance by currency stats data */
  getBuyerAppPerformanceByCurrencyStats: BuyerAppPerformanceByCurrencyStatsOutput;
  /** Cleared invoices for the selected divisions, funder markets, and due-date range. */
  getBuyerAppPrematurityAdvice: BuyerAppPrematurityAdviceOutput;
  /** API to fetch recent manual upload files history */
  getBuyerAppRecentManualFileUploadHistory: BuyerAppManualUploadProcessorHistoryOutput;
  /** API to get the repeat and new income data */
  getBuyerAppRepeatVsNewIncome?: Maybe<Array<BuyerAppRepeatVsNewIncomeOutput>>;
  /** API to get the repeat vs new loaded ap data */
  getBuyerAppRepeatVsNewLoadedApData?: Maybe<Array<BuyerAppRepeatVsNewLoadedApOutput>>;
  /** Query to get revenue share graph data. */
  getBuyerAppRevShareGraph: Array<BuyerAppRevShareOutput>;
  /** API to get the scf disclosure timeframe boundaries for all the funders of the divisions */
  getBuyerAppScfDisclosureTimeFrameBoundaries?: Maybe<Array<BuyerAppScfDisclosureTimeframeBoundariesOutput>>;
  /** Query to get adjusted invoices of the given supplier in the buyer's market */
  getBuyerAppSupplierAdjustments: BuyerAppSupplierAdjustmentsOutput;
  /** Query to get supplier clear history data. */
  getBuyerAppSupplierClearHistory: Array<BuyerAppSupplierClearHistoryOutput>;
  /** Query to get supplier details */
  getBuyerAppSupplierDetails: BuyerAppSupplierDetailsOutput;
  /** Query to get invoices of the given supplier in the buyer's market */
  getBuyerAppSupplierInvoices: BuyerAppSupplierInvoicesOutput;
  /** API to get the YoY Supplier performance report data */
  getBuyerAppSupplierPerformanceReportData?: Maybe<Array<BuyerAppSupplierPerformanceReportOutput>>;
  /** Query to get supplier settings data. */
  getBuyerAppSupplierSettings: BuyerAppSupplierSettingsOutput;
  /** Query to get supplier stats */
  getBuyerAppSupplierStats: BuyerAppSupplierStatsOutput;
  /** Query to get suppliers offers data. */
  getBuyerAppSuppliersOffers: BuyerAppSuppliersOffersOutput;
  getBuyerAppUserFilters?: Maybe<Array<BuyerAppUserFiltersOutput>>;
  /** Returns buyer-platform user preferences stored in user_preferences (JWT user scope). */
  getBuyerAppUserPreference: GetBuyerAppUserPreferenceOutput;
  /** API to get the reporting currencies for the given org */
  getBuyerReportingCurrencies: BuyerReportingCurrenciesOutput;
  getCashUsed: Array<CashUsed>;
  getClearingStats: Array<ClearingStatsOutput>;
  /** API to query encryption settings for given funderUuid */
  getEncryptionSettingDetails: EncryptionSettingsOutput;
  /** API to query file Delivery settings */
  getFileDeliverySettings: DeliverySettingsOutput;
  /** Get the custom delivery retry policy for a funder */
  getFunderDeliveryRetryPolicy: FunderDeliveryRetryPolicy;
  /** API to query distinct writer types for a funder */
  getFunderDistinctWriterTypes: WriterTypeOutput;
  getIncomeOverTime: Array<IncomeOverTimeReturnType>;
  getInvoiceStatsForMarket: Array<InvoiceStatsOutput>;
  getLiveMarketStats?: Maybe<Array<LiveMarketStatsData>>;
  getManyBuyerAppBuyerSupplierCounts: Array<BuyerAppBuyerSupplierCounts>;
  getManyBuyerAppSubprocessorsSubscriptionDetails: Array<BuyerAppSubprocessorsSubscription>;
  getManyWcmMasterBuyersDetails: Array<WcmMasterBuyerList>;
  getManyWcmMasterCountryRegionDetails: Array<WcmMasterRegionCountryList>;
  getManyWcmUserBuyerMappingDetails: Array<WcmUserBuyerMappingDetails>;
  getManyWcmUserInformation: Array<WcmUserInformation>;
  /** API to fetch market settings of the market */
  getMarketSettings: MarketSettingsOutput;
  /** API to query program file configurations for a funder and buyer */
  getProgramFileConfigs: Array<ProgramFileConfig>;
  /** API to query all  Fileset level configurations for different file types */
  getProgramFileSetConfigurationsV1: ProgramFileSetsOutputV1;
  /** API to query distinct currencies for a program */
  getProgramUniqueCurrencies: CurrenciesDto;
  /** API to query distinct locations for a program */
  getProgramUniqueLocations: LocationsDto;
  getQualifiedSuppliersForProgram: SupplierDetailsOutput;
  getSupplierStats: SupplierStats;
  getTakersMarketsStatsForMarket?: Maybe<TakersMarketsStatsForMarket>;
  /** Cascading invoice adherence filter facets for monitoring. */
  getWcmAdherenceDynamicInvoiceFilters: WcmAdherenceDynamicInvoiceFilters;
  /** Paged adherence KPI rows grouped by 1..3 supplier dimensions. Each row includes baseline, selected, and delta blocks. */
  getWcmAdherenceKpiByAggregator: WcmAdherenceKpiByAggregatorOutput;
  /** Paged non-comparative adherence KPI rows, one per period bucket optionally nested by 0..3 supplier dimensions, spanning the baseline..selected month range. Each row has plain metric columns; the response also carries range-wide scope totals. */
  getWcmAdherenceKpiByPeriod: WcmAdherenceKpiByPeriodOutput;
  /** Baseline vs selected payment month adherence KPI comparison for monitoring. */
  getWcmAdherenceKpis: WcmAdherenceKpis;
  /** Anchor-driven 12-month adherence trend with rolling averages. */
  getWcmAdherenceTrend: WcmAdherenceTrend;
  /** This query is used to get Wcm Aggregated Tabular Data */
  getWcmAggregatedSpends: GetWcmAggregatedSpendsOutput;
  /** Query to get assignable wcm permissions for a permission manager */
  getWcmAllAssignablePermissionsForPermissionManager: GetWcmRolePermissionsOutput;
  /** Query to get negotiation sync enabled WCM external buyer map rows, optionally filtered by source name and data center */
  getWcmAllNegotiationSyncEnabledExternalBuyerMaps: Array<WcmExternalBuyerMap>;
  /** This query is used to get the file logs of the user */
  getWcmAllUserFileLogs: Array<WcmAllUserFileLogs>;
  /** Get WCM Benchmark Config for a buyer and currency */
  getWcmBenchmarkConfig?: Maybe<WcmBenchmarkConfigOutput>;
  /** Get WCM Benchmark Country Regulations for a buyer and currency */
  getWcmBenchmarkCountryRegulations: WcmBenchmarkCountryRegulationsOutput;
  /** Query to get all assignable wcm roles for a permission manager */
  getWcmBuyerAllAssignableRolesForPermissionManager: GetWcmBuyerAllAssignableRolesForPermissionManagerOutput;
  /** Get buyer configuration */
  getWcmBuyerConfig: BuyerAppBuyerConfigResponse;
  /** This query is used to fetch enriched file upload history for a buyer-currency */
  getWcmBuyerEnrichedFileUploadHistory: Array<WcmEnrichedFileUploadHistory>;
  /** Query to get buyer exclusion remarks */
  getWcmBuyerExclusionRemarks: Array<WcmBuyerExclusionRemark>;
  /** Query to get supplier configurations for a specific transaction */
  getWcmBuyerFileConfigs: GetWcmBuyerFileConfigsOutput;
  /** This query is used to fetch invoice file upload history for a buyer-currency */
  getWcmBuyerInvoiceFileUploadHistory: Array<WcmInvoiceFileUploadHistory>;
  /** This query is used to get the wcm buyer details */
  getWcmBuyerMetaData: WcmBuyerMetaDataOutput;
  /** Query to get wcm roles for a buyer */
  getWcmBuyerRoles: GetWcmBuyerRolesOutput;
  /** Query to validate if a user has access to a specific WCM buyer */
  getWcmBuyerUserAccess: WcmBuyerUserAccessOutput;
  /** Query to get wcm buyer users */
  getWcmBuyerUsers: GetWcmBuyerUsersOutput;
  /** Query to get wcm buyer users for wcm admin */
  getWcmBuyerUsersForAdmin: GetWcmBuyerUserDetailsForAdmin;
  /** Query to get WCM buyer users count filtered by buyer UUIDs. */
  getWcmBuyersUsersCount: Array<WcmBuyerUsersCountOutput>;
  /** This query is used to get the wcm spend cashflow distribution */
  getWcmCashflowDistribution: Array<WcmCashflowDistributionOutput>;
  /** Get cumulative financial trend data for the Financial Summary screen */
  getWcmCumulativeTrend: Array<WcmCumulativeBucket>;
  /** Get all custom attribute definitions with their unique values across all transactions */
  getWcmCustomAttributes: Array<WcmCustomAttributeResponse>;
  /** Get a dashboard. Owners receive draft + published; others receive published only. */
  getWcmDashboard: WcmDashboard;
  /** List dashboards visible to the current user for a buyer (metadata only) */
  getWcmDashboards: WcmDashboardList;
  /** Get the buyer's source spend currency and configured display FX rates. */
  getWcmDisplayCurrencyConfig: WcmDisplayCurrencyConfig;
  /** Get domain configuration by domain name */
  getWcmDomainConfig: WcmDomainClientConfigOutput;
  /** Fetches locked and updatable column definitions for the column-scoped update flow. */
  getWcmEnrichedSpendUpdatableColumns: WcmEnrichedSpendUpdatableColumns;
  /** This query is used to get the wcm exclusion criteria */
  getWcmExclusionCriteria: WcmExclusionCriteriaOutput;
  /** This query is used to get Wcm Exclusions Config */
  getWcmExclusionsConfig?: Maybe<WcmExclusionsConfigOutput>;
  /** Query to get WCM external buyer map rows, optionally filtered by source name */
  getWcmExternalBuyerMaps: Array<WcmExternalBuyerMapInfo>;
  /** This query is used to fetch suppliers for a transaction */
  getWcmFetchAllSupplier: WcmFetchAllWcmSuppliersOutput;
  /** This query is used to fetch supplier groups for a transaction */
  getWcmFetchAllSupplierGroups: WcmFetchAllSupplierGroupsOutput;
  /** This query is used to fetch suppliers satisfying working capital requirement */
  getWcmGenerateWorkingCapital: WcmGenerateWorkingCapitalOutput;
  /** This query is used to fetch supplier groups satisfying working capital requirement */
  getWcmGenerateWorkingCapitalGroups: WcmGenerateWorkingCapitalGroupsOutput;
  /** This query is used to get the grouped buyer working capital opportunity by supplier dimension */
  getWcmGroupedWorkingCapitalOpportunityByDimension: Array<WcmGroupedWorkingCapitalOpportunityByDimensionOutput>;
  /** List conversations for the current user and buyer. */
  getWcmInsightsConversations: Array<WcmInsightsConversationDto>;
  /** Get messages for a specific conversation. */
  getWcmInsightsMessages: Array<WcmInsightsMessageDto>;
  getWcmMasterBuyerDetail: WcmMasterBuyerList;
  /** Get negotiation snapshot per time bucket for the Financial Summary screen */
  getWcmMonitoringSnapshot: Array<WcmSnapshotBucket>;
  /** Get monitoring stats (headline KPIs) for the Financial Summary screen */
  getWcmMonitoringStats: WcmMonitoringStats;
  /** NAICS benchmark coverage table: buyer spend vs global benchmarks. */
  getWcmNaicsBenchmarkCoverage: WcmNaicsBenchmarkCoverage;
  /** Composed NAICS exclusion editor payload. */
  getWcmNaicsExclusions: WcmNaicsExclusions;
  /** This query is used to get NAICS suggestions */
  getWcmNaicsSuggestions: Array<WcmGetNaicsSuggestionsOutput>;
  /** Get a WCM supplier negotiation */
  getWcmNegotiation?: Maybe<WcmNegotiationOutput>;
  /** Get all negotiation status-to-phase mappings for a buyer + currency */
  getWcmNegotiationStatusPhaseMappings: Array<WcmStatusPhaseMappingItem>;
  /** Get WCM negotiations for multiple supplier entities */
  getWcmNegotiations: WcmNegotiationsOutput;
  /** This query is used to get the wcm payment terms */
  getWcmPaymentTerms: WcmPaymentTermsOutput;
  /** This query is used to get the payment terms benchmark by supplier dimension */
  getWcmPaymentTermsBenchmark: Array<WcmPaymentTermsBenchmarkOutput>;
  /** Get payment terms configurations for a buyer */
  getWcmPaymentTermsConfig: WcmPaymentTermsConfigResponse;
  /** This query is used to get the buyer's payment terms details */
  getWcmPaymentTermsLandscape: Array<WcmPaymentTermsLandscapeOutput>;
  /** Get all waves for a WCM plan */
  getWcmPlanWaves: Array<WcmPlanWaveOutput>;
  /** Get all WCM plans for a buyer */
  getWcmPlans: Array<WcmPlanOutput>;
  /** Get all WCM plans for a supplier group */
  getWcmPlansForSupplierGroup: Array<Scalars['String']['output']>;
  /** This query is used to get the details of the supplier profiles of same group of a supplier */
  getWcmSameSupplierGroupEntitiesData: WcmSupplierGroupEntitiesDataOutput;
  /** This query is used to search company financials by name or ticker symbol */
  getWcmSearchCompanyFinancials: Array<WcmSearchCompanyFinancialsOutput>;
  /** This query is used to get NAICS search results */
  getWcmSearchNaics: Array<WcmSearchNaicsOutput>;
  /** This query is used to get Wcm Segment Conversion Rate Config */
  getWcmSegmentConversionRate: WcmSegmentConversionRateConfigOutput;
  /** This query is used to get the buyer's spend analysis details */
  getWcmSpendAnalysisStats: WcmSpendAnalysisStatsOutput;
  /** This query is used to get the buyer's spend distribution details */
  getWcmSpendDistribution: Array<WcmSpendDistributionOutput>;
  /** This query is used to fetch spend filters */
  getWcmSpendDynamicFilters: WcmSpendDynamicFiltersOutput;
  /** Returns a signed S3 URL for the WCM spend file template download */
  getWcmSpendFileTemplateUrl: WcmSpendFileTemplateUrl;
  /** This query is used to get the buyer's spend geo overview */
  getWcmSpendGeoOverview: Array<WcmSpendGeoOverviewOutput>;
  /** This query is used to get the wcm spend stats */
  getWcmStats: WcmStatsOutput;
  /** Fetch every note for a supplier group, sorted newest-first. Only the first item (most recent note) is editable by the user. */
  getWcmSupplierGroupNotes: WcmSupplierGroupNotesOutput;
  /** Get WCM supplier health metrics for a specific supplier */
  getWcmSupplierHealthMetrics?: Maybe<WcmSupplierHealthMetricsOutput>;
  /** This query is used to get the details of the supplier profile */
  getWcmSupplierProfileData: WcmSupplierProfileDataOutput;
  /** This query is used to get Wcm supplier segment Config */
  getWcmSupplierSegmentConfig: FetchWcmSupplierSegmentConfigOutput;
  /** This query is used to get the buyer's suppliers spend overview */
  getWcmSupplierSpendOverview: Array<WcmSupplierSpendOverviewOutput>;
  /** Query to get benchmark strategy for suppliers by segment */
  getWcmSuppliersBenchmarkStrategyBySegment: WcmBenchmarkStrategyBySegmentOutput;
  /** Get negotiation tracking grouped by aggregator dimension (stacked bar chart) */
  getWcmTrackingByAggregator: Array<WcmTrackingByAggregatorGroup>;
  /** Get file upload status for all linked TRIAL WCM buyers of the current user */
  getWcmTrialBuyersFileStatus: Array<WcmBuyerFileStatus>;
  /** This query is used to get the details of the supplier profile */
  getWcmUserFileLogs: Array<WcmUserFileLogs>;
  /** This query is used to get wcm user info */
  getWcmUserInfo: WcmUserInfoOutput;
  /** This query is used to get user preference settings */
  getWcmUserPreference: GetWcmUserPreferenceOutput;
  /** Get list of wcm user registration requests with pagination, filtering, and sorting */
  getWcmUserRegistrationRequests: GetWcmRegistrationRequestsResponse;
  /** This query is used to get the working capital opportunity matrix */
  getWcmWorkingCapitalOpportunityMatrix: Array<WcmWorkingCapitalOpportunityMatrixOutput>;
  /** Gets login history for a user by uuid. Default limit is 20. Default sort is descending */
  loginHistory?: Maybe<Array<Maybe<LoginHistory>>>;
  lookupConfigValues: Array<LookupConfigValues>;
  lookupMaster: LookupMaster;
  lookupMasters: LookupMasterConnection;
  makerMarketClear: MakerMarketClear;
  makerMarketClearAggregate: Array<MakerMarketClearAggregateResponse>;
  makerMarketClears: MakerMarketClearConnection;
  makersTakersOrganizations: MakersTakersOrganizationsConnection;
  marketStats: Array<MarketStatsData>;
  /** Gets the current logged in user, only queryable from user and admin tokens */
  me?: Maybe<User>;
  orgStats: Array<OrgStatsData>;
  /** API to query all program level configurations for a funder buyer. */
  paymentConfigurationalData: FunderBuyerProgramFileSetOutput;
  program: Program;
  programFileset: ProgramFileset;
  programFilesets: Array<ProgramFileset>;
  programs: ProgramConnection;
  qualifiedSupplier: QualifiedSupplier;
  qualifiedSuppliers: QualifiedSupplierConnection;
  recipe: Recipe;
  recipes: Array<Recipe>;
  recordGroup: RecordGroup;
  recordGroupColumnDto: RecordGroupColumnDto;
  recordGroupColumnDtos: Array<RecordGroupColumnDto>;
  recordGroups: RecordGroupConnection;
  retrieveProfile?: Maybe<Profile>;
  /** Query to search users by name, email or uuid for wcm admin */
  searchWcmUsers: SearchWcmUsersOutput;
  /** Return an SRM by email address */
  srm?: Maybe<Srm>;
  supplierFilterDto: SupplierFilterDto;
  supplierFilterDtos: SupplierFilterDtoConnection;
  takerMarketClear: TakerMarketClear;
  takerMarketClearAggregate: Array<TakerMarketClearAggregateResponse>;
  takerMarketClears: TakerMarketClearConnection;
  takersMarkets: TakersMarketsConnection;
  takersMarketsAggregate: Array<TakersMarketsAggregateResponse>;
  /** Query to trigger manual award. */
  triggerBuyerAppManualAward: BuyerAppTriggerManualAwardOutput;
  user?: Maybe<User>;
  userByEmailAddress?: Maybe<User>;
  /** Search for users by name, email address, and uuid - returns a max of 100 users per datacenter. */
  userSearch?: Maybe<UsersResponse>;
  /** A list of users driven from Auth Service Info. Will return null when a user is not found. */
  users?: Maybe<UsersResponse>;
  /** A list of users driven from Auth Service Info. Will return null when a user is not found. */
  usersByEmailAddress?: Maybe<UsersResponse>;
};


export type QueryAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgreementAuditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgreementAuditsArgs = {
  filter?: AgreementAuditFilter;
  paging?: CursorPaging;
  sorting?: Array<AgreementAuditSort>;
};


export type QueryAgreementsArgs = {
  filter?: AgreementFilter;
  paging?: CursorPaging;
  sorting?: Array<AgreementSort>;
};


export type QueryAllTakersMarketsArgs = {
  filter?: TakersMarketsNoPageFilter;
  sorting?: Array<TakersMarketsNoPageSort>;
};


export type QueryBuyerArgs = {
  gatewayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuyerAppDivisionsUsersRolesArgs = {
  filter: BuyerAppDivisionsUsersRolesFilter;
};


export type QueryBuyerAppDualAuthEnabledArgs = {
  input: BuyerAppDualAuthorizationRolesEnabledInput;
};


export type QueryBuyerAppRolesArgs = {
  filter?: BuyerAppRoleFilter;
  paging?: CursorPaging;
  sorting?: Array<BuyerAppRoleSort>;
};


export type QueryBuyerAuditConfigDataArgs = {
  makerUuid: Scalars['String']['input'];
};


export type QueryBuyersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayBroadcast?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDcs?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayFind?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayUsercast?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryC2foColumnMasterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryC2foColumnMastersArgs = {
  filter?: C2foColumnMasterFilter;
  paging?: OffsetPaging;
  sorting?: Array<C2foColumnMasterSort>;
};


export type QueryCashInvestedArgs = {
  CashInvestedInput: CashInvestedInput;
};


export type QueryCompanyGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyGroupsArgs = {
  filter: CompanyGroupFilter;
  sorting?: Array<CompanyGroupSort>;
};


export type QueryCustomAgreementVersionHistoryArgs = {
  agreementUuid: Scalars['String']['input'];
};


export type QueryCustomAgreementWithContentArgs = {
  agreementUuid: Scalars['String']['input'];
  agreementVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomAgreementsArgs = {
  agreementNames?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<AgreementStatusEnum>;
};


export type QueryDivisionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDivisionsArgs = {
  filter?: DivisionFilter;
  paging?: CursorPaging;
  sorting?: Array<DivisionSort>;
};


export type QueryFetchCompanyGroupsArgs = {
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
};


export type QueryFetchCompanyGroupsIntersectionArgs = {
  FetchCompanyGroupsIntersectionInput: FetchCompanyGroupsIntersectionInput;
};


export type QueryFetchSuppliersForCompanyGroupArgs = {
  companyGroupUuid: Scalars['String']['input'];
  isDsf: Scalars['Boolean']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  paging: SupplierPaging;
};


export type QueryFetchUniqueCurrenciesForCgIntersectionArgs = {
  FetchUniqueCurrenciesForCGIntersectionInput: FetchUniqueCurrenciesLocationsForCgIntersectionInput;
};


export type QueryFetchUniqueLocationsForCgIntersectionArgs = {
  FetchUniqueCurrenciesForCGIntersectionInput: FetchUniqueCurrenciesLocationsForCgIntersectionInput;
};


export type QueryFunderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderBuyerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderBuyersArgs = {
  filter?: FunderBuyerFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderBuyerSort>;
};


export type QueryFunderCalculationsArgs = {
  filter?: FunderCalculationsFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderCalculationsSort>;
};


export type QueryFunderCurrenciesArgs = {
  filter?: FunderCurrenciesFilter;
  sorting?: Array<FunderCurrenciesSort>;
};


export type QueryFunderDeliverySettingsDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderDeliverySettingsDtosArgs = {
  filter?: FunderDeliverySettingsDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderDeliverySettingsDtoSort>;
};


export type QueryFunderFeedbackConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFeedbackConfigsArgs = {
  filter?: FunderFeedbackConfigFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderFeedbackConfigSort>;
};


export type QueryFunderFeedbackPipelineConfigByAckTypeArgs = {
  ackType: Scalars['String']['input'];
  funderUuid: Scalars['String']['input'];
};


export type QueryFunderFeedbackPipelineConfigsArgs = {
  funderUuid: Scalars['String']['input'];
};


export type QueryFunderFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFileColumnMasterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFileColumnMastersArgs = {
  filter?: FunderFileColumnMasterFilter;
  paging?: OffsetPaging;
  sorting?: Array<FunderFileColumnMasterSort>;
};


export type QueryFunderFileDeliveryDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFileDeliveryDtosArgs = {
  filter?: FunderFileDeliveryDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderFileDeliveryDtoSort>;
};


export type QueryFunderFilesArgs = {
  filter?: FunderFileFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderFileSort>;
};


export type QueryFunderGeographiesArgs = {
  filter?: FunderGeographiesFilter;
  sorting?: Array<FunderGeographiesSort>;
};


export type QueryFunderLegalAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderLegalAgreementsArgs = {
  filter?: FunderLegalAgreementFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderLegalAgreementSort>;
};


export type QueryFunderNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderNotificationsArgs = {
  filter?: FunderNotificationFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderNotificationSort>;
};


export type QueryFunderSummaryArgs = {
  id: Scalars['String']['input'];
};


export type QueryFunderVariableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderVariablesArgs = {
  filter?: FunderVariableFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderVariableSort>;
};


export type QueryFundersArgs = {
  filter?: FunderFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderSort>;
};


export type QueryGetAggregateHistoryInfoArgs = {
  HistoryInfoInput: HistoryInfoInput;
};


export type QueryGetAggregatedMarketStatsArgs = {
  data: AggregatedMarketsStatsInput;
};


export type QueryGetAggregatedSuppliersHistoryInfoArgs = {
  SupplierHistoryInfoInput: SupplierHistoryInfoInput;
};


export type QueryGetBuyerAppAggregatedScfDisclosureArgs = {
  input: BuyerAppAggregatedScfDisclosureInput;
};


export type QueryGetBuyerAppApPerformanceReportDataArgs = {
  input: BuyerAppApPerformanceReportInput;
};


export type QueryGetBuyerAppApSummaryDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppAwardHistoryArgs = {
  input: BuyerAppMakerMarketClearHistoryInputDto;
};


export type QueryGetBuyerAppAwardedSuppliersHistoryArgs = {
  AwardedSuppliersHistoryInput: BuyerAppAwardedSuppliersHistoryInput;
};


export type QueryGetBuyerAppClearHistoryGraphArgs = {
  input: BuyerAppClearHistoryGraphInput;
};


export type QueryGetBuyerAppClearHistoryStatsArgs = {
  input: BuyerAppClearHistoryStatsInput;
};


export type QueryGetBuyerAppClearingTopOffersArgs = {
  input: BuyerAppClearingTopOffersInput;
};


export type QueryGetBuyerAppCoreMarketMetricsDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppCoreMarketMetricsDownloadDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppCreditLimitArgs = {
  input: BuyerAppCreditLimitInput;
};


export type QueryGetBuyerAppCumulativeVendorsDataArgs = {
  input: BuyerAppBuyerReportsMarketsInput;
};


export type QueryGetBuyerAppDivisionRegionsArgs = {
  filter?: BuyerAppDivisionRegionFilter;
  sorting?: Array<BuyerAppDivisionRegionSort>;
};


export type QueryGetBuyerAppDivisionReportingCurrenciesArgs = {
  input: BuyerAppDivisionReportingCurrenciesInput;
};


export type QueryGetBuyerAppDivisionRolesArgs = {
  DivisionRolesGetInput: BuyerAppGetDivisionRolesInput;
};


export type QueryGetBuyerAppDpeAnalysisDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppEverAfterEmbedUrlArgs = {
  input: GetBuyerAppEverafterEmbedUrlInput;
};


export type QueryGetBuyerAppEverafterBuyerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBuyerAppFileHistoriesArgs = {
  filter?: BuyerAppFileHistoryFilter;
  paging?: CursorPaging;
  sorting?: Array<BuyerAppFileHistorySort>;
};


export type QueryGetBuyerAppFunderPaymentStatsArgs = {
  input: BuyerAppFunderPaymentStatsInput;
};


export type QueryGetBuyerAppLiveStatsArgs = {
  input: BuyerAppLiveHistoryStatsInput;
};


export type QueryGetBuyerAppMonthlyScfDisclosureArgs = {
  input: BuyerAppMonthlyScfDisclosureInput;
};


export type QueryGetBuyerAppNetworkGrowthDataArgs = {
  input: BuyerAppBuyerReportsMarketsInput;
};


export type QueryGetBuyerAppNonClearingTopOffersArgs = {
  input: BuyerAppNonClearingTopOffersInput;
};


export type QueryGetBuyerAppParticipationBreakdownDataArgs = {
  input: BuyerAppBuyerReportsMarketsInput;
};


export type QueryGetBuyerAppPerformanceByCurrencyDataArgs = {
  input: BuyerAppPerformanceByCurrencyDataInput;
};


export type QueryGetBuyerAppPerformanceByCurrencyStatsArgs = {
  input: BuyerAppPerformanceByCurrencyStatsInput;
};


export type QueryGetBuyerAppPrematurityAdviceArgs = {
  input: BuyerAppPrematurityAdviceInput;
};


export type QueryGetBuyerAppRecentManualFileUploadHistoryArgs = {
  input: BuyerAppManualUploadProcessorHistoryInput;
};


export type QueryGetBuyerAppRepeatVsNewIncomeArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppRepeatVsNewLoadedApDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppRevShareGraphArgs = {
  input: BuyerAppRevShareGraphInput;
};


export type QueryGetBuyerAppScfDisclosureTimeFrameBoundariesArgs = {
  input: BuyerAppScfDisclosureTimeframeBoundariesInput;
};


export type QueryGetBuyerAppSupplierAdjustmentsArgs = {
  input: BuyerAppSupplierAdjustmentsInput;
};


export type QueryGetBuyerAppSupplierClearHistoryArgs = {
  input: BuyerAppSupplierClearHistoryInput;
};


export type QueryGetBuyerAppSupplierDetailsArgs = {
  input: BuyerAppSupplierDetailsInput;
};


export type QueryGetBuyerAppSupplierInvoicesArgs = {
  input: BuyerAppSupplierInvoicesInput;
};


export type QueryGetBuyerAppSupplierPerformanceReportDataArgs = {
  input: BuyerAppSupplierPerformanceReportInput;
};


export type QueryGetBuyerAppSupplierSettingsArgs = {
  input: BuyerAppSupplierSettingsInput;
};


export type QueryGetBuyerAppSupplierStatsArgs = {
  input: BuyerAppSupplierStatsInput;
};


export type QueryGetBuyerAppSuppliersOffersArgs = {
  input: BuyerAppSuppliersOffersInput;
};


export type QueryGetBuyerAppUserPreferenceArgs = {
  input?: InputMaybe<GetBuyerAppUserPreferenceInput>;
};


export type QueryGetBuyerReportingCurrenciesArgs = {
  input: BuyerReportingCurrenciesInput;
};


export type QueryGetCashUsedArgs = {
  CashUsedInput: CashUsedInput;
};


export type QueryGetClearingStatsArgs = {
  ClearingStatsInput: ClearingStatsInput;
};


export type QueryGetEncryptionSettingDetailsArgs = {
  funderFileTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  funderUuid: Scalars['String']['input'];
};


export type QueryGetFileDeliverySettingsArgs = {
  fileType?: InputMaybe<Scalars['String']['input']>;
  funderFileTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  programUuid: Scalars['String']['input'];
  subType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFunderDeliveryRetryPolicyArgs = {
  funderUuid: Scalars['String']['input'];
};


export type QueryGetFunderDistinctWriterTypesArgs = {
  funderUuid: Scalars['String']['input'];
};


export type QueryGetIncomeOverTimeArgs = {
  data: GetIncomeOverTime;
};


export type QueryGetInvoiceStatsForMarketArgs = {
  filter: InvoiceStatsFilterForMarket;
};


export type QueryGetLiveMarketStatsArgs = {
  LiveMarketStatsInput: LiveMarketStatsInput;
};


export type QueryGetManyBuyerAppBuyerSupplierCountsArgs = {
  filter?: BuyerAppBuyerSupplierCountsFilter;
  sorting?: Array<BuyerAppBuyerSupplierCountsSort>;
};


export type QueryGetManyBuyerAppSubprocessorsSubscriptionDetailsArgs = {
  filter?: BuyerAppSubprocessorsSubscriptionFilter;
  sorting?: Array<BuyerAppSubprocessorsSubscriptionSort>;
};


export type QueryGetManyWcmMasterBuyersDetailsArgs = {
  filter?: WcmMasterBuyerListFilter;
  sorting?: Array<WcmMasterBuyerListSort>;
};


export type QueryGetManyWcmMasterCountryRegionDetailsArgs = {
  filter?: WcmMasterRegionCountryListFilter;
  sorting?: Array<WcmMasterRegionCountryListSort>;
};


export type QueryGetManyWcmUserBuyerMappingDetailsArgs = {
  filter?: WcmUserBuyerMappingDetailsFilter;
  sorting?: Array<WcmUserBuyerMappingDetailsSort>;
};


export type QueryGetManyWcmUserInformationArgs = {
  filter?: WcmUserInformationFilter;
  sorting?: Array<WcmUserInformationSort>;
};


export type QueryGetMarketSettingsArgs = {
  input: MarketSettingsInput;
};


export type QueryGetProgramFileConfigsArgs = {
  buyerUuid: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  funderName: Scalars['String']['input'];
};


export type QueryGetProgramFileSetConfigurationsV1Args = {
  funderUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryGetProgramUniqueCurrenciesArgs = {
  programUuid: Scalars['String']['input'];
};


export type QueryGetProgramUniqueLocationsArgs = {
  programUuid: Scalars['String']['input'];
};


export type QueryGetQualifiedSuppliersForProgramArgs = {
  SupplierDetailsInput: SupplierDetailsInput;
};


export type QueryGetSupplierStatsArgs = {
  SupplierStatsInput: SupplierStatsInput;
};


export type QueryGetTakersMarketsStatsForMarketArgs = {
  marketUuid: Scalars['String']['input'];
};


export type QueryGetWcmAdherenceDynamicInvoiceFiltersArgs = {
  input: WcmAdherenceDynamicInvoiceFiltersInput;
};


export type QueryGetWcmAdherenceKpiByAggregatorArgs = {
  input: WcmAdherenceKpiByAggregatorInput;
};


export type QueryGetWcmAdherenceKpiByPeriodArgs = {
  input: WcmAdherenceKpiByPeriodInput;
};


export type QueryGetWcmAdherenceKpisArgs = {
  input: WcmAdherenceKpisInput;
};


export type QueryGetWcmAdherenceTrendArgs = {
  input: WcmAdherenceTrendInput;
};


export type QueryGetWcmAggregatedSpendsArgs = {
  input: GetWcmAggregatedSpendsInput;
};


export type QueryGetWcmAllNegotiationSyncEnabledExternalBuyerMapsArgs = {
  input?: InputMaybe<GetWcmAllNegotiationSyncEnabledExternalBuyerMapsInput>;
};


export type QueryGetWcmBenchmarkConfigArgs = {
  input: GetWcmBenchmarkConfigInput;
};


export type QueryGetWcmBenchmarkCountryRegulationsArgs = {
  input: GetWcmBenchmarkCountryRegulationsInput;
};


export type QueryGetWcmBuyerAllAssignableRolesForPermissionManagerArgs = {
  input: GetWcmBuyerAllAssignableRolesForPermissionManagerInput;
};


export type QueryGetWcmBuyerConfigArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmBuyerEnrichedFileUploadHistoryArgs = {
  input: WcmFetchEnrichedFileUploadHistoryInput;
};


export type QueryGetWcmBuyerExclusionRemarksArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmBuyerFileConfigsArgs = {
  input: GetWcmBuyerFileConfigsInput;
};


export type QueryGetWcmBuyerInvoiceFileUploadHistoryArgs = {
  input: WcmFetchInvoiceFileUploadHistoryInput;
};


export type QueryGetWcmBuyerMetaDataArgs = {
  input: WcmBuyerMetaDataInput;
};


export type QueryGetWcmBuyerRolesArgs = {
  input: GetWcmBuyerRolesInput;
};


export type QueryGetWcmBuyerUserAccessArgs = {
  input: WcmBuyerUserAccessInput;
};


export type QueryGetWcmBuyerUsersArgs = {
  input: GetWcmBuyerUsersInput;
};


export type QueryGetWcmBuyerUsersForAdminArgs = {
  input: GetWcmBuyerUsersInput;
};


export type QueryGetWcmBuyersUsersCountArgs = {
  input: GetWcmBuyersUsersCountInput;
};


export type QueryGetWcmCashflowDistributionArgs = {
  input: WcmCashflowDistributionInput;
};


export type QueryGetWcmCumulativeTrendArgs = {
  input: WcmMonitoringCumulativeInput;
};


export type QueryGetWcmCustomAttributesArgs = {
  currency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmDashboardArgs = {
  id: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmDashboardsArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmDisplayCurrencyConfigArgs = {
  input: WcmGetDisplayCurrencyConfigInput;
};


export type QueryGetWcmDomainConfigArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetWcmEnrichedSpendUpdatableColumnsArgs = {
  input: WcmFetchEnrichedSpendUpdatableColumnsInput;
};


export type QueryGetWcmExclusionCriteriaArgs = {
  input: WcmExclusionCriteriaInput;
};


export type QueryGetWcmExclusionsConfigArgs = {
  input: GetWcmExclusionsConfigInput;
};


export type QueryGetWcmExternalBuyerMapsArgs = {
  input?: InputMaybe<GetWcmExternalBuyerMapsInput>;
};


export type QueryGetWcmFetchAllSupplierArgs = {
  input: WcmFetchAllSuppliersInput;
};


export type QueryGetWcmFetchAllSupplierGroupsArgs = {
  input: WcmFetchAllSupplierGroupsInput;
};


export type QueryGetWcmGenerateWorkingCapitalArgs = {
  input: WcmGenerateWorkingCapitalInput;
};


export type QueryGetWcmGenerateWorkingCapitalGroupsArgs = {
  input: WcmGenerateWorkingCapitalInput;
};


export type QueryGetWcmGroupedWorkingCapitalOpportunityByDimensionArgs = {
  input: WcmGroupedWorkingCapitalOpportunityByDimensionFilters;
};


export type QueryGetWcmInsightsConversationsArgs = {
  input: WcmInsightsConversationsInputDto;
};


export type QueryGetWcmInsightsMessagesArgs = {
  input: WcmInsightsMessagesInputDto;
};


export type QueryGetWcmMasterBuyerDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWcmMonitoringSnapshotArgs = {
  input: WcmMonitoringSnapshotInput;
};


export type QueryGetWcmMonitoringStatsArgs = {
  input: WcmMonitoringStatsInput;
};


export type QueryGetWcmNaicsBenchmarkCoverageArgs = {
  input: WcmGetNaicsBenchmarkCoverageInput;
};


export type QueryGetWcmNaicsExclusionsArgs = {
  input: WcmGetNaicsExclusionsInput;
};


export type QueryGetWcmNaicsSuggestionsArgs = {
  input: WcmGetNaicsSuggestionsInput;
};


export type QueryGetWcmNegotiationArgs = {
  currency: Scalars['String']['input'];
  vendorVariantId: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmNegotiationStatusPhaseMappingsArgs = {
  currency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmNegotiationsArgs = {
  currency: Scalars['String']['input'];
  input: GetWcmNegotiationsInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmPaymentTermsArgs = {
  input: WcmPaymentTermsInput;
};


export type QueryGetWcmPaymentTermsBenchmarkArgs = {
  input: WcmPaymentTermsBenchmarkFilters;
};


export type QueryGetWcmPaymentTermsConfigArgs = {
  input: GetWcmPaymentTermsConfigInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmPaymentTermsLandscapeArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmPlanWavesArgs = {
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmPlansArgs = {
  input: GetWcmPlansInput;
};


export type QueryGetWcmPlansForSupplierGroupArgs = {
  input: GetWcmPlansForSupplierGroupInput;
};


export type QueryGetWcmSameSupplierGroupEntitiesDataArgs = {
  input: WcmSupplierGroupEntitiesDataInput;
};


export type QueryGetWcmSearchCompanyFinancialsArgs = {
  input: WcmSearchCompanyFinancialsInput;
};


export type QueryGetWcmSearchNaicsArgs = {
  input: WcmSearchNaicsInput;
};


export type QueryGetWcmSegmentConversionRateArgs = {
  input: GetWcmSegmentConversionRateInput;
};


export type QueryGetWcmSpendAnalysisStatsArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmSpendDistributionArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmSpendDynamicFiltersArgs = {
  input: WcmSpendDynamicFiltersInput;
};


export type QueryGetWcmSpendFileTemplateUrlArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmSpendGeoOverviewArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmStatsArgs = {
  input: WcmStatsInput;
};


export type QueryGetWcmSupplierGroupNotesArgs = {
  input: GetWcmSupplierGroupNotesInput;
};


export type QueryGetWcmSupplierHealthMetricsArgs = {
  input: GetWcmSupplierHealthMetricsInput;
};


export type QueryGetWcmSupplierProfileDataArgs = {
  input: WcmSupplierProfileDataInput;
};


export type QueryGetWcmSupplierSegmentConfigArgs = {
  input: FetchWcmSupplierSegmentConfigInput;
};


export type QueryGetWcmSupplierSpendOverviewArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmSuppliersBenchmarkStrategyBySegmentArgs = {
  input: GetWcmSuppliersBenchmarkStrategyBySegmentInput;
};


export type QueryGetWcmTrackingByAggregatorArgs = {
  input: WcmMonitoringTrackingByAggregatorInput;
};


export type QueryGetWcmUserFileLogsArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmUserPreferenceArgs = {
  input?: InputMaybe<GetWcmUserPreferenceInput>;
};


export type QueryGetWcmUserRegistrationRequestsArgs = {
  input: GetWcmRegistrationRequestsInput;
};


export type QueryGetWcmWorkingCapitalOpportunityMatrixArgs = {
  input: WcmWorkingCapitalOpportunityMatrixFilters;
};


export type QueryLoginHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
  userUuids: Array<Scalars['ID']['input']>;
};


export type QueryLookupConfigValuesArgs = {
  filter?: LookupConfigValuesFilter;
  sorting?: Array<LookupConfigValuesSort>;
};


export type QueryLookupMasterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLookupMastersArgs = {
  filter?: LookupMasterFilter;
  paging?: CursorPaging;
  sorting?: Array<LookupMasterSort>;
};


export type QueryMakerMarketClearArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMakerMarketClearAggregateArgs = {
  filter?: InputMaybe<MakerMarketClearAggregateFilter>;
};


export type QueryMakerMarketClearsArgs = {
  filter?: MakerMarketClearFilter;
  paging?: CursorPaging;
  sorting?: Array<MakerMarketClearSort>;
};


export type QueryMakersTakersOrganizationsArgs = {
  filter?: MakersTakersOrganizationsFilter;
  paging?: CursorPaging;
  sorting?: Array<MakersTakersOrganizationsSort>;
};


export type QueryMarketStatsArgs = {
  marketStatsInput: MarketStatsInput;
};


export type QueryOrgStatsArgs = {
  orgStatsInput: OrgStatsInput;
};


export type QueryPaymentConfigurationalDataArgs = {
  fileType: Scalars['String']['input'];
  funderUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
};


export type QueryProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramFilesetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramFilesetsArgs = {
  filter?: ProgramFilesetFilter;
  sorting?: Array<ProgramFilesetSort>;
};


export type QueryProgramsArgs = {
  filter?: ProgramFilter;
  paging?: CursorPaging;
  sorting?: Array<ProgramSort>;
};


export type QueryQualifiedSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQualifiedSuppliersArgs = {
  filter?: QualifiedSupplierFilter;
  paging?: CursorPaging;
  sorting?: Array<QualifiedSupplierSort>;
};


export type QueryRecipeArgs = {
  gatewayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecipesArgs = {
  gatewayBroadcast?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDcs?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayFind?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayUsercast?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecordGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordGroupColumnDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordGroupColumnDtosArgs = {
  filter?: RecordGroupColumnDtoFilter;
  sorting?: Array<RecordGroupColumnDtoSort>;
};


export type QueryRecordGroupsArgs = {
  filter?: RecordGroupFilter;
  paging?: CursorPaging;
  sorting?: Array<RecordGroupSort>;
};


export type QueryRetrieveProfileArgs = {
  input: ProfileInput;
};


export type QuerySearchWcmUsersArgs = {
  input: SearchWcmUsersInput;
};


export type QuerySrmArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QuerySupplierFilterDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierFilterDtosArgs = {
  filter?: SupplierFilterDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<SupplierFilterDtoSort>;
};


export type QueryTakerMarketClearArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTakerMarketClearAggregateArgs = {
  filter?: InputMaybe<TakerMarketClearAggregateFilter>;
};


export type QueryTakerMarketClearsArgs = {
  filter?: TakerMarketClearFilter;
  paging?: CursorPaging;
  sorting?: Array<TakerMarketClearSort>;
};


export type QueryTakersMarketsArgs = {
  filter?: TakersMarketsFilter;
  paging?: CursorPaging;
  sorting?: Array<TakersMarketsSort>;
};


export type QueryTakersMarketsAggregateArgs = {
  filter?: InputMaybe<TakersMarketsAggregateFilter>;
};


export type QueryTriggerBuyerAppManualAwardArgs = {
  input: BuyerAppTriggerManualAwardInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByEmailAddressArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QueryUserSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryUsersByEmailAddressArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
};

export type Report_Type =
  | 'SUPPLIER_LEVEL_REPORT';

export type Report_TypeFilterComparison = {
  eq?: InputMaybe<Report_Type>;
  gt?: InputMaybe<Report_Type>;
  gte?: InputMaybe<Report_Type>;
  iLike?: InputMaybe<Report_Type>;
  in?: InputMaybe<Array<Report_Type>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Report_Type>;
  lt?: InputMaybe<Report_Type>;
  lte?: InputMaybe<Report_Type>;
  neq?: InputMaybe<Report_Type>;
  notILike?: InputMaybe<Report_Type>;
  notIn?: InputMaybe<Array<Report_Type>>;
  notLike?: InputMaybe<Report_Type>;
};

export type Recipe = {
  __typename?: 'Recipe';
  creationDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredients: Array<Scalars['String']['output']>;
  /** This is just a helper to let me know where the data came from. We probably dont want it in production */
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReconColumnDetails = {
  __typename?: 'ReconColumnDetails';
  batchReferenceColumn?: Maybe<Scalars['String']['output']>;
  companyIdColumn?: Maybe<Scalars['String']['output']>;
  invoiceIdColumn?: Maybe<Scalars['String']['output']>;
  transactionReferenceColumn?: Maybe<Scalars['String']['output']>;
  voucherIdColumn?: Maybe<Scalars['String']['output']>;
};

export type ReconColumnDetailsInput = {
  batchReferenceColumn?: InputMaybe<Scalars['String']['input']>;
  companyIdColumn?: InputMaybe<Scalars['String']['input']>;
  invoiceIdColumn?: InputMaybe<Scalars['String']['input']>;
  transactionReferenceColumn?: InputMaybe<Scalars['String']['input']>;
  voucherIdColumn?: InputMaybe<Scalars['String']['input']>;
};

export type RecordGroup = {
  __typename?: 'RecordGroup';
  funderFileTemplateId: Scalars['String']['output'];
  isBatchRecordGroup: Scalars['Boolean']['output'];
  isTransactionRecordGroup: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rgOrder: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type RecordGroupColumnDto = {
  __typename?: 'RecordGroupColumnDto';
  columnOrder: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  fileColumn?: Maybe<FunderFileColumnMaster>;
  funderFileColumnId: Scalars['String']['output'];
  groupBy: Scalars['Boolean']['output'];
  isBatchColumn: Scalars['Boolean']['output'];
  isInvoiceColumn: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isTransactionColumn: Scalars['Boolean']['output'];
  mergeConfig?: Maybe<MergeConfigOutput>;
  recordGroup?: Maybe<RecordGroup>;
  recordGroupId: Scalars['String']['output'];
  serializerConfig?: Maybe<SerializerColumnSettingsOuput>;
  sortBy: Scalars['Boolean']['output'];
  transformationConfig?: Maybe<Scalars['JSON']['output']>;
  uuid: Scalars['String']['output'];
};

export type RecordGroupColumnDtoDeleteFilter = {
  and?: InputMaybe<Array<RecordGroupColumnDtoDeleteFilter>>;
  or?: InputMaybe<Array<RecordGroupColumnDtoDeleteFilter>>;
  recordGroupId?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type RecordGroupColumnDtoDeleteResponse = {
  __typename?: 'RecordGroupColumnDtoDeleteResponse';
  columnOrder?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  funderFileColumnId?: Maybe<Scalars['String']['output']>;
  groupBy?: Maybe<Scalars['Boolean']['output']>;
  isBatchColumn?: Maybe<Scalars['Boolean']['output']>;
  isInvoiceColumn?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  isTransactionColumn?: Maybe<Scalars['Boolean']['output']>;
  mergeConfig?: Maybe<MergeConfigOutput>;
  recordGroupId?: Maybe<Scalars['String']['output']>;
  serializerConfig?: Maybe<SerializerColumnSettingsOuput>;
  sortBy?: Maybe<Scalars['Boolean']['output']>;
  transformationConfig?: Maybe<Scalars['JSON']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RecordGroupColumnDtoFilter = {
  and?: InputMaybe<Array<RecordGroupColumnDtoFilter>>;
  or?: InputMaybe<Array<RecordGroupColumnDtoFilter>>;
  recordGroupId?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type RecordGroupColumnDtoSort = {
  direction: SortDirection;
  field: RecordGroupColumnDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type RecordGroupColumnDtoSortFields =
  | 'recordGroupId'
  | 'uuid';

export type RecordGroupConnection = {
  __typename?: 'RecordGroupConnection';
  /** Array of edges. */
  edges: Array<RecordGroupEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type RecordGroupEdge = {
  __typename?: 'RecordGroupEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RecordGroup */
  node: RecordGroup;
};

export type RecordGroupFilter = {
  and?: InputMaybe<Array<RecordGroupFilter>>;
  funderFileTemplateId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RecordGroupFilter>>;
  rgOrder?: InputMaybe<NumberFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type RecordGroupSort = {
  direction: SortDirection;
  field: RecordGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type RecordGroupSortFields =
  | 'funderFileTemplateId'
  | 'rgOrder'
  | 'uuid';

/** C2FO registration information for a user. Use Auth UUID to look it up. */
export type RegistrationInfo = Node & {
  __typename?: 'RegistrationInfo';
  /** C2FO database ID. BigInt. */
  c2foDbId?: Maybe<Scalars['String']['output']>;
  /** Has the users email been verified */
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID */
  id: Scalars['ID']['output'];
  /** When the user was registered. */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** What method was used for registration. */
  registrationMethod?: Maybe<Scalars['String']['output']>;
  /** C2FO User status. 0 = new, 1 = new but not completed registration, 2 = completed registration */
  status?: Maybe<Scalars['Int']['output']>;
  /** Has the user accepted terms and conditions. */
  termsCondsFlag?: Maybe<Scalars['Boolean']['output']>;
};

/** C2FO registration information for a user. Use Auth UUID to look it up. */
export type RegistrationInfoInput = {
  /** Has the users email been verified */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** When the user was registered. */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** What method was used for registration. */
  registrationMethod?: InputMaybe<Scalars['String']['input']>;
  /** C2FO User status. 0 = new, 1 = new but not completed registration, 2 = completed registration */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Has the user accepted terms and conditions. */
  termsCondsFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveSuppliersInput = {
  /** All selected configuration */
  allSelected?: InputMaybe<PlanAllSelectedOptions>;
  /** List of vendor variant IDs to remove from the wave */
  vendorVariantIds: Array<Scalars['String']['input']>;
};

export type ReserveSettingsOutput = {
  __typename?: 'ReserveSettingsOutput';
  /** Priority of Invoice */
  invoicePriority?: Maybe<Scalars['String']['output']>;
  /** Percentage of Reserved amount */
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  /** Reserve ID */
  reserveSettingsId?: Maybe<Scalars['ID']['output']>;
  /** Reserve to be run before adjustment */
  runBeforeAdjustments?: Maybe<Scalars['Boolean']['output']>;
};

export type ReserveSettingsUnionBuyerAppDualAuthorization = BuyerAppDualAuthorization | ReserveSettingsOutput;

export type RestrictionSettingsOutput = {
  __typename?: 'RestrictionSettingsOutput';
  /** Max Days Paid Early */
  maxDPE?: Maybe<Scalars['Float']['output']>;
  /** Max Due Date of Invoice */
  maxDueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RestrictionUnionBuyerAppDualAuthorization = BuyerAppDualAuthorization | RestrictionSettingsOutput;

/** The Role for a user. Similar to title but a specific category we give them. */
export type Role =
  | 'ACCOUNTING'
  | 'ACCOUNTS_RECEIVABLE'
  | 'BOOKKEEPER'
  | 'BUYING_MANAGER'
  | 'CEO'
  | 'CFO'
  | 'CONTROLLER'
  | 'CPO'
  | 'CREDIT_MANAGER'
  | 'FINANCE_DIRECTOR'
  | 'OFFICE_MANAGER'
  /** Deprecated: use OFFICE_MANAGER OR OTHER. Kept around in case anyone has already used this. */
  | 'OFFICE_MANAGER_AND_OTHER'
  | 'OTHER'
  | 'OWNER_FOUNDER'
  | 'PRESIDENT'
  | 'TREASURER';

export type Service_Provider =
  | 'AWS'
  | 'GCP';

export type Suppliers_Offers_Advanced_Filter =
  | 'ALL_SUPPLIERS'
  | 'CLEARING_DPE_GTE_10_LT_20'
  | 'CLEARING_DPE_GTE_20_LT_30'
  | 'CLEARING_DPE_GTE_30'
  | 'CLEARING_DPE_LT_10'
  | 'CLEARING_YIELD_GTE_3PCT_LT_6PCT'
  | 'CLEARING_YIELD_GTE_6PCT_LT_9PCT'
  | 'CLEARING_YIELD_GTE_9PCT'
  | 'CLEARING_YIELD_LT_3PCT'
  | 'ELIGIBLE_AP_GTE_400K_LT_800K'
  | 'ELIGIBLE_AP_GTE_800K_LT_1200K'
  | 'ELIGIBLE_AP_GTE_1200K'
  | 'ELIGIBLE_AP_LT_400K'
  | 'HAS_CLEARING_AP'
  | 'HAS_NON_CLEARING_AP'
  | 'HAS_NOT_PLACED_OFFER'
  | 'HAS_PLACED_OFFER'
  | 'NON_CLEARING_DPE_GTE_10_LT_20'
  | 'NON_CLEARING_DPE_GTE_20_LT_30'
  | 'NON_CLEARING_DPE_GTE_30'
  | 'NON_CLEARING_DPE_LT_10'
  | 'NON_CLEARING_YIELD_GTE_3PCT_LT_6PCT'
  | 'NON_CLEARING_YIELD_GTE_6PCT_LT_9PCT'
  | 'NON_CLEARING_YIELD_GTE_9PCT'
  | 'NON_CLEARING_YIELD_LT_3PCT'
  | 'NON_REGISTERED_SUPPLIERS'
  | 'REGISTERED_SUPPLIERS'
  | 'WITHOUT_ELIGIBLE_AP'
  | 'WITH_ELIGIBLE_AP';

export type Suppliers_Offers_Order_Level =
  | 'CLEARING_AP'
  | 'CLEARING_DPE'
  | 'CLEARING_INCOME'
  | 'CLEARING_YIELD'
  | 'ELIGIBLE_AP'
  | 'NON_CLEARING_AP'
  | 'NON_CLEARING_DPE'
  | 'NON_CLEARING_INCOME'
  | 'NON_CLEARING_YIELD';

export type Supplier_Adjustments_Order_Level =
  | 'ADJ_INVOICE_ID'
  | 'AMOUNT'
  | 'DUE_DATE'
  | 'VOUCHER_ID';

export type Supplier_Invoices_Order_Level =
  | 'AMOUNT'
  | 'BLENDED_RETURN_AMOUNT'
  | 'DUE_DATE'
  | 'EARN'
  | 'MIN_DISCOUNT'
  | 'VOUCHER_ID';

export type Supplier_Operation_Type =
  | 'EXCLUDE'
  | 'INCLUDE';

export type SearchWcmUsersInput = {
  /** Filter to return only onboarded users */
  onlyOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search query for user name, email or uuid */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SearchWcmUsersOutput = {
  __typename?: 'SearchWcmUsersOutput';
  /** List of users found */
  users: Array<WcmPublicUser>;
};

export type SecretOverride = {
  __typename?: 'SecretOverride';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SegmentationRules = {
  /** Minimum spend for strategic suppliers */
  strategicMinSpend: Scalars['Float']['input'];
  /** Maximum spend for tail suppliers */
  tailMaxSpend: Scalars['Float']['input'];
};

export type SerializerColumnSettingsInput = {
  alignment?: InputMaybe<Scalars['String']['input']>;
  padValue?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type SerializerColumnSettingsOuput = {
  __typename?: 'SerializerColumnSettingsOuput';
  alignment?: Maybe<Scalars['String']['output']>;
  padValue?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type SerializerOverride = {
  __typename?: 'SerializerOverride';
  funderFileTemplateUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SerializerSettingsInput = {
  columnDelimiter?: InputMaybe<Scalars['String']['input']>;
  fileSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  maxFileRecords?: InputMaybe<Scalars['String']['input']>;
  maxFileSize?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateURI?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  useCRLF?: InputMaybe<Scalars['Boolean']['input']>;
  writeColumnHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  writeEmptyFile?: InputMaybe<Scalars['Boolean']['input']>;
  writeHeaders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SerializerSettingsOuput = {
  __typename?: 'SerializerSettingsOuput';
  columnDelimiter?: Maybe<Scalars['String']['output']>;
  fileSplitting?: Maybe<Scalars['Boolean']['output']>;
  maxFileRecords?: Maybe<Scalars['String']['output']>;
  maxFileSize?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateURI?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  useCRLF?: Maybe<Scalars['Boolean']['output']>;
  writeColumnHeaders?: Maybe<Scalars['Boolean']['output']>;
  writeEmptyFile?: Maybe<Scalars['Boolean']['output']>;
  writeHeaders?: Maybe<Scalars['Boolean']['output']>;
};

export type SetBuyerAuditConfigDto = {
  auditFileCount?: InputMaybe<Scalars['Float']['input']>;
  makerUuid: Scalars['String']['input'];
  type: BuyerAuditConfigType;
};

export type SetWcmUserAccessValidityInput = {
  /** Expiry date in yyyy-mm-dd format (max 30 days from today) */
  expiryDate: Scalars['String']['input'];
  /** User UUIDs for which to set access validity, max limit 200 */
  userUuids: Array<Scalars['String']['input']>;
};

export type SetWcmUserAccessValidityOutput = {
  __typename?: 'SetWcmUserAccessValidityOutput';
  /** Number of users for which access validity was set */
  count: Scalars['Float']['output'];
  /** Message describing the result */
  message: Scalars['String']['output'];
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type Settings = {
  __typename?: 'Settings';
  allowWeekendDelivery?: Maybe<Scalars['Boolean']['output']>;
  delayInSeconds?: Maybe<Scalars['Float']['output']>;
  deliveryLocation: Scalars['String']['output'];
  deliveryLocationName?: Maybe<Scalars['String']['output']>;
  deliveryMethod: Scalars['String']['output'];
  deliveryTime?: Maybe<Scalars['String']['output']>;
  isDeliveryEnabled: Scalars['Boolean']['output'];
  loadWindowEndTime?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  useBuyerLocation: Scalars['Boolean']['output'];
  x509SignedZipEnabled: Scalars['Boolean']['output'];
};

/** Sort Directions */
export type SortDirection =
  | 'ASC'
  | 'DESC';

export type SortField =
  | 'COMPANY_GROUP'
  | 'COMPANY_ID'
  | 'CURRENCY'
  | 'LOCATION'
  | 'SUPPLIER_NAME'
  | 'UPLOAD_DATE';

/** Sort Nulls Options */
export type SortNulls =
  | 'NULLS_FIRST'
  | 'NULLS_LAST';

export type Sorting = {
  groupBy: GroupByDto;
  orderBy?: InputMaybe<Array<OrderByDto>>;
};

/** Supplier Relationship Manager (SRM) - SRM's are assigned to SalesForce Accounts. Supplier Divisions are connected to those Accounts. */
export type Srm = {
  __typename?: 'Srm';
  /** A link to the users calendar service. Could be Calendly or Microsoft Bookings. If this field is null then the SRM does not have a calendar link. */
  calendarLink?: Maybe<Scalars['String']['output']>;
  /**
   * Calendly ID - sometimes has bad data. You should rely on th calendlyLink to be clean.
   * @deprecated Calendly is not longer supported. Use calendarLink instead.
   */
  calendlyId?: Maybe<Scalars['String']['output']>;
  /**
   * DEPRECATED: Link to Calendly - if null then calendly is not enabled for the SRM.
   * @deprecated Use calendarLink instead.
   */
  calendlyLink?: Maybe<Scalars['String']['output']>;
  /** The office the SRM works out of. USA-SRM, GBR-SRM, CHN-SRM, IND-SRM, etc. */
  center?: Maybe<Scalars['String']['output']>;
  /** Email Address of the SRM */
  emailAddress: Scalars['String']['output'];
  /** Lets the client know if the SRM was null, and we provide to a fallback. */
  fallback: Scalars['Boolean']['output'];
  /** First name of the SRM */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * If calendly is enabled or not. If this is false, then the calendly link is potentially invalid.
   * @deprecated Calendly is not longer supported. There is not replacement boolean field for this. If you want to know if a user has a calendar link then query for `calendarLink`.
   */
  isCalendlyEnabled: Scalars['Boolean']['output'];
  /** Last name of the SRM */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone Number of the SRM */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Salesforce specific ID of the SRM */
  salesforceId: Scalars['String']['output'];
  /** The team of the SRM. US-KS-HQ is the most common. IN-MUMBAI, UK-BRISTOL, CN-SUZHOU, etc. */
  team?: Maybe<Scalars['String']['output']>;
  /** Username for SRM - this does not always match the email address. You should use email address for displaying in app. */
  username: Scalars['String']['output'];
};

export type StringComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notILike?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeBuyerAppSubprocessorsNotificationInput = {
  /** Email Address */
  emailAddress: Scalars['String']['input'];
  /** Entity Name */
  entityName: Scalars['String']['input'];
  /** Organization Uuid */
  organizationUuid: Scalars['String']['input'];
  /** Role at Entity */
  role: Scalars['String']['input'];
};

export type SummaryDetails = {
  __typename?: 'SummaryDetails';
  funderFileType?: Maybe<FunderFileType>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  companyGroup?: Maybe<Scalars['String']['output']>;
  companyGroupUuid?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  makerId?: Maybe<Scalars['Float']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  updatedBy: Scalars['String']['output'];
  uploadDate: Scalars['DateTime']['output'];
};

export type SupplierDetailsFilters = {
  companyGroup?: InputMaybe<StringComparison>;
  companyId?: InputMaybe<StringComparison>;
  currency?: InputMaybe<StringComparison>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<StringComparison>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierName?: InputMaybe<StringComparison>;
};

export type SupplierDetailsInput = {
  filters?: InputMaybe<SupplierDetailsFilters>;
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  paging: SupplierDetailsPaging;
  programUuid: Scalars['String']['input'];
  sorting: SupplierDetailsSorting;
};

export type SupplierDetailsOutput = {
  __typename?: 'SupplierDetailsOutput';
  newSuppliers?: Maybe<Array<NewSuppliers>>;
  supplierDetails?: Maybe<Array<SupplierDetails>>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SupplierDetailsPaging = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};

export type SupplierDetailsSorting = {
  orderBy?: Direction;
  sortingField?: SortField;
};

export type SupplierFilterDto = {
  __typename?: 'SupplierFilterDto';
  filterName: Scalars['String']['output'];
};

export type SupplierFilterDtoConnection = {
  __typename?: 'SupplierFilterDtoConnection';
  /** Array of edges. */
  edges: Array<SupplierFilterDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type SupplierFilterDtoEdge = {
  __typename?: 'SupplierFilterDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SupplierFilterDto */
  node: SupplierFilterDto;
};

export type SupplierFilterDtoFilter = {
  and?: InputMaybe<Array<SupplierFilterDtoFilter>>;
  filterName?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierFilterDtoFilter>>;
};

export type SupplierFilterDtoSort = {
  direction: SortDirection;
  field: SupplierFilterDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type SupplierFilterDtoSortFields =
  | 'filterName';

export type SupplierHistoryInfo = {
  __typename?: 'SupplierHistoryInfo';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceCounts?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  divisionId?: Maybe<Scalars['Float']['output']>;
  firstAwardDate?: Maybe<Scalars['DateTime']['output']>;
  lastAwardDate?: Maybe<Scalars['DateTime']['output']>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierHistoryInfoAggregationLevel =
  | 'CURRENCY'
  | 'MARKET'
  | 'PAY_DATE'
  | 'TAKER';

export type SupplierHistoryInfoFilters = {
  clearedInvoiceAmount?: InputMaybe<NumberComparison>;
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  marketUuids: Array<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  takerUuids: Array<Scalars['String']['input']>;
};

export type SupplierHistoryInfoGroupBy = {
  aggregationLevels?: InputMaybe<Array<SupplierHistoryInfoAggregationLevel>>;
  timePeriod?: InputMaybe<GroupByTimePeriod>;
};

export type SupplierHistoryInfoInput = {
  filters: SupplierHistoryInfoFilters;
  paging: SupplierHistoryInfoPaging;
  sorting: SupplierHistoryInfoSorting;
};

export type SupplierHistoryInfoOrderBy = {
  orderLevel: SupplierHistoryInfoOrderLevel;
  orderType?: OrderTypeEnums;
};

export type SupplierHistoryInfoOrderLevel =
  | 'CLEARED_INVOICE_AMOUNT'
  | 'PAY_DATE';

export type SupplierHistoryInfoOutput = {
  __typename?: 'SupplierHistoryInfoOutput';
  history?: Maybe<Array<SupplierHistoryInfo>>;
  totalRows?: Maybe<Scalars['Float']['output']>;
};

export type SupplierHistoryInfoPaging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type SupplierHistoryInfoSorting = {
  groupBy: SupplierHistoryInfoGroupBy;
  orderBy?: InputMaybe<Array<SupplierHistoryInfoOrderBy>>;
};

export type SupplierIntersectionDetails = {
  __typename?: 'SupplierIntersectionDetails';
  companyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SupplierPaging = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};

export type SupplierSegmentationConfig = {
  __typename?: 'SupplierSegmentationConfig';
  /** Maximum spend value across all supplier groups */
  maxGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend value across all supplier groups */
  minGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend for strategic suppliers */
  strategicMinSpend: Scalars['Float']['output'];
  /** Maximum spend for tail suppliers */
  tailMaxSpend: Scalars['Float']['output'];
};

export type SupplierStats = {
  __typename?: 'SupplierStats';
  clearingSuppliersCount: Scalars['Int']['output'];
  eligibleSuppliersCount: Scalars['Int']['output'];
  nonClearingSuppliersCount: Scalars['Int']['output'];
  overallTotal: Scalars['Int']['output'];
  overallWithAp: Scalars['Int']['output'];
  overallWithoutAp: Scalars['Int']['output'];
  participatingSuppliersCount: Scalars['Int']['output'];
  participatingTotal: Scalars['Int']['output'];
  participatingWithAp: Scalars['Int']['output'];
  participatingWithoutAp: Scalars['Int']['output'];
  registeredTotal: Scalars['Int']['output'];
  registeredWithAp: Scalars['Int']['output'];
  registeredWithoutAp: Scalars['Int']['output'];
};

export type SupplierStatsInput = {
  marketUuids?: Array<Scalars['String']['input']>;
};

export type SuppliersDataDto = {
  __typename?: 'SuppliersDataDto';
  companyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  isPinned: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
};

export type SuppliersOutputDto = {
  __typename?: 'SuppliersOutputDto';
  supplierDetails?: Maybe<Array<SuppliersDataDto>>;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type SyncDsfCompanyGroupInput = {
  companyGroupName: Scalars['String']['input'];
  companyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};

export type SyncUsersResponse = {
  __typename?: 'SyncUsersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SyncWcmPlanResponse = {
  __typename?: 'SyncWcmPlanResponse';
  /** Whether the plan was successfully synced */
  isSynced: Scalars['Boolean']['output'];
  /** Sync operation result message */
  message: Scalars['String']['output'];
};

export type Time_Periods =
  | 'DAY'
  | 'MONTH'
  | 'QUARTER'
  | 'WEEK'
  | 'YEAR';

export type TakerMarketClear = {
  __typename?: 'TakerMarketClear';
  acceptedAprWeightedSum: Scalars['Float']['output'];
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedAprWeightedSum: Scalars['Float']['output'];
  clearedAprWeightedSum: Scalars['Float']['output'];
  clearedDiscountWeightedSum: Scalars['Float']['output'];
  clearedDiscountedAmount: Scalars['Float']['output'];
  clearedDpeWeightedSum: Scalars['Float']['output'];
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedInvoiceCount: Scalars['Float']['output'];
  clearedYield?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  dataCenterCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Int']['output'];
  marketUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type TakerMarketClearAggregateFilter = {
  and?: InputMaybe<Array<TakerMarketClearAggregateFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  clearedEarn?: InputMaybe<NumberFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TakerMarketClearAggregateFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakerMarketClearAggregateGroupBy = {
  __typename?: 'TakerMarketClearAggregateGroupBy';
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPendingClear?: Maybe<Scalars['Boolean']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakerMarketClearAggregateResponse = {
  __typename?: 'TakerMarketClearAggregateResponse';
  avg?: Maybe<TakerMarketClearAvgAggregate>;
  count?: Maybe<TakerMarketClearCountAggregate>;
  groupBy?: Maybe<TakerMarketClearAggregateGroupBy>;
  max?: Maybe<TakerMarketClearMaxAggregate>;
  min?: Maybe<TakerMarketClearMinAggregate>;
  sum?: Maybe<TakerMarketClearSumAggregate>;
};

export type TakerMarketClearAvgAggregate = {
  __typename?: 'TakerMarketClearAvgAggregate';
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
};

export type TakerMarketClearConnection = {
  __typename?: 'TakerMarketClearConnection';
  /** Array of edges. */
  edges: Array<TakerMarketClearEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type TakerMarketClearCountAggregate = {
  __typename?: 'TakerMarketClearCountAggregate';
  awardDate?: Maybe<Scalars['Int']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  clearedEarn?: Maybe<Scalars['Int']['output']>;
  dataCenterCode?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPendingClear?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['Int']['output']>;
};

export type TakerMarketClearEdge = {
  __typename?: 'TakerMarketClearEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TakerMarketClear */
  node: TakerMarketClear;
};

export type TakerMarketClearFilter = {
  and?: InputMaybe<Array<TakerMarketClearFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  clearedEarn?: InputMaybe<NumberFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TakerMarketClearFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakerMarketClearMaxAggregate = {
  __typename?: 'TakerMarketClearMaxAggregate';
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakerMarketClearMinAggregate = {
  __typename?: 'TakerMarketClearMinAggregate';
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakerMarketClearSort = {
  direction: SortDirection;
  field: TakerMarketClearSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakerMarketClearSortFields =
  | 'awardDate'
  | 'clearedDiscountedAmount'
  | 'clearedEarn'
  | 'dataCenterCode'
  | 'id'
  | 'isPendingClear'
  | 'makerUuid'
  | 'marketUuid'
  | 'takerUuid';

export type TakerMarketClearSumAggregate = {
  __typename?: 'TakerMarketClearSumAggregate';
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarkets = {
  __typename?: 'TakersMarkets';
  acceptedAprWeightedAvg: Scalars['Float']['output'];
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg: Scalars['Float']['output'];
  acceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount: Scalars['Float']['output'];
  acceptedDpeWeightedAvg: Scalars['Float']['output'];
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount: Scalars['Float']['output'];
  awardedDpeWeightedAvg: Scalars['Float']['output'];
  awardedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode: Scalars['String']['output'];
  eligibleAprWeightedSum: Scalars['Float']['output'];
  eligibleDpeWeightedAvg: Scalars['Float']['output'];
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceCount: Scalars['Float']['output'];
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ineligibleEpInvoiceAmount: Scalars['Float']['output'];
  ineligibleEpInvoiceCount: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  makerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  makerExcludedInvoiceAmount: Scalars['Float']['output'];
  makerExcludedInvoiceCount: Scalars['Float']['output'];
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationId?: Maybe<Scalars['Float']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid: Scalars['String']['output'];
  marketId: Scalars['Int']['output'];
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  matchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  matchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  maxAcceptedApr?: Maybe<Scalars['Float']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  maxNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinYield?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg: Scalars['Float']['output'];
  pendingDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  pendingDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  pendingEarn: Scalars['Float']['output'];
  pendingInvoiceAmount: Scalars['Float']['output'];
  pendingInvoiceCount: Scalars['Float']['output'];
  reservedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  reservedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount: Scalars['Float']['output'];
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices: Scalars['Boolean']['output'];
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigOfferType?: Maybe<Scalars['String']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  takerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationId?: Maybe<Scalars['Float']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
  totalAdjustedAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarketsAggregateFilter = {
  acceptedAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<TakersMarketsAggregateFilter>>;
  awardedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  awardedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<NumberFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  eligibleAprWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  eligibleYield?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  ineligibleEpInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  ineligibleEpInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastClearDate?: InputMaybe<DateFieldComparison>;
  makerDivisionName?: InputMaybe<StringFieldComparison>;
  makerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationName?: InputMaybe<StringFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketProductType?: InputMaybe<StringFieldComparison>;
  marketType?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  maxAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  maxEligibleDpe?: InputMaybe<IntFieldComparison>;
  minEligibleDpe?: InputMaybe<IntFieldComparison>;
  minPendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedAboveMinEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  notAcceptedEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TakersMarketsAggregateFilter>>;
  pendingAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  pendingEarn?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceCount?: InputMaybe<NumberFieldComparison>;
  signedUpCount?: InputMaybe<NumberFieldComparison>;
  takerConfigCreated?: InputMaybe<DateFieldComparison>;
  takerConfigDisableAt?: InputMaybe<DateFieldComparison>;
  takerConfigExcludeNewInvoices?: InputMaybe<BooleanFieldComparison>;
  takerConfigId?: InputMaybe<IntFieldComparison>;
  takerConfigIsDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  takerConfigIsEnabled?: InputMaybe<BooleanFieldComparison>;
  takerConfigMaxApr?: InputMaybe<NumberFieldComparison>;
  takerConfigMaxDiscount?: InputMaybe<NumberFieldComparison>;
  takerConfigUpdated?: InputMaybe<DateFieldComparison>;
  takerDivisionName?: InputMaybe<StringFieldComparison>;
  takerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerMakerId?: InputMaybe<StringFieldComparison>;
  takerOrganizationName?: InputMaybe<StringFieldComparison>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakersMarketsAggregateGroupBy = {
  __typename?: 'TakersMarketsAggregateGroupBy';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakersMarketsAggregateResponse = {
  __typename?: 'TakersMarketsAggregateResponse';
  avg?: Maybe<TakersMarketsAvgAggregate>;
  count?: Maybe<TakersMarketsCountAggregate>;
  groupBy?: Maybe<TakersMarketsAggregateGroupBy>;
  max?: Maybe<TakersMarketsMaxAggregate>;
  min?: Maybe<TakersMarketsMinAggregate>;
  sum?: Maybe<TakersMarketsSumAggregate>;
};

export type TakersMarketsAvgAggregate = {
  __typename?: 'TakersMarketsAvgAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarketsConnection = {
  __typename?: 'TakersMarketsConnection';
  /** Array of edges. */
  edges: Array<TakersMarketsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type TakersMarketsCountAggregate = {
  __typename?: 'TakersMarketsCountAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Int']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Int']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Int']['output']>;
  acceptedEarn?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  acceptedYield?: Maybe<Scalars['Int']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  awardedEarn?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  awardedYield?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  dataCenterCode?: Maybe<Scalars['Int']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Int']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Int']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Int']['output']>;
  eligibleYield?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Int']['output']>;
  lastClearDate?: Maybe<Scalars['Int']['output']>;
  makerDivisionName?: Maybe<Scalars['Int']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Int']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['Int']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['Int']['output']>;
  marketType?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Int']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Int']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Int']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  notAcceptedYield?: Maybe<Scalars['Int']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Int']['output']>;
  pendingEarn?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Int']['output']>;
  signedUpCount?: Maybe<Scalars['Int']['output']>;
  takerConfigCreated?: Maybe<Scalars['Int']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['Int']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Int']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Int']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Int']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Int']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Int']['output']>;
  takerConfigUpdated?: Maybe<Scalars['Int']['output']>;
  takerDivisionName?: Maybe<Scalars['Int']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Int']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['Int']['output']>;
  takerOrganizationName?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['Int']['output']>;
};

export type TakersMarketsEdge = {
  __typename?: 'TakersMarketsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TakersMarkets */
  node: TakersMarkets;
};

export type TakersMarketsFilter = {
  acceptedAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<TakersMarketsFilter>>;
  awardedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  awardedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<NumberFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  eligibleAprWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  eligibleYield?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  ineligibleEpInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  ineligibleEpInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastClearDate?: InputMaybe<DateFieldComparison>;
  makerDivisionName?: InputMaybe<StringFieldComparison>;
  makerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationName?: InputMaybe<StringFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketProductType?: InputMaybe<StringFieldComparison>;
  marketType?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  maxAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  maxEligibleDpe?: InputMaybe<IntFieldComparison>;
  minEligibleDpe?: InputMaybe<IntFieldComparison>;
  minPendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedAboveMinEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  notAcceptedEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TakersMarketsFilter>>;
  pendingAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  pendingEarn?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceCount?: InputMaybe<NumberFieldComparison>;
  signedUpCount?: InputMaybe<NumberFieldComparison>;
  takerConfigCreated?: InputMaybe<DateFieldComparison>;
  takerConfigDisableAt?: InputMaybe<DateFieldComparison>;
  takerConfigExcludeNewInvoices?: InputMaybe<BooleanFieldComparison>;
  takerConfigId?: InputMaybe<IntFieldComparison>;
  takerConfigIsDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  takerConfigIsEnabled?: InputMaybe<BooleanFieldComparison>;
  takerConfigMaxApr?: InputMaybe<NumberFieldComparison>;
  takerConfigMaxDiscount?: InputMaybe<NumberFieldComparison>;
  takerConfigUpdated?: InputMaybe<DateFieldComparison>;
  takerDivisionName?: InputMaybe<StringFieldComparison>;
  takerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerMakerId?: InputMaybe<StringFieldComparison>;
  takerOrganizationName?: InputMaybe<StringFieldComparison>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakersMarketsMaxAggregate = {
  __typename?: 'TakersMarketsMaxAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakersMarketsMinAggregate = {
  __typename?: 'TakersMarketsMinAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakersMarketsNoPage = {
  __typename?: 'TakersMarketsNoPage';
  acceptedAprWeightedAvg: Scalars['Float']['output'];
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg: Scalars['Float']['output'];
  acceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount: Scalars['Float']['output'];
  acceptedDpeWeightedAvg: Scalars['Float']['output'];
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount: Scalars['Float']['output'];
  awardedDpeWeightedAvg: Scalars['Float']['output'];
  awardedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode: Scalars['String']['output'];
  eligibleAprWeightedSum: Scalars['Float']['output'];
  eligibleDpeWeightedAvg: Scalars['Float']['output'];
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceCount: Scalars['Float']['output'];
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ineligibleEpInvoiceAmount: Scalars['Float']['output'];
  ineligibleEpInvoiceCount: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  makerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  makerExcludedInvoiceAmount: Scalars['Float']['output'];
  makerExcludedInvoiceCount: Scalars['Float']['output'];
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationId?: Maybe<Scalars['Float']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid: Scalars['String']['output'];
  marketId: Scalars['Int']['output'];
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  matchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  matchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  maxAcceptedApr?: Maybe<Scalars['Float']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  maxNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinYield?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg: Scalars['Float']['output'];
  pendingDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  pendingDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  pendingEarn: Scalars['Float']['output'];
  pendingInvoiceAmount: Scalars['Float']['output'];
  pendingInvoiceCount: Scalars['Float']['output'];
  reservedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  reservedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount: Scalars['Float']['output'];
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices: Scalars['Boolean']['output'];
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigOfferType?: Maybe<Scalars['String']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  takerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationId?: Maybe<Scalars['Float']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
  totalAdjustedAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarketsNoPageFilter = {
  acceptedAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<TakersMarketsNoPageFilter>>;
  awardedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  awardedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<NumberFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  eligibleAprWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  eligibleYield?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  ineligibleEpInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  ineligibleEpInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastClearDate?: InputMaybe<DateFieldComparison>;
  makerDivisionName?: InputMaybe<StringFieldComparison>;
  makerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationName?: InputMaybe<StringFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketProductType?: InputMaybe<StringFieldComparison>;
  marketType?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  maxAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  maxEligibleDpe?: InputMaybe<IntFieldComparison>;
  minEligibleDpe?: InputMaybe<IntFieldComparison>;
  minPendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedAboveMinEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  notAcceptedEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TakersMarketsNoPageFilter>>;
  pendingAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  pendingEarn?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceCount?: InputMaybe<NumberFieldComparison>;
  signedUpCount?: InputMaybe<NumberFieldComparison>;
  takerConfigCreated?: InputMaybe<DateFieldComparison>;
  takerConfigDisableAt?: InputMaybe<DateFieldComparison>;
  takerConfigExcludeNewInvoices?: InputMaybe<BooleanFieldComparison>;
  takerConfigId?: InputMaybe<IntFieldComparison>;
  takerConfigIsDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  takerConfigIsEnabled?: InputMaybe<BooleanFieldComparison>;
  takerConfigMaxApr?: InputMaybe<NumberFieldComparison>;
  takerConfigMaxDiscount?: InputMaybe<NumberFieldComparison>;
  takerConfigUpdated?: InputMaybe<DateFieldComparison>;
  takerDivisionName?: InputMaybe<StringFieldComparison>;
  takerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerMakerId?: InputMaybe<StringFieldComparison>;
  takerOrganizationName?: InputMaybe<StringFieldComparison>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakersMarketsNoPageSort = {
  direction: SortDirection;
  field: TakersMarketsNoPageSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakersMarketsNoPageSortFields =
  | 'acceptedAprWeightedAvg'
  | 'acceptedDiscountWeightedAvg'
  | 'acceptedDiscountedAmount'
  | 'acceptedDpeWeightedAvg'
  | 'acceptedDpeWeightedSum'
  | 'acceptedEarn'
  | 'acceptedInvoiceAmount'
  | 'acceptedInvoiceCount'
  | 'acceptedYield'
  | 'awardedDiscountedAmount'
  | 'awardedDpeWeightedAvg'
  | 'awardedEarn'
  | 'awardedInvoiceAmount'
  | 'awardedInvoiceCount'
  | 'awardedYield'
  | 'currency'
  | 'dataCenterCode'
  | 'eligibleAprWeightedSum'
  | 'eligibleDpeWeightedAvg'
  | 'eligibleDpeWeightedSum'
  | 'eligibleInvoiceAmount'
  | 'eligibleInvoiceCount'
  | 'eligibleYield'
  | 'id'
  | 'ineligibleEpInvoiceAmount'
  | 'ineligibleEpInvoiceCount'
  | 'lastClearDate'
  | 'makerDivisionName'
  | 'makerExcludedForTodayInvoiceAmount'
  | 'makerExcludedForTodayInvoiceCount'
  | 'makerExcludedInvoiceAmount'
  | 'makerExcludedInvoiceCount'
  | 'makerId'
  | 'makerOrganizationName'
  | 'makerOrganizationUuid'
  | 'makerUuid'
  | 'marketId'
  | 'marketProductType'
  | 'marketType'
  | 'marketUuid'
  | 'maxAcceptedInvoiceAmount'
  | 'maxEligibleDpe'
  | 'minEligibleDpe'
  | 'minPendingInvoiceAmount'
  | 'notAcceptedAboveMinEarn'
  | 'notAcceptedDpeWeightedAvg'
  | 'notAcceptedDpeWeightedSum'
  | 'notAcceptedEarn'
  | 'notAcceptedInvoiceAmount'
  | 'notAcceptedInvoiceCount'
  | 'notAcceptedYield'
  | 'pendingAprWeightedAvg'
  | 'pendingEarn'
  | 'pendingInvoiceAmount'
  | 'pendingInvoiceCount'
  | 'signedUpCount'
  | 'takerConfigCreated'
  | 'takerConfigDisableAt'
  | 'takerConfigExcludeNewInvoices'
  | 'takerConfigId'
  | 'takerConfigIsDiscountBidding'
  | 'takerConfigIsEnabled'
  | 'takerConfigMaxApr'
  | 'takerConfigMaxDiscount'
  | 'takerConfigUpdated'
  | 'takerDivisionName'
  | 'takerExcludedForTodayInvoiceAmount'
  | 'takerExcludedForTodayInvoiceCount'
  | 'takerExcludedInvoiceAmount'
  | 'takerExcludedInvoiceCount'
  | 'takerId'
  | 'takerMakerId'
  | 'takerOrganizationName'
  | 'takerUuid';

export type TakersMarketsSort = {
  direction: SortDirection;
  field: TakersMarketsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakersMarketsSortFields =
  | 'acceptedAprWeightedAvg'
  | 'acceptedDiscountWeightedAvg'
  | 'acceptedDiscountedAmount'
  | 'acceptedDpeWeightedAvg'
  | 'acceptedDpeWeightedSum'
  | 'acceptedEarn'
  | 'acceptedInvoiceAmount'
  | 'acceptedInvoiceCount'
  | 'acceptedYield'
  | 'awardedDiscountedAmount'
  | 'awardedDpeWeightedAvg'
  | 'awardedEarn'
  | 'awardedInvoiceAmount'
  | 'awardedInvoiceCount'
  | 'awardedYield'
  | 'currency'
  | 'dataCenterCode'
  | 'eligibleAprWeightedSum'
  | 'eligibleDpeWeightedAvg'
  | 'eligibleDpeWeightedSum'
  | 'eligibleInvoiceAmount'
  | 'eligibleInvoiceCount'
  | 'eligibleYield'
  | 'id'
  | 'ineligibleEpInvoiceAmount'
  | 'ineligibleEpInvoiceCount'
  | 'lastClearDate'
  | 'makerDivisionName'
  | 'makerExcludedForTodayInvoiceAmount'
  | 'makerExcludedForTodayInvoiceCount'
  | 'makerExcludedInvoiceAmount'
  | 'makerExcludedInvoiceCount'
  | 'makerId'
  | 'makerOrganizationName'
  | 'makerOrganizationUuid'
  | 'makerUuid'
  | 'marketId'
  | 'marketProductType'
  | 'marketType'
  | 'marketUuid'
  | 'maxAcceptedInvoiceAmount'
  | 'maxEligibleDpe'
  | 'minEligibleDpe'
  | 'minPendingInvoiceAmount'
  | 'notAcceptedAboveMinEarn'
  | 'notAcceptedDpeWeightedAvg'
  | 'notAcceptedDpeWeightedSum'
  | 'notAcceptedEarn'
  | 'notAcceptedInvoiceAmount'
  | 'notAcceptedInvoiceCount'
  | 'notAcceptedYield'
  | 'pendingAprWeightedAvg'
  | 'pendingEarn'
  | 'pendingInvoiceAmount'
  | 'pendingInvoiceCount'
  | 'signedUpCount'
  | 'takerConfigCreated'
  | 'takerConfigDisableAt'
  | 'takerConfigExcludeNewInvoices'
  | 'takerConfigId'
  | 'takerConfigIsDiscountBidding'
  | 'takerConfigIsEnabled'
  | 'takerConfigMaxApr'
  | 'takerConfigMaxDiscount'
  | 'takerConfigUpdated'
  | 'takerDivisionName'
  | 'takerExcludedForTodayInvoiceAmount'
  | 'takerExcludedForTodayInvoiceCount'
  | 'takerExcludedInvoiceAmount'
  | 'takerExcludedInvoiceCount'
  | 'takerId'
  | 'takerMakerId'
  | 'takerOrganizationName'
  | 'takerUuid';

export type TakersMarketsStatsForMarket = {
  __typename?: 'TakersMarketsStatsForMarket';
  acceptedAprWeightedSum: Scalars['Float']['output'];
  acceptedDiscountWeightedSum: Scalars['Float']['output'];
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedTakerCount: Scalars['Float']['output'];
  acceptedYield: Scalars['Float']['output'];
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedTakerCount: Scalars['Float']['output'];
  awardedYield: Scalars['Float']['output'];
  bankingDaysWeightedSum: Scalars['Float']['output'];
  cashPoolUsed: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceCount: Scalars['Float']['output'];
  eligibleTakerCount: Scalars['Float']['output'];
  ineligibleEpInvoiceAmount: Scalars['Float']['output'];
  notAcceptedAprWeightedSum: Scalars['Float']['output'];
  notAcceptedDiscountWeightedSum: Scalars['Float']['output'];
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedTakerCount: Scalars['Float']['output'];
  notAcceptedYield: Scalars['Float']['output'];
  pendingEarn: Scalars['Float']['output'];
  pendingInvoiceAmount: Scalars['Float']['output'];
  pendingInvoiceCount: Scalars['Float']['output'];
  pendingTakerCount: Scalars['Float']['output'];
};

export type TakersMarketsSumAggregate = {
  __typename?: 'TakersMarketsSumAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type TimeRange =
  | 'ALL_TIME'
  | 'PAST_7_DAYS'
  | 'PAST_30_DAYS'
  | 'PAST_60_DAYS'
  | 'PAST_YEAR'
  | 'THIS_QUARTER'
  | 'THIS_QUARTER_TO_DATE'
  | 'THIS_YEAR'
  | 'THIS_YEAR_TO_DATE';

export type Update_Wcm_Role_Users_Action_Type =
  | 'ADD_USERS'
  | 'DELETE_USERS';

export type UpdateBuyerAppBuyerConfigInput = {
  /** Configuration name */
  configName: Buyer_Config;
  /** Configuration value (true/false) */
  value: Scalars['Boolean']['input'];
};

export type UpdateBuyerAppEverafterBuyerConfig = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  divisionUuid?: InputMaybe<Scalars['String']['input']>;
  embedLocationId?: InputMaybe<Scalars['String']['input']>;
  personaName?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBuyerAppInvoiceInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** array of invoice ids */
  invoiceIds: Array<Scalars['Float']['input']>;
  /** makerExcluded flag for invoices */
  makerExcluded: Scalars['Boolean']['input'];
};

export type UpdateBuyerAppInvoiceOutput = {
  __typename?: 'UpdateBuyerAppInvoiceOutput';
  /** Invoice Id */
  id: Scalars['Float']['output'];
  /** maker excluded flag for invoices */
  makerExcluded: Scalars['Boolean']['output'];
  /** The status of the invoice */
  status: Scalars['String']['output'];
};

export type UpdateBuyerDeliveryLocationInput = {
  deliverySettingsUuid: Scalars['String']['input'];
  funderFileTemplateUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};

export type UpdateBuyerDeliveryLocationOutput = {
  __typename?: 'UpdateBuyerDeliveryLocationOutput';
  deliverySettingsUuid: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
};

export type UpdateCompanyIdGroupInput = {
  companyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
  qualifiedSupplierInput: Array<QualifiedSupplierInput>;
};

export type UpdateCustomAttributeResult = {
  __typename?: 'UpdateCustomAttributeResult';
  /** Number of supplier assignments affected by this operation */
  assignmentsAffected: Scalars['Int']['output'];
  /** Information about the custom attribute that was updated */
  customAttribute: CustomAttributeInfo;
  /** Array of supplier IDs that were impacted by this operation */
  impactedSupplierIds: Array<Scalars['Int']['output']>;
  /** Human-readable message describing the result of the operation */
  message: Scalars['String']['output'];
};

export type UpdateCustomAttributeValueResponseDto = {
  __typename?: 'UpdateCustomAttributeValueResponseDto';
  /** Unique ID of the value mapping */
  id: Scalars['Int']['output'];
  /** The old value of the value mapping */
  oldValue: Scalars['String']['output'];
  /** The actual text value */
  value: Scalars['String']['output'];
};

export type UpdateDeliverySettingsInput = {
  deliveryMethod: Scalars['String']['input'];
  deliveryTime: Variance;
  funderFileTemplateUuid: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isDeliveryEnabled: Scalars['Boolean']['input'];
  programUuid: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeliverySettingsOutput = {
  __typename?: 'UpdateDeliverySettingsOutput';
  deliveryMethod: Scalars['String']['output'];
  deliveryTime?: Maybe<Scalars['String']['output']>;
  funderFileTemplateUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isDeliveryEnabled: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UpdateFileStatusInput = {
  /** Update file action */
  action: Scalars['String']['input'];
  /** Buyer file configurations */
  buyerFileConfigs: BuyerFileConfigs;
  /** File currency */
  fileCurrency: Scalars['String']['input'];
  /** Transaction UUID */
  transactionUuid: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateFileStatusOutput = {
  __typename?: 'UpdateFileStatusOutput';
  /** Status of the file update operation */
  status: Scalars['String']['output'];
};

export type UpdateFunderCalculationsInput = {
  funderUuid: Scalars['String']['input'];
  interestCalcOutputStrategy?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Scalars['String']['input']>;
  priceTypes?: InputMaybe<Scalars['String']['input']>;
  rateSelectionStrategy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunderCurrenciesInput = {
  bankingDays?: InputMaybe<Scalars['Float']['input']>;
  currencyLookupId: Scalars['Float']['input'];
  funderUuid: Scalars['String']['input'];
  rateSource: Scalars['String']['input'];
  refRateFloor?: InputMaybe<Scalars['Float']['input']>;
  referenceRate: Scalars['String']['input'];
};

export type UpdateFunderDeliveryRetryPolicyInput = {
  funderUuid: Scalars['String']['input'];
  maxRetry?: InputMaybe<Scalars['Int']['input']>;
  maxTimeout?: InputMaybe<Scalars['Int']['input']>;
  useCustomDeliveryRetryPolicy: Scalars['Boolean']['input'];
};

export type UpdateFunderDeliverySettingsInputDto = {
  fdsAuthId?: InputMaybe<Scalars['String']['input']>;
  fdsLocationId?: InputMaybe<Scalars['String']['input']>;
  fdsLocationName?: InputMaybe<Scalars['String']['input']>;
  fdsLocationUri?: InputMaybe<Scalars['String']['input']>;
  isBuyerAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunderFeedbackConfigInputDto = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceAmountComputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFunderFeedbackPipelineConfigInput = {
  ackType?: InputMaybe<Scalars['String']['input']>;
  aggregationConfig?: InputMaybe<Scalars['JSON']['input']>;
  filenamePattern?: InputMaybe<Scalars['String']['input']>;
  lookupType?: InputMaybe<Scalars['String']['input']>;
  parserConfig?: InputMaybe<Scalars['JSON']['input']>;
  parserType?: InputMaybe<Scalars['String']['input']>;
  targetDcs?: InputMaybe<Array<Scalars['String']['input']>>;
  transformConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateFunderGeographiesInput = {
  funderUuid: Scalars['String']['input'];
  geographyLookupId: Scalars['Float']['input'];
  includeExclude?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunderLegalSetupInput = {
  agreementType?: InputMaybe<Scalars['String']['input']>;
  funderUuid: Scalars['String']['input'];
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyBuyerAppDivisionRegionsInput = {
  /** Filter used to find fields to update */
  filter: BuyerAppDivisionRegionUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: BuyerAppDivisionRegionUpdateInput;
};

export type UpdateManyQualifiedSuppliersInput = {
  /** Filter used to find fields to update */
  filter: QualifiedSupplierUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateQualifiedSupplier;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int']['output'];
};

export type UpdateMultipleRecordGroupInput = {
  funderFileTemplateId: Scalars['String']['input'];
  isBatchRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isTransactionRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rgOrder: Scalars['Float']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateOneBuyerAppEverafterBuyerConfigInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateBuyerAppEverafterBuyerConfig;
};

export type UpdateOneFunderDeliverySettingsDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateFunderDeliverySettingsInputDto;
};

export type UpdateOneFunderFeedbackConfigInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateFunderFeedbackConfigInputDto;
};

export type UpdateOneFunderFileInput = {
  buyerGeneratedUseForReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  deliverySettings: FunderFileDeliverySettingsInput;
  fileNameFormat: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  funder: Scalars['String']['input'];
  funderFileType: Scalars['String']['input'];
  reconColumnDetails?: InputMaybe<ReconColumnDetailsInput>;
  serializer: SerializerSettingsInput;
  subType: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
  writerType: Scalars['String']['input'];
  x509SignedZipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneFunderInput = {
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateOneFunderNotificationConfigInput = {
  email: Array<Scalars['String']['input']>;
  funder: Scalars['String']['input'];
  funderFiles: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateOneQualifiedSupplierInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateQualifiedSupplier;
};

export type UpdateOneRecordGroupColumnDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateRecordGroupColumnInput;
};

export type UpdateOneRecordGroupInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateRecordGroup;
};

export type UpdateProgramFileSetInput = {
  filterCriteria: UpdateProgramSetFilterCriteriaDto;
  filterVariables: Array<UpdateProgramSetVariableDto>;
  variables: Array<UpdateProgramSetVariableDto>;
};

export type UpdateProgramFileSetSettings = {
  programFileSettings: Array<UpdateProgramFileSettings>;
  writerType: Scalars['String']['input'];
};

export type UpdateProgramFileSettings = {
  fileSettingsUuid?: InputMaybe<Scalars['String']['input']>;
  funderFileTemplateUuid: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Variance;
  serialNo: Scalars['Float']['input'];
  subType: Scalars['String']['input'];
};

export type UpdateProgramSetFilterCriteriaDto = {
  filterColumn: Scalars['String']['input'];
  filterValue: Scalars['String']['input'];
};

export type UpdateProgramSetVariableDto = {
  mandatory: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value: Variance;
};

export type UpdateQualifiedSupplier = {
  companyGroupUuid?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  makerId?: InputMaybe<Scalars['Float']['input']>;
  makerUuid?: InputMaybe<Scalars['String']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  takerId?: InputMaybe<Scalars['Float']['input']>;
  takerUuid?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  uploadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecordGroup = {
  funderFileTemplateId?: InputMaybe<Scalars['String']['input']>;
  isBatchRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isTransactionRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rgOrder?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecordGroupColumnInput = {
  columnOrder: Scalars['Float']['input'];
  displayName: Scalars['String']['input'];
  funderFileColumnId: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['Boolean']['input']>;
  isBatchColumn: Scalars['Boolean']['input'];
  isInvoiceColumn: Scalars['Boolean']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isTransactionColumn: Scalars['Boolean']['input'];
  mergeConfig: MergeConfigInput;
  recordGroupId: Scalars['String']['input'];
  serializerConfig: SerializerColumnSettingsInput;
  sortBy?: InputMaybe<Scalars['Boolean']['input']>;
  transformationConfig: Scalars['JSON']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateWcmBuyerExclusionRemarkInput = {
  id: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmBuyerExclusionRemarkOutput = {
  __typename?: 'UpdateWcmBuyerExclusionRemarkOutput';
  id: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  wcmBuyerUuid: Scalars['String']['output'];
};

export type UpdateWcmBuyerNegotiationIngestedThroughAtInput = {
  /** Timestamp through which negotiations have been ingested in UTC */
  negotiationIngestedThroughAtUtc: Scalars['String']['input'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmBuyerNegotiationIngestedThroughAtOutput = {
  __typename?: 'UpdateWcmBuyerNegotiationIngestedThroughAtOutput';
  /** Timestamp through which negotiations have been ingested */
  negotiationIngestedThroughAt: Scalars['DateTime']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type UpdateWcmBuyerTypeToPaidInput = {
  /** UUID of the buyer to update from trial to paid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmBuyerTypeToPaidOutput = {
  __typename?: 'UpdateWcmBuyerTypeToPaidOutput';
  /** Number of other non-paid buyer mappings deleted for non-C2FO users associated with the given buyer */
  deletedOtherNonPaidMappingsCount: Scalars['Int']['output'];
  /** Message describing the result */
  message: Scalars['String']['output'];
  /** Number of access validity records removed for affected users */
  removedUsersExpiryCount: Scalars['Int']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** UUID of the updated buyer */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type UpdateWcmCustomAttributeDefinitionInput = {
  /** Display name of the custom attribute for UI purposes */
  displayName: Scalars['String']['input'];
};

export type UpdateWcmCustomAttributeForSuppliersInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** Array of custom attributes to update */
  attributes: Array<WcmAttributeUpdateItem>;
  /** Supplier IDs to be excluded from the benchmarking strategy update */
  deselectedSupplierIds?: Array<Scalars['Float']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Supplier IDs for which the custom attribute will be updated */
  selectedSupplierIds?: Array<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmCustomAttributeForSuppliersOutput = {
  __typename?: 'UpdateWcmCustomAttributeForSuppliersOutput';
  /** Results for each attribute that was updated */
  results: Array<UpdateCustomAttributeResult>;
  /** Indicates whether all attribute updates were successful */
  success: Scalars['Boolean']['output'];
};

export type UpdateWcmCustomAttributeValueInput = {
  /** The new value text */
  value: Scalars['String']['input'];
};

export type UpdateWcmDashboardInput = {
  /** Dashboard description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Full draft config replacement (auto-save / save) */
  draftConfig?: InputMaybe<Scalars['JSON']['input']>;
  /** Dashboard name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWcmDiversityStatusInput = {
  displayCurrency: Scalars['String']['input'];
  diversityStatus: Scalars['String']['input'];
  /** List of supplier IDs selected for diversity status update */
  supplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmDiversityStatusOutput = {
  __typename?: 'UpdateWcmDiversityStatusOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmNaicsPaymentTermsInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** List of supplier IDs explicitly not selected(excluded) for naics update */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  naicsCode: Scalars['Int']['input'];
  /** List of supplier IDs selected for naics update */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmNaicsPaymentTermsOutput = {
  __typename?: 'UpdateWcmNaicsPaymentTermsOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmPaymentTermConfigInput = {
  /** Effective payment term in days */
  effectiveTermDays?: InputMaybe<Scalars['Int']['input']>;
  /** Internal notes */
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Active status */
  isActive: Scalars['Boolean']['input'];
  /** Indicates whether the payment term is EOM-based */
  isEom: Scalars['Boolean']['input'];
  /** Payment term code */
  paymentTermCode: Scalars['String']['input'];
  /** Payment term description */
  paymentTermDescription: Scalars['String']['input'];
  /** Payment term tiers */
  tiers: Array<WcmPaymentTermConfigTierInput>;
};

export type UpdateWcmPaymentTermsVersionInput = {
  /** Benchmarking generation date */
  benchmarkingGenerationDate: Scalars['String']['input'];
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmPaymentTermsVersionOutput = {
  __typename?: 'UpdateWcmPaymentTermsVersionOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmPlanWaveInput = {
  /** Wave end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Wave name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner of the wave */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Wave start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateWcmRolePermissionsOutput = {
  __typename?: 'UpdateWcmRolePermissionsOutput';
  permissionIds: Array<Scalars['ID']['output']>;
};

export type UpdateWcmRoleUsersInput = {
  actionType: Update_Wcm_Role_Users_Action_Type;
  roleId: Scalars['ID']['input'];
  userMappingIds: Array<Scalars['ID']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmRoleUsersOutput = {
  __typename?: 'UpdateWcmRoleUsersOutput';
  message: Scalars['String']['output'];
};

export type UpdateWcmRolesPermissionsInput = {
  addPermissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managedByC2foUsers?: InputMaybe<Scalars['Boolean']['input']>;
  removePermissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleId: Scalars['ID']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierGroupBenchmarkingStrategyInputDto = {
  benchmarkingStrategy: Benchmarking_Strategies;
  customBenchmark?: InputMaybe<Scalars['Int']['input']>;
  isDefaultStrategy: Scalars['Boolean']['input'];
  supplierId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierGroupBenchmarkingStrategyOutput = {
  __typename?: 'UpdateWcmSupplierGroupBenchmarkingStrategyOutput';
  status: Scalars['Float']['output'];
};

export type UpdateWcmSupplierGroupNoteInput = {
  /** Updated note content */
  content: Scalars['String']['input'];
  /** ID of the note to update */
  noteId: Scalars['Int']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierItemInput = {
  /** Company ID */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Supplier ID */
  id: Scalars['Float']['input'];
  /** Ticker group / symbol */
  tickerGroup?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWcmSupplierPreferredAttributesInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** List of supplier IDs explicitly not selected (excluded) for preferred attributes update */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Preferred supplier segment override (null to reset) */
  preferredSupplierSegment?: InputMaybe<Scalars['String']['input']>;
  /** Preferred WCO conversion rate override (null to reset) */
  preferredWcoConversionRate?: InputMaybe<Scalars['Int']['input']>;
  /** List of supplier IDs selected for preferred attributes update */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierPreferredAttributesOutput = {
  __typename?: 'UpdateWcmSupplierPreferredAttributesOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmSupplierSegmentConfigInput = {
  displayCurrency: Scalars['String']['input'];
  segmentationRules: SegmentationRules;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierSegmentConfigOutput = {
  __typename?: 'UpdateWcmSupplierSegmentConfigOutput';
  status: Scalars['String']['output'];
};

export type UpdateWcmSuppliersBenchmarkStrategyBySegmentInput = {
  applyTermsHarmonization?: InputMaybe<Scalars['Boolean']['input']>;
  benchmarkingStrategy: WcmBenchmarkStrategyBySegmentInput;
  displayCurrency: Scalars['String']['input'];
  overrideCustomBenchmarks: Scalars['Boolean']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersBenchmarkStrategyBySegmentOutput = {
  __typename?: 'UpdateWcmSuppliersBenchmarkStrategyBySegmentOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmSuppliersBenchmarkStrategyInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  benchmarkingStrategy: Benchmarking_Strategies;
  customBenchmark?: InputMaybe<Scalars['Float']['input']>;
  /** Supplier IDs to be excluded from the benchmarking strategy update */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Supplier IDs for which the benchmarking strategy will be updated */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersBenchmarkStrategyOutput = {
  __typename?: 'UpdateWcmSuppliersBenchmarkStrategyOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmSuppliersCurrentTermsInputDto = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** List of enriched spend IDs explicitly not selected */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Payment term config ID */
  paymentTermConfigId: Scalars['Int']['input'];
  /** List of enriched spend IDs to update */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersCurrentTermsOutput = {
  __typename?: 'UpdateWcmSuppliersCurrentTermsOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmSuppliersInput = {
  /** Array of suppliers to update with their new attributes */
  suppliers: Array<UpdateWcmSupplierItemInput>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersOutput = {
  __typename?: 'UpdateWcmSuppliersOutput';
  /** Status of the update operation */
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmUserRegistrationRequestInput = {
  /** Registration request ID */
  id: Scalars['ID']['input'];
  /** New status */
  status: Wcm_User_Self_Registration_Request_Status;
};

export type UpdateWcmUserRegistrationRequestResponse = {
  __typename?: 'UpdateWcmUserRegistrationRequestResponse';
  /** Update status: SUCCESS */
  status: Scalars['String']['output'];
};

export type UpsertBuyerAppMarketTakerConfigurationInput = {
  divisionUuid: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  minReturnAmount: Scalars['Float']['input'];
  takerUuid: Scalars['String']['input'];
};

export type UpsertBuyerAppMarketTakerConfigurationOutput = {
  __typename?: 'UpsertBuyerAppMarketTakerConfigurationOutput';
  minReturnAmount: Scalars['Float']['output'];
};

export type UpsertBuyerAppUserPreferenceInput = {
  /** Preference name */
  preferenceName: Scalars['String']['input'];
  /** User preference settings */
  settings: Scalars['JSON']['input'];
};

export type UpsertBuyerAppUserPreferenceOutput = {
  __typename?: 'UpsertBuyerAppUserPreferenceOutput';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

/** Canonical phase for status-phase mapping upsert; UNMAPPED removes the mapping */
export type UpsertStatusPhaseCanonicalPhaseInput =
  | 'COMPLETED'
  | 'ERP_UPDATED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'UNMAPPED'
  | 'UNSUCCESSFUL';

export type UpsertWcmBenchmarkConfigInput = {
  /** Apply terms harmonization in benchmarking */
  applyTermsHarmonization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of banking days used for WCO calculations */
  bankingDays?: InputMaybe<Scalars['Float']['input']>;
  /** Benchmark period (PERIOD_TO_DATE, TWELVE_MONTHS, TWENTY_FOUR_MONTHS, THIRTY_SIX_MONTHS). */
  benchmarkingPeriod?: InputMaybe<Benchmarking_Period>;
  /** Benchmarking version calendar date (ISO 8601 date, e.g. 2026-04-27) */
  benchmarkingVersionDate?: InputMaybe<Scalars['String']['input']>;
  /** Display Currency */
  currency: Scalars['String']['input'];
  /** S3 key for the global benchmark CSV (resolved by version date) */
  globalS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Enable country-specific regulatory term limits */
  goodPracticeAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum allowable payment-term days (1–365) */
  maxTermDays?: InputMaybe<Scalars['Int']['input']>;
  /** Day increment for suppliers without NAICS (5-60 in increments of 5) */
  noNaicsTermsIncrement?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum payment-term days for PACA-related suppliers (1–365) */
  pacaMaxTermDays?: InputMaybe<Scalars['Int']['input']>;
  /** S3 key for the regional benchmark CSV (resolved by version date) */
  regionalS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Total days in the spend period */
  spendPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Last calendar month in the spend period */
  spendPeriodEndMonth?: InputMaybe<Scalars['String']['input']>;
  /** Total months in the spend period */
  spendPeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  /** First calendar month in the spend period */
  spendPeriodStartMonth?: InputMaybe<Scalars['String']['input']>;
  /** Rounding step (in days) for target payment terms */
  targetTermRoundingDays?: InputMaybe<Scalars['Float']['input']>;
  /** Buyer WACC in % */
  waccPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmBenchmarkCountryRegulationsInput = {
  /** Currency code */
  currency: Scalars['String']['input'];
  /** List of country regulations to upsert */
  regulations: Array<WcmCountryRegulationItemInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmDomainConfigInput = {
  /** Buyer access type (ALL, SOME, or NONE) */
  buyerAccessType: Scalars['String']['input'];
  /** Domain-specific configuration */
  config?: InputMaybe<WcmDomainClientConfigInput>;
  /** Domain name */
  domain: Scalars['String']['input'];
};

export type UpsertWcmEconomicValueConfigInput = {
  displayCurrency: Scalars['String']['input'];
  economicValue: Scalars['Float']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmExclusionsConfigInput = {
  /** Exclude suppliers with discounted payment terms */
  discountTermExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display Currency */
  displayCurrency: Scalars['String']['input'];
  /** Exclude diverse suppliers */
  diverseSupplierExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum spend value threshold for supplier groups */
  minSpendValue?: InputMaybe<Scalars['Float']['input']>;
  /** Exclude suppliers with missing payment terms */
  missingTermExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmNegotiationInput = {
  /** Backdateable ISO 8601 date the status change took effect */
  eventDate?: InputMaybe<Scalars['String']['input']>;
  /** Negotiated terms value */
  negotiatedTerms?: InputMaybe<Scalars['Float']['input']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: InputMaybe<Scalars['Float']['input']>;
  /** Free-text remarks recorded against the negotiation and its status event */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertWcmNegotiationItem = {
  /** Backdateable ISO 8601 date the status change took effect */
  eventDate?: InputMaybe<Scalars['String']['input']>;
  /** Negotiated terms value */
  negotiatedTerms?: InputMaybe<Scalars['Float']['input']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: InputMaybe<Scalars['Float']['input']>;
  /** Free-text remarks recorded against the negotiation and its status event */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
  /** Vendor variant ID */
  vendorVariantId: Scalars['String']['input'];
};

export type UpsertWcmNegotiationsInput = {
  /** Array of negotiations to create or update */
  negotiations: Array<UpsertWcmNegotiationItem>;
};

export type UpsertWcmSegmentConversionRateInput = {
  coreSegmentConversionRate: Scalars['Float']['input'];
  displayCurrency: Scalars['String']['input'];
  strategicSegmentConversionRate: Scalars['Float']['input'];
  tailSegmentConversionRate: Scalars['Float']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmStatusPhaseMappingItemInput = {
  /** Canonical phase to map the status to; UNMAPPED removes the mapping */
  canonicalPhase: UpsertStatusPhaseCanonicalPhaseInput;
  /** Ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['input'];
  /** ID of the custom status from wcm_custom_attribute_value_mappings */
  customStatusValueId: Scalars['Int']['input'];
};

export type UpsertWcmStatusPhaseMappingsInput = {
  /** Array of status phase mappings to upsert */
  mappings: Array<UpsertWcmStatusPhaseMappingItemInput>;
};

export type UpsertWcmUserPreferenceInput = {
  /** Preference name */
  preferenceName: Scalars['String']['input'];
  /** User preference settings */
  settings: Scalars['JSON']['input'];
};

export type UpsertWcmUserPreferenceOutput = {
  __typename?: 'UpsertWcmUserPreferenceOutput';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type UpsertWcmUsersInput = {
  /** WCM user info */
  users: Array<WcmUpsertUserInfoParams>;
};

export type User = Node & {
  __typename?: 'User';
  /** The Account this user belongs to. This is determined by joining the user's divisions to the account's divisions. If the user has multiple divisions we pick the first one. */
  account?: Maybe<Account>;
  created?: Maybe<Scalars['String']['output']>;
  /** Who created the user */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** How was the user created. */
  createdSource?: Maybe<Scalars['String']['output']>;
  /** A list of datacenters where the user exists. */
  datacenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Divisions this user is associated with. */
  divisions?: Maybe<Array<Maybe<Division>>>;
  /** The email address of the user. */
  emailAddress: Scalars['String']['output'];
  /** The date when the user's email was verified */
  emailVerifiedDate?: Maybe<Scalars['String']['output']>;
  /** Features the user has access to. */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The date the user triggered the Right to be Forgotten process */
  forgottenOn?: Maybe<Scalars['String']['output']>;
  /** Date/Number/Currency formatting preferences of the user */
  formatPreferences?: Maybe<FormatPreferences>;
  /** Does the user have a password. New users and SSO users will not have passwords. */
  hasPassword: Scalars['Boolean']['output'];
  /** User UUID */
  id: Scalars['ID']['output'];
  /** Intercom User ID */
  intercomUserId?: Maybe<Scalars['String']['output']>;
  /** If the accounts is locked and requires a password reset before logging in. */
  isAccountLocked: Scalars['Boolean']['output'];
  /** Is the user connected to a Buyer Division. A user can be a Buyer and a Supplier! */
  isBuyer?: Maybe<Scalars['Boolean']['output']>;
  /** Is this user a C2FO employee */
  isC2FO?: Maybe<Scalars['Boolean']['output']>;
  /** Can the user make offer decisions? */
  isDecisionMaker?: Maybe<Scalars['Boolean']['output']>;
  /** If the accounts is locked and requires a manual unlocking by support to logging in. */
  isHardLocked: Scalars['Boolean']['output'];
  /** Is the DC we are in the same as the users 'source' DC. */
  isSource?: Maybe<Scalars['Boolean']['output']>;
  /** Is the user connected to a Supplier Division. A user can be a Buyer and a Supplier! */
  isSupplier?: Maybe<Scalars['Boolean']['output']>;
  isWCM: Scalars['Boolean']['output'];
  /** Timestamp of the last time the user logged in. */
  lastLogin?: Maybe<Scalars['String']['output']>;
  /** Where the lead came from. */
  leadSource?: Maybe<Scalars['String']['output']>;
  /** Login history for the user */
  loginHistory?: Maybe<Array<Maybe<LoginHistory>>>;
  /** Does the user need a password. */
  needsPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of the last time they updated their password. */
  passwordUpdatedOnDate?: Maybe<Scalars['Boolean']['output']>;
  /** Personal Identifiable Information of the user. */
  personalInfo?: Maybe<PersonalInfo>;
  /** Registration and other info from C2FO. */
  registration?: Maybe<RegistrationInfo>;
  /** Roles the user belongs to. */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The datacenter where the user was first created. Usually via ESLAP file loads. */
  source: Scalars['String']['output'];
  /** Is the user readonly. Applies to supplier app only. */
  supplierReadOnly?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  /** Randomly generated UUID for the user. NOT auth service uuid. */
  uuid?: Maybe<Scalars['String']['output']>;
};


export type UserLoginHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
};

export type UserAddressInput = {
  /** This is the name of the locality. USA, Canda, etc. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Zip or postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdSource?: InputMaybe<Scalars['String']['input']>;
  formatPreferences?: InputMaybe<FormatPreferencesInput>;
  id: Scalars['ID']['input'];
  isDecisionMaker?: InputMaybe<Scalars['Boolean']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  personalInfo?: InputMaybe<PersonalInfoInput>;
  registration?: InputMaybe<RegistrationInfoInput>;
  supplierReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputViaWcm = {
  /** User country code */
  country?: Scalars['String']['input'];
  /** User email address */
  emailAddress: Scalars['String']['input'];
  /** User first name */
  firstName: Scalars['String']['input'];
  /** Whether user has full version access in WCM */
  fullVersion?: Scalars['Boolean']['input'];
  /** User last name */
  lastName: Scalars['String']['input'];
  /** User locale */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Whether to onboard user to WCM */
  onboardToWcm?: Scalars['Boolean']['input'];
  /** User password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** User role */
  role?: Admin_User_Role;
};

export type UserMutationResponse = MultiMutationResponse & {
  __typename?: 'UserMutationResponse';
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  message: Scalars['String']['output'];
  nodes?: Maybe<Array<Maybe<User>>>;
  success: Scalars['Boolean']['output'];
};

export type UserSyncInput = {
  authServiceUuid?: InputMaybe<Scalars['ID']['input']>;
  c2foDbId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UsersResponse = MultiQueryResponse & {
  __typename?: 'UsersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
};

export type Variable = {
  __typename?: 'Variable';
  mandatory: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Variance = {
  current?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type Wcm_Adherence_Kpi_By_Aggregator_Sort_Field =
  | 'BASELINE_EARLY_PAYMENTS_PCT'
  | 'BASELINE_PAYMENT_RUN_ADHERENCE_PCT'
  | 'BASELINE_WA_DTP_DAYS'
  | 'BASELINE_WA_EARLY_LATE_DAYS'
  | 'BASELINE_WA_TERMS_DAYS'
  | 'DELTA_AMOUNT_PAID_EARLY'
  | 'DELTA_EARLY_PAYMENTS_PCT'
  | 'DELTA_INVOICE_COUNT_NOT_PAID_ON_PAYMENT_RUN'
  | 'DELTA_PAYMENT_RUN_ADHERENCE_PCT'
  | 'DELTA_WA_DTP_DAYS'
  | 'DELTA_WA_EARLY_LATE_DAYS'
  | 'DELTA_WA_TERMS_DAYS'
  | 'INVOICE_COUNT'
  | 'SELECTED_EARLY_PAYMENTS_PCT'
  | 'SELECTED_PAYMENT_RUN_ADHERENCE_PCT'
  | 'SELECTED_WA_DTP_DAYS'
  | 'SELECTED_WA_EARLY_LATE_DAYS'
  | 'SELECTED_WA_TERMS_DAYS'
  | 'TOTAL_AMOUNT';

export type Wcm_Adherence_Kpi_By_Period_Sort_Field =
  | 'EARLY_PAYMENTS_PCT'
  | 'INVOICE_COUNT'
  | 'PAYMENT_RUN_ADHERENCE_PCT'
  | 'PERIOD'
  | 'TOTAL_AMOUNT'
  | 'WA_DTP_DAYS'
  | 'WA_EARLY_LATE_DAYS'
  | 'WA_TERMS_DAYS';

export type Wcm_Adherence_Kpi_Period_Granularity =
  | 'MONTH'
  | 'YEAR';

export type Wcm_Buyer_Region =
  | 'AMER'
  | 'APAC'
  | 'EMEA';

export type Wcm_Buyer_Type =
  | 'DEMO'
  | 'PAID'
  | 'TRIAL';

export type Wcm_Buyer_TypeFilterComparison = {
  eq?: InputMaybe<Wcm_Buyer_Type>;
  gt?: InputMaybe<Wcm_Buyer_Type>;
  gte?: InputMaybe<Wcm_Buyer_Type>;
  iLike?: InputMaybe<Wcm_Buyer_Type>;
  in?: InputMaybe<Array<Wcm_Buyer_Type>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Wcm_Buyer_Type>;
  lt?: InputMaybe<Wcm_Buyer_Type>;
  lte?: InputMaybe<Wcm_Buyer_Type>;
  neq?: InputMaybe<Wcm_Buyer_Type>;
  notILike?: InputMaybe<Wcm_Buyer_Type>;
  notIn?: InputMaybe<Array<Wcm_Buyer_Type>>;
  notLike?: InputMaybe<Wcm_Buyer_Type>;
};

/** Canonical negotiation phases for monitoring charts */
export type Wcm_Canonical_Phase =
  | 'COMPLETED'
  | 'ERP_UPDATED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'UNSUCCESSFUL';

/** Status of a WCM reporting dashboard */
export type Wcm_Dashboard_Status =
  | 'DRAFT'
  | 'PUBLISHED';

export type Wcm_Segment =
  | 'Core'
  | 'Strategic'
  | 'Tail';

export type Wcm_Suppliers_Order_Level =
  | 'BENCHMARK_STRATEGY'
  | 'BENCHMARK_TERMS'
  | 'CONTRACTUAL_TERMS_DESCRIPTION'
  | 'COUNTRY'
  | 'CURRENT_TERMS'
  | 'ESTIMATED_OPPORTUNITY'
  | 'ESTIMATED_TERMS'
  | 'INDUSTRY'
  | 'IS_DIVERSE_SUPPLIER'
  | 'NEGOTIATION_STATUS'
  | 'SEGMENT'
  | 'SPEND'
  | 'SUPPLIER_NAME'
  | 'WCO_CONVERSION_RATE'
  | 'WORKING_CAPITAL_OPPORTUNITY';

/** Controls which suppliers are included: only in-scope, only excluded, or all */
export type Wcm_Supplier_Scope =
  | 'ALL'
  | 'EXCLUDED'
  | 'IN_SCOPE';

export type Wcm_User_Roles_For_Registration_Request =
  | 'ACCOUNTING'
  | 'BUYING_MANAGER'
  | 'CEO'
  | 'CFO'
  | 'CONTROLLER'
  | 'CPO'
  | 'FINANCE_DIRECTOR'
  | 'OFFICE_MANAGER'
  | 'OTHER'
  | 'PRESIDENT'
  | 'TREASURER';

export type Wcm_User_Self_Registration_Order_By =
  | 'CREATED'
  | 'UPDATED';

export type Wcm_User_Self_Registration_Request_Status =
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED';

export type Wco_Matrix_Bucket =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM';

export type Wco_Matrix_Tier =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM';

export type WcmAdherenceDynamicInvoiceFilters = {
  __typename?: 'WcmAdherenceDynamicInvoiceFilters';
  /** Custom-attribute facets keyed by attribute internal name; each holds its displayName and available values */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  /** Distinct naics_description (level 1) values still selectable given the other filter selections */
  industries: Array<Scalars['String']['output']>;
  /** Distinct naics_description (level 2) values still selectable given the other filter selections */
  industriesL2: Array<Scalars['String']['output']>;
  /** Distinct naics_description (level 3) values still selectable given the other filter selections */
  industriesL3: Array<Scalars['String']['output']>;
  /** Distinct negotiation-status values still selectable given the other filter selections. Empty string is the "No status" bucket. */
  negotiationStatus: Array<Scalars['String']['output']>;
  /** Distinct payment months (ISO first-of-month) with at least one paid invoice in scope */
  paymentMonths: Array<Scalars['String']['output']>;
  /** Distinct plan-wave {label, value} options still selectable given the other filter selections */
  planWaves: Array<WcmFilterOption>;
  /** Distinct plan {label, value} options still selectable given the other filter selections */
  plans: Array<WcmFilterOption>;
  /** Distinct regions derived from `supplierCountries` */
  region: Array<Scalars['String']['output']>;
  /** Distinct supplier_country values still selectable given the other filter selections */
  supplierCountries: Array<Scalars['String']['output']>;
  /** Distinct supplier_segment values still selectable given the other filter selections */
  supplierSegments: Array<Scalars['String']['output']>;
};

export type WcmAdherenceDynamicInvoiceFiltersInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  filters?: InputMaybe<WcmAdherenceInvoiceFiltersInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceInvoiceFiltersInput = {
  /** Baseline month (ISO, first of month) */
  baselineMonth?: InputMaybe<Scalars['String']['input']>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** NAICS description (level 1) */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 2) */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 3) */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation status values to filter by. Empty string is the "No status" bucket. */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Logical regions; expanded to country codes for buyer-api and derived back in output when `region` is requested */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Selected month (ISO, first of month) */
  selectedMonth?: InputMaybe<Scalars['String']['input']>;
  /** Supplier country codes (ISO) */
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier segments */
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WcmAdherenceKpiByAggregatorInput = {
  /** Group-by supplier dimensions (min: 1, max: 3). Each value is a WCM_AGGREGATOR_DIMENSION_MAP key or `custom_attribute_{N}`. */
  aggregators: Array<Scalars['String']['input']>;
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Adherence filters with required baseline/selected month */
  filters: WcmAdherenceKpisFiltersInput;
  /** Optional paging */
  paging?: InputMaybe<WcmAdherenceKpiByAggregatorPagingInput>;
  /** Optional sorting */
  sorting?: InputMaybe<WcmAdherenceKpiByAggregatorSortingInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceKpiByAggregatorMetricsValues = {
  __typename?: 'WcmAdherenceKpiByAggregatorMetricsValues';
  earlyPaymentsPct?: Maybe<Scalars['Float']['output']>;
  paymentRunAdherencePct?: Maybe<Scalars['Float']['output']>;
  waDtpDays?: Maybe<Scalars['Float']['output']>;
  waEarlyLateDays?: Maybe<Scalars['Float']['output']>;
  waTermsDays?: Maybe<Scalars['Float']['output']>;
};

export type WcmAdherenceKpiByAggregatorOutput = {
  __typename?: 'WcmAdherenceKpiByAggregatorOutput';
  rows: Array<WcmAdherenceKpiByAggregatorRow>;
  summary: WcmAdherenceKpiByAggregatorSummary;
  /** Pre-paging row count (leaf rows + rollup subtotals) */
  totalRows: Scalars['Int']['output'];
};

export type WcmAdherenceKpiByAggregatorPagingInput = {
  /** Page number (zero-indexed) */
  page?: Scalars['Int']['input'];
  /** Rows per page (max 100) */
  pageSize?: Scalars['Int']['input'];
};

export type WcmAdherenceKpiByAggregatorRow = {
  __typename?: 'WcmAdherenceKpiByAggregatorRow';
  /** true for rollup subtotal rows, false for leaf rows */
  aggregated: Scalars['Boolean']['output'];
  aggregator1: Scalars['String']['output'];
  aggregator1Code?: Maybe<Scalars['String']['output']>;
  aggregator2?: Maybe<Scalars['String']['output']>;
  aggregator2Code?: Maybe<Scalars['String']['output']>;
  aggregator3?: Maybe<Scalars['String']['output']>;
  aggregator3Code?: Maybe<Scalars['String']['output']>;
  /** Variance-only (selected − baseline) of amount paid early; null when either month has no invoices */
  amountPaidEarlyVariance?: Maybe<Scalars['Float']['output']>;
  baseline?: Maybe<WcmAdherenceKpiByAggregatorMetricsValues>;
  delta?: Maybe<WcmAdherenceKpiByAggregatorMetricsValues>;
  /** Invoices in this group across both months */
  invoiceCount: Scalars['Int']['output'];
  /** Variance-only (selected − baseline) of invoice count not paid on the payment run; null when either month has no invoices */
  invoiceCountNotPaidOnPaymentRunVariance?: Maybe<Scalars['Float']['output']>;
  selected?: Maybe<WcmAdherenceKpiByAggregatorMetricsValues>;
  /** Sum of `amount` in this group across both months (file currency) */
  totalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceKpiByAggregatorSortingInput = {
  /** Sort direction (default DESC) */
  direction?: Order_Type;
  /** Sortable column. One of 19 fields. */
  field: Wcm_Adherence_Kpi_By_Aggregator_Sort_Field;
};

export type WcmAdherenceKpiByAggregatorSummary = {
  __typename?: 'WcmAdherenceKpiByAggregatorSummary';
  baseline: WcmAdherenceSummaryTotals;
  selected: WcmAdherenceSummaryTotals;
};

export type WcmAdherenceKpiByPeriodInput = {
  /** Group-by supplier dimensions nested under the period (max: 3). Each value is a WCM_AGGREGATOR_DIMENSION_MAP key or `custom_attribute_{N}`. Omit/empty for a pure period view. */
  aggregators?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Adherence filters; baseline/selected months are optional (omit both for the full range) */
  filters: WcmAdherenceInvoiceFiltersInput;
  /** Time-bucket width for each row (default MONTH). */
  granularity?: InputMaybe<Wcm_Adherence_Kpi_Period_Granularity>;
  /** Optional paging */
  paging?: InputMaybe<WcmAdherenceKpiByAggregatorPagingInput>;
  /** Optional sorting */
  sorting?: InputMaybe<WcmAdherenceKpiByPeriodSortingInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceKpiByPeriodMetricsValues = {
  __typename?: 'WcmAdherenceKpiByPeriodMetricsValues';
  earlyPaymentsPct?: Maybe<Scalars['Float']['output']>;
  paymentRunAdherencePct?: Maybe<Scalars['Float']['output']>;
  waDtpDays?: Maybe<Scalars['Float']['output']>;
  waEarlyLateDays?: Maybe<Scalars['Float']['output']>;
  waTermsDays?: Maybe<Scalars['Float']['output']>;
};

export type WcmAdherenceKpiByPeriodOutput = {
  __typename?: 'WcmAdherenceKpiByPeriodOutput';
  rows: Array<WcmAdherenceKpiByPeriodRow>;
  /** Range-wide scope totals over the visible period range (vendor count + net payment amount). */
  summary: WcmAdherenceSummaryTotals;
  /** Pre-paging count of `(period, group)` rows */
  totalRows: Scalars['Int']['output'];
};

export type WcmAdherenceKpiByPeriodRow = {
  __typename?: 'WcmAdherenceKpiByPeriodRow';
  /** true for rollup subtotal ("Total") rows, false for leaf rows */
  aggregated: Scalars['Boolean']['output'];
  aggregator1: Scalars['String']['output'];
  aggregator1Code?: Maybe<Scalars['String']['output']>;
  aggregator2?: Maybe<Scalars['String']['output']>;
  aggregator2Code?: Maybe<Scalars['String']['output']>;
  aggregator3?: Maybe<Scalars['String']['output']>;
  aggregator3Code?: Maybe<Scalars['String']['output']>;
  /** Invoices paid in this period for this group */
  invoiceCount: Scalars['Int']['output'];
  metrics: WcmAdherenceKpiByPeriodMetricsValues;
  /** Period start (ISO date, first of the bucket) */
  period: Scalars['String']['output'];
  /** Sum of `amount` paid in this period for this group (file currency) */
  totalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceKpiByPeriodSortingInput = {
  /** Sort direction (default DESC) */
  direction?: Order_Type;
  /** Sortable column. One of 8 fields (default PERIOD). */
  field?: Wcm_Adherence_Kpi_By_Period_Sort_Field;
};

export type WcmAdherenceKpiMetricTriple = {
  __typename?: 'WcmAdherenceKpiMetricTriple';
  baseline?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  selected?: Maybe<Scalars['Float']['output']>;
};

export type WcmAdherenceKpis = {
  __typename?: 'WcmAdherenceKpis';
  baselineInvoiceCount: Scalars['Int']['output'];
  baselineMonth: Scalars['String']['output'];
  baselineTotalAmount: Scalars['Float']['output'];
  metrics: WcmAdherenceKpisMetrics;
  selectedInvoiceCount: Scalars['Int']['output'];
  selectedMonth: Scalars['String']['output'];
  selectedTotalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceKpisFiltersInput = {
  /** Baseline month (ISO, first of month) */
  baselineMonth: Scalars['String']['input'];
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** NAICS description (level 1) */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 2) */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 3) */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation status values to filter by. Empty string is the "No status" bucket. */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Logical regions; expanded to country codes for buyer-api and derived back in output when `region` is requested */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Selected month (ISO, first of month) */
  selectedMonth: Scalars['String']['input'];
  /** Supplier country codes (ISO) */
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier segments */
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WcmAdherenceKpisInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  filters: WcmAdherenceKpisFiltersInput;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceKpisMetrics = {
  __typename?: 'WcmAdherenceKpisMetrics';
  earlyPaymentsPct: WcmAdherenceKpiMetricTriple;
  paymentRunAdherencePct: WcmAdherenceKpiMetricTriple;
  waDtpDays: WcmAdherenceKpiMetricTriple;
  waEarlyLateDays: WcmAdherenceKpiMetricTriple;
  waTermsDays: WcmAdherenceKpiMetricTriple;
};

export type WcmAdherenceSeriesMetricsValues = {
  __typename?: 'WcmAdherenceSeriesMetricsValues';
  earlyPaymentsPct: Scalars['Float']['output'];
  paymentRunAdherencePct: Scalars['Float']['output'];
  waDtpDays: Scalars['Float']['output'];
  waEarlyLateDays: Scalars['Float']['output'];
  waTermsDays: Scalars['Float']['output'];
};

export type WcmAdherenceSeriesPoint = {
  __typename?: 'WcmAdherenceSeriesPoint';
  invoiceCount: Scalars['Int']['output'];
  /** Null when no payments in the month */
  metrics?: Maybe<WcmAdherenceSeriesMetricsValues>;
  month: Scalars['String']['output'];
  /** Rolling 3-month average (null if this month has no data) */
  rolling3?: Maybe<WcmAdherenceSeriesMetricsValues>;
  /** Rolling 6-month average (null if this month has no data) */
  rolling6?: Maybe<WcmAdherenceSeriesMetricsValues>;
  totalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceSeriesWindow = {
  __typename?: 'WcmAdherenceSeriesWindow';
  /** Latest paid_date among invoices matching filters */
  latestPaidDate: Scalars['String']['output'];
  /** Last month in the 12-bucket series (UTC, first of month) */
  seriesEndMonth: Scalars['String']['output'];
  /** First month in the 12-bucket series (UTC, first of month) */
  seriesStartMonth: Scalars['String']['output'];
};

export type WcmAdherenceSummaryTotals = {
  __typename?: 'WcmAdherenceSummaryTotals';
  /** Sum of `amount` paid in scope (file currency) */
  netPaymentAmount: Scalars['Float']['output'];
  /** Distinct suppliers (vendor entities) with paid invoices in scope */
  vendorCount: Scalars['Int']['output'];
};

export type WcmAdherenceTrend = {
  __typename?: 'WcmAdherenceTrend';
  /** Exactly 12 buckets, newest month first */
  points: Array<WcmAdherenceSeriesPoint>;
  window: WcmAdherenceSeriesWindow;
};

export type WcmAdherenceTrendInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  filters?: InputMaybe<WcmAdherenceInvoiceFiltersInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAggregatedSpends = {
  __typename?: 'WcmAggregatedSpends';
  aggregated: Scalars['Boolean']['output'];
  aggregator1: Scalars['String']['output'];
  aggregator1Code?: Maybe<Scalars['String']['output']>;
  aggregator2?: Maybe<Scalars['String']['output']>;
  aggregator2Code?: Maybe<Scalars['String']['output']>;
  aggregator3?: Maybe<Scalars['String']['output']>;
  aggregator3Code?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  changeInTerms: Scalars['Float']['output'];
  estimatedBenchmarkTerms: Scalars['Float']['output'];
  estimatedChangeInTerms: Scalars['Float']['output'];
  estimatedWco: Scalars['Float']['output'];
  existingTerms: Scalars['Float']['output'];
  harmonizationBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  harmonizationWco?: Maybe<Scalars['Float']['output']>;
  industryCountry75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry75Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry85Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry90Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry95Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry99Wco?: Maybe<Scalars['Float']['output']>;
  industryCountryMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountryMaxWco?: Maybe<Scalars['Float']['output']>;
  industryCountryMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountryMedianWco?: Maybe<Scalars['Float']['output']>;
  industryGlobal75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal75Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal85Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal90Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal95Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal99Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobalMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobalMaxWco?: Maybe<Scalars['Float']['output']>;
  industryGlobalMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobalMedianWco?: Maybe<Scalars['Float']['output']>;
  negotiatedTerms?: Maybe<Scalars['Float']['output']>;
  percentageEstimatedWco: Scalars['Float']['output'];
  percentageSpend: Scalars['Float']['output'];
  percentageWco: Scalars['Float']['output'];
  realisedOpportunity: Scalars['Float']['output'];
  spend: Scalars['Float']['output'];
  statusBreakdown?: Maybe<Array<WcmStatusBreakdownEntry>>;
  supplierEntities: Scalars['Float']['output'];
  supplierGroups: Scalars['Float']['output'];
  updatedOpportunity: Scalars['Float']['output'];
  wco: Scalars['Float']['output'];
};

export type WcmAggregatedSpendsFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  displayCurrency: Scalars['String']['input'];
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  regionsList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAggregatedSpendsPaging = {
  pageNum?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export type WcmAllUserFileLogs = {
  __typename?: 'WcmAllUserFileLogs';
  /** Buyer Name */
  buyerName: Scalars['String']['output'];
  /** Created Date and Time */
  created: Scalars['String']['output'];
  /** File name */
  fileName: Scalars['String']['output'];
  /** File Uuid */
  fileUuid: Scalars['String']['output'];
  /** WCM buyer uuid */
  status: Scalars['String']['output'];
  /** User Email */
  userEmail: Scalars['String']['output'];
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmAttributeUpdateItem = {
  /** Internal name of the custom attribute */
  internalName: Scalars['String']['input'];
  /** Value ID to assign/update. Use null to unassign/remove the attribute. */
  valueId?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmBenchmarkApplyStatus = {
  __typename?: 'WcmBenchmarkApplyStatus';
  /** Error message when apply status is FAILED */
  benchmarkVersionApplyFailureReason?: Maybe<Scalars['String']['output']>;
  /** PENDING | IN_PROGRESS | COMPLETED | FAILED */
  benchmarkVersionApplyStatus?: Maybe<Scalars['String']['output']>;
  /** Version date currently being applied (YYYY-MM-DD) */
  benchmarkVersionPendingDate?: Maybe<Scalars['String']['output']>;
  /** Benchmark period currently being applied */
  benchmarkVersionPendingPeriod?: Maybe<Benchmarking_Period>;
  /** Benchmark version date that was active before the latest apply (YYYY-MM-DD) */
  benchmarkVersionPreviousDate?: Maybe<Scalars['String']['output']>;
  /** Benchmark period that was active before the latest apply */
  benchmarkVersionPreviousPeriod?: Maybe<Benchmarking_Period>;
  /** ISO timestamp of when the latest apply job was queued; used to detect stuck syncs */
  benchmarkVersionSyncStartedAt?: Maybe<Scalars['String']['output']>;
};

export type WcmBenchmarkConfigOutput = {
  __typename?: 'WcmBenchmarkConfigOutput';
  /** Apply terms harmonization in benchmarking */
  applyTermsHarmonization: Scalars['Boolean']['output'];
  /** Available benchmarking version dates grouped by benchmark period */
  availableBenchmarkVersionsByPeriod: Array<WcmBenchmarkVersionsByPeriod>;
  bankingDays: Scalars['Float']['output'];
  /** Benchmark period (PERIOD_TO_DATE, TWELVE_MONTHS, TWENTY_FOUR_MONTHS, THIRTY_SIX_MONTHS). */
  benchmarkingPeriod: Benchmarking_Period;
  /** Benchmarking version calendar date (YYYY-MM-DD) */
  benchmarkingVersionDate?: Maybe<Scalars['String']['output']>;
  buyerUuid: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** Enable country-specific regulatory term limits */
  goodPracticeAdjustment: Scalars['Boolean']['output'];
  /** Maximum allowable payment-term days (1–365) */
  maxTermDays: Scalars['Int']['output'];
  /** Async apply job status */
  metadata?: Maybe<WcmBenchmarkApplyStatus>;
  /** Day increment for suppliers without NAICS (15, 30, 45, or 60) */
  noNaicsTermsIncrement: Scalars['Int']['output'];
  /** Maximum payment-term days for PACA-related suppliers (1–365) */
  pacaMaxTermDays: Scalars['Int']['output'];
  /** Total days in the spend period */
  spendPeriodDays: Scalars['Int']['output'];
  spendPeriodEndMonth?: Maybe<Scalars['DateTime']['output']>;
  spendPeriodMonths: Scalars['Float']['output'];
  spendPeriodStartMonth?: Maybe<Scalars['DateTime']['output']>;
  targetTermRoundingDays: Scalars['Float']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  waccPercentage?: Maybe<Scalars['Float']['output']>;
};

export type WcmBenchmarkCountryRegulationItem = {
  __typename?: 'WcmBenchmarkCountryRegulationItem';
  /** Country code (ISO2) */
  countryCode: Scalars['String']['output'];
  /** Country name */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Default max terms from regulated_country_terms */
  defaultMaxTerms?: Maybe<Scalars['Int']['output']>;
  /** Whether the country has regulatory term limits */
  isRegulated: Scalars['Boolean']['output'];
  /** Override max terms for this country */
  maxTerms?: Maybe<Scalars['Int']['output']>;
};

export type WcmBenchmarkCountryRegulationsOutput = {
  __typename?: 'WcmBenchmarkCountryRegulationsOutput';
  /** List of country regulations */
  regulations: Array<WcmBenchmarkCountryRegulationItem>;
};

export type WcmBenchmarkStrategyBySegmentInput = {
  Core: Benchmarking_Strategies;
  Strategic: Benchmarking_Strategies;
  Tail: Benchmarking_Strategies;
};

export type WcmBenchmarkStrategyBySegmentOutput = {
  __typename?: 'WcmBenchmarkStrategyBySegmentOutput';
  Core: Benchmarking_Strategies;
  Strategic: Benchmarking_Strategies;
  Tail: Benchmarking_Strategies;
  applyTermsHarmonization: Scalars['Boolean']['output'];
};

export type WcmBenchmarkVersionsByPeriod = {
  __typename?: 'WcmBenchmarkVersionsByPeriod';
  /** Available benchmarking version dates for this period (YYYY-MM-DD) */
  dates: Array<Scalars['String']['output']>;
  /** Benchmark period (PERIOD_TO_DATE, TWELVE_MONTHS, TWENTY_FOUR_MONTHS, THIRTY_SIX_MONTHS) */
  period: Benchmarking_Period;
};

export type WcmBenchmarkingStrategies = {
  __typename?: 'WcmBenchmarkingStrategies';
  benchmarkTerms: Scalars['Float']['output'];
  custom: Scalars['Float']['output'];
  industryCountry75: Scalars['Float']['output'];
  industryCountry85: Scalars['Float']['output'];
  industryCountry90: Scalars['Float']['output'];
  industryCountry95: Scalars['Float']['output'];
  industryCountry99: Scalars['Float']['output'];
  industryCountryMax: Scalars['Float']['output'];
  industryCountryMedian: Scalars['Float']['output'];
  industryGlobal75: Scalars['Float']['output'];
  industryGlobal85: Scalars['Float']['output'];
  industryGlobal90: Scalars['Float']['output'];
  industryGlobal95: Scalars['Float']['output'];
  industryGlobal99: Scalars['Float']['output'];
  industryGlobalMax: Scalars['Float']['output'];
  industryGlobalMedian: Scalars['Float']['output'];
  waHarmonization: Scalars['Float']['output'];
};

export type WcmBuyerData = {
  __typename?: 'WcmBuyerData';
  /** Wcm Buyer Permissions */
  permissions: Array<Scalars['String']['output']>;
  /** Wcm Buyer Name */
  wcmBuyerName: Scalars['String']['output'];
  /** WCM Buyer Type */
  wcmBuyerType: Wcm_Buyer_Type;
  /** Wcm Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerExclusionRemark = {
  __typename?: 'WcmBuyerExclusionRemark';
  id: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
};

export type WcmBuyerExclusionRemarkOutput = {
  __typename?: 'WcmBuyerExclusionRemarkOutput';
  status: Scalars['Boolean']['output'];
};

export type WcmBuyerFileStatus = {
  __typename?: 'WcmBuyerFileStatus';
  isWorkingCapitalInsightsReady: Scalars['Boolean']['output'];
  spendFile: WcmBuyerSpendFileStatus;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerMetaDataInput = {
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmBuyerMetaDataOutput = {
  __typename?: 'WcmBuyerMetaDataOutput';
  /** report currencies */
  reportCurrencies: Array<Scalars['String']['output']>;
};

export type WcmBuyerSpendFileStatus = {
  __typename?: 'WcmBuyerSpendFileStatus';
  daysSinceUpload?: Maybe<Scalars['Int']['output']>;
  uploaded: Scalars['Boolean']['output'];
};

export type WcmBuyerUser = {
  __typename?: 'WcmBuyerUser';
  buyerUserMappingId: Scalars['Int']['output'];
  emailAddress: Scalars['String']['output'];
  /** Access expiry in UTC format (e.g., "2025-01-01T00:00:00.000Z") */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** True when the user has a role granting wcm_insights_access for this buyer. */
  hasInsightsBotAccess: Scalars['Boolean']['output'];
  /** True when the user has a role granting wcm_sales_enabler_access for this buyer. */
  hasSalesEnablerAccess: Scalars['Boolean']['output'];
  isC2FO: Scalars['Boolean']['output'];
  isPermissionManager: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roles: Array<WcmUserRolesInfo>;
  userUuid: Scalars['String']['output'];
};

export type WcmBuyerUserAccessInput = {
  /** Allows external users to access DEMO type buyers. Not required for internal C2FO users as they have access if mapping exists regardless of buyer type. */
  allowDemoAccessForExternalUsers?: Scalars['Boolean']['input'];
  /** Allows external users to access Trial type buyers. Not required for internal C2FO users as they have access if mapping exists regardless of buyer type. */
  allowTrialAccessForExternalUsers?: Scalars['Boolean']['input'];
  /** User UUID */
  userUuid: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmBuyerUserAccessOutput = {
  __typename?: 'WcmBuyerUserAccessOutput';
  /** Access validation status */
  status: Scalars['Boolean']['output'];
};

export type WcmBuyerUserDetailsForAdmin = {
  __typename?: 'WcmBuyerUserDetailsForAdmin';
  buyerUserMappingId: Scalars['Int']['output'];
  emailAddress: Scalars['String']['output'];
  /** Access expiry in UTC format (e.g., "2025-01-01T00:00:00.000Z") */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** True when the user has a role granting wcm_insights_access for this buyer. */
  hasInsightsBotAccess: Scalars['Boolean']['output'];
  /** True when the user has a role granting wcm_sales_enabler_access for this buyer. */
  hasSalesEnablerAccess: Scalars['Boolean']['output'];
  isC2FO: Scalars['Boolean']['output'];
  isPermissionManager: Scalars['Boolean']['output'];
  /** User last login date */
  lastLogin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roles: Array<WcmUserRolesInfo>;
  userUuid: Scalars['String']['output'];
  wcmBuyers: Array<WcmUserBuyer>;
};

export type WcmBuyerUserMappingOutput = {
  __typename?: 'WcmBuyerUserMappingOutput';
  userUuid: Scalars['String']['output'];
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerUsersCountOutput = {
  __typename?: 'WcmBuyerUsersCountOutput';
  /** Count of distinct C2FO users mapped to this buyer */
  c2foUserCount: Scalars['Int']['output'];
  /** Count of distinct non-C2FO users mapped to this buyer */
  nonC2foUserCount: Scalars['Int']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerUsersDetailsPaging = {
  pageNum?: Scalars['Int']['input'];
};

export type WcmCashflowDistributionInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmCashflowDistributionOutput = {
  __typename?: 'WcmCashflowDistributionOutput';
  /** alpha 2 code of top spend country of supplier */
  alpha2Code: Scalars['String']['output'];
  /** alpha 3 code of top spend country of supplier */
  alpha3Code: Scalars['String']['output'];
  /** cashflow spend amount */
  cashflow: Scalars['Float']['output'];
  /** top spend country of supplier */
  countryName: Scalars['String']['output'];
  /** estimated working capital opportunity */
  estimatedWco: Scalars['Float']['output'];
  /** region of supplier */
  region: Wcm_Buyer_Region;
  /** Segemnt category of spend data */
  segment: Wcm_Segment;
};

export type WcmCountryAggregatedValue = {
  __typename?: 'WcmCountryAggregatedValue';
  /** Aggregated values for this country */
  aggregatedValues: WcmSuppliersGroupAggregatedValue;
  /** Country code (e.g., US, CA, MX) */
  country: Scalars['String']['output'];
};

export type WcmCountryRegulationItemInput = {
  /** Country code (ISO2 or ISO3) */
  countryCode: Scalars['String']['input'];
  /** Whether the country has regulatory term limits */
  isRegulated: Scalars['Boolean']['input'];
  /** Override max terms for this country */
  maxTerms?: InputMaybe<Scalars['Int']['input']>;
};

export type WcmCreatePlanInput = {
  /** Plan end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Currency */
  fileCurrency: Scalars['String']['input'];
  /** Plan name */
  name: Scalars['String']['input'];
  /** Owner of the plan */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Plan start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmCumulativeBucket = {
  __typename?: 'WcmCumulativeBucket';
  /** Bucket start date (ISO format) */
  bucketStart: Scalars['String']['output'];
  /** Cumulative status entries for COMPLETED/ERP_UPDATED phases */
  statuses: Array<WcmCumulativeStatusEntry>;
  /** Target WCO at this bucket (null when non-plan/wave filters applied) */
  targetWco?: Maybe<Scalars['Float']['output']>;
};

export type WcmCumulativeStatusEntry = {
  __typename?: 'WcmCumulativeStatusEntry';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Cumulative supplier entity count that ever reached this status */
  cumSupplierEntities: Scalars['Int']['output'];
  /** Cumulative WCO for supplier entities that ever reached this status */
  cumWco: Scalars['Float']['output'];
  /** Sub-ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Status label (e.g. "Terms Agreed") */
  statusLabel: Scalars['String']['output'];
};

export type WcmCustomAttributeDefinitionResponse = {
  __typename?: 'WcmCustomAttributeDefinitionResponse';
  /** ISO 4217 currency code (3 letters) */
  currency: Scalars['String']['output'];
  /** Display name of the custom attribute for UI purposes */
  displayName: Scalars['String']['output'];
  /** Internal name of the custom attribute (snake_case) */
  internalName: Scalars['String']['output'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmCustomAttributeResponse = {
  __typename?: 'WcmCustomAttributeResponse';
  /** Attribute definition ID */
  attributeId: Scalars['Int']['output'];
  /** Display name of the custom attribute for UI purposes */
  displayName: Scalars['String']['output'];
  /** Internal name of the custom attribute (snake_case) */
  internalName: Scalars['String']['output'];
  /** Array of value objects with usage counts */
  values: Array<CustomAttributeValueDto>;
};

export type WcmDashboard = {
  __typename?: 'WcmDashboard';
  /** Whether the current user can edit this dashboard */
  canEdit: Scalars['Boolean']['output'];
  /** Created timestamp */
  created: Scalars['String']['output'];
  /** Created by */
  createdBy: Scalars['String']['output'];
  /** Dashboard description */
  description?: Maybe<Scalars['String']['output']>;
  /** Draft dashboard config (owner only) */
  draftConfig?: Maybe<Scalars['JSON']['output']>;
  /** Dashboard ID */
  id: Scalars['Int']['output'];
  /** Last time this report was opened */
  lastViewed?: Maybe<Scalars['String']['output']>;
  /** Short-lived GET URLs keyed by image assetId */
  mediaUrls?: Maybe<Scalars['JSON']['output']>;
  /** Dashboard name */
  name: Scalars['String']['output'];
  /** Published dashboard config */
  publishedConfig?: Maybe<Scalars['JSON']['output']>;
  /** Dashboard status */
  status: Wcm_Dashboard_Status;
  /** Last Updated timestamp */
  updated?: Maybe<Scalars['String']['output']>;
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Buyer UUID */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmDashboardList = {
  __typename?: 'WcmDashboardList';
  /** List of dashboards */
  items: Array<WcmDashboardListItem>;
  /** Total number of dashboards */
  total: Scalars['Int']['output'];
};

export type WcmDashboardListItem = {
  __typename?: 'WcmDashboardListItem';
  /** Created timestamp */
  created: Scalars['String']['output'];
  /** Created by */
  createdBy: Scalars['String']['output'];
  /** Details of the user that created the dashboard */
  createdByDetails?: Maybe<WcmDashboardUserDetails>;
  /** Dashboard description */
  description?: Maybe<Scalars['String']['output']>;
  /** Dashboard ID */
  id: Scalars['Int']['output'];
  /** Last time this report was opened */
  lastViewed?: Maybe<Scalars['String']['output']>;
  /** Dashboard name */
  name: Scalars['String']['output'];
  /** Dashboard status */
  status: Wcm_Dashboard_Status;
  /** Last Updated timestamp */
  updated?: Maybe<Scalars['String']['output']>;
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Details of the user that last updated the dashboard */
  updatedByDetails?: Maybe<WcmDashboardUserDetails>;
  /** Buyer UUID */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmDashboardMediaUploadSignedUrl = {
  __typename?: 'WcmDashboardMediaUploadSignedUrl';
  /** Media asset id to store on the image widget */
  assetId: Scalars['String']['output'];
  /** Presigned POST fields the client must send before the file part */
  fields: Scalars['JSON']['output'];
  /** Presigned S3 POST URL. Client must POST multipart/form-data, not PUT. */
  signedUrl: Scalars['String']['output'];
};

export type WcmDashboardUserDetails = {
  __typename?: 'WcmDashboardUserDetails';
  /** Email address of the user */
  emailAddress: Scalars['String']['output'];
  /** First name of the user */
  firstName: Scalars['String']['output'];
  /** Last name of the user */
  lastName: Scalars['String']['output'];
};

export type WcmDeleteDashboardResponse = {
  __typename?: 'WcmDeleteDashboardResponse';
  /** Dashboard ID */
  id: Scalars['Int']['output'];
  /** Response message */
  message: Scalars['String']['output'];
  /** Success flag */
  success: Scalars['Boolean']['output'];
};

export type WcmDeleteDisplayCurrencyRateInput = {
  /** Target display currency (ISO 4217) */
  targetCurrency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmDeleteDomainBuyerMappingsInput = {
  /** Array of buyer UUIDs to remove from the domain */
  buyerUuids: Array<Scalars['String']['input']>;
  /** Domain name */
  domain: Scalars['String']['input'];
};

export type WcmDisplayCurrencyConfig = {
  __typename?: 'WcmDisplayCurrencyConfig';
  /** Configured display FX rates */
  rates: Array<WcmDisplayCurrencyRate>;
  /** Source currency from the latest approved All_Data file, or null when none exists */
  sourceCurrency?: Maybe<Scalars['String']['output']>;
};

export type WcmDisplayCurrencyRate = {
  __typename?: 'WcmDisplayCurrencyRate';
  /** Created timestamp */
  created: Scalars['DateTime']['output'];
  /** Auth-service UUID of the user who created the rate */
  createdBy: Scalars['String']['output'];
  /** Fixed conversion rate: 1 source = rate target */
  rate: Scalars['Float']['output'];
  /** Source spend currency stamped from the latest approved All_Data file */
  sourceCurrency: Scalars['String']['output'];
  /** Target display currency (ISO 4217) */
  targetCurrency: Scalars['String']['output'];
  /** Updated timestamp */
  updated: Scalars['DateTime']['output'];
  /** Auth-service UUID of the user who last updated the rate */
  updatedBy: Scalars['String']['output'];
};

export type WcmDomainClientConfig = {
  __typename?: 'WcmDomainClientConfig';
  logoUrl?: Maybe<Scalars['String']['output']>;
  showAccountSettings: Scalars['Boolean']['output'];
  showAllRightsReserved: Scalars['Boolean']['output'];
  showBuyerApp: Scalars['Boolean']['output'];
  showC2FOChatbot: Scalars['Boolean']['output'];
  showC2FOLogo: Scalars['Boolean']['output'];
  showNavigator: Scalars['Boolean']['output'];
  showPoweredByC2FO: Scalars['Boolean']['output'];
  showPrivacyPolicy: Scalars['Boolean']['output'];
  showSalesEnabler: Scalars['Boolean']['output'];
  showSubProcessors: Scalars['Boolean']['output'];
  showSupplierAgreement: Scalars['Boolean']['output'];
  showViewAsSupplier: Scalars['Boolean']['output'];
  /** Theme identifier to use for this domain */
  uiThemeName: Scalars['String']['output'];
};

export type WcmDomainClientConfigInput = {
  /** Custom logo URL to display */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show Account Settings */
  showAccountSettings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show "All Rights Reserved" text */
  showAllRightsReserved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Buyer App link */
  showBuyerApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show C2FO chatbot */
  showC2FOChatbot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show C2FO logo */
  showC2FOLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Navigator link */
  showNavigator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show "Powered by C2FO" text */
  showPoweredByC2FO?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Privacy Policy link */
  showPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Sales Enabler link */
  showSalesEnabler?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Subprocessors link */
  showSubProcessors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Supplier Agreement link */
  showSupplierAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show View as Supplier option */
  showViewAsSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  /** Theme identifier to use for this domain (e.g., EY, PWC, DEFAULT) */
  uiThemeName?: InputMaybe<Scalars['String']['input']>;
};

export type WcmDomainClientConfigOutput = {
  __typename?: 'WcmDomainClientConfigOutput';
  /** List of allowed buyer UUIDs (only for SOME access type) */
  allowedBuyerUuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Buyer access type (ALL, SOME, or NONE) */
  buyerAccessType: Scalars['String']['output'];
  /** Client-specific configuration settings */
  clientConfig: Scalars['JSONObject']['output'];
};

export type WcmDomainConfigResponse = {
  __typename?: 'WcmDomainConfigResponse';
  /** Operation status */
  status: Scalars['Boolean']['output'];
};

export type WcmEconomicValueConfigOutput = {
  __typename?: 'WcmEconomicValueConfigOutput';
  economicValue: Scalars['Float']['output'];
};

export type WcmEnrichedFileUploadHistory = {
  __typename?: 'WcmEnrichedFileUploadHistory';
  created: Scalars['String']['output'];
  fileCurrency: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionUuid: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
  wcmBuyerName?: Maybe<Scalars['String']['output']>;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmEnrichedSpendUpdatableColumnField = {
  __typename?: 'WcmEnrichedSpendUpdatableColumnField';
  /** Description shown alongside the field. */
  description: Scalars['String']['output'];
  /** Unique key for the field */
  key: Scalars['String']['output'];
  /** Display label for the field. */
  label: Scalars['String']['output'];
};

export type WcmEnrichedSpendUpdatableColumnGroup = {
  __typename?: 'WcmEnrichedSpendUpdatableColumnGroup';
  /** Whether the group is pre-selected on first render. */
  defaultSelected: Scalars['Boolean']['output'];
  /** Fields belonging to this group. */
  fields: Array<WcmEnrichedSpendUpdatableColumnField>;
  /** Group identifier. */
  id: Scalars['String']['output'];
  /** Display name of the group. */
  name: Scalars['String']['output'];
};

export type WcmEnrichedSpendUpdatableColumns = {
  __typename?: 'WcmEnrichedSpendUpdatableColumns';
  /** Grouped updatable columns for the column-scoped update flow. */
  groups: Array<WcmEnrichedSpendUpdatableColumnGroup>;
  /** Identity / audit columns shown for transparency only — never updatable. */
  locked: Array<WcmEnrichedSpendUpdatableColumnField>;
};

export type WcmExclusionCriteria = {
  __typename?: 'WcmExclusionCriteria';
  /** exclusion criteria of supplier */
  exclusionCriteria: Scalars['String']['output'];
  /** exclusion remark of supplier */
  exclusionRemark?: Maybe<Scalars['String']['output']>;
  /** spend amount */
  spend: Scalars['Float']['output'];
  /** number of suppliers */
  supplierCount: Scalars['Float']['output'];
  /** Number of suppliers entities */
  supplierEntitiesCount: Scalars['Float']['output'];
  /** WA Current Terms */
  waCurrentTerms: Scalars['Float']['output'];
  /** Working Capital Opportunity */
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmExclusionCriteriaInput = {
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmExclusionCriteriaOutput = {
  __typename?: 'WcmExclusionCriteriaOutput';
  buyerExclusionCriterias: Array<WcmExclusionCriteria>;
  /** Economic Value Config */
  economicValueConfig: Scalars['Float']['output'];
  exclusionCriterias: Array<WcmExclusionCriteria>;
  /** Total Spend */
  totalSpend: Scalars['Float']['output'];
  /** Total Number of suppliers entities */
  totalSupplierEntitiesCount: Scalars['Float']['output'];
  /** Total Number of suppliers groups */
  totalSupplierGroupsCount: Scalars['Float']['output'];
  /** Total WA Current Terms */
  totalWaCurrentTerms: Scalars['Float']['output'];
};

export type WcmExclusionsConfigOutput = {
  __typename?: 'WcmExclusionsConfigOutput';
  /** Exclude suppliers with discounted payment terms */
  discountTermExclusion: Scalars['Boolean']['output'];
  /** Exclude diverse suppliers */
  diverseSupplierExclusion: Scalars['Boolean']['output'];
  /** Minimum spend value threshold for supplier groups */
  minSpendValue: Scalars['Float']['output'];
  /** Exclude suppliers with missing payment terms */
  missingTermExclusion: Scalars['Boolean']['output'];
};

export type WcmExternalBuyerMap = {
  __typename?: 'WcmExternalBuyerMap';
  /** External buyer map id */
  id: Scalars['ID']['output'];
  /** Timestamp through which negotiations have been ingested */
  negotiationIngestedThroughAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether negotiation sync is enabled */
  negotiationSyncEnabled: Scalars['Boolean']['output'];
  /** External source id */
  sourceId: Scalars['String']['output'];
  /** External source name */
  sourceName: Scalars['String']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmExternalBuyerMapInfo = {
  __typename?: 'WcmExternalBuyerMapInfo';
  /** External buyer map id */
  id: Scalars['ID']['output'];
  /** Timestamp through which negotiations have been ingested */
  negotiationIngestedThroughAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether negotiation sync is enabled */
  negotiationSyncEnabled: Scalars['Boolean']['output'];
  /** External source id */
  sourceId: Scalars['String']['output'];
  /** External source name */
  sourceName: Scalars['String']['output'];
  /** WCM buyer name */
  wcmBuyerName: Scalars['String']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmFetchAllSupplierGroups = {
  __typename?: 'WcmFetchAllSupplierGroups';
  /** Additional Exclusion Remark */
  additionalExclusionRemark?: Maybe<Scalars['String']['output']>;
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  contractualTermsDescription?: Maybe<Scalars['String']['output']>;
  currentTerms: Scalars['Float']['output'];
  /** Custom attributes for the supplier group from the supplier with highest spend (spend rank 1). Object with internal attribute names as keys and objects containing displayName and value as values. */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  estimatedTerms: Scalars['Float']['output'];
  estimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Exclusion Remark */
  exclusionRemark?: Maybe<Scalars['String']['output']>;
  groupBenchmarkStrategies?: Maybe<Array<Scalars['String']['output']>>;
  groupCategories?: Maybe<Array<Scalars['String']['output']>>;
  groupContractualTermsDescriptions?: Maybe<Array<Scalars['String']['output']>>;
  groupRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** Enriched Supplier File Data ID */
  ids: Array<Scalars['Float']['output']>;
  includeReason: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  /** Indicates if supplier group has discounted terms */
  isDiscountedTerms?: Maybe<Scalars['Boolean']['output']>;
  isDiverseSupplier?: Maybe<Scalars['String']['output']>;
  naicsCode?: Maybe<Scalars['Float']['output']>;
  negotiationStatus?: Maybe<Array<Scalars['String']['output']>>;
  region: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  supplierGroup: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory: Scalars['String']['output'];
  vendorId?: Maybe<Scalars['String']['output']>;
  vendorMasterId: Scalars['String']['output'];
  /** Enriched Supplier Variant ID */
  vendorVariantIds: Array<Scalars['String']['output']>;
  /** Effective WCO conversion rate as a 0-100 integer. */
  wcoConversionRate?: Maybe<Scalars['Float']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmFetchAllSupplierGroupsFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  displayCurrency: Scalars['String']['input'];
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Level 6 Supplier Industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 2 Supplier Industries */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 3 Supplier Industries */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary Supplier Categories */
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Supplier Categories */
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Supplier Categories */
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type WcmFetchAllSupplierGroupsInput = {
  filters: WcmFetchAllSupplierGroupsFilters;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  paging: BuyerAppFetchAllSuppliersPaging;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<WcmFetchAllSupplierGroupsSorting>;
  /** Wave ID to filter suppliers by plan */
  waveId?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmFetchAllSupplierGroupsOutput = {
  __typename?: 'WcmFetchAllSupplierGroupsOutput';
  coreSupplierGroupCount: Scalars['Float']['output'];
  strategicSupplierGroupCount: Scalars['Float']['output'];
  supplierGroups: Array<WcmFetchAllSupplierGroups>;
  tailSupplierGroupCount: Scalars['Float']['output'];
  totalAnnualSpend: Scalars['Float']['output'];
  totalEstimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  totalSupplierGroups: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmFetchAllSupplierGroupsSorting = {
  /** Field on which sorting is to be carried out (supports WCM_SUPPLIERS_ORDER_LEVEL or custom_attribute_N) */
  orderLevel: Scalars['String']['input'];
  orderType?: Order_Type;
};

export type WcmFetchAllSuppliersFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  displayCurrency: Scalars['String']['input'];
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Level 6 Supplier Industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 2 Supplier Industries */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 3 Supplier Industries */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  naicsCodes?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary Supplier Categories */
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Supplier Categories */
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Supplier Categories */
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type WcmFetchAllSuppliersInput = {
  filters: WcmFetchAllSuppliersFilters;
  paging: BuyerAppFetchAllSuppliersPaging;
  sorting?: InputMaybe<WcmFetchAllSuppliersSorting>;
};

export type WcmFetchAllSuppliersSorting = {
  /** Field on which sorting is to be carried out (supports WCM_SUPPLIERS_ORDER_LEVEL or custom_attribute_N) */
  orderLevel: Scalars['String']['input'];
  orderType?: Order_Type;
};

export type WcmFetchAllWcmSuppliers = {
  __typename?: 'WcmFetchAllWcmSuppliers';
  /** Additional Exclusion Remark */
  additionalExclusionRemark?: Maybe<Scalars['String']['output']>;
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  bargainingPower: Scalars['String']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  contractualTermsDescription?: Maybe<Scalars['String']['output']>;
  currentTerms: Scalars['Float']['output'];
  /** Custom attributes for the supplier. Object with internal attribute names as keys and objects containing displayName and value as values. */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  estimatedTerms: Scalars['Float']['output'];
  estimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Exclusion Remark */
  exclusionRemark?: Maybe<Scalars['String']['output']>;
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  includeReason: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  /** True when the conversion rate is a per-supplier override, not the segment-level default. */
  isConversionRateOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if supplier has discounted terms */
  isDiscountedTerms?: Maybe<Scalars['Boolean']['output']>;
  isDiverseSupplier?: Maybe<Scalars['String']['output']>;
  /** True when the displayed segment is a user-chosen override, not the system-derived value. */
  isSegmentOverridden?: Maybe<Scalars['Boolean']['output']>;
  naicsCode?: Maybe<Scalars['Float']['output']>;
  negotiationStatus?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory: Scalars['String']['output'];
  /** Effective WCO conversion rate as a 0-100 integer. */
  wcoConversionRate?: Maybe<Scalars['Float']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmFetchAllWcmSuppliersOutput = {
  __typename?: 'WcmFetchAllWcmSuppliersOutput';
  coreSupplierEntitiesCount: Scalars['Float']['output'];
  maxAnnualSpend?: Maybe<Scalars['Float']['output']>;
  maxCurrentTerms?: Maybe<Scalars['Float']['output']>;
  minAnnualSpend?: Maybe<Scalars['Float']['output']>;
  minCurrentTerms?: Maybe<Scalars['Float']['output']>;
  strategicSupplierEntitiesCount: Scalars['Float']['output'];
  suppliers: Array<WcmFetchAllWcmSuppliers>;
  tailSupplierEntitiesCount: Scalars['Float']['output'];
  totalAnnualSpend?: Maybe<Scalars['Float']['output']>;
  totalEstimatedWorkingCapitalOpportunity?: Maybe<Scalars['Float']['output']>;
  totalSuppliers: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity?: Maybe<Scalars['Float']['output']>;
};

export type WcmFetchEnrichedFileUploadHistoryInput = {
  /** File Currency */
  fileCurrency: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmFetchEnrichedSpendUpdatableColumnsInput = {
  /** File Currency */
  fileCurrency: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmFetchInvoiceFileUploadHistoryInput = {
  fileCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmFilterOption = {
  __typename?: 'WcmFilterOption';
  /** Display label */
  label: Scalars['String']['output'];
  /** Filter value (stringified ID, empty string for NA) */
  value: Scalars['String']['output'];
};

export type WcmGenerateWorkingCapitalFilters = {
  displayCurrency: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  spendValue?: InputMaybe<WcmWorkingCapitalFilters>;
  supplierCount?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<WcmWorkingCapitalFilters>;
  wcmBuyerUuid: Scalars['String']['input'];
  workingCapitalRequirement: Scalars['Float']['input'];
};

export type WcmGenerateWorkingCapitalGroupsOutput = {
  __typename?: 'WcmGenerateWorkingCapitalGroupsOutput';
  supplierGroups: Array<WcmGenerateWorkingCapitalSupplierGroup>;
  totalRows: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGenerateWorkingCapitalInput = {
  filters: WcmGenerateWorkingCapitalFilters;
  paging: BuyerAppFetchAllSuppliersPaging;
  sorting?: InputMaybe<WcmGenerateWorkingCapitalSorting>;
};

export type WcmGenerateWorkingCapitalOutput = {
  __typename?: 'WcmGenerateWorkingCapitalOutput';
  suppliers: Array<WcmGenerateWorkingCapitalSupplier>;
  totalRows: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGenerateWorkingCapitalSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Wcm_Suppliers_Order_Level;
  orderType?: Order_Type;
};

export type WcmGenerateWorkingCapitalSupplier = {
  __typename?: 'WcmGenerateWorkingCapitalSupplier';
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  bargainingPower: Scalars['String']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  currentTerms: Scalars['Float']['output'];
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  industry: Scalars['String']['output'];
  region: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory: Scalars['String']['output'];
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGenerateWorkingCapitalSupplierGroup = {
  __typename?: 'WcmGenerateWorkingCapitalSupplierGroup';
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  currentTerms: Scalars['Float']['output'];
  groupRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** Enriched Supplier File Data IDs */
  ids: Array<Scalars['Float']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  supplierGroup: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory?: Maybe<Scalars['String']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGetDisplayCurrencyConfigInput = {
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmGetNaicsBenchmarkCoverageInput = {
  /** Display currency for benchmark configuration */
  displayCurrency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmGetNaicsExclusionsInput = {
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmGetNaicsSuggestionsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  supplierName: Scalars['String']['input'];
  supplierUuid: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type WcmGetNaicsSuggestionsOutput = {
  __typename?: 'WcmGetNaicsSuggestionsOutput';
  /** Indicates if the NAICS code is excluded for this buyer */
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
  /** Naics code */
  naicsCode: Scalars['Float']['output'];
  /** Naics description */
  naicsDescription: Scalars['String']['output'];
};

export type WcmGroupedWorkingCapitalOpportunityByDimensionFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dimension on which data is grouped by (enum value or custom_attribute_N) */
  groupBy: Scalars['String']['input'];
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmGroupedWorkingCapitalOpportunityByDimensionOutput = {
  __typename?: 'WcmGroupedWorkingCapitalOpportunityByDimensionOutput';
  coreEstimatedWCO: Scalars['Float']['output'];
  coreWCO: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  labelCode: Scalars['String']['output'];
  strategicEstimatedWCO: Scalars['Float']['output'];
  strategicWCO: Scalars['Float']['output'];
  tailEstimatedWCO: Scalars['Float']['output'];
  tailWCO: Scalars['Float']['output'];
};

/** A WCM Insights conversation */
export type WcmInsightsConversationDto = {
  __typename?: 'WcmInsightsConversationDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messageCount: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for listing conversations */
export type WcmInsightsConversationsInputDto = {
  /** Max number of conversations to return */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Input for deleting a conversation */
export type WcmInsightsDeleteConversationInputDto = {
  /** The conversation ID to delete */
  conversationId: Scalars['String']['input'];
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Result of deleting a conversation */
export type WcmInsightsDeleteResultDto = {
  __typename?: 'WcmInsightsDeleteResultDto';
  success: Scalars['Boolean']['output'];
};

/** Input for submitting feedback on an assistant message */
export type WcmInsightsFeedbackInputDto = {
  /** Optional comment with the feedback */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The message ID to provide feedback for */
  messageId: Scalars['String']['input'];
  /** Feedback rating */
  rating: WcmInsightsFeedbackRating;
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Rating for WCM Insights assistant messages */
export type WcmInsightsFeedbackRating =
  | 'NEGATIVE'
  | 'POSITIVE';

/** Result of submitting feedback */
export type WcmInsightsFeedbackResultDto = {
  __typename?: 'WcmInsightsFeedbackResultDto';
  id: Scalars['ID']['output'];
  rating: WcmInsightsFeedbackRating;
  success: Scalars['Boolean']['output'];
};

/** A message within a WCM Insights conversation */
export type WcmInsightsMessageDto = {
  __typename?: 'WcmInsightsMessageDto';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The current user's like or dislike for this assistant message, if they have rated it. */
  feedbackRating?: Maybe<WcmInsightsFeedbackRating>;
  id: Scalars['ID']['output'];
  /** Query results for the UI widget. Null for knowledge-only answers. */
  queryResults?: Maybe<Scalars['JSON']['output']>;
  role: Scalars['String']['output'];
};

/** Input for getting messages in a conversation */
export type WcmInsightsMessagesInputDto = {
  /** The conversation ID */
  conversationId: Scalars['String']['input'];
  /** Max number of most recent messages to return */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Input for querying WCM Insights via GraphQL */
export type WcmInsightsQueryInputDto = {
  /** Optional conversation ID to continue */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** ISO 4217 display currency (e.g. USD, EUR). Spend is stored in the source file currency; this value is converted with a configured FX rate. If omitted, the source file currency is used. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The user question or prompt */
  question: Scalars['String']['input'];
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Result of a WCM Insights query via GraphQL */
export type WcmInsightsQueryResultDto = {
  __typename?: 'WcmInsightsQueryResultDto';
  /** The LLM answer */
  answer: Scalars['String']['output'];
  /** The conversation ID */
  conversationId: Scalars['String']['output'];
  inputTokens: Scalars['Float']['output'];
  latencyMs: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
};

export type WcmInvoiceFileUploadHistory = {
  __typename?: 'WcmInvoiceFileUploadHistory';
  created: Scalars['String']['output'];
  fileCurrency: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionUuid: Scalars['String']['output'];
  uploadBatchId: Scalars['Int']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
  wcmBuyerName?: Maybe<Scalars['String']['output']>;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmMasterBuyerList = {
  __typename?: 'WcmMasterBuyerList';
  /** WCM buyer created date */
  created: Scalars['DateTime']['output'];
  /** WCM buyer data center */
  dataCenter: Scalars['String']['output'];
  /** WCM buyer type */
  type: Wcm_Buyer_Type;
  /** WCM buyer name */
  wcmBuyerName: Scalars['String']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmMasterBuyerListFilter = {
  and?: InputMaybe<Array<WcmMasterBuyerListFilter>>;
  dataCenter?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<WcmMasterBuyerListFilter>>;
  type?: InputMaybe<Wcm_Buyer_TypeFilterComparison>;
  wcmBuyerUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmMasterBuyerListSort = {
  direction: SortDirection;
  field: WcmMasterBuyerListSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmMasterBuyerListSortFields =
  | 'dataCenter'
  | 'type'
  | 'wcmBuyerUuid';

export type WcmMasterRegionCountryList = {
  __typename?: 'WcmMasterRegionCountryList';
  /** alpha2 country code */
  alpha2Code: Scalars['String']['output'];
  /** alpha3 country code */
  alpha3Code: Scalars['String']['output'];
  /** Country name */
  countryName: Scalars['String']['output'];
  /** Region */
  region: Wcm_Buyer_Region;
};

export type WcmMasterRegionCountryListFilter = {
  alpha2Code?: InputMaybe<StringFieldComparison>;
  alpha3Code?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<WcmMasterRegionCountryListFilter>>;
  or?: InputMaybe<Array<WcmMasterRegionCountryListFilter>>;
};

export type WcmMasterRegionCountryListSort = {
  direction: SortDirection;
  field: WcmMasterRegionCountryListSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmMasterRegionCountryListSortFields =
  | 'alpha2Code'
  | 'alpha3Code';

export type WcmMonitoringCumulativeInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** Time bucket interval */
  interval: Time_Periods;
  /** Range end date (ISO format). */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Range start date (ISO format). */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmMonitoringFiltersInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contractual Terms Descriptions */
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by country */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by industry */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Filter by segment */
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
};

export type WcmMonitoringSnapshotInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** Time bucket interval (group by) */
  interval: Time_Periods;
  /** Range end date (ISO format, e.g. 2025-12-01) */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Range start date (ISO format, e.g. 2025-01-01) */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmMonitoringStats = {
  __typename?: 'WcmMonitoringStats';
  /** Estimated working capital opportunity (benchmark-based with segment conversion rate) */
  estimatedOpportunity: Scalars['Float']['output'];
  /** Per-status stats */
  statusStats: Array<WcmMonitoringStatusStat>;
  /** Target WCO (null when non-plan/wave filters applied) */
  targetWco?: Maybe<Scalars['Float']['output']>;
  /** Total spend across all in-scope supplier entities */
  totalSpend: Scalars['Float']['output'];
  /** Total supplier entity count */
  totalSupplierEntityCount: Scalars['Int']['output'];
  /** Total working capital opportunity (phase-aware) */
  totalWco: Scalars['Float']['output'];
};

export type WcmMonitoringStatsInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmMonitoringStatusStat = {
  __typename?: 'WcmMonitoringStatusStat';
  /** Canonical negotiation phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Custom display order for this status */
  customOrder: Scalars['Int']['output'];
  /** Status label (e.g. "Outreach Sent") */
  statusLabel: Scalars['String']['output'];
  /** Number of supplier entities in this status */
  supplierEntityCount: Scalars['Int']['output'];
  /** Working capital opportunity for this status */
  wco: Scalars['Float']['output'];
};

export type WcmMonitoringTrackingByAggregatorInput = {
  /** Aggregator dimension key (e.g. SUPPLIER_SEGMENT, SUPPLIER_COUNTRY, custom_attribute_1) */
  aggregator: Scalars['String']['input'];
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** Field on which sorting is to be carried out */
  orderLevel?: InputMaybe<Scalars['String']['input']>;
  /** Order direction (ASC/DESC) */
  orderType?: InputMaybe<Order_Type>;
  /** Range end date (ISO format) */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Range start date (ISO format) */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmNaicsBenchmarkCoverage = {
  __typename?: 'WcmNaicsBenchmarkCoverage';
  /** Number of NAICS codes with global benchmark data */
  coveredNaicsCount: Scalars['Int']['output'];
  sectors: Array<WcmNaicsBenchmarkCoverageSector>;
  /** Total buyer spend across all returned NAICS codes */
  totalBuyerSpend: Scalars['Float']['output'];
  /** Total buyer supplier entities across all returned NAICS codes */
  totalBuyerSupplierCount: Scalars['Int']['output'];
  /** Total global benchmark invoice amount (USD) across NAICS codes that have benchmark data */
  totalGlobalInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Total global benchmark supplier count across NAICS codes that have benchmark data */
  totalGlobalSupplierCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of buyer NAICS codes in the response */
  totalNaicsCount: Scalars['Int']['output'];
};

export type WcmNaicsBenchmarkCoverageGroup = {
  __typename?: 'WcmNaicsBenchmarkCoverageGroup';
  /** Aggregated buyer spend in this group */
  buyerSpend: Scalars['Float']['output'];
  /** Aggregated buyer supplier count in this group */
  buyerSupplierCount: Scalars['Int']['output'];
  /** 4-digit NAICS group code */
  code: Scalars['Int']['output'];
  codes: Array<WcmNaicsBenchmarkCoverageLeaf>;
  /** NAICS group description */
  description: Scalars['String']['output'];
  /** Aggregated global benchmark invoice amount (USD) for leaf codes in this group that have benchmark data */
  globalInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Aggregated global benchmark supplier count for leaf codes in this group that have benchmark data */
  globalSupplierCount?: Maybe<Scalars['Int']['output']>;
  /** Aggregated buyer spend as a percentage of total buyer spend */
  spendPercent: Scalars['Float']['output'];
};

export type WcmNaicsBenchmarkCoverageLeaf = {
  __typename?: 'WcmNaicsBenchmarkCoverageLeaf';
  /** Buyer spend for this NAICS code */
  buyerSpend: Scalars['Float']['output'];
  /** Buyer supplier entity count for this NAICS code */
  buyerSupplierCount: Scalars['Int']['output'];
  /** 6-digit NAICS code */
  code: Scalars['Int']['output'];
  /** NAICS code description */
  description: Scalars['String']['output'];
  /** Global benchmark invoice amount (USD) when benchmark data exists for this NAICS code */
  globalInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Global benchmark supplier count when benchmark data exists for this NAICS code */
  globalSupplierCount?: Maybe<Scalars['Int']['output']>;
  /** Whether global benchmark data exists for this NAICS code */
  hasBenchmark: Scalars['Boolean']['output'];
  /** Buyer spend as a percentage of total buyer spend */
  spendPercent: Scalars['Float']['output'];
};

export type WcmNaicsBenchmarkCoverageSector = {
  __typename?: 'WcmNaicsBenchmarkCoverageSector';
  /** Aggregated buyer spend in this sector */
  buyerSpend: Scalars['Float']['output'];
  /** Aggregated buyer supplier count in this sector */
  buyerSupplierCount: Scalars['Int']['output'];
  /** 2-digit NAICS sector code */
  code: Scalars['Int']['output'];
  /** NAICS sector description */
  description: Scalars['String']['output'];
  /** Aggregated global benchmark invoice amount (USD) for leaf codes in this sector that have benchmark data */
  globalInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Aggregated global benchmark supplier count for leaf codes in this sector that have benchmark data */
  globalSupplierCount?: Maybe<Scalars['Int']['output']>;
  groups: Array<WcmNaicsBenchmarkCoverageGroup>;
  /** Aggregated buyer spend as a percentage of total buyer spend */
  spendPercent: Scalars['Float']['output'];
};

export type WcmNaicsExclusionDefaultsSummary = {
  __typename?: 'WcmNaicsExclusionDefaultsSummary';
  /** Whether the buyer set differs from the C2FO default set */
  differsFromDefaults: Scalars['Boolean']['output'];
  /** Number of codes in the C2FO managed default-exclusion set */
  totalDefaultCodes: Scalars['Int']['output'];
};

export type WcmNaicsExclusionGroup = {
  __typename?: 'WcmNaicsExclusionGroup';
  /** 4-digit NAICS group code */
  code: Scalars['Int']['output'];
  codes: Array<WcmNaicsExclusionLeaf>;
  /** NAICS group description */
  description: Scalars['String']['output'];
  /** Number of excluded leaf codes in this group */
  excludedCount: Scalars['Int']['output'];
  /** Aggregated spend from currently NAICS-excluded suppliers only in this group */
  excludedSpend: Scalars['Float']['output'];
  /** Total number of 6-digit leaf codes in this group */
  totalCount: Scalars['Int']['output'];
  /** Aggregated total spend from in-scope and NAICS-excluded suppliers in this group */
  totalSpend: Scalars['Float']['output'];
};

export type WcmNaicsExclusionLeaf = {
  __typename?: 'WcmNaicsExclusionLeaf';
  /** 6-digit NAICS code */
  code: Scalars['Int']['output'];
  /** NAICS code description */
  description: Scalars['String']['output'];
  /** Whether this code is currently excluded by the buyer */
  excluded: Scalars['Boolean']['output'];
  /** Spend from currently NAICS-excluded suppliers only for this code */
  excludedSpend: Scalars['Float']['output'];
  /** Whether this code belongs to the C2FO managed default-exclusion set */
  isC2foDefault: Scalars['Boolean']['output'];
  /** Source of the exclusion (DEFAULT/CUSTOM); null when the code is not excluded */
  source?: Maybe<NaicsExclusionSource>;
  /** Total spend from in-scope and NAICS-excluded suppliers for this code */
  totalSpend: Scalars['Float']['output'];
};

export type WcmNaicsExclusionSector = {
  __typename?: 'WcmNaicsExclusionSector';
  /** 2-digit NAICS sector code */
  code: Scalars['Int']['output'];
  /** NAICS sector description */
  description: Scalars['String']['output'];
  /** Number of excluded leaf codes in this sector */
  excludedCount: Scalars['Int']['output'];
  /** Aggregated spend from currently NAICS-excluded suppliers only in this sector */
  excludedSpend: Scalars['Float']['output'];
  groups: Array<WcmNaicsExclusionGroup>;
  /** Total number of 6-digit leaf codes in this sector */
  totalCount: Scalars['Int']['output'];
  /** Aggregated total spend from in-scope and NAICS-excluded suppliers in this sector */
  totalSpend: Scalars['Float']['output'];
};

export type WcmNaicsExclusions = {
  __typename?: 'WcmNaicsExclusions';
  defaults: WcmNaicsExclusionDefaultsSummary;
  /** Total number of codes currently excluded by the buyer */
  excludedCount: Scalars['Int']['output'];
  /** Timestamp of the most recent change to the buyer set */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Preview of what will change when the buyer restores system defaults. */
  restorePreview: WcmNaicsRestorePreview;
  sectors: Array<WcmNaicsExclusionSector>;
  /** Total number of 6-digit NAICS leaf codes in the taxonomy */
  totalNaicsCount: Scalars['Int']['output'];
};

export type WcmNaicsRestorePreview = {
  __typename?: 'WcmNaicsRestorePreview';
  /** Default NAICS codes present in the buyer spend that are not currently excluded and will be added when restoring. */
  willBeAdded: Array<Scalars['Int']['output']>;
  /** Custom NAICS codes (not in the default set) that will be dropped when restoring system defaults. */
  willBeRemoved: Array<Scalars['Int']['output']>;
};

export type WcmNegotiationItem = {
  __typename?: 'WcmNegotiationItem';
  /** Negotiated terms value */
  negotiatedTerms?: Maybe<Scalars['Float']['output']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: Maybe<Scalars['String']['output']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: Maybe<Scalars['Float']['output']>;
  /** Free-text remarks recorded against the negotiation */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: Maybe<Scalars['String']['output']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: Maybe<Scalars['String']['output']>;
  /** Vendor variant ID */
  vendorVariantId: Scalars['String']['output'];
};

export type WcmNegotiationOutput = {
  __typename?: 'WcmNegotiationOutput';
  /** Available statuses for the negotiation */
  availableStatuses?: Maybe<Array<WcmNegotiationStatusOption>>;
  /** Negotiated terms value */
  negotiatedTerms?: Maybe<Scalars['Float']['output']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: Maybe<Scalars['String']['output']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: Maybe<Scalars['Float']['output']>;
  /** Free-text remarks recorded against the negotiation */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Latest recorded event per status value ID, used to pre-fill the modal for a single entity */
  statusEvents?: Maybe<Array<WcmNegotiationStatusEventItem>>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: Maybe<Scalars['String']['output']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: Maybe<Scalars['String']['output']>;
};

export type WcmNegotiationStatusEventItem = {
  __typename?: 'WcmNegotiationStatusEventItem';
  /** ISO date (YYYY-MM-DD) of the most recent event for this status */
  eventDate?: Maybe<Scalars['String']['output']>;
  /** Status value ID this event was recorded against */
  negotiationStatusValueId: Scalars['Int']['output'];
  /** Remarks recorded with the event */
  remarks?: Maybe<Scalars['String']['output']>;
};

export type WcmNegotiationStatusOption = {
  __typename?: 'WcmNegotiationStatusOption';
  /** Canonical phase this status is mapped to. Drives chip/card color across supplier list, profile, and monitoring screens. */
  canonicalPhase?: Maybe<Wcm_Canonical_Phase>;
  /** Status ID from custom attribute value mappings */
  id: Scalars['Float']['output'];
  /** Status value */
  value: Scalars['String']['output'];
};

export type WcmNegotiationsOutput = {
  __typename?: 'WcmNegotiationsOutput';
  /** Available statuses for negotiations */
  availableStatuses?: Maybe<Array<WcmNegotiationStatusOption>>;
  /** Array of negotiation data */
  negotiations: Array<WcmNegotiationItem>;
};

export type WcmOperationMessageOutput = {
  __typename?: 'WcmOperationMessageOutput';
  /** Operation result message */
  message: Scalars['String']['output'];
};

export type WcmPaymentTermConfigTierInput = {
  /** Discount percentage */
  discountPercentage: Scalars['Float']['input'];
  /** Payment due in days for this tier. Use 0 for immediate payment (only valid for single-tier terms). */
  termDays: Scalars['Int']['input'];
  /** Tier order (1-3) */
  tierOrder: Scalars['Int']['input'];
};

export type WcmPaymentTermConfigTierType = {
  __typename?: 'WcmPaymentTermConfigTierType';
  /** Discount percentage */
  discountPercentage: Scalars['Float']['output'];
  /** Tier ID */
  id: Scalars['Int']['output'];
  /** Payment due in days for this tier */
  termDays: Scalars['Int']['output'];
  /** Tier order */
  tierOrder: Scalars['Int']['output'];
};

export type WcmPaymentTermConfigType = {
  __typename?: 'WcmPaymentTermConfigType';
  /** Created timestamp */
  created: Scalars['String']['output'];
  /** Effective payment term in days */
  effectiveTermDays: Scalars['Int']['output'];
  /** Indicates whether the payment term includes discounts */
  hasDiscount: Scalars['Boolean']['output'];
  /** Human-readable payment term */
  humanNotation: Scalars['String']['output'];
  /** Payment term ID */
  id: Scalars['Int']['output'];
  /** Internal notes */
  internalNotes?: Maybe<Scalars['String']['output']>;
  /** Active status */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the payment term is EOM-based */
  isEom: Scalars['Boolean']['output'];
  /** Net due days */
  netDueDays: Scalars['Int']['output'];
  /** Payment term code */
  paymentTermCode: Scalars['String']['output'];
  /** Payment term description */
  paymentTermDescription: Scalars['String']['output'];
  /** SAP payment term notation */
  sapNotation: Scalars['String']['output'];
  /** Number of tiers */
  tierCount: Scalars['Int']['output'];
  /** Payment term tiers */
  tiers: Array<WcmPaymentTermConfigTierType>;
  /** Last updated timestamp */
  updated: Scalars['String']['output'];
  /** Last updated by */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Buyer UUID */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmPaymentTermsBenchmarkFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dimension on which data is grouped by (enum value or custom_attribute_N) */
  groupBy: Scalars['String']['input'];
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmPaymentTermsBenchmarkOutput = {
  __typename?: 'WcmPaymentTermsBenchmarkOutput';
  country75: Scalars['Float']['output'];
  country85: Scalars['Float']['output'];
  country90: Scalars['Float']['output'];
  country95: Scalars['Float']['output'];
  country99: Scalars['Float']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  countryMax: Scalars['Float']['output'];
  countryMedian: Scalars['Float']['output'];
  currentTerms: Scalars['Float']['output'];
  global75: Scalars['Float']['output'];
  global85: Scalars['Float']['output'];
  global90: Scalars['Float']['output'];
  global95: Scalars['Float']['output'];
  global99: Scalars['Float']['output'];
  globalMax: Scalars['Float']['output'];
  globalMedian: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  totalEstimatedWco: Scalars['Float']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type WcmPaymentTermsConfigResponse = {
  __typename?: 'WcmPaymentTermsConfigResponse';
  /** List of payment terms */
  items: Array<WcmPaymentTermConfigType>;
  /** Total number of payment terms */
  total: Scalars['Int']['output'];
};

export type WcmPaymentTermsInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmPaymentTermsLandscapeOutput = {
  __typename?: 'WcmPaymentTermsLandscapeOutput';
  /** Lower bound of 10-day payment term bucket (e.g. 30 = 30–40 days) */
  paymentTermBucket: Scalars['Int']['output'];
  /** Segment (core or tail or strategic) */
  segment: Scalars['String']['output'];
  /** Exclusive upper bound of the spend bucket, or null for the open-ended last bucket */
  spendBucketMax?: Maybe<Scalars['Float']['output']>;
  /** Inclusive lower bound of the spend bucket */
  spendBucketMin: Scalars['Float']['output'];
  /** Number of suppliers in this group */
  supplierCount: Scalars['Int']['output'];
};

export type WcmPaymentTermsOutput = {
  __typename?: 'WcmPaymentTermsOutput';
  /** benchmark payment terms */
  benchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** existing payment terms */
  existingTerms?: Maybe<Scalars['Float']['output']>;
  /** Weighted average benchmark payment terms */
  weightedAvgBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
};

export type WcmPlanOutput = {
  __typename?: 'WcmPlanOutput';
  /** Creation timestamp (ISO 8601) */
  created: Scalars['String']['output'];
  /** UUID of the user who created the plan */
  createdBy: Scalars['String']['output'];
  /** Plan end date (ISO 8601) */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Plan ID */
  id: Scalars['Int']['output'];
  /** Whether the plan is synced with external system */
  isSynced: Scalars['Boolean']['output'];
  /** Plan name */
  name: Scalars['String']['output'];
  /** Owner of the plan */
  owner?: Maybe<Scalars['String']['output']>;
  /** Plan start date (ISO 8601) */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Target working capital amount */
  targetWorkingCapital: Scalars['Float']['output'];
  /** Transaction UUID associated with the plan */
  transactionUuid: Scalars['String']['output'];
  /** Last update timestamp (ISO 8601) */
  updated: Scalars['String']['output'];
};

export type WcmPlanWaveOutput = {
  __typename?: 'WcmPlanWaveOutput';
  /** Creation timestamp (ISO 8601) */
  created: Scalars['String']['output'];
  /** UUID of the user who created the wave */
  createdBy: Scalars['String']['output'];
  /** Wave end date (ISO 8601) */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Wave ID */
  id: Scalars['Int']['output'];
  /** Wave name */
  name: Scalars['String']['output'];
  /** Owner of the wave */
  owner?: Maybe<Scalars['String']['output']>;
  /** Wave start date (ISO 8601) */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Target working capital amount */
  targetWorkingCapital: Scalars['Float']['output'];
  /** Last update timestamp (ISO 8601) */
  updated: Scalars['String']['output'];
  /** Parent plan ID */
  wcmPlanId: Scalars['Int']['output'];
};

export type WcmPublicUser = {
  __typename?: 'WcmPublicUser';
  /** User Email Address */
  emailAddress: Scalars['String']['output'];
  /** Access expiry in UTC format (e.g., "2025-01-01T00:00:00.000Z") */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** Is C2FO User */
  isC2FO: Scalars['Boolean']['output'];
  /** Is User Onboarded in WCM */
  isOnboarded: Scalars['Boolean']['output'];
  /** User Name */
  name: Scalars['String']['output'];
  /** User UUID */
  uuid: Scalars['String']['output'];
};

export type WcmRole = {
  __typename?: 'WcmRole';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internallyManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<WcmRolePermission>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  usersCount: Scalars['Float']['output'];
};

export type WcmRoleBasicInfo = {
  __typename?: 'WcmRoleBasicInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WcmRolePermission = {
  __typename?: 'WcmRolePermission';
  id: Scalars['ID']['output'];
  permission: Scalars['String']['output'];
};

export type WcmSearchCompanyFinancialsInput = {
  /** Search term for company name or ticker symbol */
  searchTerm: Scalars['String']['input'];
};

export type WcmSearchCompanyFinancialsOutput = {
  __typename?: 'WcmSearchCompanyFinancialsOutput';
  /** Annual revenue in USD */
  annualRevenueUsd?: Maybe<Scalars['Float']['output']>;
  /** Average Days Payable Outstanding */
  avgDpo?: Maybe<Scalars['Float']['output']>;
  /** Average Days Sales Outstanding */
  avgDso?: Maybe<Scalars['Float']['output']>;
  /** Company ID */
  companyId: Scalars['String']['output'];
  /** Company name */
  companyName: Scalars['String']['output'];
  /** Country name */
  country: Scalars['String']['output'];
  /** ISO 2-letter country code */
  countryIso2: Scalars['String']['output'];
  /** Credit rating */
  creditRating?: Maybe<Scalars['String']['output']>;
  /** Stock ticker symbol */
  tickerSymbol?: Maybe<Scalars['String']['output']>;
};

export type WcmSearchNaicsInput = {
  query: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSearchNaicsOutput = {
  __typename?: 'WcmSearchNaicsOutput';
  /** Indicates if the NAICS code is excluded for this buyer */
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
  /** Naics code */
  naicsCode: Scalars['Float']['output'];
  /** Naics description */
  naicsDescription: Scalars['String']['output'];
};

export type WcmSegmentConversionRateConfigOutput = {
  __typename?: 'WcmSegmentConversionRateConfigOutput';
  coreSegmentConversionRate: Scalars['Float']['output'];
  strategicSegmentConversionRate: Scalars['Float']['output'];
  tailSegmentConversionRate: Scalars['Float']['output'];
};

export type WcmSnapshotBucket = {
  __typename?: 'WcmSnapshotBucket';
  /** Bucket start date (ISO format) */
  bucketStart: Scalars['String']['output'];
  /** Status distribution at this point in time */
  statuses: Array<WcmSnapshotStatusEntry>;
};

export type WcmSnapshotStatusEntry = {
  __typename?: 'WcmSnapshotStatusEntry';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Sub-ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Estimated WCO adjusted by segment conversion rate */
  estimatedWco: Scalars['Float']['output'];
  /** Status label (e.g. "Terms Agreed") */
  statusLabel: Scalars['String']['output'];
  /** Number of supplier entities in this status at this point in time */
  supplierEntityCount: Scalars['Int']['output'];
  /** Working capital opportunity for supplier entities in this status */
  wco: Scalars['Float']['output'];
};

export type WcmSpendAnalysisInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSpendAnalysisStatsOutput = {
  __typename?: 'WcmSpendAnalysisStatsOutput';
  /** count of distinct payment terms */
  paymentTermsCount: Scalars['Int']['output'];
  /** total number of supplier countries */
  supplierCountriesCount: Scalars['Int']['output'];
  /** total number of supplier entities */
  supplierEntitiesCount: Scalars['Int']['output'];
  /** total number of supplier groups */
  supplierGroupsCount: Scalars['Int']['output'];
  /** total spend amount */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSpendDistributionOutput = {
  __typename?: 'WcmSpendDistributionOutput';
  /** percentage of total spend in this range */
  spendPercentage: Scalars['Float']['output'];
  /** spend range category */
  spendRange: Scalars['String']['output'];
  /** count of supplier groups in this spend range */
  supplierGroupCount: Scalars['Int']['output'];
  /** percentage of supplier groups in this spend range */
  supplierGroupPercentage: Scalars['Float']['output'];
  /** total spend amount in this range */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSpendDynamicFiltersInput = {
  /** Display Currency */
  displayCurrency: Scalars['String']['input'];
  selectedFilters?: InputMaybe<WcmSpendSelectedFilters>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSpendDynamicFiltersOutput = {
  __typename?: 'WcmSpendDynamicFiltersOutput';
  benchmarkingStrategies?: Maybe<Array<Scalars['String']['output']>>;
  buyingEntity?: Maybe<Array<Scalars['String']['output']>>;
  buyingTeam?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Array<Scalars['String']['output']>>;
  contractualTermsDescription?: Maybe<Array<Scalars['String']['output']>>;
  country?: Maybe<Array<Scalars['String']['output']>>;
  /** Custom attributes - key is attribute internal name, value contains displayName and available values */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  excludeReason?: Maybe<Array<Scalars['String']['output']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: Maybe<Array<Scalars['String']['output']>>;
  isDiscountedTerms?: Maybe<Array<Scalars['String']['output']>>;
  isDiverseSupplier?: Maybe<Array<Scalars['String']['output']>>;
  naicsDescription?: Maybe<Array<Scalars['String']['output']>>;
  naicsDescriptionL2?: Maybe<Array<Scalars['String']['output']>>;
  naicsDescriptionL3?: Maybe<Array<Scalars['String']['output']>>;
  /** Negotiation Status */
  negotiationStatus?: Maybe<Array<Scalars['String']['output']>>;
  /** Plan wave filter options with label and ID */
  planWaves?: Maybe<Array<WcmFilterOption>>;
  /** Plan filter options with label and ID */
  plans?: Maybe<Array<WcmFilterOption>>;
  region?: Maybe<Array<Scalars['String']['output']>>;
  supplierLead?: Maybe<Array<Scalars['String']['output']>>;
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  vendorCategory?: Maybe<Array<Scalars['String']['output']>>;
  vendorCategoryL2?: Maybe<Array<Scalars['String']['output']>>;
  vendorCategoryL3?: Maybe<Array<Scalars['String']['output']>>;
};

export type WcmSpendFileTemplateUrl = {
  __typename?: 'WcmSpendFileTemplateUrl';
  /** Signed URL for the WCM spend file template download */
  signedUrl: Scalars['String']['output'];
};

export type WcmSpendGeoOverviewOutput = {
  __typename?: 'WcmSpendGeoOverviewOutput';
  /** Country ISO Code(2 characters) */
  alpha2Code: Scalars['String']['output'];
  /** Country ISO Code(3 characters) */
  alpha3Code: Scalars['String']['output'];
  /** Country Name */
  countryName: Scalars['String']['output'];
  /** Total Spend Amount */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSpendSelectedFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeam?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Segment Category */
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  excludeReason?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS Description (Level 6) */
  naicsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS Description (Level 2) */
  naicsDescriptionL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS Description (Level 3) */
  naicsDescriptionL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status to filter by */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Region */
  region?: InputMaybe<Array<Wcm_Buyer_Region>>;
  supplierLead?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary category */
  vendorCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary category */
  vendorCategoryL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary category */
  vendorCategoryL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type WcmStatsInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of benchmarking strategies for which additional stats will be calculated. If present, stats will include results for these strategies in addition to the default ones. */
  benchmarkingStrategiesForStats?: InputMaybe<Array<Benchmarking_Strategies_With_Harmonization>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Supplier name search filter */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmStatsOutput = {
  __typename?: 'WcmStatsOutput';
  /** estimated working capital opportunity */
  estimatedWco?: Maybe<Scalars['Float']['output']>;
  /** Realised working capital opportunity — total WCO from suppliers whose negotiation has reached COMPLETED or ERP_UPDATED, evaluated against negotiated terms. */
  realisedWco?: Maybe<Scalars['Float']['output']>;
  /** spend amount */
  spend?: Maybe<Scalars['Float']['output']>;
  /** total number of supplier entities */
  supplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** total number of supplier groups */
  supplierGroupCount?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to waHarmonization */
  totalHarmonizationSupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for waHarmonization */
  totalHarmonizationWco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountry75 */
  totalIndustryCountry75SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry75 */
  totalIndustryCountry75Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountry85 */
  totalIndustryCountry85SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry85 */
  totalIndustryCountry85Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountry90 */
  totalIndustryCountry90SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry90 */
  totalIndustryCountry90Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountry95 */
  totalIndustryCountry95SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry95 */
  totalIndustryCountry95Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountry99 */
  totalIndustryCountry99SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry99 */
  totalIndustryCountry99Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountryMax */
  totalIndustryCountryMaxSupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountryMax */
  totalIndustryCountryMaxWco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryCountryMedian */
  totalIndustryCountryMedianSupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountryMedian */
  totalIndustryCountryMedianWco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobal75 */
  totalIndustryGlobal75SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal75 */
  totalIndustryGlobal75Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobal85 */
  totalIndustryGlobal85SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal85 */
  totalIndustryGlobal85Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobal90 */
  totalIndustryGlobal90SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal90 */
  totalIndustryGlobal90Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobal95 */
  totalIndustryGlobal95SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal95 */
  totalIndustryGlobal95Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobal99 */
  totalIndustryGlobal99SupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal99 */
  totalIndustryGlobal99Wco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobalMax */
  totalIndustryGlobalMaxSupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobalMax */
  totalIndustryGlobalMaxWco?: Maybe<Scalars['Float']['output']>;
  /** Supplier entities assigned to industryGlobalMedian */
  totalIndustryGlobalMedianSupplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobalMedian */
  totalIndustryGlobalMedianWco?: Maybe<Scalars['Float']['output']>;
  /** total working capital amount */
  twc?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for waHarmonization */
  waHarmonizationBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry75 */
  waIndustryCountry75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry85 */
  waIndustryCountry85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry90 */
  waIndustryCountry90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry95 */
  waIndustryCountry95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry99 */
  waIndustryCountry99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountryMax */
  waIndustryCountryMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountryMedian */
  waIndustryCountryMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal75 */
  waIndustryGlobal75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal85 */
  waIndustryGlobal85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal90 */
  waIndustryGlobal90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal95 */
  waIndustryGlobal95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal99 */
  waIndustryGlobal99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobalMax */
  waIndustryGlobalMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobalMedian */
  waIndustryGlobalMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
};

export type WcmStatusBreakdownEntry = {
  __typename?: 'WcmStatusBreakdownEntry';
  canonicalPhase: Scalars['String']['output'];
  customOrder: Scalars['Float']['output'];
  estimatedWco: Scalars['Float']['output'];
  percentageWco: Scalars['Float']['output'];
  statusLabel: Scalars['String']['output'];
  supplierEntities: Scalars['Float']['output'];
  supplierGroups: Scalars['Float']['output'];
  wco: Scalars['Float']['output'];
};

export type WcmStatusPhaseMappingItem = {
  __typename?: 'WcmStatusPhaseMappingItem';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Custom status value ID */
  customStatusValueId: Scalars['Int']['output'];
  /** Phase mapping ID */
  id: Scalars['Int']['output'];
};

export type WcmStatusPhaseMappings = {
  __typename?: 'WcmStatusPhaseMappings';
  /** List of successfully upserted mappings */
  mappings: Array<WcmStatusPhaseMappingItem>;
};

export type WcmSupplierGroupEntitiesData = {
  __typename?: 'WcmSupplierGroupEntitiesData';
  annualSpend: Scalars['Float']['output'];
  benchmarkTerms: Scalars['Float']['output'];
  contractualTermsDescription?: Maybe<Scalars['String']['output']>;
  currentTerms: Scalars['Float']['output'];
  /** Custom attributes with display names and values. Keys are internal names (e.g., custom_attribute_1) */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  defaultBenchmarkStrategy: Scalars['String']['output'];
  excludeReason?: Maybe<Scalars['String']['output']>;
  hasAContract?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  naicsCode?: Maybe<Scalars['Float']['output']>;
  naicsDescription?: Maybe<Scalars['String']['output']>;
  paidOnTime?: Maybe<Scalars['Boolean']['output']>;
  preferredBenchmarkStrategy: Scalars['String']['output'];
  region: Scalars['String']['output'];
  segmentConversionRate: Scalars['Float']['output'];
  supplierCountryRegulationTerms: Scalars['Float']['output'];
  supplierName: Scalars['String']['output'];
  supplierSegment?: Maybe<Scalars['String']['output']>;
  termsRegulationsLimit?: Maybe<Scalars['String']['output']>;
  topCurrency?: Maybe<Scalars['String']['output']>;
  vendorCategory?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
  vendorVariantId: Scalars['String']['output'];
  withMaxSpend?: Maybe<Scalars['Boolean']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmSupplierGroupEntitiesDataInput = {
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Exclude Reasons */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['input'];
  onlyIncludeEntitiesWithPositiveTermsDifference?: Scalars['Boolean']['input'];
  /** Supplier Categories */
  supplierCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Industries */
  supplierIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSupplierGroupEntitiesDataOutput = {
  __typename?: 'WcmSupplierGroupEntitiesDataOutput';
  aggregatedValues: WcmSuppliersGroupAggregatedValue;
  /** Aggregated values grouped by country. Each entry contains a country code and its aggregated benchmarks. */
  countryWiseAggregatedValues: Array<WcmCountryAggregatedValue>;
  /** supplier entities */
  entities: Array<WcmSupplierGroupEntitiesData>;
  entitiesCountWithPositiveTermDifference: Scalars['Int']['output'];
  /** filtered out supplier entities */
  filteredOutEntities?: Maybe<Array<WcmSupplierGroupEntitiesData>>;
  vendorMasterId: Scalars['String']['output'];
};

export type WcmSupplierGroupNote = {
  __typename?: 'WcmSupplierGroupNote';
  /** Note body */
  content: Scalars['String']['output'];
  /** Timestamp when the note was created (ISO string) */
  createdAt: Scalars['String']['output'];
  /** UUID of the user that created the note */
  createdBy: Scalars['String']['output'];
  /** Details of the user that created the note */
  createdByDetails?: Maybe<BuyerAppUserDetails>;
  /** Timeline event type for the entry */
  eventType: Scalars['String']['output'];
  /** Primary key of the note */
  id: Scalars['Int']['output'];
  /** True if this is the most recent note for the supplier group and may therefore be edited by the user. */
  isEditable: Scalars['Boolean']['output'];
  /** Structured metadata for system events (e.g. changes, suppliersCount) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Origin of the timeline entry (USER or SYSTEM) */
  source: Scalars['String']['output'];
  /** Timestamp when the note was last updated (ISO string) */
  updatedAt: Scalars['String']['output'];
  /** UUID of the user that last updated the note */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Details of the user that last updated the note */
  updatedByDetails?: Maybe<BuyerAppUserDetails>;
  /** Vendor master ID identifying the supplier group */
  vendorMasterId: Scalars['String']['output'];
  /** WCM Buyer UUID owning the note */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmSupplierGroupNotesOutput = {
  __typename?: 'WcmSupplierGroupNotesOutput';
  /** Notes for the supplier group. */
  items: Array<WcmSupplierGroupNote>;
  /** Total number of notes for the supplier group */
  total: Scalars['Int']['output'];
};

export type WcmSupplierGroupNotesPaging = {
  /** Page number (zero-indexed) */
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  /** Page size (max 100) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type WcmSupplierHealthMetricsOutput = {
  __typename?: 'WcmSupplierHealthMetricsOutput';
  /** Entity terms health data */
  entity: WcmSupplierTermsHealthMetrics;
  /** Supplier group terms health data */
  supplierGroup: WcmSupplierTermsHealthMetrics;
};

export type WcmSupplierProfileBenchmarkingStrategies = {
  __typename?: 'WcmSupplierProfileBenchmarkingStrategies';
  custom: Scalars['Float']['output'];
  industryCountry75: Scalars['Float']['output'];
  industryCountry85: Scalars['Float']['output'];
  industryCountry90: Scalars['Float']['output'];
  industryCountry95: Scalars['Float']['output'];
  industryCountry99: Scalars['Float']['output'];
  industryCountryMax: Scalars['Float']['output'];
  industryCountryMedian: Scalars['Float']['output'];
  industryGlobal75: Scalars['Float']['output'];
  industryGlobal85: Scalars['Float']['output'];
  industryGlobal90: Scalars['Float']['output'];
  industryGlobal95: Scalars['Float']['output'];
  industryGlobal99: Scalars['Float']['output'];
  industryGlobalMax: Scalars['Float']['output'];
  industryGlobalMedian: Scalars['Float']['output'];
  waHarmonization: Scalars['Float']['output'];
};

export type WcmSupplierProfileCommonFilters = {
  /** Exclude Reasons */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyIncludeEntitiesWithPositiveTermsDifference?: Scalars['Boolean']['input'];
  /** Supplier Categories */
  supplierCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Industries */
  supplierIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
};

export type WcmSupplierProfileDataInput = {
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['input'];
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSupplierProfileDataOutput = {
  __typename?: 'WcmSupplierProfileDataOutput';
  annualRevenue: Scalars['Float']['output'];
  annualRevenueGroup: Scalars['Float']['output'];
  annualSpend: Scalars['Float']['output'];
  bargainingPower?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  /** Company financials data */
  companyFinancials?: Maybe<WcmSearchCompanyFinancialsOutput>;
  countryInvoiceSampleSize: Scalars['Float']['output'];
  creditRating: Scalars['String']['output'];
  currentTerms: Scalars['Float']['output'];
  custom: Scalars['Float']['output'];
  /** Custom attributes with display names and values. Keys are internal names (e.g., custom_attribute_1) */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  defaultBenchmarkStrategy: Scalars['String']['output'];
  diverseSupplier?: Maybe<Scalars['String']['output']>;
  dpoGroup: Scalars['Float']['output'];
  dsoGroup: Scalars['Float']['output'];
  estimatedBenchmarkTerms: WcmBenchmarkingStrategies;
  estimatedWorkingCapitalOpportunity: WcmBenchmarkingStrategies;
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Executive summary describing the supplier risk posture */
  executiveSummary?: Maybe<Scalars['String']['output']>;
  /** Buyer file currency for the transaction associated with this supplier */
  fileCurrency?: Maybe<Scalars['String']['output']>;
  globalInvoiceSampleSize: Scalars['Float']['output'];
  hasCustomBenchmark: Scalars['Boolean']['output'];
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  industryCountry75: Scalars['Float']['output'];
  industryCountry85: Scalars['Float']['output'];
  industryCountry90: Scalars['Float']['output'];
  industryCountry95: Scalars['Float']['output'];
  industryCountry99: Scalars['Float']['output'];
  industryCountryMax: Scalars['Float']['output'];
  industryCountryMedian: Scalars['Float']['output'];
  industryGlobal75: Scalars['Float']['output'];
  industryGlobal85: Scalars['Float']['output'];
  industryGlobal90: Scalars['Float']['output'];
  industryGlobal95: Scalars['Float']['output'];
  industryGlobal99: Scalars['Float']['output'];
  industryGlobalMax: Scalars['Float']['output'];
  industryGlobalMedian: Scalars['Float']['output'];
  /** True when the conversion rate is a per-supplier override, not the segment-level default. */
  isConversionRateOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** True when the displayed segment is a user-chosen override, not the system-derived value. */
  isSegmentOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** Market concentration label */
  marketConcentrationLabel?: Maybe<Scalars['String']['output']>;
  /** Market concentration score on a 0-100 scale */
  marketConcentrationScore?: Maybe<Scalars['Float']['output']>;
  materiality: Scalars['String']['output'];
  multiBuyerSupplier?: Maybe<Scalars['Boolean']['output']>;
  naicsCode?: Maybe<Scalars['Float']['output']>;
  naicsDescription: Scalars['String']['output'];
  /** Detailed NAICS description for Level 6 industry tooltip */
  naicsDetailedDescription?: Maybe<Scalars['String']['output']>;
  /** NAICS weighted-average global payment terms */
  naicsWaAvgTermsGlobal?: Maybe<Scalars['Float']['output']>;
  preferredBenchmarkStrategy: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /** Composite supplier risk score on a 0-100 scale (0 = Critical, 100 = Safe) */
  riskScore?: Maybe<Scalars['Float']['output']>;
  roundedBenchmarkValues: WcmSupplierProfileBenchmarkingStrategies;
  segmentConversionRate: Scalars['Float']['output'];
  /** Substitutability label, e.g. Low / Medium / High */
  substitutabilityLabel?: Maybe<Scalars['String']['output']>;
  /** Substitutability score on a 0-100 scale */
  substitutabilityScore?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  supplierCountryRegulationTerms: Scalars['Float']['output'];
  supplierName: Scalars['String']['output'];
  supplierSegment?: Maybe<Scalars['String']['output']>;
  termsRegulationsLimit?: Maybe<Scalars['String']['output']>;
  ticker?: Maybe<Scalars['String']['output']>;
  tickerGroup: Scalars['String']['output'];
  topCurrency?: Maybe<Scalars['String']['output']>;
  vendorCategory?: Maybe<Scalars['String']['output']>;
  vendorDpo: Scalars['Float']['output'];
  vendorDso: Scalars['Float']['output'];
  vendorId: Scalars['String']['output'];
  vendorMasterId: Scalars['String']['output'];
  vendorVariantId: Scalars['String']['output'];
  waCurrentTerms: Scalars['Float']['output'];
  waHarmonization?: Maybe<Scalars['Float']['output']>;
  workingCapitalOpportunity: WcmBenchmarkingStrategies;
};

export type WcmSupplierSpendOverviewOutput = {
  __typename?: 'WcmSupplierSpendOverviewOutput';
  /** Top Supplier Of Supplier Group */
  topSupplierName: Scalars['String']['output'];
  /** Total spend amount for the segment */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSupplierTermsHealthMetrics = {
  __typename?: 'WcmSupplierTermsHealthMetrics';
  /** Different terms of same supplier */
  differentTermsOfSameSupplier?: Maybe<Scalars['Boolean']['output']>;
  /** Discount terms mismatch */
  discountTermsMismatch?: Maybe<Scalars['Boolean']['output']>;
  /** Has a contract */
  hasAContract?: Maybe<Scalars['Boolean']['output']>;
  /** Has discount terms */
  hasDiscountTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Paid on time */
  paidOnTime?: Maybe<Scalars['Boolean']['output']>;
  /** Terms shorter than industry standard */
  termsShorterThanIndustryStandard?: Maybe<Scalars['Boolean']['output']>;
  /** Terms shorter than other suppliers in same industry */
  termsShorterThanOtherSuppliersInSameIndustry?: Maybe<Scalars['Boolean']['output']>;
};

export type WcmSuppliersGroupAggregatedValue = {
  __typename?: 'WcmSuppliersGroupAggregatedValue';
  defaultBenchmarkStrategy: Scalars['String']['output'];
  hasCustomBenchmark: Scalars['Boolean']['output'];
  preferredBenchmarkStrategy: Scalars['String']['output'];
  supplierCountryRegulationTerms?: Maybe<Scalars['Float']['output']>;
  termsRegulationsLimit?: Maybe<Scalars['String']['output']>;
  totalEstimatedOpportunity: WcmBenchmarkingStrategies;
  totalRevenue: Scalars['Float']['output'];
  totalSpend: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: WcmBenchmarkingStrategies;
  weightedAverageBenchmarkTerms: WcmBenchmarkingStrategies;
  weightedAverageCurrentTerm: Scalars['Float']['output'];
  weightedAverageEstimatedBenchmarkTerms: WcmBenchmarkingStrategies;
  weightedAverageMateriality: Scalars['Float']['output'];
  weightedAverageRawTerms: WcmBenchmarkingStrategies;
};

export type WcmSuppliersOperationResponse = {
  __typename?: 'WcmSuppliersOperationResponse';
  /** Supplier operation result message */
  message: Scalars['String']['output'];
};

export type WcmTrackingByAggregatorGroup = {
  __typename?: 'WcmTrackingByAggregatorGroup';
  /** Aggregator code (used for linking/filtering) */
  aggregatorCode: Scalars['String']['output'];
  /** Aggregator display label */
  aggregatorLabel: Scalars['String']['output'];
  /** Status breakdown for this aggregator group */
  statuses: Array<WcmTrackingStatusEntry>;
};

export type WcmTrackingStatusEntry = {
  __typename?: 'WcmTrackingStatusEntry';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Sub-ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Total spend for supplier entities in this status */
  spend: Scalars['Float']['output'];
  /** Status label (e.g. "Terms Agreed") */
  statusLabel: Scalars['String']['output'];
  /** Number of supplier entities in this status */
  supplierEntityCount: Scalars['Int']['output'];
  /** Working capital opportunity for supplier entities in this status */
  wco: Scalars['Float']['output'];
};

export type WcmUpdateNaicsExclusionsInput = {
  /** Complete set of 6-digit NAICS codes to exclude for the buyer. Replaces any existing set. */
  excludedNaicsCodes: Array<Scalars['Int']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmUpdatePlanInput = {
  /** Plan end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Plan name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner of the plan */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Plan start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmUpsertDisplayCurrencyRateInput = {
  /** Fixed conversion rate: 1 source = rate target */
  rate: Scalars['Float']['input'];
  /** Target display currency (ISO 4217) */
  targetCurrency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmUpsertUserInfoParams = {
  /** WCM full version access */
  fullVersion: Scalars['Boolean']['input'];
  /** WCM user uuid */
  userUuid: Scalars['String']['input'];
};

export type WcmUserBuyer = {
  __typename?: 'WcmUserBuyer';
  wcmBuyerName: Scalars['String']['output'];
  /** WCM Buyer Type */
  wcmBuyerType: Wcm_Buyer_Type;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmUserBuyerMapping = {
  /** User auth uuid */
  userUuid: Scalars['String']['input'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmUserBuyerMappingDetails = {
  __typename?: 'WcmUserBuyerMappingDetails';
  /** WCM user uuid */
  userUuid: Scalars['String']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmUserBuyerMappingDetailsFilter = {
  and?: InputMaybe<Array<WcmUserBuyerMappingDetailsFilter>>;
  or?: InputMaybe<Array<WcmUserBuyerMappingDetailsFilter>>;
  userUuid?: InputMaybe<StringFieldComparison>;
  wcmBuyerUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmUserBuyerMappingDetailsSort = {
  direction: SortDirection;
  field: WcmUserBuyerMappingDetailsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmUserBuyerMappingDetailsSortFields =
  | 'userUuid'
  | 'wcmBuyerUuid';

export type WcmUserFileLogs = {
  __typename?: 'WcmUserFileLogs';
  /** WCM user file upload date */
  created: Scalars['String']['output'];
  /** WCM user uploaded file name */
  fileName: Scalars['String']['output'];
  /** WCM user uploaded file uuid */
  fileUuid: Scalars['String']['output'];
  /** WCM user file upload status */
  status: File_Upload_Status;
};

export type WcmUserInfo = {
  __typename?: 'WcmUserInfo';
  /** WCM full version access */
  fullVersion: Scalars['Boolean']['output'];
  /** WCM C2FO user */
  isC2foUser?: Maybe<Scalars['Boolean']['output']>;
  /** WCM self-registration request id */
  selfRegistrationRequestId?: Maybe<Scalars['String']['output']>;
  /** WCM user uuid */
  userUuid: Scalars['String']['output'];
};

export type WcmUserInfoOutput = {
  __typename?: 'WcmUserInfoOutput';
  /** client config */
  clientConfig: WcmDomainClientConfig;
  /** error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** user access expiry date */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** wcm user full version access */
  fullVersion: Scalars['Boolean']['output'];
  /** Wcm Buyers */
  wcmBuyers: Array<WcmBuyerData>;
};

export type WcmUserInformation = {
  __typename?: 'WcmUserInformation';
  /** WCM full version access */
  fullVersion: Scalars['Boolean']['output'];
  /** WCM is C2FO user */
  isC2foUser?: Maybe<Scalars['Boolean']['output']>;
  /** WCM user uuid */
  userUuid: Scalars['String']['output'];
};

export type WcmUserInformationFilter = {
  and?: InputMaybe<Array<WcmUserInformationFilter>>;
  fullVersion?: InputMaybe<BooleanFieldComparison>;
  isC2foUser?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<WcmUserInformationFilter>>;
  userUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmUserInformationSort = {
  direction: SortDirection;
  field: WcmUserInformationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmUserInformationSortFields =
  | 'fullVersion'
  | 'isC2foUser'
  | 'userUuid';

export type WcmUserPreference = {
  __typename?: 'WcmUserPreference';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** User preference settings */
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type WcmUserRolesInfo = {
  __typename?: 'WcmUserRolesInfo';
  internallyManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
};

export type WcmWorkingCapitalFilters = {
  maxValue: Scalars['Float']['input'];
  minValue: Scalars['Float']['input'];
};

export type WcmWorkingCapitalOpportunityMatrixFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  contractualTermsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmWorkingCapitalOpportunityMatrixOutput = {
  __typename?: 'WcmWorkingCapitalOpportunityMatrixOutput';
  coreSupplierGroupCount: Scalars['Float']['output'];
  estimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  strategicSupplierGroupCount: Scalars['Float']['output'];
  supplierGroupCount: Scalars['Float']['output'];
  tailSupplierGroupCount: Scalars['Float']['output'];
  weightedAverageBenchmarkTerms: Scalars['Float']['output'];
  weightedAverageCurrentTerms: Scalars['Float']['output'];
  weightedAverageEstimatedTerms: Scalars['Float']['output'];
  workingCapitalOpportunity: Scalars['Float']['output'];
  workingCapitalOpportunityBucket: Wco_Matrix_Bucket;
  wtAvgTermsChangeBucket: Wco_Matrix_Bucket;
};

export type WriterTypeOutput = {
  __typename?: 'WriterTypeOutput';
  buyerGeneratedWriterTypes: Array<Scalars['String']['output']>;
  writerTypes: Array<Scalars['String']['output']>;
};

export type FileSetConfiguration = {
  __typename?: 'fileSetConfiguration';
  addC2foFeeRecord: Scalars['Boolean']['output'];
  filterCriteria: FilterCriteria;
  name: Scalars['String']['output'];
  paymentConfig: OverrideConfig;
  uuid: Scalars['String']['output'];
  writerType: Scalars['String']['output'];
};

export type GetWcmBuyerAllAssignableRolesForPermissionManagerInput = {
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerAllAssignableRolesForPermissionManagerOutput = {
  __typename?: 'getWcmBuyerAllAssignableRolesForPermissionManagerOutput';
  roles: Array<WcmRoleBasicInfo>;
  total: Scalars['Float']['output'];
};

export type GetWcmBuyerRolesInput = {
  paging: BuyerAppFetchAllSuppliersPaging;
  roleNameSearch?: InputMaybe<Scalars['String']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerRolesOutput = {
  __typename?: 'getWcmBuyerRolesOutput';
  roles: Array<WcmRole>;
  total: Scalars['Float']['output'];
};

export type GetWcmRolePermissionsOutput = {
  __typename?: 'getWcmRolePermissionsOutput';
  permissions: Array<WcmRolePermission>;
};

export type ProgramsData = {
  __typename?: 'programsData';
  auditFileCount: Scalars['Float']['output'];
  fileSetConfiguration: Array<FileSetConfiguration>;
  programUuid: Scalars['String']['output'];
};

export type UpdateReserveInputDto = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** Invoice priority field */
  invoicePriority: Scalars['String']['input'];
  /** Market reserve id */
  marketReserveId: Scalars['Float']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Reserve percentage value */
  reservePercentage: Scalars['Float']['input'];
  /** Field to indicate run before adjustments */
  runBeforeAdjustments: Scalars['Boolean']['input'];
};

export type UpsertWcmUsersOutput = {
  __typename?: 'upsertWcmUsersOutput';
  /** WCM users info */
  users: Array<WcmUserInfo>;
};

export type UpdateCompanyProfileMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateCompanyProfileMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type UpdateLocationMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type GetSupplierAgreementsQueryVariables = Exact<{
  marketUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetSupplierAgreementsQuery = { __typename?: 'Query', agreements: { __typename?: 'AgreementConnection', edges: Array<{ __typename?: 'AgreementEdge', node: { __typename?: 'Agreement', id: string, cmsId: string, marketId: string } }> } };

export type GetCustomAgreementsQueryVariables = Exact<{
  agreementNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<AgreementStatusEnum>;
}>;


export type GetCustomAgreementsQuery = { __typename?: 'Query', customAgreements: Array<{ __typename?: 'CustomAgreement', uuid: string }> };

export type GetCustomAgreementWithContentQueryVariables = Exact<{
  agreementUuid: Scalars['String']['input'];
}>;


export type GetCustomAgreementWithContentQuery = { __typename?: 'Query', customAgreementWithContent: { __typename?: 'CustomAgreementWithContent', content: string, agreementTitle: string, updatedAt?: any | null, updatedBy?: string | null } };

export type ConfirmSupplierAgreementsMutationVariables = Exact<{
  agreementAudits: Array<AgreementAuditInput> | AgreementAuditInput;
}>;


export type ConfirmSupplierAgreementsMutation = { __typename?: 'Mutation', createManyAgreementAudits: Array<{ __typename?: 'AgreementAudit', dateAccepted: string }> };

export type UpdateUserCurrencyMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateUserCurrencyMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type UpdateUserLanguageMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', created?: string | null, emailAddress: string, intercomUserId?: string | null, supplierReadOnly?: boolean | null, account?: { __typename?: 'Account', name: string, newExperienceEnabled?: boolean | null, segment?: string | null, id: string, srm?: { __typename?: 'Srm', calendarLink?: string | null, center?: string | null, emailAddress: string, fallback: boolean, firstName?: string | null, isCalendlyEnabled: boolean, lastName?: string | null, phoneNumber?: string | null, team?: string | null } | null } | null, divisions?: Array<{ __typename?: 'Division', accountId?: string | null, srm?: { __typename?: 'Srm', team?: string | null } | null } | null> | null, formatPreferences?: { __typename?: 'FormatPreferences', aggregateCurrencyFormat?: string | null, dateDisplayFormat?: string | null, numberDisplayFormat?: string | null, useCustomFormatting: boolean } | null, loginHistory?: Array<{ __typename?: 'LoginHistory', created: string } | null> | null, personalInfo?: { __typename?: 'PersonalInfo', arDepartmentEmailAddress?: string | null, firstName?: string | null, fiscalYearEnd?: string | null, industry?: string | null, lastName?: string | null, locale?: string | null, primaryPhoneNumber?: string | null, role?: Role | null, secondaryPhoneNumber?: string | null, address?: { __typename?: 'Address', country?: string | null, postalCode?: string | null } | null } | null } | null };


export const UpdateCompanyProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables>;
export const UpdateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const GetSupplierAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplierAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketUuids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"marketId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketUuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cmsId"}},{"kind":"Field","name":{"kind":"Name","value":"marketId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSupplierAgreementsQuery, GetSupplierAgreementsQueryVariables>;
export const GetCustomAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementStatusEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customAgreements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementNames"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<GetCustomAgreementsQuery, GetCustomAgreementsQueryVariables>;
export const GetCustomAgreementWithContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomAgreementWithContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customAgreementWithContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"agreementTitle"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]}}]} as unknown as DocumentNode<GetCustomAgreementWithContentQuery, GetCustomAgreementWithContentQueryVariables>;
export const ConfirmSupplierAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmSupplierAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementAudits"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementAuditInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyAgreementAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agreementAudits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementAudits"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateAccepted"}}]}}]}}]} as unknown as DocumentNode<ConfirmSupplierAgreementsMutation, ConfirmSupplierAgreementsMutationVariables>;
export const UpdateUserCurrencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserCurrency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserCurrencyMutation, UpdateUserCurrencyMutationVariables>;
export const UpdateUserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"newExperienceEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"srm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendarLink"}},{"kind":"Field","name":{"kind":"Name","value":"center"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fallback"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"isCalendlyEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"team"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"divisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"srm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"formatPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateCurrencyFormat"}},{"kind":"Field","name":{"kind":"Name","value":"dateDisplayFormat"}},{"kind":"Field","name":{"kind":"Name","value":"numberDisplayFormat"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomFormatting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intercomUserId"}},{"kind":"Field","name":{"kind":"Name","value":"loginHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"arDepartmentEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fiscalYearEnd"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryPhoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierReadOnly"}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;